/* eslint-disable */
/**
 * Generated by orval 🍺
 * ThanksBen Django API
 * Internal API for ThanksBen
 * OpenAPI spec version: 1.0.0
 */
export interface ACHCheckoutRequestRequest {
  /** @minLength 1 */
  returnUrl: string;
}

export interface ACHCheckoutSession {
  redirectUrl: string;
}

export interface ACHMandateStatus {
  id: number;
  status: string;
  createdAt: string;
  /** @nullable */
  setupCompletedAt: string | null;
  /** @nullable */
  verificationMethod: string | null;
}

export interface ACHMicroDepositCheckoutRequestRequest {
  /**
   * @minLength 1
   * @pattern ^\d{4,17}$
   */
  accountNumber: string;
  /**
   * @minLength 1
   * @pattern ^\d{9}$
   */
  routingNumber: string;
}

/**
 * * `action_link` - action_link
 */
export type ActionLinkComponentTypeEnum =
  (typeof ActionLinkComponentTypeEnum)[keyof typeof ActionLinkComponentTypeEnum];

export const ActionLinkComponentTypeEnum = {
  action_link: 'action_link',
} as const;

/**
 * * `ADD_DEPENDANT` - ADD_DEPENDANT
 * * `VIEW_POLICIES` - VIEW_POLICIES
 * * `EXPLORE_BENEFITS` - EXPLORE_BENEFITS
 * * `VIEW_BENEFIT_SELECTIONS` - VIEW_BENEFIT_SELECTIONS
 * * `SUBMIT_LIFE_EVENT` - SUBMIT_LIFE_EVENT
 * * `VIEW_MISSING_RECEIPTS` - VIEW_MISSING_RECEIPTS
 * * `VIEW_NOTIFICATIONS` - VIEW_NOTIFICATIONS
 * * `EDIT_PROFILE` - EDIT_PROFILE
 * * `EDIT_BANK_DETAILS` - EDIT_BANK_DETAILS
 * * `VIEW_RESOURCES` - VIEW_RESOURCES
 * * `OPEN_BENEFIT_SIMULATOR` - OPEN_BENEFIT_SIMULATOR
 * * `OPEN_EQUITY_MODELER` - OPEN_EQUITY_MODELER
 * * `VIEW_TOTAL_REWARDS_STATEMENT` - VIEW_TOTAL_REWARDS_STATEMENT
 */
export type LinkEnum = (typeof LinkEnum)[keyof typeof LinkEnum];

export const LinkEnum = {
  ADD_DEPENDANT: 'ADD_DEPENDANT',
  VIEW_POLICIES: 'VIEW_POLICIES',
  EXPLORE_BENEFITS: 'EXPLORE_BENEFITS',
  VIEW_BENEFIT_SELECTIONS: 'VIEW_BENEFIT_SELECTIONS',
  SUBMIT_LIFE_EVENT: 'SUBMIT_LIFE_EVENT',
  VIEW_MISSING_RECEIPTS: 'VIEW_MISSING_RECEIPTS',
  VIEW_NOTIFICATIONS: 'VIEW_NOTIFICATIONS',
  EDIT_PROFILE: 'EDIT_PROFILE',
  EDIT_BANK_DETAILS: 'EDIT_BANK_DETAILS',
  VIEW_RESOURCES: 'VIEW_RESOURCES',
  OPEN_BENEFIT_SIMULATOR: 'OPEN_BENEFIT_SIMULATOR',
  OPEN_EQUITY_MODELER: 'OPEN_EQUITY_MODELER',
  VIEW_TOTAL_REWARDS_STATEMENT: 'VIEW_TOTAL_REWARDS_STATEMENT',
} as const;

export interface ActionLinkComponent {
  type: ActionLinkComponentTypeEnum;
  /** @maxLength 60 */
  label: string;
  link: LinkEnum;
}

export interface ActionedByResponse {
  /** @nullable */
  pk: number | null;
  fullName: string;
}

export interface ActivatePhysicalCardRequestRequest {
  /** @minLength 1 */
  managedCardId: string;
  /**
   * @minLength 1
   * @maxLength 4
   */
  activationCode?: string;
  confirmCardReceived?: boolean;
}

export type ActiveHolidayPreviousSelection = { [key: string]: unknown };

export interface ActiveHoliday {
  id: number;
  status: string;
  startDate: string;
  /** @nullable */
  endDate: string | null;
  /** @nullable */
  requestedStartDate: string | null;
  /** @nullable */
  requestedDurationMonths: number | null;
  previousSelection: ActiveHolidayPreviousSelection;
}

/**
 * * `CARD_DELIVERY_ADDRESS` - Card Delivery Address
 * * `CARD_BILLING_ADDRESS` - Card Billing Address
 * * `HOME_ADDRESS` - Home Address
 * * `CONTACT_ADDRESS` - Contact Address
 * * `PROFILE_HOME_ADDRESS` - Profile Home Address
 * * `REGISTERED_WITH_BANK_ADDRESS` - Registered with Bank Address
 */
export type AddressTypeEnum =
  (typeof AddressTypeEnum)[keyof typeof AddressTypeEnum];

export const AddressTypeEnum = {
  CARD_DELIVERY_ADDRESS: 'CARD_DELIVERY_ADDRESS',
  CARD_BILLING_ADDRESS: 'CARD_BILLING_ADDRESS',
  HOME_ADDRESS: 'HOME_ADDRESS',
  CONTACT_ADDRESS: 'CONTACT_ADDRESS',
  PROFILE_HOME_ADDRESS: 'PROFILE_HOME_ADDRESS',
  REGISTERED_WITH_BANK_ADDRESS: 'REGISTERED_WITH_BANK_ADDRESS',
} as const;

export interface User {
  /** @maxLength 150 */
  firstName?: string;
  /** @maxLength 150 */
  lastName?: string;
  readonly imageUrl: unknown;
}

export interface AdminEnrolmentChangeDetailResponse {
  readonly id: number;
  employee: User;
  timestamp: string;
  actionType: string;
  readonly actionedBy: unknown;
  readonly changes: string;
  /** An admin viewable reason that the change to the related enrolment occurred. E.g. 'User was unenrolled by the system as they are no longer eligible'. */
  changeReason?: string;
}

export interface AdminEnrolmentChangeListResponse {
  readonly id: number;
  employee: User;
  timestamp: string;
  actionType: string;
  readonly actionedBy: unknown;
}

export interface AirwallexAccountCreateErrorResponse {
  error: string;
}

export interface AirwallexAccountCreateRequestRequest {
  /** @minLength 1 */
  returnUrl?: string;
  /** @minLength 1 */
  primaryEmail?: string;
}

export interface AirwallexAccountCreateResponse {
  url: string;
}

export interface AirwallexFinancialReportDownloadResponse {
  downloadUrl: string;
}

/**
 * * `TRANSACTIONS` - Transactions
 * * `BALANCE` - Balance
 */
export type ReportTypeEnum =
  (typeof ReportTypeEnum)[keyof typeof ReportTypeEnum];

export const ReportTypeEnum = {
  TRANSACTIONS: 'TRANSACTIONS',
  BALANCE: 'BALANCE',
} as const;

export interface AirwallexFinancialReportGenerateRequestRequest {
  reportType: ReportTypeEnum;
  startDate: string;
  endDate: string;
  /** @minLength 1 */
  timezone: string;
}

/**
 * * `GENERATING` - Generating
 * * `COMPLETED` - Completed
 * * `FAILED` - Failed
 */
export type AirwallexFinancialReportStatusEnum =
  (typeof AirwallexFinancialReportStatusEnum)[keyof typeof AirwallexFinancialReportStatusEnum];

export const AirwallexFinancialReportStatusEnum = {
  GENERATING: 'GENERATING',
  COMPLETED: 'COMPLETED',
  FAILED: 'FAILED',
} as const;

export interface AirwallexFinancialReportGenerateResponse {
  status: AirwallexFinancialReportStatusEnum;
}

export interface AirwallexFinancialReportListItem {
  id: number;
  reportType: ReportTypeEnum;
  startDate: string;
  endDate: string;
  timezone: string;
  status: AirwallexFinancialReportStatusEnum;
}

export interface AirwallexGlobalAccountDetails {
  /** @nullable */
  beneficiary?: string | null;
  /** @nullable */
  beneficiaryBank?: string | null;
  /** @nullable */
  accountType?: string | null;
  /** @nullable */
  accountNumber?: string | null;
  /** @nullable */
  currency?: string | null;
  /** @nullable */
  transferMethod?: string | null;
  /** @nullable */
  featureType?: string | null;
  /** @nullable */
  localClearingSystem?: string | null;
  /** @nullable */
  readonly routingCode: string | null;
  /** @nullable */
  code?: string | null;
}

/**
 * * `left` - left
 * * `right` - right
 */
export type AlignEnum = (typeof AlignEnum)[keyof typeof AlignEnum];

export const AlignEnum = {
  left: 'left',
  right: 'right',
} as const;

/**
 * Return schema with property expressions evaluated and applied.
 */
export type AllowanceRJSFFormConfigResponseSchema = { [key: string]: unknown };

/**
 * RJSF form config serializer that evaluates property expressions for
 * allowances.
 */
export interface AllowanceRJSFFormConfigResponse {
  id: string;
  /** @maxLength 250 */
  name: string;
  /** @nullable */
  description?: string | null;
  /** Return schema with property expressions evaluated and applied. */
  readonly schema: AllowanceRJSFFormConfigResponseSchema;
  mapping: unknown;
}

/**
 * Serializer for benefit deduction data.
 */
export interface AllowanceBenefitDeductionResponse {
  benefitId: number;
  benefitName: string;
  /**
   * Get allowance deduction, converted to cycle pricing if enabled.
   * @nullable
   */
  readonly allowanceDeduction: string | null;
  /**
   * Get salary deduction, converted to cycle pricing if enabled.
   * @nullable
   */
  readonly salaryDeduction: string | null;
  currency: string;
}

/**
 * Response serializer for allowance balance with comprehensive deduction summaries.
 * Serializes pre-structured data from repository layer.
 * Converts monthly amounts to employee's payroll cycle frequency for display.
 */
export interface AllowanceBalanceDetailResponse {
  pk: number;
  /**
   * Get available balance, calculated from converted amount
   * and deductions if cycle pricing is enabled.
   */
  readonly availableBalance: string;
  availableBalanceCurrency: string;
  updatedTimestamp: string;
  userSelection: unknown;
  allowanceId: number;
  allowanceName: string;
  /** Get amount, converted to cycle pricing if enabled. */
  readonly amount: string;
  amountCurrency: string;
  selectionFormConfig: AllowanceRJSFFormConfigResponse | null;
  /**
   * Get renewal date, set to null if cycle pricing is enabled
   * and payroll period is not monthly.
   * @nullable
   */
  readonly renewalDate: string | null;
  /** Get total allowance deductions, converted to cycle pricing if enabled. */
  readonly totalAllowanceDeductions: string;
  /** Get total salary deductions, converted to cycle pricing if enabled. */
  readonly totalSalaryDeductions: string;
  enrollments: AllowanceBenefitDeductionResponse[];
}

/**
 * @nullable
 */
export type AllowanceBalanceSnapshotUserSelection = {
  [key: string]: unknown;
} | null;

export interface AllowanceBalanceSnapshot {
  /** @nullable */
  id?: number | null;
  /** @nullable */
  allowanceId?: number | null;
  /** @nullable */
  employeeId?: number | null;
  /** @nullable */
  userSelection?: AllowanceBalanceSnapshotUserSelection;
  /** @nullable */
  amount?: number | null;
  /** @nullable */
  renewalAmount?: number | null;
}

/**
 * @nullable
 */
export type AllowanceBalanceSnapshotRequestUserSelection = {
  [key: string]: unknown;
} | null;

export interface AllowanceBalanceSnapshotRequest {
  /** @nullable */
  id?: number | null;
  /** @nullable */
  allowanceId?: number | null;
  /** @nullable */
  employeeId?: number | null;
  /** @nullable */
  userSelection?: AllowanceBalanceSnapshotRequestUserSelection;
  /** @nullable */
  amount?: number | null;
  /** @nullable */
  renewalAmount?: number | null;
}

/**
 * * `card` - card
 * * `allowance` - allowance
 */
export type WalletTypeEnum =
  (typeof WalletTypeEnum)[keyof typeof WalletTypeEnum];

export const WalletTypeEnum = {
  card: 'card',
  allowance: 'allowance',
} as const;

export interface AllowanceListBlockItem {
  id: number;
  name: string;
  currency: string;
  /** @nullable */
  total: string | null;
  /** @nullable */
  remaining: string | null;
  /** @nullable */
  renewalDaysRemaining: number | null;
  /** @nullable */
  maxRolloverAmount: string | null;
  walletType: WalletTypeEnum;
  walletId: string;
}

export interface AllowanceListBlockData {
  items: AllowanceListBlockItem[];
}

export interface PayrollCycleContextResponse {
  interval: string;
  cycleCount: number;
}

export interface BenefitCycleContextResponse {
  cycleCount: number;
  remainingCycleCount: number;
}

export interface RunwayContextResponse {
  coveredBenefitCycles: number;
  /** @pattern ^-?\d{0,10}(?:\.\d{0,2})?$ */
  balanceAfterCurrentCycle: string;
  /** @pattern ^-?\d{0,10}(?:\.\d{0,2})?$ */
  balanceAtNextRenewal: string;
  /**
   * @nullable
   * @pattern ^-?\d{0,10}(?:\.\d{0,2})?$
   */
  immediateAllowanceTotal?: string | null;
}

export interface BoundaryEventResponse {
  eventType: string;
  date: string;
  /**
   * @nullable
   * @pattern ^-?\d{0,10}(?:\.\d{0,2})?$
   */
  balanceAfter: string | null;
}

export interface AllowancePeriodContextResponse {
  allowanceCycleInterval: string;
  currentPeriodStartDate: string;
  currentPeriodEndDate: string;
  nextPeriodStartDate: string;
  payrollCycle: PayrollCycleContextResponse;
  benefitCycle: BenefitCycleContextResponse;
  runway?: RunwayContextResponse | null;
  boundaries: BoundaryEventResponse[];
}

export interface AllowanceReceipt {
  transaction: number;
  /** @nullable */
  note?: string | null;
  /** @nullable */
  receiptFile?: string | null;
  /**
   * @minimum 0
   * @nullable
   */
  taxRate?: number | null;
  receiptUnavailable?: boolean;
  rjsfFormSchema?: unknown | null;
  rjsfFormData?: unknown | null;
}

export interface AllowanceReceiptRequest {
  transaction: number;
  /**
   * @minLength 1
   * @nullable
   */
  note?: string | null;
  /** @nullable */
  receiptFile?: Blob | null;
  /**
   * @minimum 0
   * @nullable
   */
  taxRate?: number | null;
  receiptUnavailable?: boolean;
  rjsfFormSchema?: unknown | null;
  rjsfFormData?: unknown | null;
}

/**
 * * `MONTHLY` - Monthly
 * * `YEARLY` - Yearly
 * * `QUARTERLY` - Quarterly
 * * `ON_MONTHS` - On Specific Months
 */
export type IntervalEnum = (typeof IntervalEnum)[keyof typeof IntervalEnum];

export const IntervalEnum = {
  MONTHLY: 'MONTHLY',
  YEARLY: 'YEARLY',
  QUARTERLY: 'QUARTERLY',
  ON_MONTHS: 'ON_MONTHS',
} as const;

export interface RJSFFormConfigResponse {
  id: string;
  /** @maxLength 250 */
  name: string;
  /** @nullable */
  description?: string | null;
  readonly schema: unknown;
  mapping: unknown;
}

export interface ManagedCardConfigResponse {
  /** @maxLength 250 */
  name: string;
  /**
   * @maxLength 30
   * @nullable
   */
  cardDisplayName?: string | null;
  /** @nullable */
  message?: string | null;
  reimbursementAllowed?: boolean;
  fundRequestAllowed?: boolean;
  topupAllowed?: boolean;
  requiresReceipts?: boolean;
  requiresReceiptsApproval?: boolean;
  allowPhysicalCard?: boolean;
  receiptFormConfig: RJSFFormConfigResponse;
}

export interface AllowanceResponse {
  readonly id: number;
  /** @maxLength 250 */
  name: string;
  /**
   * @nullable
   * @pattern ^-?\d{0,13}(?:\.\d{0,2})?$
   */
  amount?: string | null;
  readonly amountCurrency: string;
  /** @nullable */
  readonly employerAmount: string | null;
  /** @nullable */
  readonly employerAmountCurrency: string | null;
  /**
   * @nullable
   * @pattern ^-?\d{0,5}(?:\.\d{0,2})?$
   */
  percentage?: string | null;
  active?: boolean;
  rollover?: boolean;
  recurring?: boolean;
  interval?: IntervalEnum | null;
  employees?: number[];
  scheduledStartTime: string;
  readonly message: string;
  readonly requiresReceipts: boolean;
  readonly allowPhysicalCard: boolean;
  cardConfig: ManagedCardConfigResponse;
  readonly nextRenewalDate: string;
  readonly balanceExpires: string;
  readonly rolloverAmount: string;
  /** @nullable */
  readonly employerRolloverAmount: string | null;
  /** @nullable */
  readonly employerRolloverAmountCurrency: string | null;
  readonly assignedUsersCount: string;
  readonly totalBalance: string;
  /** @nullable */
  readonly employerTotalBalance: number | null;
  hasManagedCards?: boolean;
}

export interface Amount {
  name?: string;
  /** @pattern ^-?\d{0,8}(?:\.\d{0,2})?$ */
  amount: string;
  /** @maxLength 3 */
  currency: string;
}

export interface AnnouncementFeaturedBlockItem {
  id: number;
  title: string;
  /** @nullable */
  description: string | null;
  /** @nullable */
  ctaText: string | null;
  /** @nullable */
  ctaLink: string | null;
  imageUrl: string;
  imageAltText: string;
  /** @nullable */
  expiration: string | null;
}

export interface AnnouncementFeaturedBlockData {
  items: AnnouncementFeaturedBlockItem[];
}

/**
 * * `APPROVED` - APPROVED
 * * `REJECTED` - REJECTED
 * * `REDIRECTED` - REDIRECTED
 */
export type ApprovalActionActionEnum =
  (typeof ApprovalActionActionEnum)[keyof typeof ApprovalActionActionEnum];

export const ApprovalActionActionEnum = {
  APPROVED: 'APPROVED',
  REJECTED: 'REJECTED',
  REDIRECTED: 'REDIRECTED',
} as const;

export interface ApprovalActionRequest {
  stepExecutionId: string;
  action: ApprovalActionActionEnum;
  /** @nullable */
  reason?: string | null;
  /** @nullable */
  redirectToEmployee?: number | null;
}

export interface ApprovalErrors {
  errorString: string;
  reimbursementRequestPk?: string;
  fundRequestPk?: string;
}

/**
 * * `OPT_IN` - Opt in
 * * `OPT_OUT` - Opt out
 * * `OPT_IN_START` - Opt in start
 * * `OPT_IN_END` - Opt in end
 * * `OPT_OUT_START` - Opt out start
 * * `OPT_OUT_END` - Opt out end
 * * `CHANGE` - Change
 * * `CHANGE_START` - Change start
 * * `CHANGE_END` - Change end
 * * `REQUEST` - Request
 * * `REQUEST_START` - Request start
 * * `REQUEST_END` - Request end
 */
export type ApprovalProcessStepResponseActionEnum =
  (typeof ApprovalProcessStepResponseActionEnum)[keyof typeof ApprovalProcessStepResponseActionEnum];

export const ApprovalProcessStepResponseActionEnum = {
  OPT_IN: 'OPT_IN',
  OPT_OUT: 'OPT_OUT',
  OPT_IN_START: 'OPT_IN_START',
  OPT_IN_END: 'OPT_IN_END',
  OPT_OUT_START: 'OPT_OUT_START',
  OPT_OUT_END: 'OPT_OUT_END',
  CHANGE: 'CHANGE',
  CHANGE_START: 'CHANGE_START',
  CHANGE_END: 'CHANGE_END',
  REQUEST: 'REQUEST',
  REQUEST_START: 'REQUEST_START',
  REQUEST_END: 'REQUEST_END',
} as const;

/**
 * * `NOT_READY` - Not Ready
 * * `PENDING` - Pending
 * * `CANCELLED` - Cancelled
 * * `EDITED` - Edited
 * * `EXPIRED` - Expired
 * * `APPROVED` - Approved
 * * `REJECTED` - Rejected
 * * `REDIRECTED` - Redirected
 */
export type ApprovalProcessStepResponseStateEnum =
  (typeof ApprovalProcessStepResponseStateEnum)[keyof typeof ApprovalProcessStepResponseStateEnum];

export const ApprovalProcessStepResponseStateEnum = {
  NOT_READY: 'NOT_READY',
  PENDING: 'PENDING',
  CANCELLED: 'CANCELLED',
  EDITED: 'EDITED',
  EXPIRED: 'EXPIRED',
  APPROVED: 'APPROVED',
  REJECTED: 'REJECTED',
  REDIRECTED: 'REDIRECTED',
} as const;

export interface MinimalEmployeeResponse {
  readonly id: number;
  /** @maxLength 254 */
  email?: string;
  /** @maxLength 150 */
  firstName?: string;
  /** @maxLength 150 */
  lastName?: string;
  /**
   * @maxLength 255
   * @nullable
   */
  companyPosition?: string | null;
}

export interface ApprovalProcessStepResponse {
  readonly id: string;
  action: ApprovalProcessStepResponseActionEnum;
  state: ApprovalProcessStepResponseStateEnum;
  /** @nullable */
  assignedApprovers?: MinimalEmployeeResponse[] | null;
  /** @nullable */
  readonly approvalNote: string | null;
  /** @nullable */
  rejectionReason?: string | null;
  readonly actionedBy: MinimalEmployeeResponse | null;
  /** @nullable */
  timestamp?: string | null;
  /** @nullable */
  pendingReviewerDisplayString?: string | null;
  readonly actionReason: string;
  readonly redirectedTo: MinimalEmployeeResponse | null;
}

/**
 * Base serializer for the query params of a paginated list.
 */
export interface ApprovalProcessesListView {
  pageNumber?: number;
  /** @minimum 0 */
  pageSize?: number;
  name?: string;
}

/**
 * * `approve` - approve
 * * `reject` - reject
 */
export type ApprovalRequestActionActionEnum =
  (typeof ApprovalRequestActionActionEnum)[keyof typeof ApprovalRequestActionActionEnum];

export const ApprovalRequestActionActionEnum = {
  approve: 'approve',
  reject: 'reject',
} as const;

export interface ApprovalRequestActionRequest {
  reimbursementRequests?: string[];
  fundRequests?: string[];
  action: ApprovalRequestActionActionEnum;
  /**
   * @maxLength 500
   * @nullable
   */
  rejectionReason?: string | null;
}

export interface MinimalAllowanceResponse {
  readonly id: number;
  /** @maxLength 250 */
  name: string;
  hasManagedCards?: boolean;
}

export interface MinimalTopUpCardTemplateResponse {
  readonly id: number;
  /** @maxLength 50 */
  name: string;
}

/**
 * * `CONDITION` - Condition
 * * `STATIC` - Static
 * * `DYNAMIC` - Dynamic
 * * `AI_ADJUDICATION` - AI Adjudication
 */
export type ApprovalStepStepTypeEnum =
  (typeof ApprovalStepStepTypeEnum)[keyof typeof ApprovalStepStepTypeEnum];

export const ApprovalStepStepTypeEnum = {
  CONDITION: 'CONDITION',
  STATIC: 'STATIC',
  DYNAMIC: 'DYNAMIC',
  AI_ADJUDICATION: 'AI_ADJUDICATION',
} as const;

/**
 * * `CLIMB_MANAGEMENT_CHAIN` - Climb Management Chain
 * * `MANAGEMENT_CHAIN_LEVELS` - Management Chain Levels
 */
export type DynamicStepProcedureEnum =
  (typeof DynamicStepProcedureEnum)[keyof typeof DynamicStepProcedureEnum];

export const DynamicStepProcedureEnum = {
  CLIMB_MANAGEMENT_CHAIN: 'CLIMB_MANAGEMENT_CHAIN',
  MANAGEMENT_CHAIN_LEVELS: 'MANAGEMENT_CHAIN_LEVELS',
} as const;

export type ApprovalStepApprovingEmployeesItem = { [key: string]: unknown };

export interface ApprovalStep {
  readonly id: number;
  readonly approvingEmployees: readonly ApprovalStepApprovingEmployeesItem[];
  /** @maxLength 25 */
  name: string;
  stepType?: ApprovalStepStepTypeEnum;
  useManagerAsApprover?: boolean;
  dynamicStepProcedure?: DynamicStepProcedureEnum | null;
  dynamicProcedureConfig?: unknown | null;
  process: number;
}

/**
 * Render a ``TransactionStatus`` as a display payload for ECC approval surfaces.
 *
 * Mirrors the employee-app ``TransactionDisplayStatusSerializer`` output
 * (``status`` / ``type`` / ``disabled``), reusing the same level and disabled maps.
 */
export interface ApprovalRequestDisplayStatus {
  readonly status: string;
  readonly type: string;
  readonly disabled: boolean;
}

/**
 * @nullable
 */
export type ReimbursementResponseWalletDeductionDetail = {
  [key: string]: string | boolean;
} | null;

/**
 * @nullable
 */
export type ReimbursementResponseRjsfFormData = {
  [key: string]: unknown;
} | null;

export interface ReimbursementResponse {
  readonly uuid: string;
  allowance: MinimalAllowanceResponse;
  topupCardTemplate: MinimalTopUpCardTemplateResponse;
  employee: MinimalEmployeeResponse;
  approver: MinimalEmployeeResponse;
  /** @nullable */
  readonly walletDeductionDetail: ReimbursementResponseWalletDeductionDetail;
  readonly actionWithOverridePermission: boolean;
  readonly currentApprovalStep: ApprovalStep | null;
  readonly nextApprovalStep: ApprovalStep | null;
  rjsfFormSchema?: unknown | null;
  /** @nullable */
  readonly rjsfFormData: ReimbursementResponseRjsfFormData;
  /** @nullable */
  readonly reservedBalance: string | null;
  readonly amountExceedsReservedBalance: boolean;
  /** @nullable */
  readonly amountExceedingReservedBalance: string | null;
  readonly isUsingReservedAmount: boolean;
  readonly approvalRequestDisplayStatus: ApprovalRequestDisplayStatus;
  readonly amountCurrency: string;
  /** @pattern ^-?\d{0,13}(?:\.\d{0,2})?$ */
  amount: string;
  /** @nullable */
  readonly actualAmountCurrency: string | null;
  /**
   * Amount in card's currency
   * @nullable
   * @pattern ^-?\d{0,13}(?:\.\d{0,2})?$
   */
  actualAmount?: string | null;
  /** @nullable */
  readonly transferAmountCurrency: string | null;
  /**
   * This is the amount that will be used for SendTransfer/Transfer if the account currency is different from the card currency.
   * @nullable
   * @pattern ^-?\d{0,13}(?:\.\d{0,2})?$
   */
  transferAmount?: string | null;
  /** @maxLength 250 */
  name: string;
  purchaseDate: string;
  readonly uploadedTimestamp: string;
  /** @nullable */
  actionedTimestamp?: string | null;
  /** @nullable */
  note?: string | null;
  receiptFile: string;
  approved?: boolean;
  rejected?: boolean;
  cancelled?: boolean;
  /** @nullable */
  rejectionReason?: string | null;
  manualTransferComplete?: boolean;
  /** @nullable */
  taxRate?: number | null;
  /**
   * @maxLength 100
   * @nullable
   */
  xeroTaxCode?: string | null;
  managedExternally?: boolean;
  fxDetails?: unknown | null;
  /** @nullable */
  readonly deductedFromAvailableBalanceCurrency: string | null;
  /**
   * This is the amount that will be taken from available balance of the card
   * @nullable
   * @pattern ^-?\d{0,13}(?:\.\d{0,2})?$
   */
  deductedFromAvailableBalance?: string | null;
  /** @nullable */
  readonly deductedFromReservedBalanceCurrency: string | null;
  /**
   * This is the amount that will be taken from reserved balance of the card
   * @nullable
   * @pattern ^-?\d{0,13}(?:\.\d{0,2})?$
   */
  deductedFromReservedBalance?: string | null;
  /** @nullable */
  readonly exceedingAmountCurrency: string | null;
  /**
   * This is the amount that is exceeding the available balance + reserved balance
   * @nullable
   * @pattern ^-?\d{0,13}(?:\.\d{0,2})?$
   */
  exceedingAmount?: string | null;
  employer: number;
}

/**
 * @nullable
 */
export type FundRequestAdminResponseRjsfFormData = {
  [key: string]: unknown;
} | null;

export interface FundRequestAdminResponse {
  readonly uuid: string;
  allowance: MinimalAllowanceResponse;
  topupCardTemplate: MinimalTopUpCardTemplateResponse;
  employee: MinimalEmployeeResponse;
  approver: MinimalEmployeeResponse;
  readonly actionWithOverridePermission: boolean;
  readonly currentApprovalStep: ApprovalStep | null;
  readonly nextApprovalStep: ApprovalStep | null;
  rjsfFormSchema?: unknown | null;
  /** @nullable */
  readonly rjsfFormData: FundRequestAdminResponseRjsfFormData;
  /** @nullable */
  readonly reservedBalance: string | null;
  readonly amountExceedsReservedBalance: boolean;
  /** @nullable */
  readonly amountExceedingReservedBalance: string | null;
  readonly isUsingReservedAmount: boolean;
  readonly approvalRequestDisplayStatus: ApprovalRequestDisplayStatus;
  readonly amountCurrency: string;
  /** @pattern ^-?\d{0,13}(?:\.\d{0,2})?$ */
  amount: string;
  /** @maxLength 250 */
  name: string;
  /** @nullable */
  note?: string | null;
  /**
   * @maxLength 250
   * @nullable
   */
  url?: string | null;
  readonly createdTimestamp: string;
  /** @nullable */
  actionedTimestamp?: string | null;
  approved?: boolean;
  rejected?: boolean;
  cancelled?: boolean;
  /** @nullable */
  rejectionReason?: string | null;
  employer: number;
}

/**
 * @nullable
 */
export type BenefitRequestResponseCurrentApprovalStep = {
  [key: string]: unknown;
} | null;

/**
 * @nullable
 */
export type BenefitRequestResponseNextApprovalStep = {
  [key: string]: unknown;
} | null;

/**
 * Return the RJSF schema for the benefit request.
 *
 * Uses the same format as BenefitRequestConfigSerializer.
 * @nullable
 */
export type BenefitRequestResponseSchema = { [key: string]: unknown } | null;

export interface BenefitRequestResponse {
  id: number;
  requestingEmployeeName: string;
  benefitName: string;
  requestData: unknown;
  requestedTimestamp: string;
  /** @nullable */
  readonly currentApprovalStep: BenefitRequestResponseCurrentApprovalStep;
  /** @nullable */
  readonly nextApprovalStep: BenefitRequestResponseNextApprovalStep;
  /**
   * Return the RJSF schema for the benefit request.
   *
   * Uses the same format as BenefitRequestConfigSerializer.
   * @nullable
   */
  readonly schema: BenefitRequestResponseSchema;
}

/**
 * * `DRAFT` - Draft
 * * `WAITING_ACTIVATION_APPROVAL` - Waiting Activation Approval
 * * `PENDING_ACTIVATION` - Pending Activation
 * * `ACTIVE` - Active
 * * `WAITING_DEACTIVATION_APPROVAL` - Waiting Deactivation Approval
 * * `PENDING_DEACTIVATION` - Pending Deactivation
 * * `DEACTIVATED` - Deactivated
 * * `REJECTED` - Rejected
 * * `OPTED_OUT` - Opted out
 */
export type Status00aEnum = (typeof Status00aEnum)[keyof typeof Status00aEnum];

export const Status00aEnum = {
  DRAFT: 'DRAFT',
  WAITING_ACTIVATION_APPROVAL: 'WAITING_ACTIVATION_APPROVAL',
  PENDING_ACTIVATION: 'PENDING_ACTIVATION',
  ACTIVE: 'ACTIVE',
  WAITING_DEACTIVATION_APPROVAL: 'WAITING_DEACTIVATION_APPROVAL',
  PENDING_DEACTIVATION: 'PENDING_DEACTIVATION',
  DEACTIVATED: 'DEACTIVATED',
  REJECTED: 'REJECTED',
  OPTED_OUT: 'OPTED_OUT',
} as const;

export interface BenefitEnrolmentEmployee {
  readonly id: number;
  /** @maxLength 254 */
  email?: string;
  /** @maxLength 150 */
  firstName?: string;
  /** @maxLength 150 */
  lastName?: string;
  readonly tagsList: readonly string[];
}

export interface PendingEnrollableBenefitResponse {
  readonly id: number;
  /** @maxLength 200 */
  name: string;
}

/**
 * @nullable
 */
export type PendingBenefitEnrolmentResponseCurrentApprovalStep = {
  [key: string]: unknown;
} | null;

/**
 * @nullable
 */
export type PendingBenefitEnrolmentResponseNextApprovalStep = {
  [key: string]: unknown;
} | null;

export type PendingBenefitEnrolmentResponseApprovalRequestType = {
  [key: string]: string;
};

export interface PendingBenefitEnrolmentResponse {
  readonly id: number;
  status?: Status00aEnum;
  /** @nullable */
  statusUpdatedTimestamp?: string | null;
  /** @nullable */
  optInTimestamp?: string | null;
  employee: BenefitEnrolmentEmployee;
  benefit: PendingEnrollableBenefitResponse;
  readonly actionWithOverridePermission: boolean;
  /** @nullable */
  readonly currentApprovalStep: PendingBenefitEnrolmentResponseCurrentApprovalStep;
  /** @nullable */
  readonly nextApprovalStep: PendingBenefitEnrolmentResponseNextApprovalStep;
  readonly approvalRequestType: PendingBenefitEnrolmentResponseApprovalRequestType;
  readonly employerName: string;
  readonly requiresDocumentSigning: boolean;
  /** @nullable */
  readonly documentSigningRequestId: number | null;
}

export type ApprovalRequestData =
  | ReimbursementResponse
  | FundRequestAdminResponse
  | BenefitRequestResponse
  | PendingBenefitEnrolmentResponse;

export interface ApprovalRequestRedirectionMetadata {
  redirectionFromStepExecution?: string;
  redirectionTimestamp?: string;
  redirectionTo?: MinimalEmployeeResponse;
  redirectionBy?: MinimalEmployeeResponse;
  redirectedToStepExecution?: string;
  redirectedTimestamp?: string;
  redirectedTo?: MinimalEmployeeResponse;
  redirectedBy?: MinimalEmployeeResponse;
}

/**
 * @nullable
 */
export type ApprovalRequestResponseCurrentApprovalStep = {
  [key: string]: unknown;
} | null;

/**
 * @nullable
 */
export type ApprovalRequestResponseNextApprovalStep = {
  [key: string]: unknown;
} | null;

/**
 * * `REIMBURSEMENT` - REIMBURSEMENT
 * * `BUDGET_REQUEST` - BUDGET_REQUEST
 */
export type ApprovalRequestTypeEnum =
  (typeof ApprovalRequestTypeEnum)[keyof typeof ApprovalRequestTypeEnum];

export const ApprovalRequestTypeEnum = {
  REIMBURSEMENT: 'REIMBURSEMENT',
  BUDGET_REQUEST: 'BUDGET_REQUEST',
} as const;

export interface ApprovalRequestResponse {
  uuid: string;
  requestName: string;
  requestDate: string;
  employeeName: string;
  amount: number;
  amountCurrency: string;
  approvalRequestType: ApprovalRequestTypeEnum;
  allowanceName: string;
  approverName: string;
  approved: boolean;
  rejected: boolean;
  hasManagedCard: boolean;
  readonly actionWithOverridePermission: boolean;
  /** @nullable */
  readonly currentApprovalStep: ApprovalRequestResponseCurrentApprovalStep;
  /** @nullable */
  readonly nextApprovalStep: ApprovalRequestResponseNextApprovalStep;
  amountExceedsReservedBalance: boolean;
  /** @nullable */
  amountExceedingReservedBalance: number | null;
  /** @nullable */
  reservedBalance: number | null;
  isUsingReservedAmount: boolean;
  readonly approvalRequestDisplayStatus: ApprovalRequestDisplayStatus;
}

/**
 * * `BENEFIT_ENROLMENT` - Benefit Enrolment
 * * `BENEFIT_REQUEST` - Benefit Request
 * * `FUND_REQUEST` - Fund Request
 * * `REIMBURSEMENT_REQUEST` - Reimbursement Request
 */
export type ApprovalTypeEnum =
  (typeof ApprovalTypeEnum)[keyof typeof ApprovalTypeEnum];

export const ApprovalTypeEnum = {
  BENEFIT_ENROLMENT: 'BENEFIT_ENROLMENT',
  BENEFIT_REQUEST: 'BENEFIT_REQUEST',
  FUND_REQUEST: 'FUND_REQUEST',
  REIMBURSEMENT_REQUEST: 'REIMBURSEMENT_REQUEST',
} as const;

/**
 * * `NOT_READY` - Not Ready
 * * `PENDING` - Pending
 * * `APPROVED` - Approved
 * * `REJECTED` - Rejected
 * * `CANCELLED` - Cancelled
 * * `REDIRECTED` - Redirected
 */
export type ApprovalRequestStepExecutionResponseStatusEnum =
  (typeof ApprovalRequestStepExecutionResponseStatusEnum)[keyof typeof ApprovalRequestStepExecutionResponseStatusEnum];

export const ApprovalRequestStepExecutionResponseStatusEnum = {
  NOT_READY: 'NOT_READY',
  PENDING: 'PENDING',
  APPROVED: 'APPROVED',
  REJECTED: 'REJECTED',
  CANCELLED: 'CANCELLED',
  REDIRECTED: 'REDIRECTED',
} as const;

export interface EmployeeMinimalDetailsResponse {
  id: number;
  email: string;
  firstName: string;
  lastName: string;
  readonly tagsList: readonly unknown[];
}

export interface StepExecutionActionedByResponse {
  id: number;
  name: string;
}

export interface ApprovalRequestStepExecutionResponse {
  uuid: string;
  processExecution: string;
  approvalType: ApprovalTypeEnum;
  status: ApprovalRequestStepExecutionResponseStatusEnum;
  requestedTimestamp: string;
  requestedBy: number;
  readonly isManagerApprovalStep: boolean;
  readonly managerReviewer: EmployeeMinimalDetailsResponse | null;
  actionedTimestamp?: string;
  actionedBy?: StepExecutionActionedByResponse;
  readonly isProcessingAction: boolean;
  readonly isRedirected: boolean;
  readonly isRedirection: boolean;
  readonly redirectionMetadata: ApprovalRequestRedirectionMetadata;
  readonly requestData: ApprovalRequestData;
  readonly isActionable: boolean;
}

export interface ApprovalRequestsActionErrors {
  stepExecution: string;
  errorString: string;
}

export interface ApprovalRequestsActionResponse {
  stepExecutions: string[];
  errors: ApprovalRequestsActionErrors[];
}

export interface ApprovalResponseAction {
  errors: ApprovalErrors[];
}

export interface Approver {
  readonly id: number;
  /** @maxLength 254 */
  email?: string;
  /** @maxLength 150 */
  firstName?: string;
  /** @maxLength 150 */
  lastName?: string;
}

/**
 * Serializer for the ModularBenefitTag model.
 */
export interface BenefitTag {
  readonly id: number;
  /** @maxLength 50 */
  name: string;
  /**
   * @maxLength 50
   * @nullable
   */
  icon?: string | null;
}

/**
 * Serializer for the AreaOfInterest model.
 */
export interface AreaOfInterest {
  readonly id: number;
  readonly name: string;
  readonly description: string;
  /** @pattern ^[-a-zA-Z0-9_]+$ */
  readonly slug: string;
  readonly icon: string;
  benefitTags: BenefitTag[];
}

/**
 * @nullable
 */
export type ExpectedInstructionExpectedOutput = {
  [key: string]: unknown;
} | null;

export interface ExpectedInstruction {
  instructionConfigId: number;
  shouldFire: boolean;
  /** @nullable */
  expectedOutput?: ExpectedInstructionExpectedOutput;
}

export interface Assertions {
  expectedInstructions?: ExpectedInstruction[];
}

/**
 * @nullable
 */
export type ExpectedInstructionRequestExpectedOutput = {
  [key: string]: unknown;
} | null;

export interface ExpectedInstructionRequest {
  instructionConfigId: number;
  shouldFire: boolean;
  /** @nullable */
  expectedOutput?: ExpectedInstructionRequestExpectedOutput;
}

export interface AssertionsRequest {
  expectedInstructions?: ExpectedInstructionRequest[];
}

/**
 * * `ALL` - All
 * * `SEGMENT` - Segment
 */
export type AudienceEnum = (typeof AudienceEnum)[keyof typeof AudienceEnum];

export const AudienceEnum = {
  ALL: 'ALL',
  SEGMENT: 'SEGMENT',
} as const;

export interface AustralianBankAccountRequest {
  /** @minLength 1 */
  beneficiaryBankAddress?: string;
  /** @minLength 1 */
  beneficiaryBankName?: string;
  /** @minLength 1 */
  beneficiaryBankCountry?: string;
  /**
   * Beneficiary name (Regex: ^[\p{L}][\p{L} -'.]*$)
   * @minLength 1
   * @maxLength 100
   */
  beneficiaryName: string;
  active?: boolean;
  /**
   * @minLength 1
   * @maxLength 150
   */
  beneficiaryAddress: string;
  /**
   * BSB code, 6 digits or 3-3 format (Regex: ^(?:\d{6}|\d{3}-\d{3})$)
   * @minLength 1
   * @maxLength 7
   */
  bsbCode: string;
  /**
   * Account number, 6-10 digits (Regex: ^\d{6,10}$)
   * @minLength 1
   * @maxLength 10
   */
  accountNumber: string;
  employee: number;
}

/**
 * * `PROCESSING` - Processing
 * * `COMPLETE` - Complete
 * * `FAILED` - Failed
 */
export type ContributionHolidaysExportJobStatusEnum =
  (typeof ContributionHolidaysExportJobStatusEnum)[keyof typeof ContributionHolidaysExportJobStatusEnum];

export const ContributionHolidaysExportJobStatusEnum = {
  PROCESSING: 'PROCESSING',
  COMPLETE: 'COMPLETE',
  FAILED: 'FAILED',
} as const;

export interface AutoEnrolmentAssessmentReportExportResponse {
  status: ContributionHolidaysExportJobStatusEnum;
  /** @nullable */
  downloadUrl?: string | null;
  /** @nullable */
  expiresAt?: string | null;
  /** @nullable */
  filename?: string | null;
  /** @nullable */
  error?: string | null;
  /** @nullable */
  createdTimestamp?: string | null;
  /** @nullable */
  chunksCompleted?: number | null;
  /** @nullable */
  chunksTotal?: number | null;
}

export interface AutoEnrolmentAssessmentReportGenerateResponse {
  status: ContributionHolidaysExportJobStatusEnum;
}

export interface AvailableCurrencies {
  /** @maxLength 3 */
  code: string;
  /** @maxLength 50 */
  name: string;
}

export type BenefitRequestGetResponseDisplayStatus = { [key: string]: unknown };

export interface BenefitRequestGetResponse {
  readonly approvalSteps: readonly ApprovalProcessStepResponse[];
  readonly canCancel: boolean;
  readonly displayStatus: BenefitRequestGetResponseDisplayStatus;
  readonly id: number;
  readonly isPending: boolean;
  readonly name: string;
  requestData: unknown;
  readonly requestDate: string;
  readonly requestEndTimestamp: string;
  readonly hasSeenAlert: unknown | null;
  readonly isApproved: boolean;
  /**
   * @minimum -2147483648
   * @maximum 2147483647
   */
  version?: number;
  /** @nullable */
  readonly configId: number | null;
}

export interface AvcCycleContext {
  payrollConfigPresent: boolean;
  /** @nullable */
  cutoffDatetime: string | null;
  /** @nullable */
  currentCycleEnd: string | null;
  maxRequestsPerCycle: number;
  activeRequest: BenefitRequestGetResponse | null;
  canSubmit: boolean;
  canCancel: boolean;
  /** @nullable */
  blockedReason: string | null;
}

export type AwaitingResumeHolidayPreviousSelection = { [key: string]: unknown };

export interface AwaitingResumeHoliday {
  id: number;
  resumesOn: string;
  previousSelection: AwaitingResumeHolidayPreviousSelection;
}

export interface BalanceTransferRequestRequest {
  /** @nullable */
  sourceCard: string | null;
  /** @nullable */
  destinationCard: string | null;
  /** @pattern ^-?\d{0,5}(?:\.\d{0,2})?$ */
  amount: string;
}

export interface SEPABankaccountRequest {
  /** @minLength 1 */
  beneficiaryBankAddress?: string;
  /** @minLength 1 */
  beneficiaryBankName?: string;
  /** @minLength 1 */
  beneficiaryBankCountry?: string;
  active?: boolean;
  /**
   * @minLength 1
   * @maxLength 100
   */
  beneficiaryName: string;
  /**
   * @minLength 1
   * @maxLength 150
   */
  beneficiaryAddress: string;
  /**
   * @minLength 1
   * @maxLength 250
   */
  iban: string;
  /**
   * @minLength 1
   * @maxLength 250
   */
  bankIdentifierCode: string;
  employee: number;
}

export interface FasterPaymentsBankAccountRequest {
  /** @minLength 1 */
  beneficiaryBankAddress?: string;
  /** @minLength 1 */
  beneficiaryBankName?: string;
  /** @minLength 1 */
  beneficiaryBankCountry?: string;
  active?: boolean;
  /**
   * @minLength 1
   * @maxLength 100
   */
  beneficiaryName: string;
  /**
   * @minLength 1
   * @maxLength 150
   */
  beneficiaryAddress: string;
  /**
   * @minLength 1
   * @maxLength 250
   */
  accountNumber: string;
  /**
   * @minLength 1
   * @maxLength 250
   */
  sortCode: string;
  employee: number;
}

export interface SWIFTBankAccountRequest {
  /** @minLength 1 */
  beneficiaryBankAddress?: string;
  /** @minLength 1 */
  beneficiaryBankName?: string;
  /** @minLength 1 */
  beneficiaryBankCountry?: string;
  active?: boolean;
  /**
   * @minLength 1
   * @maxLength 100
   */
  beneficiaryName: string;
  /**
   * @minLength 1
   * @maxLength 150
   */
  beneficiaryAddress: string;
  /**
   * @minLength 1
   * @maxLength 250
   */
  iban: string;
  /**
   * @minLength 1
   * @maxLength 250
   */
  swift: string;
  /**
   * @maxLength 250
   * @nullable
   */
  otherBankDetails?: string | null;
  employee: number;
}

/**
 * * `CHECKING` - Checking
 * * `SAVINGS` - Savings
 */
export type CanadianBankAccountAccountTypeEnum =
  (typeof CanadianBankAccountAccountTypeEnum)[keyof typeof CanadianBankAccountAccountTypeEnum];

export const CanadianBankAccountAccountTypeEnum = {
  CHECKING: 'CHECKING',
  SAVINGS: 'SAVINGS',
} as const;

export interface CanadianBankAccountRequest {
  /** @minLength 1 */
  beneficiaryBankAddress?: string;
  /** @minLength 1 */
  beneficiaryBankName?: string;
  /** @minLength 1 */
  beneficiaryBankCountry?: string;
  active?: boolean;
  /**
   * @minLength 1
   * @maxLength 100
   */
  beneficiaryName: string;
  /**
   * @minLength 1
   * @maxLength 150
   */
  beneficiaryAddress: string;
  /**
   * @minLength 1
   * @maxLength 250
   */
  fullName: string;
  /**
   * @minLength 1
   * @maxLength 3
   */
  institutionNumber: string;
  /**
   * @minLength 1
   * @maxLength 5
   */
  transitNumber: string;
  /**
   * @minLength 1
   * @maxLength 250
   */
  accountNumber: string;
  accountType: CanadianBankAccountAccountTypeEnum;
  employee: number;
}

/**
 * * `CHECKING` - Checking
 * * `SAVINGS` - Savings
 * * `TRANSACTING` - Transacting
 */
export type BrazilianBankAccountAccountTypeEnum =
  (typeof BrazilianBankAccountAccountTypeEnum)[keyof typeof BrazilianBankAccountAccountTypeEnum];

export const BrazilianBankAccountAccountTypeEnum = {
  CHECKING: 'CHECKING',
  SAVINGS: 'SAVINGS',
  TRANSACTING: 'TRANSACTING',
} as const;

export interface BrazilianBankAccountRequest {
  /** @minLength 1 */
  beneficiaryBankAddress?: string;
  /** @minLength 1 */
  beneficiaryBankName?: string;
  /** @minLength 1 */
  beneficiaryBankCountry?: string;
  /**
   * CPF - Brazilian individual tax ID. Format: ^(?:\d{11}|(?:\d{3}\.){2}\d{3}-\d{2})$
   * @minLength 1
   * @maxLength 14
   */
  documentNumber: string;
  active?: boolean;
  /**
   * @minLength 1
   * @maxLength 100
   */
  beneficiaryName: string;
  /**
   * @minLength 1
   * @maxLength 150
   */
  beneficiaryAddress: string;
  /**
   * digit bank number
   * @minLength 1
   */
  bankCode: string;
  /**
   * 4-digit branch code with optional check digit (Regex: ^[0-9]{4}(?:-?[0-9Xx])?$)
   * @minLength 1
   * @maxLength 6
   */
  agencyCode: string;
  /**
   * 6-12 digit account number with optional check digit (Regex: ^[0-9]{6,12}(?:-[0-9Xx])?$)
   * @minLength 1
   * @maxLength 14
   */
  accountNumber: string;
  accountType?: BrazilianBankAccountAccountTypeEnum;
  employee: number;
}

export interface MexicanBankAccountRequest {
  /** @minLength 1 */
  beneficiaryBankAddress?: string;
  /** @minLength 1 */
  beneficiaryBankName?: string;
  /** @minLength 1 */
  beneficiaryBankCountry?: string;
  active?: boolean;
  /**
   * @minLength 1
   * @maxLength 100
   */
  beneficiaryName: string;
  /**
   * @minLength 1
   * @maxLength 150
   */
  beneficiaryAddress: string;
  /**
   * 18-digit CLABE (Clave Bancaria Estandarizada) (Regex: ^[0-9]{18}$)
   * @minLength 1
   * @maxLength 18
   */
  clabe: string;
  /**
   * CURP (Clave Única de Registro de Población) - Mexican tax ID. (Regex: ^[A-Z]{4}\d{6}[A-Z]{6}[0-9A-Z]\d$)
   * @maxLength 18
   * @nullable
   */
  curp?: string | null;
  /**
   * BIC/SWIFT code (Regex: ^[A-Z]{4}[A-Z]{2}[0-9A-Z]{2}(?:[0-9A-Z]{3})?$)
   * @minLength 1
   * @maxLength 11
   */
  bicSwiftCode: string;
  employee: number;
}

/**
 * * `FUTSUU` - 普通
 * * `CHOCHIKU` - 貯蓄
 * * `TOUZA` - 当座
 */
export type JapaneseBankAccountAccountTypeEnum =
  (typeof JapaneseBankAccountAccountTypeEnum)[keyof typeof JapaneseBankAccountAccountTypeEnum];

export const JapaneseBankAccountAccountTypeEnum = {
  FUTSUU: 'FUTSUU',
  CHOCHIKU: 'CHOCHIKU',
  TOUZA: 'TOUZA',
} as const;

export interface JapaneseBankAccountRequest {
  /** @minLength 1 */
  beneficiaryBankAddress?: string;
  /** @minLength 1 */
  beneficiaryBankName?: string;
  /** @minLength 1 */
  beneficiaryBankCountry?: string;
  /**
   * The beneficiary name must be in Katakana カタカナ. (Regex: ^[\u30A1-\u30FA\u30FC\u3000]+$)
   * @minLength 1
   * @maxLength 100
   */
  beneficiaryName: string;
  /**
   * 4-digit bank code (Regex: ^\d{4}$)
   * @minLength 1
   * @maxLength 4
   * @nullable
   */
  bankCode?: string | null;
  /**
   * @minLength 1
   * @maxLength 100
   */
  bankNameOrCode?: string;
  active?: boolean;
  /**
   * @minLength 1
   * @maxLength 150
   */
  beneficiaryAddress: string;
  /**
   * 3-digit branch code (Regex: ^\d{3}$)
   * @minLength 1
   * @maxLength 10
   */
  branchCode: string;
  accountType?: JapaneseBankAccountAccountTypeEnum;
  /**
   * 7-digit account number (Regex: ^\d{7}$)
   * @minLength 1
   * @maxLength 7
   */
  accountNumber: string;
  employee: number;
}

export interface PolishBankAccountRequest {
  /** @minLength 1 */
  beneficiaryBankAddress?: string;
  /** @minLength 1 */
  beneficiaryBankName?: string;
  /** @minLength 1 */
  beneficiaryBankCountry?: string;
  /**
   * Beneficiary name (Regex: ^[\p{L}][\p{L} -'.]*$)
   * @minLength 1
   * @maxLength 100
   */
  beneficiaryName: string;
  active?: boolean;
  /**
   * @minLength 1
   * @maxLength 150
   */
  beneficiaryAddress: string;
  /**
   * 26-digit account number (Regex: ^\d{26}$)
   * @minLength 1
   * @maxLength 26
   */
  accountNumber: string;
  /**
   * Optional IBAN starting with PL (Regex: ^PL\d{26}$)
   * @maxLength 28
   * @nullable
   */
  iban?: string | null;
  employee: number;
}

export interface IndianBankAccountRequest {
  /** @minLength 1 */
  beneficiaryBankAddress?: string;
  /** @minLength 1 */
  beneficiaryBankName?: string;
  /** @minLength 1 */
  beneficiaryBankCountry?: string;
  /**
   * Beneficiary name (Regex: ^[\p{L}][\p{L} -'.]*$)
   * @minLength 1
   * @maxLength 100
   */
  beneficiaryName: string;
  active?: boolean;
  /**
   * @minLength 1
   * @maxLength 150
   */
  beneficiaryAddress: string;
  /**
   * The Indian Financial System Code (IFSC) identifies the Indian bank branch. It's 11 characters long, and used for RTGS and NEFT transfers. You can find your IFSC here: https://www.rbi.org.in/scripts/bs_viewcontent.aspx?Id=2009 (Regex: ^[A-Z]{4}0[A-Z0-9]{6}$)
   * @minLength 1
   * @maxLength 11
   */
  ifscCode: string;
  /**
   * Account number, 9-18 digits (Regex: ^\d{9,18}$)
   * @minLength 1
   * @maxLength 18
   */
  accountNumber: string;
  employee: number;
}

export interface SwissBankAccountRequest {
  /** @minLength 1 */
  beneficiaryBankAddress?: string;
  /** @minLength 1 */
  beneficiaryBankName?: string;
  /** @minLength 1 */
  beneficiaryBankCountry?: string;
  /**
   * Beneficiary name (Regex: ^[\p{L}][\p{L} -'.]*$)
   * @minLength 1
   * @maxLength 100
   */
  beneficiaryName: string;
  active?: boolean;
  /**
   * @minLength 1
   * @maxLength 150
   */
  beneficiaryAddress: string;
  /**
   * Swiss IBAN (Regex: ^CH\d{2}\d{5}[0-9A-Z]{12}$)
   * @minLength 1
   * @maxLength 21
   */
  iban: string;
  employee: number;
}

export interface DanishBankAccountRequest {
  /** @minLength 1 */
  beneficiaryBankAddress?: string;
  /** @minLength 1 */
  beneficiaryBankName?: string;
  /** @minLength 1 */
  beneficiaryBankCountry?: string;
  /**
   * Beneficiary name (Regex: ^[\p{L}][\p{L} -'.]*$)
   * @minLength 1
   * @maxLength 100
   */
  beneficiaryName: string;
  active?: boolean;
  /**
   * @minLength 1
   * @maxLength 150
   */
  beneficiaryAddress: string;
  /**
   * Danish IBAN (Regex: ^DK\d{16}$)
   * @minLength 1
   * @maxLength 18
   */
  iban: string;
  employee: number;
}

export interface MalaysianBankAccountRequest {
  /** @minLength 1 */
  beneficiaryBankAddress?: string;
  /** @minLength 1 */
  beneficiaryBankName?: string;
  /** @minLength 1 */
  beneficiaryBankCountry?: string;
  /**
   * Beneficiary name (Regex: ^[\p{L}][\p{L} -'.]*$)
   * @minLength 1
   * @maxLength 100
   */
  beneficiaryName: string;
  active?: boolean;
  /**
   * @minLength 1
   * @maxLength 150
   */
  beneficiaryAddress: string;
  /**
   * BIC/SWIFT code (Regex: ^[A-Z]{4}MY[A-Z0-9]{2}([A-Z0-9]{3})?$). Enter the bank's SWIFT/BIC code (8 or 11 characters, e.g. RHBBMYKL)
   * @minLength 1
   * @maxLength 11
   */
  bicSwiftCode: string;
  /**
   * Account number, 7-20 digits (Regex: ^\d{7,20}$)
   * @minLength 1
   * @maxLength 20
   */
  accountNumber: string;
  employee: number;
}

export interface NewZealandBankAccountRequest {
  /** @minLength 1 */
  beneficiaryBankAddress?: string;
  /** @minLength 1 */
  beneficiaryBankName?: string;
  /** @minLength 1 */
  beneficiaryBankCountry?: string;
  /**
   * Beneficiary name (Regex: ^[\p{L}][\p{L} -'.]*$)
   * @minLength 1
   * @maxLength 100
   */
  beneficiaryName: string;
  active?: boolean;
  /**
   * @minLength 1
   * @maxLength 150
   */
  beneficiaryAddress: string;
  /**
   * Account number in 16-digit or formatted format (Regex: ^(?:\d{16}|\d{2}-\d{4}-\d{7}-\d{2,3})$)
   * @minLength 1
   * @maxLength 20
   */
  accountNumber: string;
  employee: number;
}

export interface SingaporeanBankAccountRequest {
  /** @minLength 1 */
  beneficiaryBankAddress?: string;
  /** @minLength 1 */
  beneficiaryBankName?: string;
  /** @minLength 1 */
  beneficiaryBankCountry?: string;
  /**
   * Beneficiary name (Regex: ^[\p{L}][\p{L} -'.]*$)
   * @minLength 1
   * @maxLength 100
   */
  beneficiaryName: string;
  active?: boolean;
  /**
   * @minLength 1
   * @maxLength 150
   */
  beneficiaryAddress: string;
  /**
   * BIC/SWIFT code (Regex: ^[A-Z]{4}SG[A-Z0-9]{2}([A-Z0-9]{3})?$). Enter the bank's SWIFT/BIC code (8 or 11 characters, e.g. DBSSSGSG)
   * @minLength 1
   * @maxLength 11
   */
  bicSwiftCode: string;
  /**
   * Account number, 7-20 digits (Regex: ^\d{7,20}$)
   * @minLength 1
   * @maxLength 20
   */
  accountNumber: string;
  employee: number;
}

export type BankAccountRequest =
  | SEPABankaccountRequest
  | FasterPaymentsBankAccountRequest
  | SWIFTBankAccountRequest
  | CanadianBankAccountRequest
  | BrazilianBankAccountRequest
  | MexicanBankAccountRequest
  | JapaneseBankAccountRequest
  | PolishBankAccountRequest
  | AustralianBankAccountRequest
  | IndianBankAccountRequest
  | SwissBankAccountRequest
  | DanishBankAccountRequest
  | MalaysianBankAccountRequest
  | NewZealandBankAccountRequest
  | SingaporeanBankAccountRequest;

/**
 * * `information` - information
 * * `critical` - critical
 */
export type VariantEnum = (typeof VariantEnum)[keyof typeof VariantEnum];

export const VariantEnum = {
  information: 'information',
  critical: 'critical',
} as const;

/**
 * * `chart` - chart
 * * `vesting_chart` - vesting_chart
 * * `breakdown` - breakdown
 */
export type LocationEnum = (typeof LocationEnum)[keyof typeof LocationEnum];

export const LocationEnum = {
  chart: 'chart',
  vesting_chart: 'vesting_chart',
  breakdown: 'breakdown',
} as const;

export interface BannerItem {
  title: string;
  description: string;
  variant: VariantEnum;
  displayOrder: number;
  location: LocationEnum;
}

export interface BaseAgentRequestRequest {
  toolName: string;
  request: string;
}

export interface BaseAgentRequestRequestRequest {
  /** @minLength 1 */
  toolName: string;
  /** @minLength 1 */
  request: string;
}

export interface BaseImage {
  image: string;
  readonly uuid: string;
  readonly originalName: string;
  readonly fileUrl: string;
}

export interface BenPermission {
  id: number;
  name: string;
}

/**
 * * `AW` - Aruba
 * * `AF` - Afghanistan
 * * `AO` - Angola
 * * `AI` - Anguilla
 * * `AX` - Åland Islands
 * * `AL` - Albania
 * * `AD` - Andorra
 * * `AE` - United Arab Emirates
 * * `AR` - Argentina
 * * `AM` - Armenia
 * * `AS` - American Samoa
 * * `AQ` - Antarctica
 * * `TF` - French Southern Territories
 * * `AG` - Antigua and Barbuda
 * * `AU` - Australia
 * * `AT` - Austria
 * * `AZ` - Azerbaijan
 * * `BI` - Burundi
 * * `BE` - Belgium
 * * `BJ` - Benin
 * * `BQ` - Bonaire, Sint Eustatius and Saba
 * * `BF` - Burkina Faso
 * * `BD` - Bangladesh
 * * `BG` - Bulgaria
 * * `BH` - Bahrain
 * * `BS` - Bahamas
 * * `BA` - Bosnia and Herzegovina
 * * `BL` - Saint Barthélemy
 * * `BY` - Belarus
 * * `BZ` - Belize
 * * `BM` - Bermuda
 * * `BO` - Bolivia, Plurinational State of
 * * `BR` - Brazil
 * * `BB` - Barbados
 * * `BN` - Brunei Darussalam
 * * `BT` - Bhutan
 * * `BV` - Bouvet Island
 * * `BW` - Botswana
 * * `CF` - Central African Republic
 * * `CA` - Canada
 * * `CC` - Cocos (Keeling) Islands
 * * `CH` - Switzerland
 * * `CL` - Chile
 * * `CN` - China
 * * `CI` - Côte d'Ivoire
 * * `CM` - Cameroon
 * * `CD` - Congo, The Democratic Republic of the
 * * `CG` - Congo
 * * `CK` - Cook Islands
 * * `CO` - Colombia
 * * `KM` - Comoros
 * * `CV` - Cabo Verde
 * * `CR` - Costa Rica
 * * `CU` - Cuba
 * * `CW` - Curaçao
 * * `CX` - Christmas Island
 * * `KY` - Cayman Islands
 * * `CY` - Cyprus
 * * `CZ` - Czechia
 * * `DE` - Germany
 * * `DJ` - Djibouti
 * * `DM` - Dominica
 * * `DK` - Denmark
 * * `DO` - Dominican Republic
 * * `DZ` - Algeria
 * * `EC` - Ecuador
 * * `EG` - Egypt
 * * `ER` - Eritrea
 * * `EH` - Western Sahara
 * * `ES` - Spain
 * * `EE` - Estonia
 * * `ET` - Ethiopia
 * * `FI` - Finland
 * * `FJ` - Fiji
 * * `FK` - Falkland Islands (Malvinas)
 * * `FR` - France
 * * `FO` - Faroe Islands
 * * `FM` - Micronesia, Federated States of
 * * `GA` - Gabon
 * * `GB` - United Kingdom
 * * `GE` - Georgia
 * * `GG` - Guernsey
 * * `GH` - Ghana
 * * `GI` - Gibraltar
 * * `GN` - Guinea
 * * `GP` - Guadeloupe
 * * `GM` - Gambia
 * * `GW` - Guinea-Bissau
 * * `GQ` - Equatorial Guinea
 * * `GR` - Greece
 * * `GD` - Grenada
 * * `GL` - Greenland
 * * `GT` - Guatemala
 * * `GF` - French Guiana
 * * `GU` - Guam
 * * `GY` - Guyana
 * * `HK` - Hong Kong
 * * `HM` - Heard Island and McDonald Islands
 * * `HN` - Honduras
 * * `HR` - Croatia
 * * `HT` - Haiti
 * * `HU` - Hungary
 * * `ID` - Indonesia
 * * `IM` - Isle of Man
 * * `IN` - India
 * * `IO` - British Indian Ocean Territory
 * * `IE` - Ireland
 * * `IR` - Iran, Islamic Republic of
 * * `IQ` - Iraq
 * * `IS` - Iceland
 * * `IL` - Israel
 * * `IT` - Italy
 * * `JM` - Jamaica
 * * `JE` - Jersey
 * * `JO` - Jordan
 * * `JP` - Japan
 * * `KZ` - Kazakhstan
 * * `KE` - Kenya
 * * `KG` - Kyrgyzstan
 * * `KH` - Cambodia
 * * `KI` - Kiribati
 * * `KN` - Saint Kitts and Nevis
 * * `KR` - Korea, Republic of
 * * `KW` - Kuwait
 * * `LA` - Lao People's Democratic Republic
 * * `LB` - Lebanon
 * * `LR` - Liberia
 * * `LY` - Libya
 * * `LC` - Saint Lucia
 * * `LI` - Liechtenstein
 * * `LK` - Sri Lanka
 * * `LS` - Lesotho
 * * `LT` - Lithuania
 * * `LU` - Luxembourg
 * * `LV` - Latvia
 * * `MO` - Macao
 * * `MF` - Saint Martin (French part)
 * * `MA` - Morocco
 * * `MC` - Monaco
 * * `MD` - Moldova, Republic of
 * * `MG` - Madagascar
 * * `MV` - Maldives
 * * `MX` - Mexico
 * * `MH` - Marshall Islands
 * * `MK` - North Macedonia
 * * `ML` - Mali
 * * `MT` - Malta
 * * `MM` - Myanmar
 * * `ME` - Montenegro
 * * `MN` - Mongolia
 * * `MP` - Northern Mariana Islands
 * * `MZ` - Mozambique
 * * `MR` - Mauritania
 * * `MS` - Montserrat
 * * `MQ` - Martinique
 * * `MU` - Mauritius
 * * `MW` - Malawi
 * * `MY` - Malaysia
 * * `YT` - Mayotte
 * * `NA` - Namibia
 * * `NC` - New Caledonia
 * * `NE` - Niger
 * * `NF` - Norfolk Island
 * * `NG` - Nigeria
 * * `NI` - Nicaragua
 * * `NU` - Niue
 * * `NL` - Netherlands
 * * `NO` - Norway
 * * `NP` - Nepal
 * * `NR` - Nauru
 * * `NZ` - New Zealand
 * * `OM` - Oman
 * * `PK` - Pakistan
 * * `PA` - Panama
 * * `PN` - Pitcairn
 * * `PE` - Peru
 * * `PH` - Philippines
 * * `PW` - Palau
 * * `PG` - Papua New Guinea
 * * `PL` - Poland
 * * `PR` - Puerto Rico
 * * `KP` - Korea, Democratic People's Republic of
 * * `PT` - Portugal
 * * `PY` - Paraguay
 * * `PS` - Palestine, State of
 * * `PF` - French Polynesia
 * * `QA` - Qatar
 * * `RE` - Réunion
 * * `RO` - Romania
 * * `RU` - Russian Federation
 * * `RW` - Rwanda
 * * `SA` - Saudi Arabia
 * * `SD` - Sudan
 * * `SN` - Senegal
 * * `SG` - Singapore
 * * `GS` - South Georgia and the South Sandwich Islands
 * * `SH` - Saint Helena, Ascension and Tristan da Cunha
 * * `SJ` - Svalbard and Jan Mayen
 * * `SB` - Solomon Islands
 * * `SL` - Sierra Leone
 * * `SV` - El Salvador
 * * `SM` - San Marino
 * * `SO` - Somalia
 * * `PM` - Saint Pierre and Miquelon
 * * `RS` - Serbia
 * * `SS` - South Sudan
 * * `ST` - Sao Tome and Principe
 * * `SR` - Suriname
 * * `SK` - Slovakia
 * * `SI` - Slovenia
 * * `SE` - Sweden
 * * `SZ` - Eswatini
 * * `SX` - Sint Maarten (Dutch part)
 * * `SC` - Seychelles
 * * `SY` - Syrian Arab Republic
 * * `TC` - Turks and Caicos Islands
 * * `TD` - Chad
 * * `TG` - Togo
 * * `TH` - Thailand
 * * `TJ` - Tajikistan
 * * `TK` - Tokelau
 * * `TM` - Turkmenistan
 * * `TL` - Timor-Leste
 * * `TO` - Tonga
 * * `TT` - Trinidad and Tobago
 * * `TN` - Tunisia
 * * `TR` - Türkiye
 * * `TV` - Tuvalu
 * * `TW` - Taiwan, Province of China
 * * `TZ` - Tanzania, United Republic of
 * * `UG` - Uganda
 * * `UA` - Ukraine
 * * `UM` - United States Minor Outlying Islands
 * * `UY` - Uruguay
 * * `US` - United States
 * * `UZ` - Uzbekistan
 * * `VA` - Holy See (Vatican City State)
 * * `VC` - Saint Vincent and the Grenadines
 * * `VE` - Venezuela, Bolivarian Republic of
 * * `VG` - Virgin Islands, British
 * * `VI` - Virgin Islands, U.S.
 * * `VN` - Viet Nam
 * * `VU` - Vanuatu
 * * `WF` - Wallis and Futuna
 * * `WS` - Samoa
 * * `YE` - Yemen
 * * `ZA` - South Africa
 * * `ZM` - Zambia
 * * `ZW` - Zimbabwe
 * * `XK` - Kosovo
 */
export type HomeAddressCountryEnum =
  (typeof HomeAddressCountryEnum)[keyof typeof HomeAddressCountryEnum];

export const HomeAddressCountryEnum = {
  AW: 'AW',
  AF: 'AF',
  AO: 'AO',
  AI: 'AI',
  AX: 'AX',
  AL: 'AL',
  AD: 'AD',
  AE: 'AE',
  AR: 'AR',
  AM: 'AM',
  AS: 'AS',
  AQ: 'AQ',
  TF: 'TF',
  AG: 'AG',
  AU: 'AU',
  AT: 'AT',
  AZ: 'AZ',
  BI: 'BI',
  BE: 'BE',
  BJ: 'BJ',
  BQ: 'BQ',
  BF: 'BF',
  BD: 'BD',
  BG: 'BG',
  BH: 'BH',
  BS: 'BS',
  BA: 'BA',
  BL: 'BL',
  BY: 'BY',
  BZ: 'BZ',
  BM: 'BM',
  BO: 'BO',
  BR: 'BR',
  BB: 'BB',
  BN: 'BN',
  BT: 'BT',
  BV: 'BV',
  BW: 'BW',
  CF: 'CF',
  CA: 'CA',
  CC: 'CC',
  CH: 'CH',
  CL: 'CL',
  CN: 'CN',
  CI: 'CI',
  CM: 'CM',
  CD: 'CD',
  CG: 'CG',
  CK: 'CK',
  CO: 'CO',
  KM: 'KM',
  CV: 'CV',
  CR: 'CR',
  CU: 'CU',
  CW: 'CW',
  CX: 'CX',
  KY: 'KY',
  CY: 'CY',
  CZ: 'CZ',
  DE: 'DE',
  DJ: 'DJ',
  DM: 'DM',
  DK: 'DK',
  DO: 'DO',
  DZ: 'DZ',
  EC: 'EC',
  EG: 'EG',
  ER: 'ER',
  EH: 'EH',
  ES: 'ES',
  EE: 'EE',
  ET: 'ET',
  FI: 'FI',
  FJ: 'FJ',
  FK: 'FK',
  FR: 'FR',
  FO: 'FO',
  FM: 'FM',
  GA: 'GA',
  GB: 'GB',
  GE: 'GE',
  GG: 'GG',
  GH: 'GH',
  GI: 'GI',
  GN: 'GN',
  GP: 'GP',
  GM: 'GM',
  GW: 'GW',
  GQ: 'GQ',
  GR: 'GR',
  GD: 'GD',
  GL: 'GL',
  GT: 'GT',
  GF: 'GF',
  GU: 'GU',
  GY: 'GY',
  HK: 'HK',
  HM: 'HM',
  HN: 'HN',
  HR: 'HR',
  HT: 'HT',
  HU: 'HU',
  ID: 'ID',
  IM: 'IM',
  IN: 'IN',
  IO: 'IO',
  IE: 'IE',
  IR: 'IR',
  IQ: 'IQ',
  IS: 'IS',
  IL: 'IL',
  IT: 'IT',
  JM: 'JM',
  JE: 'JE',
  JO: 'JO',
  JP: 'JP',
  KZ: 'KZ',
  KE: 'KE',
  KG: 'KG',
  KH: 'KH',
  KI: 'KI',
  KN: 'KN',
  KR: 'KR',
  KW: 'KW',
  LA: 'LA',
  LB: 'LB',
  LR: 'LR',
  LY: 'LY',
  LC: 'LC',
  LI: 'LI',
  LK: 'LK',
  LS: 'LS',
  LT: 'LT',
  LU: 'LU',
  LV: 'LV',
  MO: 'MO',
  MF: 'MF',
  MA: 'MA',
  MC: 'MC',
  MD: 'MD',
  MG: 'MG',
  MV: 'MV',
  MX: 'MX',
  MH: 'MH',
  MK: 'MK',
  ML: 'ML',
  MT: 'MT',
  MM: 'MM',
  ME: 'ME',
  MN: 'MN',
  MP: 'MP',
  MZ: 'MZ',
  MR: 'MR',
  MS: 'MS',
  MQ: 'MQ',
  MU: 'MU',
  MW: 'MW',
  MY: 'MY',
  YT: 'YT',
  NA: 'NA',
  NC: 'NC',
  NE: 'NE',
  NF: 'NF',
  NG: 'NG',
  NI: 'NI',
  NU: 'NU',
  NL: 'NL',
  NO: 'NO',
  NP: 'NP',
  NR: 'NR',
  NZ: 'NZ',
  OM: 'OM',
  PK: 'PK',
  PA: 'PA',
  PN: 'PN',
  PE: 'PE',
  PH: 'PH',
  PW: 'PW',
  PG: 'PG',
  PL: 'PL',
  PR: 'PR',
  KP: 'KP',
  PT: 'PT',
  PY: 'PY',
  PS: 'PS',
  PF: 'PF',
  QA: 'QA',
  RE: 'RE',
  RO: 'RO',
  RU: 'RU',
  RW: 'RW',
  SA: 'SA',
  SD: 'SD',
  SN: 'SN',
  SG: 'SG',
  GS: 'GS',
  SH: 'SH',
  SJ: 'SJ',
  SB: 'SB',
  SL: 'SL',
  SV: 'SV',
  SM: 'SM',
  SO: 'SO',
  PM: 'PM',
  RS: 'RS',
  SS: 'SS',
  ST: 'ST',
  SR: 'SR',
  SK: 'SK',
  SI: 'SI',
  SE: 'SE',
  SZ: 'SZ',
  SX: 'SX',
  SC: 'SC',
  SY: 'SY',
  TC: 'TC',
  TD: 'TD',
  TG: 'TG',
  TH: 'TH',
  TJ: 'TJ',
  TK: 'TK',
  TM: 'TM',
  TL: 'TL',
  TO: 'TO',
  TT: 'TT',
  TN: 'TN',
  TR: 'TR',
  TV: 'TV',
  TW: 'TW',
  TZ: 'TZ',
  UG: 'UG',
  UA: 'UA',
  UM: 'UM',
  UY: 'UY',
  US: 'US',
  UZ: 'UZ',
  VA: 'VA',
  VC: 'VC',
  VE: 'VE',
  VG: 'VG',
  VI: 'VI',
  VN: 'VN',
  VU: 'VU',
  WF: 'WF',
  WS: 'WS',
  YE: 'YE',
  ZA: 'ZA',
  ZM: 'ZM',
  ZW: 'ZW',
  XK: 'XK',
} as const;

export interface BeneficiaryAddressRequestRequest {
  /**
   * @minLength 1
   * @maxLength 250
   */
  addressLine1: string;
  /**
   * @maxLength 250
   * @nullable
   */
  addressLine2?: string | null;
  /**
   * @minLength 1
   * @maxLength 250
   */
  city: string;
  country: HomeAddressCountryEnum;
  /**
   * @minLength 1
   * @maxLength 20
   */
  postcode: string;
  /**
   * @maxLength 150
   * @nullable
   */
  state?: string | null;
}

export interface BeneficiaryAddressResponse {
  addressLine1: string;
  /** @nullable */
  addressLine2: string | null;
  city: string;
  country: string;
  postcode: string;
  /** @nullable */
  state: string | null;
}

/**
 * * `SPOUSE` - Spouse / Partner
 * * `CHILD` - Child
 * * `FRIEND` - Friend
 * * `OTHER` - Other
 */
export type RelationshipEnum =
  (typeof RelationshipEnum)[keyof typeof RelationshipEnum];

export const RelationshipEnum = {
  SPOUSE: 'SPOUSE',
  CHILD: 'CHILD',
  FRIEND: 'FRIEND',
  OTHER: 'OTHER',
} as const;

/**
 * * `FEMALE` - Female
 * * `MALE` - Male
 * * `NOT_SPECIFIED` - Not Specified
 */
export type LegalSexEnum = (typeof LegalSexEnum)[keyof typeof LegalSexEnum];

export const LegalSexEnum = {
  FEMALE: 'FEMALE',
  MALE: 'MALE',
  NOT_SPECIFIED: 'NOT_SPECIFIED',
} as const;

/**
 * * `SINGLE` - Single
 * * `MARRIED` - Married
 * * `DIVORCED` - Divorced
 * * `SEPARATED` - Separated
 * * `WIDOWED` - Widowed
 */
export type MaritalStatusEnum =
  (typeof MaritalStatusEnum)[keyof typeof MaritalStatusEnum];

export const MaritalStatusEnum = {
  SINGLE: 'SINGLE',
  MARRIED: 'MARRIED',
  DIVORCED: 'DIVORCED',
  SEPARATED: 'SEPARATED',
  WIDOWED: 'WIDOWED',
} as const;

export interface BeneficiaryPersonRequestRequest {
  /** @nullable */
  linkedContact?: number | null;
  /**
   * @minLength 1
   * @maxLength 250
   */
  firstName?: string;
  /**
   * @minLength 1
   * @maxLength 250
   */
  lastName?: string;
  relationship?: RelationshipEnum;
  /**
   * @minLength 1
   * @maxLength 20
   * @nullable
   */
  relationshipOther?: string | null;
  legalSex?: LegalSexEnum;
  /** @nullable */
  dob?: string | null;
  addressSameAsHomeAddress?: boolean;
  address?: BeneficiaryAddressRequestRequest | null;
  /** @nullable */
  fullTimeEducation?: boolean | null;
  /** @nullable */
  educationEndDate?: string | null;
  /** @nullable */
  financiallyDependent?: boolean | null;
  maritalStatus?: MaritalStatusEnum | null;
  /**
   * @minLength 1
   * @maxLength 200
   * @nullable
   */
  ssn?: string | null;
  nationality?: HomeAddressCountryEnum | null;
}

export interface BeneficiaryPersonResponse {
  linkedContact: number;
  firstName: string;
  lastName: string;
  relationship: string;
  /** @nullable */
  relationshipOther: string | null;
  legalSex: string;
  /** @nullable */
  dob: string | null;
  addressSameAsHomeAddress: boolean;
  address: BeneficiaryAddressResponse | null;
}

/**
 * * `PERSON` - Person
 */
export type BeneficiaryRequestTypeEnum =
  (typeof BeneficiaryRequestTypeEnum)[keyof typeof BeneficiaryRequestTypeEnum];

export const BeneficiaryRequestTypeEnum = {
  PERSON: 'PERSON',
} as const;

export interface BeneficiaryRequestRequest {
  type?: BeneficiaryRequestTypeEnum;
  person: BeneficiaryPersonRequestRequest;
}

export interface BeneficiaryResponse {
  id: string;
  type: string;
  isArchived: boolean;
  person: BeneficiaryPersonResponse;
}

export interface BenefitDeductionResponse {
  benefitId: number;
  benefitName?: string;
  /** Get amount, converted to cycle pricing if enabled. */
  readonly amount: string;
  currency: string;
}

export interface BenefitAllowanceDetailResponse {
  id: number;
  name: string;
  /**
   * Get amount after deductions, calculated from converted amount
   * and deductions if cycle pricing is enabled.
   */
  readonly amountAfterDeductions: string;
  interval: string;
  /** Get amount, converted to cycle pricing if enabled. */
  readonly amount: string;
  currency: string;
  rolloverMessage?: string;
  benefitDeductions: BenefitDeductionResponse[];
  /**
   * Get next renewal date, set to null if cycle pricing is enabled
   * and payroll period is not monthly.
   * @nullable
   */
  readonly nextRenewalDate: string | null;
  hasSelectionFormConfig: boolean;
}

export interface BenefitAllowancesResponse {
  /**
   * Get total amount after deductions, calculated from converted allowance amounts
   * if cycle pricing is enabled.
   */
  readonly totalAmountAfterDeductions: string;
  currency: string;
  emptyAllowancesMessage?: string;
  totalAllowancesCount: number;
  allowances: BenefitAllowanceDetailResponse[];
}

export interface BenefitBroker {
  readonly id: number;
  /** @maxLength 50 */
  name: string;
}

export interface BenefitBrokerResponse {
  readonly id: number;
  /** @maxLength 50 */
  name: string;
}

/**
 * Serializer for the BenefitCategory model
 */
export interface BenefitCategory {
  readonly id: number;
  /** @maxLength 200 */
  name: string;
  /**
   * @minimum -2147483648
   * @maximum 2147483647
   */
  rank?: number;
  /** @maxLength 100 */
  icon?: string;
}

/**
 * Serializer for a list of benefit categories
 */
export interface BenefitCategoryListResponse {
  totalItemCount: number;
  countMissingIcon: number;
  readonly benefitCategories: string;
}

/**
 * Serializer for the BenefitCategory model
 */
export interface BenefitCategoryRequest {
  /**
   * @minLength 1
   * @maxLength 200
   */
  name: string;
  /**
   * @minimum -2147483648
   * @maximum 2147483647
   */
  rank?: number;
  /** @maxLength 100 */
  icon?: string;
}

export interface RunEntityRef {
  id: number;
  name: string;
}

export interface RunGroupRef {
  id: string;
  name: string;
}

export interface RunActor {
  id: number;
  email: string;
}

/**
 * * `CHANGE_NOT_PENDING` - CHANGE_NOT_PENDING
 * * `CHANGE_NOT_RUN_LINKED` - CHANGE_NOT_RUN_LINKED
 * * `RUN_NOT_ACTIVE` - RUN_NOT_ACTIVE
 * * `RUN_MISSING_WORKFLOW` - RUN_MISSING_WORKFLOW
 */
export type DecidableReasonEnum =
  (typeof DecidableReasonEnum)[keyof typeof DecidableReasonEnum];

export const DecidableReasonEnum = {
  CHANGE_NOT_PENDING: 'CHANGE_NOT_PENDING',
  CHANGE_NOT_RUN_LINKED: 'CHANGE_NOT_RUN_LINKED',
  RUN_NOT_ACTIVE: 'RUN_NOT_ACTIVE',
  RUN_MISSING_WORKFLOW: 'RUN_MISSING_WORKFLOW',
} as const;

/**
 * List row for a configuration change. No payload — too large.
 */
export interface BenefitConfigurationChange {
  id: string;
  domain: string;
  status: string;
  summary: string;
  source: string;
  createdTimestamp: string;
  /** @nullable */
  appliedAt: string | null;
  /** @nullable */
  rejectedAt: string | null;
  createdByIdentifier: string;
  appliedByIdentifier: string;
  employer: number;
  benefit: RunEntityRef | null;
  /** @nullable */
  benefitConfigurationRun: number | null;
  requirementGroup: RunGroupRef | null;
  programme: RunEntityRef | null;
  createdBy: RunActor | null;
  appliedBy: RunActor | null;
  decidable: boolean;
  decidableReason: DecidableReasonEnum | null;
}

export interface RevisionStatus {
  /** @nullable */
  currentRevision: string | null;
  /** @nullable */
  isStale: boolean | null;
  /** @nullable */
  reason: string | null;
}

export interface LinkedRequirement {
  id: string;
  name: string;
  groupId: string;
  groupName: string;
  /** @nullable */
  groupDomain: string | null;
  contentHashAtGeneration: string;
  isCurrent: boolean;
}

/**
 * One leaf-level before/after, for a "what is changing" summary.
 */
export interface FieldChange {
  path: string;
  before: unknown;
  after: unknown;
}

/**
 * Change detail. ``diff`` is deliberately absent — it is on its way out.
 */
export interface BenefitConfigurationChangeDetail {
  id: string;
  domain: string;
  status: string;
  summary: string;
  source: string;
  createdTimestamp: string;
  /** @nullable */
  appliedAt: string | null;
  /** @nullable */
  rejectedAt: string | null;
  createdByIdentifier: string;
  appliedByIdentifier: string;
  employer: number;
  benefit: RunEntityRef | null;
  /** @nullable */
  benefitConfigurationRun: number | null;
  requirementGroup: RunGroupRef | null;
  programme: RunEntityRef | null;
  createdBy: RunActor | null;
  appliedBy: RunActor | null;
  decidable: boolean;
  decidableReason: DecidableReasonEnum | null;
  changeReason: string;
  payload: unknown;
  appliedResult: unknown | null;
  payloadHash: string;
  baseRevision: string;
  resultingRevision: string;
  dependencyRevisions: unknown;
  revisionStatus: RevisionStatus;
  requirements: LinkedRequirement[];
  fieldChanges: FieldChange[];
  fieldChangesTruncated: boolean;
}

/**
 * The envelope ``get_paginated_response`` wraps every list in.
 */
export interface BenefitConfigurationChangePage {
  count: number;
  /** @nullable */
  next: number | null;
  /** @nullable */
  previous: number | null;
  results: BenefitConfigurationChange[];
}

/**
 * * `CREATE` - Create
 * * `UPDATE` - Update
 */
export type OperationEnum = (typeof OperationEnum)[keyof typeof OperationEnum];

export const OperationEnum = {
  CREATE: 'CREATE',
  UPDATE: 'UPDATE',
} as const;

/**
 * Request body for starting a run.
 *
 * ``programme`` is required: the API does not resolve candidate programmes,
 * so the admin's picking logic is not duplicated. ``auto_approve`` only means
 * anything for CREATE — it pre-populates the workflow's decisions so the run
 * completes without a human approve step.
 */
export interface BenefitConfigurationRunCreateRequest {
  requirementGroup: string;
  operation: OperationEnum;
  programme: number;
  autoApprove?: boolean;
}

export interface BenefitContributions {
  currency: string;
  enrolledBenefitsCount: number;
  benefitsTotalCount: number;
  /**
   * @nullable
   * @pattern ^-?\d{0,8}(?:\.\d{0,2})?$
   */
  allowancesContribution: string | null;
  /**
   * @nullable
   * @pattern ^-?\d{0,8}(?:\.\d{0,2})?$
   */
  salaryContribution: string | null;
  /**
   * @nullable
   * @pattern ^-?\d{0,8}(?:\.\d{0,2})?$
   */
  yearlyContribution: string | null;
}

export interface BenefitContributionsFeaturedBlockData {
  currency: string;
  /**
   * @nullable
   * @pattern ^-?\d{0,10}(?:\.\d{0,2})?$
   */
  totalPerYear: string | null;
  /**
   * @nullable
   * @pattern ^-?\d{0,10}(?:\.\d{0,2})?$
   */
  viaAllowances: string | null;
  /**
   * @nullable
   * @pattern ^-?\d{0,10}(?:\.\d{0,2})?$
   */
  viaSalary: string | null;
}

/**
 * * `NEVER` - Never
 * * `FIRST_OF_NEXT_WEEK` - First of Next Week
 * * `FIRST_OF_NEXT_MONTH` - First of Next Month
 * * `LAST_OF_NEXT_MONTH` - Last of Next Month
 * * `LAST_OF_CURRENT_MONTH` - Last of Current Month
 * * `FIRST_OF_NEXT_QUARTER` - First of Next Quarter
 * * `IN_X_DAYS_TIME` - In X Days Time
 * * `ON_THE_SAME_DAY` - On the Same Day
 * * `FIRST_OF_CURRENT_MONTH` - First of Current Month
 * * `FIRST_OF_MONTH_AFTER_NEXT_MONTH` - First of Month after Next Month
 * * `FIRST_OF_THIRD_MONTH_AFTER_EMPLOYMENT_START` - First of Third Month after employment start
 * * `FIRST_OF_NEXT_CYCLE` - First of Next Cycle
 * * `LAST_OF_CURRENT_CYCLE` - Last of Current Cycle
 * * `FIRST_OF_LAST_CYCLE_BEFORE_END_OF_MONTH` - First of Last Cycle before End of Month
 * * `LAST_OF_SECOND_LAST_CYCLE_BEFORE_END_OF_MONTH` - Last of Second Last Cycle before End of Month
 * * `EMPLOYMENT_START` - Employment Start
 */
export type BenefitDelayTypeEnum =
  (typeof BenefitDelayTypeEnum)[keyof typeof BenefitDelayTypeEnum];

export const BenefitDelayTypeEnum = {
  NEVER: 'NEVER',
  FIRST_OF_NEXT_WEEK: 'FIRST_OF_NEXT_WEEK',
  FIRST_OF_NEXT_MONTH: 'FIRST_OF_NEXT_MONTH',
  LAST_OF_NEXT_MONTH: 'LAST_OF_NEXT_MONTH',
  LAST_OF_CURRENT_MONTH: 'LAST_OF_CURRENT_MONTH',
  FIRST_OF_NEXT_QUARTER: 'FIRST_OF_NEXT_QUARTER',
  IN_X_DAYS_TIME: 'IN_X_DAYS_TIME',
  ON_THE_SAME_DAY: 'ON_THE_SAME_DAY',
  FIRST_OF_CURRENT_MONTH: 'FIRST_OF_CURRENT_MONTH',
  FIRST_OF_MONTH_AFTER_NEXT_MONTH: 'FIRST_OF_MONTH_AFTER_NEXT_MONTH',
  FIRST_OF_THIRD_MONTH_AFTER_EMPLOYMENT_START:
    'FIRST_OF_THIRD_MONTH_AFTER_EMPLOYMENT_START',
  FIRST_OF_NEXT_CYCLE: 'FIRST_OF_NEXT_CYCLE',
  LAST_OF_CURRENT_CYCLE: 'LAST_OF_CURRENT_CYCLE',
  FIRST_OF_LAST_CYCLE_BEFORE_END_OF_MONTH:
    'FIRST_OF_LAST_CYCLE_BEFORE_END_OF_MONTH',
  LAST_OF_SECOND_LAST_CYCLE_BEFORE_END_OF_MONTH:
    'LAST_OF_SECOND_LAST_CYCLE_BEFORE_END_OF_MONTH',
  EMPLOYMENT_START: 'EMPLOYMENT_START',
} as const;

export interface BenefitDelay {
  readonly id: number;
  type?: BenefitDelayTypeEnum;
  /**
   * @minimum -2147483648
   * @maximum 2147483647
   * @nullable
   */
  days?: number | null;
  readonly name: string;
}

export interface BenefitDisplayStatus {
  type: string;
  text: string;
}

export interface BenefitDocument {
  readonly id: number;
  readonly document: string;
  readonly createdTimestamp: string;
  /** @maxLength 200 */
  name: string;
  /**
   * @maxLength 200
   * @nullable
   */
  nameEn?: string | null;
  /**
   * @maxLength 200
   * @nullable
   */
  nameDe?: string | null;
  /**
   * @maxLength 200
   * @nullable
   */
  nameFr?: string | null;
  /**
   * @maxLength 200
   * @nullable
   */
  nameEs?: string | null;
  /**
   * @maxLength 200
   * @nullable
   */
  nameEsXl?: string | null;
  /**
   * @maxLength 200
   * @nullable
   */
  nameEnUs?: string | null;
  /**
   * @maxLength 200
   * @nullable
   */
  nameSk?: string | null;
  /**
   * @maxLength 200
   * @nullable
   */
  nameEl?: string | null;
  /**
   * @maxLength 200
   * @nullable
   */
  nameCs?: string | null;
  /**
   * @maxLength 200
   * @nullable
   */
  nameIt?: string | null;
  /**
   * @maxLength 200
   * @nullable
   */
  nameJa?: string | null;
  /**
   * @maxLength 200
   * @nullable
   */
  nameKo?: string | null;
  /**
   * @maxLength 200
   * @nullable
   */
  nameMs?: string | null;
  /**
   * @maxLength 200
   * @nullable
   */
  namePl?: string | null;
  /**
   * @maxLength 200
   * @nullable
   */
  nameTr?: string | null;
  /**
   * @maxLength 200
   * @nullable
   */
  namePt?: string | null;
  /**
   * @maxLength 200
   * @nullable
   */
  nameHu?: string | null;
  /**
   * @maxLength 200
   * @nullable
   */
  nameIo?: string | null;
  /**
   * @maxLength 200
   * @nullable
   */
  nameVi?: string | null;
  /**
   * @maxLength 200
   * @nullable
   */
  nameZh?: string | null;
  description?: string;
  /** @nullable */
  descriptionEn?: string | null;
  /** @nullable */
  descriptionDe?: string | null;
  /** @nullable */
  descriptionFr?: string | null;
  /** @nullable */
  descriptionEs?: string | null;
  /** @nullable */
  descriptionEsXl?: string | null;
  /** @nullable */
  descriptionEnUs?: string | null;
  /** @nullable */
  descriptionSk?: string | null;
  /** @nullable */
  descriptionEl?: string | null;
  /** @nullable */
  descriptionCs?: string | null;
  /** @nullable */
  descriptionIt?: string | null;
  /** @nullable */
  descriptionJa?: string | null;
  /** @nullable */
  descriptionKo?: string | null;
  /** @nullable */
  descriptionMs?: string | null;
  /** @nullable */
  descriptionPl?: string | null;
  /** @nullable */
  descriptionTr?: string | null;
  /** @nullable */
  descriptionPt?: string | null;
  /** @nullable */
  descriptionHu?: string | null;
  /** @nullable */
  descriptionIo?: string | null;
  /** @nullable */
  descriptionVi?: string | null;
  /** @nullable */
  descriptionZh?: string | null;
  isPolicyDocument?: boolean;
  readonly uuid: string;
  file: string;
  /** @nullable */
  benefit?: number | null;
  /** @nullable */
  employer?: number | null;
}

export interface BenefitDocumentCreateRequest {
  readonly id: number;
  /** @maxLength 200 */
  name: string;
  description?: string;
  file: string;
  isPolicyDocument?: boolean;
}

export interface BenefitDocumentCreateRequestRequest {
  /**
   * @minLength 1
   * @maxLength 200
   */
  name: string;
  description?: string;
  file: Blob;
  isPolicyDocument?: boolean;
}

export interface BenefitDocumentRequest {
  /**
   * @minLength 1
   * @maxLength 200
   */
  name: string;
  /**
   * @maxLength 200
   * @nullable
   */
  nameEn?: string | null;
  /**
   * @maxLength 200
   * @nullable
   */
  nameDe?: string | null;
  /**
   * @maxLength 200
   * @nullable
   */
  nameFr?: string | null;
  /**
   * @maxLength 200
   * @nullable
   */
  nameEs?: string | null;
  /**
   * @maxLength 200
   * @nullable
   */
  nameEsXl?: string | null;
  /**
   * @maxLength 200
   * @nullable
   */
  nameEnUs?: string | null;
  /**
   * @maxLength 200
   * @nullable
   */
  nameSk?: string | null;
  /**
   * @maxLength 200
   * @nullable
   */
  nameEl?: string | null;
  /**
   * @maxLength 200
   * @nullable
   */
  nameCs?: string | null;
  /**
   * @maxLength 200
   * @nullable
   */
  nameIt?: string | null;
  /**
   * @maxLength 200
   * @nullable
   */
  nameJa?: string | null;
  /**
   * @maxLength 200
   * @nullable
   */
  nameKo?: string | null;
  /**
   * @maxLength 200
   * @nullable
   */
  nameMs?: string | null;
  /**
   * @maxLength 200
   * @nullable
   */
  namePl?: string | null;
  /**
   * @maxLength 200
   * @nullable
   */
  nameTr?: string | null;
  /**
   * @maxLength 200
   * @nullable
   */
  namePt?: string | null;
  /**
   * @maxLength 200
   * @nullable
   */
  nameHu?: string | null;
  /**
   * @maxLength 200
   * @nullable
   */
  nameIo?: string | null;
  /**
   * @maxLength 200
   * @nullable
   */
  nameVi?: string | null;
  /**
   * @maxLength 200
   * @nullable
   */
  nameZh?: string | null;
  description?: string;
  /** @nullable */
  descriptionEn?: string | null;
  /** @nullable */
  descriptionDe?: string | null;
  /** @nullable */
  descriptionFr?: string | null;
  /** @nullable */
  descriptionEs?: string | null;
  /** @nullable */
  descriptionEsXl?: string | null;
  /** @nullable */
  descriptionEnUs?: string | null;
  /** @nullable */
  descriptionSk?: string | null;
  /** @nullable */
  descriptionEl?: string | null;
  /** @nullable */
  descriptionCs?: string | null;
  /** @nullable */
  descriptionIt?: string | null;
  /** @nullable */
  descriptionJa?: string | null;
  /** @nullable */
  descriptionKo?: string | null;
  /** @nullable */
  descriptionMs?: string | null;
  /** @nullable */
  descriptionPl?: string | null;
  /** @nullable */
  descriptionTr?: string | null;
  /** @nullable */
  descriptionPt?: string | null;
  /** @nullable */
  descriptionHu?: string | null;
  /** @nullable */
  descriptionIo?: string | null;
  /** @nullable */
  descriptionVi?: string | null;
  /** @nullable */
  descriptionZh?: string | null;
  isPolicyDocument?: boolean;
  file: Blob;
  /** @nullable */
  benefit?: number | null;
  /** @nullable */
  employer?: number | null;
}

export interface BenefitDocumentUpdateRequest {
  readonly id: number;
  /** @maxLength 200 */
  name: string;
  description?: string;
  isPolicyDocument?: boolean;
}

/**
 * * `DRAFT` - Draft
 * * `AWAITING_FULFILLMENT` - Awaiting Fulfillment
 * * `SENT_TO_SUPPLIER` - Sent to Supplier
 * * `SUPPLIER_CONFIRMED` - Supplier Confirmed
 * * `FULFILLED` - Fulfilled
 * * `BLOCKED` - Blocked
 */
export type FulfillmentStatusEnum =
  (typeof FulfillmentStatusEnum)[keyof typeof FulfillmentStatusEnum];

export const FulfillmentStatusEnum = {
  DRAFT: 'DRAFT',
  AWAITING_FULFILLMENT: 'AWAITING_FULFILLMENT',
  SENT_TO_SUPPLIER: 'SENT_TO_SUPPLIER',
  SUPPLIER_CONFIRMED: 'SUPPLIER_CONFIRMED',
  FULFILLED: 'FULFILLED',
  BLOCKED: 'BLOCKED',
} as const;

export interface BenefitEnrolmentDisplayStatus {
  type: string;
  text: string;
}

/**
 * One enrolment-scoped window, whether a row exists for it or not.
 *
 * A plain ``Serializer`` because a derived interval is a ``DerivedWindow``, not
 * a row, and a ``ModelSerializer`` cannot read one.
 *
 * Nothing in the payload says which is which. A reader wants the interval and
 * whether it is open; provenance is ours to know rather than theirs to branch
 * on, and every action offered against a window works either way — the write
 * path creates a row when none exists.
 *
 * The row-only columns a derived interval cannot fill are simply absent from
 * this shape rather than emitted as nulls. ``target_type`` and ``target_id``
 * are gone for a stronger reason: this payload carries enrolment-scoped
 * windows only, so both were always null in it.
 */
export interface EnrolmentWindowResponse {
  /**
   * None for a derived interval, which has no row to identify.
   * @nullable
   */
  readonly id: number | null;
  /** @nullable */
  readonly enrolment: number | null;
  windowType: string;
  /**
   * The sub type, wherever this instance keeps it.
   *
   * A stored row reaches it through its config; a derived interval carries it
   * directly, having been built from that config.
   * @nullable
   */
  readonly windowSubType: string | null;
  startTimestamp: string;
  endTimestamp: string;
  /** @nullable */
  readonly timezone: string | null;
  readonly isOpen: boolean;
}

export interface BenefitEnrollment {
  readonly name: string;
  readonly benefitId: number;
  readonly id: number;
  readonly status: Status00aEnum;
  readonly fulfillmentStatus: FulfillmentStatusEnum;
  readonly displayStatus: BenefitEnrolmentDisplayStatus;
  /** @nullable */
  readonly price: string | null;
  /** @nullable */
  readonly employeeMonthlyPrice: string | null;
  /** @nullable */
  readonly employerMonthlyPrice: string | null;
  /** @nullable */
  readonly employeeCyclePrice: string | null;
  /** @nullable */
  readonly employerCyclePrice: string | null;
  /** @nullable */
  readonly priceCurrency: string | null;
  readonly imageUrl: string;
  readonly imageAltText: string;
  readonly shortDescription: string;
  readonly enrolmentWindows: readonly EnrolmentWindowResponse[];
  readonly showPrice: boolean;
  readonly enrolmentType: string;
  readonly lockedEnrolment: boolean;
  readonly isSelected: boolean;
  readonly isFavorite: boolean;
  readonly optInCopy: string;
  readonly optOutCopy: string;
  /** @nullable */
  readonly payDeductionType: string | null;
}

export interface MinimalAreaOfInterest {
  readonly id: number;
  readonly name: string;
  readonly icon: string;
}

export interface BenefitEnrollmentSerializerWithInterests {
  readonly id: number;
  readonly benefitId: number;
  readonly name: string;
  readonly shortDescription: string;
  readonly displayStatus: BenefitEnrolmentDisplayStatus;
  readonly imageUrl: string;
  readonly imageAltText: string;
  readonly isFavorite: boolean;
  readonly benefitTags: readonly BenefitTag[];
  readonly areasOfInterest: readonly MinimalAreaOfInterest[];
}

/**
 * * `GROSS` - Gross
 * * `NET` - Net
 */
export type PayDeductionTypeEnum =
  (typeof PayDeductionTypeEnum)[keyof typeof PayDeductionTypeEnum];

export const PayDeductionTypeEnum = {
  GROSS: 'GROSS',
  NET: 'NET',
} as const;

export interface BenefitEnrollmentUpdate {
  isFavorite?: boolean;
  payDeductionType?: PayDeductionTypeEnum;
}

export interface BenefitEnrolmentContributionSourceRequestRequest {
  /** @nullable */
  allowance?: number | null;
  /** @pattern ^-?\d{0,13}(?:\.\d{0,2})?$ */
  amount: string;
}

/**
 * @nullable
 */
export type BenefitEnrolmentDetailResponseAdditionalInfo = {
  [key: string]: unknown;
} | null;

export type BenefitEnrolmentDetailResponseUserSelectionsItem = {
  [key: string]: unknown;
};

export type DocumentSigningRequestAdminSignersItem = { [key: string]: unknown };

export interface DocumentSigningRequestAdmin {
  id: number;
  version: number;
  status: string;
  documentType: string;
  readonly signers: readonly DocumentSigningRequestAdminSignersItem[];
  createdAt: string;
}

export interface BenefitEnrolmentDetailResponse {
  readonly id: number;
  employee: BenefitEnrolmentEmployee;
  /** @nullable */
  readonly payDeductionType: string | null;
  readonly benefit: string;
  readonly enrolmentWindows: readonly EnrolmentWindowResponse[];
  readonly contributionSources: string;
  /** @nullable */
  readonly additionalInfo: BenefitEnrolmentDetailResponseAdditionalInfo;
  readonly programme: string;
  readonly optInTimestamp: string;
  readonly displayStatus: string;
  readonly price: string;
  readonly userSelections: readonly BenefitEnrolmentDetailResponseUserSelectionsItem[];
  readonly additionalEnrolments: string;
  readonly estimatedBenefitStartDates: string;
  readonly approvalSteps: readonly ApprovalProcessStepResponse[];
  readonly actionWithOverridePermission: string;
  currentApprovalStep: ApprovalStep | null;
  readonly employerCanOptOut: boolean;
  readonly employerCanOptIn: boolean;
  readonly documentSigning: DocumentSigningRequestAdmin | null;
  /**
   * @nullable
   * @pattern ^-?\d{0,8}(?:\.\d{0,2})?$
   */
  employerMonthlyPrice?: string | null;
  /**
   * @nullable
   * @pattern ^-?\d{0,8}(?:\.\d{0,2})?$
   */
  employerYearlyPrice?: string | null;
  /**
   * @nullable
   * @pattern ^-?\d{0,8}(?:\.\d{0,2})?$
   */
  employeeMonthlyPrice?: string | null;
  /**
   * @nullable
   * @pattern ^-?\d{0,8}(?:\.\d{0,2})?$
   */
  employeeYearlyPrice?: string | null;
  enrolledTimestamp?: string;
  /**
   * Fallback key to match against for data ingestion. e.g. personal email
   * @maxLength 100
   */
  ingestionFallbackKey?: string;
  isActive?: boolean;
  readonly updatedTimestamp: string;
  status?: Status00aEnum;
  /** @nullable */
  statusUpdatedTimestamp?: string | null;
  fulfillmentStatus?: FulfillmentStatusEnum;
  /** @nullable */
  readonly pricePerMonthCurrency: string | null;
  /**
   * @nullable
   * @pattern ^-?\d{0,8}(?:\.\d{0,2})?$
   */
  pricePerMonth?: string | null;
  /** @nullable */
  readonly pricePerYearCurrency: string | null;
  /**
   * @nullable
   * @pattern ^-?\d{0,13}(?:\.\d{0,2})?$
   */
  pricePerYear?: string | null;
  priceIsEstimate?: boolean;
  /** @nullable */
  taxPerMonth?: number | null;
  /**
   * @maxLength 100
   * @nullable
   */
  policyNumber?: string | null;
  /**
   * @maxLength 100
   * @nullable
   */
  supplierUniqueKey?: string | null;
  /** @nullable */
  optOutTimestamp?: string | null;
  /**
   * @maxLength 150
   * @nullable
   */
  optOutReason?: string | null;
  /** @nullable */
  benefitStartDate?: string | null;
  /** @nullable */
  benefitFulfillmentDate?: string | null;
  /** @nullable */
  benefitEndDate?: string | null;
  /** @nullable */
  note?: string | null;
  sentToBroker?: boolean;
  /**
   * Amount to deduct during allowance renewal
   * @nullable
   * @pattern ^-?\d{0,8}(?:\.\d{0,2})?$
   */
  allowanceDeduction?: string | null;
  /**
   * Amount to deduct when salary is disbursed (happens outside Ben)
   * @nullable
   * @pattern ^-?\d{0,8}(?:\.\d{0,2})?$
   */
  salaryDeduction?: string | null;
  isEligible?: boolean;
  autoEnrolmentCancelled?: boolean;
  autoEnrolmentNotified?: boolean;
  /** @nullable */
  optInByAutoEnrollment?: boolean | null;
  /** @nullable */
  optInByAdmin?: boolean | null;
  isFavorite?: boolean;
  /** @nullable */
  lastAutoEnrolmentState?: boolean | null;
}

export interface BenefitNameAndPKResponse {
  name: string;
  pk: number;
}

export interface BenefitEnrolmentHistoryFilterResponse {
  names: BenefitNameAndPKResponse[];
  actionedBy: ActionedByResponse[];
}

export type BenefitEnrolmentResponseContributionSourcesItem = {
  [key: string]: string | number | null;
};

export type BenefitEnrolmentResponseAdditionalInfo = { [key: string]: unknown };

/**
 * @nullable
 */
export type BenefitEnrolmentResponseAutoEnrolmentBanner = {
  [key: string]: unknown;
} | null;

export interface ModularBenefitContactEnrolment {
  status?: Status00aEnum;
  firstName: string;
  lastName: string;
  contactType: string;
  /**
   * @maxLength 100
   * @nullable
   */
  policyNumber?: string | null;
  optInTimestamp: string;
  /** @nullable */
  benefitStartDate?: string | null;
  /** @nullable */
  benefitEndDate?: string | null;
  readonly displayStatus: string;
  readonly optInByAdmin: boolean;
}

export interface BenefitEnrolmentResponse {
  readonly id: number;
  isActive?: boolean;
  readonly isAvailable: boolean;
  status?: Status00aEnum;
  readonly updatedTimestamp: string;
  /**
   * @maxLength 100
   * @nullable
   */
  policyNumber?: string | null;
  /**
   * Return true if there is no config window or any of the config windows is
   * open. Return false otherwise.
   */
  readonly configWindowOpen: boolean;
  readonly lockedWindowOpen: boolean;
  readonly enrolmentWindows: readonly EnrolmentWindowResponse[];
  enrolmentType: string;
  readonly contributionSources: readonly BenefitEnrolmentResponseContributionSourcesItem[];
  priceIsEstimate?: boolean;
  readonly additionalInfo: BenefitEnrolmentResponseAdditionalInfo;
  /**
   * @maxLength 150
   * @nullable
   */
  optOutReason?: string | null;
  readonly displayStatus: string;
  fulfillmentStatus?: FulfillmentStatusEnum;
  readonly approvalSteps: readonly ApprovalProcessStepResponse[];
  /** @nullable */
  readonly generatedAllowance: number | null;
  /** @nullable */
  optInTimestamp?: string | null;
  /** @nullable */
  optOutTimestamp?: string | null;
  /** @nullable */
  benefitStartDate?: string | null;
  /** @nullable */
  benefitEndDate?: string | null;
  contactEnrolments: ModularBenefitContactEnrolment[];
  /**
   * @nullable
   * @pattern ^-?\d{0,8}(?:\.\d{0,2})?$
   */
  employeeMonthlyPrice?: string | null;
  /**
   * @nullable
   * @pattern ^-?\d{0,8}(?:\.\d{0,2})?$
   */
  employerMonthlyPrice?: string | null;
  readonly currency: string;
  autoEnrolmentCancelled?: boolean;
  /** @nullable */
  readonly autoEnrolmentBanner: BenefitEnrolmentResponseAutoEnrolmentBanner;
  readonly optInByAdmin: boolean;
  readonly optInByAutoEnrollment: boolean;
  /** @nullable */
  readonly discountCode: string | null;
  /** @nullable */
  readonly payDeductionType: string | null;
}

export interface BenefitFeature {
  title: string;
  icon: string;
}

export interface BenefitForDashboardResponse {
  readonly id: number;
  name: string;
  benefitId: number;
  benefitType: string;
  shortDescription: string;
  imageUrl: string;
  imageAltText: string;
  showPrice: string;
  status?: Status00aEnum;
  readonly displayStatus: string;
  /**
   * @nullable
   * @pattern ^-?\d{0,8}(?:\.\d{0,2})?$
   */
  employeeMonthlyPrice?: string | null;
  /**
   * @nullable
   * @pattern ^-?\d{0,8}(?:\.\d{0,2})?$
   */
  employerMonthlyPrice?: string | null;
  priceCurrency: string;
  readonly enrolmentWindows: readonly EnrolmentWindowResponse[];
  isFavorite?: boolean;
  /** @nullable */
  optInCopy: string | null;
  /** @nullable */
  optOutCopy: string | null;
  /** @nullable */
  optInCopyPreposition: string | null;
  /** @nullable */
  optOutCopyPreposition: string | null;
}

export interface BenefitHeroImage {
  readonly id: number;
  benefit?: number;
  image: string;
  /**
   * @maxLength 250
   * @nullable
   */
  imageAltText?: string | null;
}

export interface BenefitHeroImageRequest {
  benefit?: number;
  image: Blob;
  /**
   * @maxLength 250
   * @nullable
   */
  imageAltText?: string | null;
}

export interface BenefitImage {
  readonly id: number;
  benefit?: number;
  image: string;
  /**
   * @maxLength 250
   * @nullable
   */
  imageAltText?: string | null;
}

export interface BenefitImageRequest {
  benefit?: number;
  image: Blob;
  /**
   * @maxLength 250
   * @nullable
   */
  imageAltText?: string | null;
}

export interface BenefitLifeEventResponse {
  pk: number;
  name: string;
  /** @nullable */
  imageUrl: string | null;
  requiresLifeEventApproval: boolean;
  requiresLifeEventProof: boolean;
}

export interface BenefitListBlockItem {
  id: number;
  name: string;
  /** @nullable */
  shortDescription: string | null;
  /** @nullable */
  imageUrl: string | null;
  /** @nullable */
  heroImageUrl: string | null;
  displayStatus: BenefitDisplayStatus | null;
  isFavourite: boolean;
  features: BenefitFeature[];
}

export interface BenefitListBlockData {
  items: BenefitListBlockItem[];
  hasMore: boolean;
}

/**
 * * `BEN` - Ben
 * * `EMPLOYER` - Employer
 * * `THIRD_PARTY` - Third Party
 * * `MANAGING_ENTITY` - Managing Entity
 */
export type ManagerTypeEnum =
  (typeof ManagerTypeEnum)[keyof typeof ManagerTypeEnum];

export const ManagerTypeEnum = {
  BEN: 'BEN',
  EMPLOYER: 'EMPLOYER',
  THIRD_PARTY: 'THIRD_PARTY',
  MANAGING_ENTITY: 'MANAGING_ENTITY',
} as const;

export interface BenefitManager {
  readonly id: number;
  /** @maxLength 50 */
  name: string;
  managerType: ManagerTypeEnum;
}

export interface BenefitManagerRequest {
  /**
   * @minLength 1
   * @maxLength 50
   */
  name: string;
  managerType: ManagerTypeEnum;
}

/**
 * Serializer for a Benefit Manager.
 */
export interface BenefitManagerResponse {
  /** @maxLength 100 */
  id: string;
  /** @maxLength 100 */
  name: string;
}

export interface BenefitOptOutRequestRequest {
  benefit: number;
  employees: number[];
}

export type BenefitPaymentHistoryCorrectionResponseTotalEmployeeContribution = {
  [key: string]: string;
};

export type BenefitPaymentHistoryCorrectionResponseContributionSources = {
  [key: string]: { [key: string]: string };
};

/**
 * * `MONTHLY` - monthly
 * * `BI_WEEKLY` - bi-weekly
 * * `SEMI_MONTHLY` - semi-monthly
 * * `WEEKLY` - weekly
 * * `FOUR_WEEKLY` - four-weekly
 */
export type PayrollPeriodEnum =
  (typeof PayrollPeriodEnum)[keyof typeof PayrollPeriodEnum];

export const PayrollPeriodEnum = {
  MONTHLY: 'MONTHLY',
  BI_WEEKLY: 'BI_WEEKLY',
  SEMI_MONTHLY: 'SEMI_MONTHLY',
  WEEKLY: 'WEEKLY',
  FOUR_WEEKLY: 'FOUR_WEEKLY',
} as const;

/**
 * * `PENDING` - PENDING
 * * `PAID` - PAID
 * * `PENDING_APPROVAL` - PENDING_APPROVAL
 * * `APPROVED` - APPROVED
 */
export type PayrollPaymentHistoryStatusEnum =
  (typeof PayrollPaymentHistoryStatusEnum)[keyof typeof PayrollPaymentHistoryStatusEnum];

export const PayrollPaymentHistoryStatusEnum = {
  PENDING: 'PENDING',
  PAID: 'PAID',
  PENDING_APPROVAL: 'PENDING_APPROVAL',
  APPROVED: 'APPROVED',
} as const;

export interface BenefitPaymentHistoryCorrectionResponse {
  payrollCycleId: number;
  payrollCycleStartDate: string;
  payrollCycleEndDate: string;
  payrollPeriod: PayrollPeriodEnum;
  readonly paymentSource: string;
  status: PayrollPaymentHistoryStatusEnum;
  readonly totalEmployeeContribution: BenefitPaymentHistoryCorrectionResponseTotalEmployeeContribution;
  readonly contributionSources: BenefitPaymentHistoryCorrectionResponseContributionSources;
  paymentDate: string;
  /** @nullable */
  correctedPayrollStartDate: string | null;
  /** @nullable */
  correctedPayrollEndDate: string | null;
}

export type BenefitPaymentHistoryDetailResponseTotalEmployeeContribution = {
  [key: string]: string;
};

export type BenefitPaymentHistoryDetailResponseContributionSources = {
  [key: string]: { [key: string]: string };
};

export interface BenefitPaymentHistoryDetailResponse {
  payrollCycleId: number;
  payrollCycleStartDate: string;
  payrollCycleEndDate: string;
  payrollPeriod: PayrollPeriodEnum;
  readonly paymentSource: string;
  status: PayrollPaymentHistoryStatusEnum;
  readonly totalEmployeeContribution: BenefitPaymentHistoryDetailResponseTotalEmployeeContribution;
  readonly contributionSources: BenefitPaymentHistoryDetailResponseContributionSources;
}

/**
 * Serializer for the BenefitProduct model
 */
export interface BenefitProduct {
  readonly id: number;
  /** @maxLength 100 */
  name: string;
  description?: string;
}

export interface BenefitProductType {
  /** @maxLength 50 */
  name: string;
  id?: number;
  /** @nullable */
  description?: string | null;
}

export interface BenefitProductTypeRequest {
  /**
   * @minLength 1
   * @maxLength 50
   */
  name: string;
  id?: number;
  /** @nullable */
  description?: string | null;
}

export interface BenefitRequestCreateRequest {
  benefitId: number;
  benefitRequestConfigId?: number;
  requestData: unknown;
}

export interface BenefitRequestListResponse {
  benefitRequests: BenefitRequestGetResponse[];
  count: number;
  next: number;
  previous: number;
}

/**
 * * `GENDER` - Gender
 * * `DOB` - Date of birth
 * * `HOME_ADDRESS` - Home address
 * * `JOB_TITLE` - Job title
 * * `NATIONALITY` - Nationality
 * * `COUNTRY` - Country
 * * `MARITAL_STATUS` - Marital status
 * * `NI_NUMBER` - NI Number (SSN)
 * * `PHONE_NUMBER` - Phone Number
 * * `TITLE` - Title
 * * `RESIDENCY_TYPE` - Residency type
 * * `EMPLOYMENT_START` - Employment start date
 * * `YEARLY_GROSS_SALARY` - Yearly gross salary
 * * `WORKED_HOURS` - Worked hours
 * * `ENTITY` - Entity
 * * `COST_CENTRE` - Cost centre
 * * `EMPLOYEE_ID` - Employee ID
 * * `OFFICE_LOCATION` - Office location
 * * `DEPENDANT_SSN` - Dependant SSN
 * * `DEPENDANT_NATIONALITY` - Dependant Nationality
 */
export type BenefitRequirementsEnum =
  (typeof BenefitRequirementsEnum)[keyof typeof BenefitRequirementsEnum];

export const BenefitRequirementsEnum = {
  GENDER: 'GENDER',
  DOB: 'DOB',
  HOME_ADDRESS: 'HOME_ADDRESS',
  JOB_TITLE: 'JOB_TITLE',
  NATIONALITY: 'NATIONALITY',
  COUNTRY: 'COUNTRY',
  MARITAL_STATUS: 'MARITAL_STATUS',
  NI_NUMBER: 'NI_NUMBER',
  PHONE_NUMBER: 'PHONE_NUMBER',
  TITLE: 'TITLE',
  RESIDENCY_TYPE: 'RESIDENCY_TYPE',
  EMPLOYMENT_START: 'EMPLOYMENT_START',
  YEARLY_GROSS_SALARY: 'YEARLY_GROSS_SALARY',
  WORKED_HOURS: 'WORKED_HOURS',
  ENTITY: 'ENTITY',
  COST_CENTRE: 'COST_CENTRE',
  EMPLOYEE_ID: 'EMPLOYEE_ID',
  OFFICE_LOCATION: 'OFFICE_LOCATION',
  DEPENDANT_SSN: 'DEPENDANT_SSN',
  DEPENDANT_NATIONALITY: 'DEPENDANT_NATIONALITY',
} as const;

export interface BenefitSource {
  benefitId: number;
  title: string;
  /** @nullable */
  link: string | null;
  /** @nullable */
  imageUrl: string | null;
}

/**
 * Serializer for the BenefitType model
 */
export interface BenefitType {
  readonly id: number;
  readonly name: string;
  /** @maxLength 100 */
  description?: string;
  /** @nullable */
  readonly imageUrl: string | null;
  /** @nullable */
  readonly imageAltText: string | null;
}

/**
 * Serializer for a list of BenefitType objects
 */
export interface BenefitTypeListResponse {
  totalItemCount: number;
  benefitTypes: BenefitType[];
}

export interface BillingAddress {
  /** @nullable */
  addressLine1: string | null;
  /** @nullable */
  addressLine2: string | null;
  /** @nullable */
  city: string | null;
  /** @nullable */
  country: string | null;
  /** @nullable */
  postcode: string | null;
  /** @nullable */
  state: string | null;
}

/**
 * * `featured` - Featured
 * * `horizontal_list` - Horizontal list
 * * `vertical_list` - Vertical list
 * * `grid` - Grid
 */
export type BlockTypeEnum = (typeof BlockTypeEnum)[keyof typeof BlockTypeEnum];

export const BlockTypeEnum = {
  featured: 'featured',
  horizontal_list: 'horizontal_list',
  vertical_list: 'vertical_list',
  grid: 'grid',
} as const;

/**
 * * `core` - core
 * * `benefits` - benefits
 * * `equity` - equity
 * * `other` - other
 * * `espp` - espp
 * * `allowances` - allowances
 */
export type BreakdownCategoryCategoryEnum =
  (typeof BreakdownCategoryCategoryEnum)[keyof typeof BreakdownCategoryCategoryEnum];

export const BreakdownCategoryCategoryEnum = {
  core: 'core',
  benefits: 'benefits',
  equity: 'equity',
  other: 'other',
  espp: 'espp',
  allowances: 'allowances',
} as const;

/**
 * * `BENEFIT` - BENEFIT
 * * `ALLOWANCE` - ALLOWANCE
 */
export type ResourceTypeEnum =
  (typeof ResourceTypeEnum)[keyof typeof ResourceTypeEnum];

export const ResourceTypeEnum = {
  BENEFIT: 'BENEFIT',
  ALLOWANCE: 'ALLOWANCE',
} as const;

/**
 * * `accrued` - accrued
 * * `payrolled` - payrolled
 */
export type CostSourceEnum =
  (typeof CostSourceEnum)[keyof typeof CostSourceEnum];

export const CostSourceEnum = {
  accrued: 'accrued',
  payrolled: 'payrolled',
} as const;

export interface BreakdownItem {
  text: string;
  tooltipText?: string;
  /** @pattern ^-?\d{0,18}(?:\.\d{0,2})?$ */
  employerContribution: string;
  /** @pattern ^-?\d{0,18}(?:\.\d{0,2})?$ */
  employeeContribution: string;
  /** @pattern ^-?\d{0,18}(?:\.\d{0,2})?$ */
  total: string;
  resourceId?: number;
  resourceType?: ResourceTypeEnum;
  resourceExternalLinkUrl?: string;
  /**
   * @nullable
   * @pattern ^-?\d{0,3}(?:\.\d{0,2})?$
   */
  contributionPercentage?: string | null;
  /**
   * 'payrolled' when amounts come from ledger records; 'accrued' when modelled from subscriptions.
   *
   * * `accrued` - accrued
   * * `payrolled` - payrolled
   */
  costSource?: CostSourceEnum | null;
  readonly subItems: readonly BreakdownItem[];
}

export interface BreakdownCategory {
  category: BreakdownCategoryCategoryEnum;
  text: string;
  tooltipText?: string;
  icon: string;
  iconColor: string;
  /** @pattern ^-?\d{0,10}(?:\.\d{0,0})?$ */
  percentage: string;
  items: BreakdownItem[];
  /** @pattern ^-?\d{0,18}(?:\.\d{0,2})?$ */
  employerTotal: string;
  /** @pattern ^-?\d{0,18}(?:\.\d{0,2})?$ */
  employeeTotal: string;
  /** @pattern ^-?\d{0,18}(?:\.\d{0,2})?$ */
  categoryTotal: string;
}

export interface Breakdown {
  /** @pattern ^-?\d{0,18}(?:\.\d{0,2})?$ */
  total: string;
  /** @pattern ^-?\d{0,18}(?:\.\d{0,2})?$ */
  employerTotal: string;
  /** @pattern ^-?\d{0,18}(?:\.\d{0,2})?$ */
  employeeTotal: string;
  showPercentages: boolean;
  categories: BreakdownCategory[];
  totalTitle: string;
}

/**
 * * `hero` - Hero
 * * `composition_bar` - Composition bar
 * * `breakdown` - Itemised breakdown
 */
export type RewardStatementComponentTypeEnum =
  (typeof RewardStatementComponentTypeEnum)[keyof typeof RewardStatementComponentTypeEnum];

export const RewardStatementComponentTypeEnum = {
  hero: 'hero',
  composition_bar: 'composition_bar',
  breakdown: 'breakdown',
} as const;

export interface BreakdownLine {
  /** Unique within this statement. Use it to key a rendered list. */
  id: string;
  /** Where the amount came from. Diagnostic only — several lines share one when a declaration fans out over every benefit. */
  sourceKey: string;
  label: string;
  /** @pattern ^-?\d{0,18}(?:\.\d{0,2})?$ */
  amount: string;
  tooltip: string;
  /** @nullable */
  resourceUrl: string | null;
}

export interface BreakdownGroup {
  id: number;
  label: string;
  colour: string;
  tooltip: string;
  /** @pattern ^-?\d{0,18}(?:\.\d{0,2})?$ */
  amount: string;
  lines: BreakdownLine[];
}

export interface BreakdownTotal {
  key: string;
  label: string;
  /** @pattern ^-?\d{0,18}(?:\.\d{0,2})?$ */
  amount: string;
}

export interface BreakdownComponent {
  type: RewardStatementComponentTypeEnum;
  title: string;
  subtitle: string;
  amountColumnLabel: string;
  groups: BreakdownGroup[];
  totals: BreakdownTotal[];
}

/**
 * Serializer for a renewal of a managed card.
 */
export interface RenewalResponse {
  /** @pattern ^-?\d{0,8}(?:\.\d{0,2})?$ */
  amount: string;
  date: string;
}

/**
 * Serializer for the price of an enrollable benefit.
 */
export interface EnrollableBenefitCostResponse {
  id: number;
  name: string;
  /** @pattern ^-?\d{0,8}(?:\.\d{0,2})?$ */
  amount: string;
}

/**
 * Serializer for a breakdown of current month managed card spend.
 */
export interface BreakdownCurrentMonthResponse {
  /** @pattern ^-?\d{0,8}(?:\.\d{0,2})?$ */
  available: string;
  /** @pattern ^-?\d{0,8}(?:\.\d{0,2})?$ */
  rollover: string;
  /** @pattern ^-?\d{0,8}(?:\.\d{0,2})?$ */
  transactions: string;
  /** @pattern ^-?\d{0,8}(?:\.\d{0,2})?$ */
  topUp: string;
  renewal: RenewalResponse | null;
  /** @nullable */
  enrolledBenefits: EnrollableBenefitCostResponse[] | null;
}

/**
 * Serializer for a breakdown of committed spending next month.
 */
export interface BreakdownNextMonthResponse {
  /** @pattern ^-?\d{0,8}(?:\.\d{0,2})?$ */
  available: string;
  renewal: RenewalResponse | null;
  /** @nullable */
  enrolledBenefits: EnrollableBenefitCostResponse[] | null;
}

export interface BudgetTemplateResponse {
  readonly id: number;
  /** @maxLength 50 */
  name: string;
  description?: string;
  readonly createdTimestamp: string;
  cardConfig: ManagedCardConfigResponse;
}

/**
 * * `OPEN` - Open to everyone in the company
 * * `CLOSED` - Closed (Assigned members only)
 */
export type MembershipModeEnum =
  (typeof MembershipModeEnum)[keyof typeof MembershipModeEnum];

export const MembershipModeEnum = {
  OPEN: 'OPEN',
  CLOSED: 'CLOSED',
} as const;

export interface BudgetDetailResponse {
  readonly id: number;
  template: BudgetTemplateResponse;
  membershipMode: MembershipModeEnum;
  budgetOwner: MinimalEmployeeResponse;
  /**
   * @nullable
   * @pattern ^-?\d{0,13}(?:\.\d{0,2})?$
   */
  budgetAmount?: string | null;
  /** @nullable */
  readonly budgetAmountCurrency: string | null;
  /** @nullable */
  membersCount?: number | null;
  /** @maxLength 50 */
  iconName?: string;
  /** @pattern ^-?\d{0,8}(?:\.\d{0,2})?$ */
  allocatedAmount?: string;
  /** @pattern ^-?\d{0,8}(?:\.\d{0,2})?$ */
  totalAmount?: string;
  /** @nullable */
  readonly employerBudgetAmount: string | null;
  /** @nullable */
  readonly employerBudgetAmountCurrency: string | null;
  /** @nullable */
  readonly employerAllocatedAmount: string | null;
  /** @nullable */
  readonly employerAllocatedAmountCurrency: string | null;
  /** @nullable */
  readonly employerTotalAmount: string | null;
  /** @nullable */
  readonly employerTotalAmountCurrency: string | null;
}

export interface BudgetEmployeeResponse {
  readonly id: number;
  /** @maxLength 254 */
  email?: string;
  /** @maxLength 150 */
  firstName?: string;
  /** @maxLength 150 */
  lastName?: string;
  /**
   * @maxLength 255
   * @nullable
   */
  companyPosition?: string | null;
  /** @nullable */
  tagsList: unknown[] | null;
}

export interface BudgetMemberEmployee {
  readonly id: number;
  /** @maxLength 150 */
  firstName?: string;
  /** @maxLength 150 */
  lastName?: string;
  /** @maxLength 254 */
  email?: string;
  /** Designates whether this user should be treated as active. Unselect this instead of deleting accounts. */
  isActive?: boolean;
}

export interface BudgetMemberResponse {
  employee: BudgetMemberEmployee;
  isBudgetOwner: boolean;
  hasMissingReceipts: boolean;
  totalGiven: number;
  totalGivenCurrency: string;
  totalSpent: number;
  totalSpentCurrency: string;
  availableBalance: number;
  availableBalanceCurrency: string;
  employerTotalGiven: number;
  employerTotalGivenCurrency: string;
  employerTotalSpent: number;
  employerTotalSpentCurrency: string;
  employerAvailableBalance: number;
  employerAvailableBalanceCurrency: string;
}

export interface BudgetResponse {
  readonly id: number;
  template: BudgetTemplateResponse;
  membershipMode: MembershipModeEnum;
  budgetOwner: MinimalEmployeeResponse;
  /**
   * @nullable
   * @pattern ^-?\d{0,13}(?:\.\d{0,2})?$
   */
  budgetAmount?: string | null;
  /** @nullable */
  readonly budgetAmountCurrency: string | null;
  /** @nullable */
  membersCount?: number | null;
  /** @maxLength 50 */
  iconName?: string;
  /** @nullable */
  allocatedAmount?: string | null;
  /** @nullable */
  totalAmount?: string | null;
  /** @nullable */
  readonly employerBudgetAmount: string | null;
  /** @nullable */
  readonly employerBudgetAmountCurrency: string | null;
  /** @nullable */
  readonly employerAllocatedAmount: string | null;
  /** @nullable */
  readonly employerAllocatedAmountCurrency: string | null;
  /** @nullable */
  readonly employerTotalAmount: string | null;
  /** @nullable */
  readonly employerTotalAmountCurrency: string | null;
}

export interface BudgetTopupRequest {
  /** @maxLength 50 */
  name: string;
  /** @maxLength 200 */
  description?: string;
  /**
   * @maxLength 255
   * @nullable
   */
  imageUrl?: string | null;
  /**
   * @nullable
   * @pattern ^-?\d{0,13}(?:\.\d{0,2})?$
   */
  amount?: string | null;
  employees: number[];
  /** @nullable */
  deductAvailable?: boolean | null;
}

export interface BudgetTopupRequestRequest {
  /**
   * @minLength 1
   * @maxLength 50
   */
  name: string;
  /** @maxLength 200 */
  description?: string;
  /**
   * @maxLength 255
   * @nullable
   */
  imageUrl?: string | null;
  /**
   * @nullable
   * @pattern ^-?\d{0,13}(?:\.\d{0,2})?$
   */
  amount?: string | null;
  employees: number[];
  /** @nullable */
  deductAvailable?: boolean | null;
}

export interface BudgetsResponse {
  totalItemCount: number;
  budgets: BudgetResponse[];
}

/**
 * * `DRAFT` - Draft
 * * `SCHEDULED` - Scheduled
 * * `SENT` - Sent
 * * `FAILED` - Failed
 */
export type StatusDedEnum = (typeof StatusDedEnum)[keyof typeof StatusDedEnum];

export const StatusDedEnum = {
  DRAFT: 'DRAFT',
  SCHEDULED: 'SCHEDULED',
  SENT: 'SENT',
  FAILED: 'FAILED',
} as const;

export interface CampaignTemplateResponse {
  /** @nullable */
  readonly subject: string | null;
  /** @nullable */
  readonly title: string | null;
  /** @nullable */
  readonly message: string | null;
  /** @nullable */
  readonly messageFallback: string | null;
  /** @nullable */
  buttonText: string | null;
  /** @nullable */
  buttonUrl: string | null;
  readonly helpText: string;
  readonly signature: string;
  readonly removeFooter: boolean;
}

export interface CampaignDetailResponse {
  id: number;
  title: string;
  description: string;
  segmentQuery: unknown | null;
  status: StatusDedEnum;
  /** @nullable */
  scheduledAt: string | null;
  /** @nullable */
  sentAt: string | null;
  updatedAt: string;
  template: CampaignTemplateResponse | null;
}

export interface CampaignListItemResponse {
  id: number;
  title: string;
  updatedAt: string;
  author?: string;
  /** @nullable */
  scheduledAt: string | null;
  /** @nullable */
  sentAt: string | null;
  status: StatusDedEnum;
}

export interface CampaignTemplateRequestRequest {
  subject?: string;
  header?: string;
  message?: string;
  buttonText?: string;
  buttonUrl?: string;
  helpText?: string;
  signature?: string;
  removeFooter?: boolean;
}

export interface CardBalanceResponse {
  /** @pattern ^-?\d{0,13}(?:\.\d{0,2})?$ */
  amount: string;
  currency: string;
  readonly expiresAt: string;
  /** @nullable */
  readonly employerAmount: string | null;
  /** @nullable */
  readonly employerCurrency: string | null;
}

export interface CardTopUpRequest {
  readonly id: number;
  employees: number[];
  readonly createdTimestamp: string;
  /** @maxLength 50 */
  name: string;
  /**
   * @nullable
   * @pattern ^-?\d{0,13}(?:\.\d{0,2})?$
   */
  amount?: string | null;
  transferAt?: string;
  /** @nullable */
  expiresAt?: string | null;
  /** @maxLength 200 */
  description?: string;
  /**
   * @maxLength 255
   * @nullable
   */
  imageUrl?: string | null;
  /** @nullable */
  deductAvailable?: boolean | null;
}

/**
 * * `PENDING` - Pending
 * * `READY` - Ready
 * * `IN_PROGRESS` - In Progress
 * * `EXECUTED` - Executed
 */
export type CardTopUpResponseStatusEnum =
  (typeof CardTopUpResponseStatusEnum)[keyof typeof CardTopUpResponseStatusEnum];

export const CardTopUpResponseStatusEnum = {
  PENDING: 'PENDING',
  READY: 'READY',
  IN_PROGRESS: 'IN_PROGRESS',
  EXECUTED: 'EXECUTED',
} as const;

export interface CardTopUpResponse {
  readonly id: number;
  /** @nullable */
  readonly employerAmount: string | null;
  /** @nullable */
  readonly employerAmountCurrency: string | null;
  readonly createdTimestamp: string;
  /** @maxLength 50 */
  name: string;
  /** @nullable */
  readonly amountCurrency: string | null;
  /**
   * @nullable
   * @pattern ^-?\d{0,13}(?:\.\d{0,2})?$
   */
  amount?: string | null;
  transferAt?: string;
  /** @nullable */
  expiresAt?: string | null;
  /** @maxLength 200 */
  description?: string;
  /**
   * @maxLength 255
   * @nullable
   */
  imageUrl?: string | null;
  status?: CardTopUpResponseStatusEnum;
  /** @nullable */
  deductAvailable?: boolean | null;
  /** @nullable */
  createdBy?: number | null;
  /** @nullable */
  template?: number | null;
  /** @nullable */
  allowance?: number | null;
  employees?: number[];
}

/**
 * * `ACTIVE` - ACTIVE
 * * `INACTIVE` - INACTIVE
 */
export type CarouselStatusEnum =
  (typeof CarouselStatusEnum)[keyof typeof CarouselStatusEnum];

export const CarouselStatusEnum = {
  ACTIVE: 'ACTIVE',
  INACTIVE: 'INACTIVE',
} as const;

export interface CarouselSegment {
  readonly id: number;
  readonly name: string;
}

export interface Carousel {
  readonly id: number;
  title: string;
  description: string;
  /** @nullable */
  ctaLink?: string | null;
  /** @nullable */
  ctaText?: string | null;
  readonly imageUrl: string;
  imageAltText: string;
  status?: CarouselStatusEnum;
  audience?: AudienceEnum;
  readonly segments: readonly CarouselSegment[];
}

export interface CarouselRequest {
  /** @minLength 1 */
  title: string;
  /** @minLength 1 */
  description: string;
  /**
   * @minLength 1
   * @nullable
   */
  cta_link?: string | null;
  /**
   * @minLength 1
   * @nullable
   */
  cta_text?: string | null;
  /** @minLength 1 */
  image_alt_text: string;
  image?: Blob;
  status?: CarouselStatusEnum;
  audience?: AudienceEnum;
  segment_ids?: number[];
}

export interface ConfigurationBreakdownItem {
  label: string;
  tooltipText: string;
  isVisible: boolean;
  displayOrder: number;
}

export type CategoryItems = { [key: string]: ConfigurationBreakdownItem };

export interface Category {
  label: string;
  tooltipText?: string;
  icon: string;
  iconColor: string;
  isVisible: boolean;
  displayOrder: number;
  items: CategoryItems;
}

export interface Categories {
  core: Category;
  equity: Category;
  benefits: Category;
  other: Category;
}

/**
 * * `BENEFIT_TYPE_LIFESTYLE` - Lifestyle
 * * `BENEFIT_TYPE_FINANCE` - Finance
 * * `BENEFIT_TYPE_FAMILY` - Family
 * * `BENEFIT_TYPE_HEALTH_WELLBEING` - Health & Wellbeing
 * * `BENEFIT_TYPE_OTHER` - Other
 * * `UNASSIGNED` - UNASSIGNED
 */
export type Category379Enum =
  (typeof Category379Enum)[keyof typeof Category379Enum];

export const Category379Enum = {
  BENEFIT_TYPE_LIFESTYLE: 'BENEFIT_TYPE_LIFESTYLE',
  BENEFIT_TYPE_FINANCE: 'BENEFIT_TYPE_FINANCE',
  BENEFIT_TYPE_FAMILY: 'BENEFIT_TYPE_FAMILY',
  BENEFIT_TYPE_HEALTH_WELLBEING: 'BENEFIT_TYPE_HEALTH_WELLBEING',
  BENEFIT_TYPE_OTHER: 'BENEFIT_TYPE_OTHER',
  UNASSIGNED: 'UNASSIGNED',
} as const;

export interface ChangeRef {
  id: string;
  domain: string;
}

/**
 * * `SMS` - SMS
 */
export type ChannelEnum = (typeof ChannelEnum)[keyof typeof ChannelEnum];

export const ChannelEnum = {
  SMS: 'SMS',
} as const;

export interface ChartCategoryItem {
  label: string;
  color: string;
  striped: boolean;
  tooltipSuffix: string;
  hideInLegend: boolean;
}

export interface ChartLegendEntry {
  dataKey: string;
  striped: boolean;
}

export interface ChartMetaTotal {
  unitText: string;
  /** @pattern ^-?\d{0,9}(?:\.\d{0,6})?$ */
  unitCount: string;
  /** @pattern ^-?\d{0,8}(?:\.\d{0,6})?$ */
  value: string;
}

export interface ChartMeta {
  dataKey: string;
  label: string;
  color: string;
  striped?: boolean;
  /** @nullable */
  tooltipSuffix?: string | null;
  /** @nullable */
  tooltipText?: string | null;
  hideInLegend?: boolean;
  total: ChartMetaTotal | null;
}

export interface ChartPeriod {
  label: string;
  startDate: string;
  endDate: string;
  isProjected: boolean;
  isCurrent: boolean;
}

export interface ChartYearPoint {
  year: string;
  /** @pattern ^-?\d{0,18}(?:\.\d{0,2})?$ */
  rsuGranted?: string;
  /** @pattern ^-?\d{0,18}(?:\.\d{0,2})?$ */
  rsuProjected?: string;
  /** @pattern ^-?\d{0,18}(?:\.\d{0,2})?$ */
  psuGranted?: string;
  /** @pattern ^-?\d{0,18}(?:\.\d{0,2})?$ */
  psuProjected?: string;
  /** @pattern ^-?\d{0,18}(?:\.\d{0,2})?$ */
  estimatedTaxes?: string;
}

/**
 * A group's requirements by status. ``total`` is every current one, so an
 * answered count is ``total - out_of_scope`` rather than a sixth field.
 */
export interface StatusCounts {
  total: number;
  dirty: number;
  proposed: number;
  clean: number;
  outOfScope: number;
}

export interface ChildGroupSummary {
  id: string;
  name: string;
  /** @nullable */
  domain: string | null;
  statusCounts: StatusCounts;
}

export interface ClaimSigningStepResponse {
  embedSrc: string;
  token: string;
}

/**
 * * `turn_in_progress` - turn_in_progress
 * * `conversation_closed` - conversation_closed
 */
export type CodeEnum = (typeof CodeEnum)[keyof typeof CodeEnum];

export const CodeEnum = {
  turn_in_progress: 'turn_in_progress',
  conversation_closed: 'conversation_closed',
} as const;

export interface CommonChartCategory {
  salary: ChartCategoryItem;
  bonus: ChartCategoryItem;
  commission: ChartCategoryItem;
  other: ChartCategoryItem;
  vestedequity: ChartCategoryItem;
  unvestedequity: ChartCategoryItem;
}

/**
 * Serializer for communication channels configuration of a recognition.
 * Used for both sent_via (responses) and send_via (requests).
 */
export interface CommunicationChannels {
  slack?: boolean;
  msTeams?: boolean;
  publicWall?: boolean;
}

/**
 * Serializer for communication channels configuration of a recognition.
 * Used for both sent_via (responses) and send_via (requests).
 */
export interface CommunicationChannelsRequest {
  slack?: boolean;
  msTeams?: boolean;
  publicWall?: boolean;
}

export interface CompanyValueCreateUpdateRequest {
  /** @nullable */
  image?: string | null;
  /**
   * @minLength 1
   * @maxLength 30
   */
  name: string;
  /** @maxLength 360 */
  description?: string;
  /**
   * @minLength 1
   * @maxLength 100
   */
  icon: string;
  /** @maxLength 100 */
  imageAltText?: string;
}

export interface CompanyValueImageResponse {
  id: number;
  uuid: string;
  fileUrl: string;
  originalName: string;
}

export interface CompanyValueResponse {
  readonly id: number;
  /** @maxLength 30 */
  name: string;
  /** @maxLength 360 */
  description?: string;
  /** @maxLength 100 */
  icon: string;
  image?: CompanyValueImageResponse | null;
  /** @nullable */
  imageAltText?: string | null;
}

export interface CompanyValueListResponse {
  results: CompanyValueResponse[];
}

export interface CompositionSegment {
  id: number;
  label: string;
  colour: string;
  tooltip: string;
  /** @pattern ^-?\d{0,18}(?:\.\d{0,2})?$ */
  amount: string;
  /** @pattern ^-?\d{0,3}(?:\.\d{0,2})?$ */
  percentage: string;
}

export interface CompositionBarComponent {
  type: RewardStatementComponentTypeEnum;
  title: string;
  subtitle: string;
  showLegend: boolean;
  showAmounts: boolean;
  segments: CompositionSegment[];
}

export interface ConfigurationHeaders {
  pageTitle: string;
  pageSubtitle: string;
  totalRewardsInsightsTitle: string;
  equityInsightsTitle: string;
  breakdownTitle: string;
  myContributionsHeader: string;
  employerContributionsHeader: string;
  chartTitle: string;
  vestingScheduleChartTitle: string;
  vestingScheduleChartSubtitle: string;
  vestingScheduleChartTotalLabel: string;
  sharePriceLabel: string;
  employerContributionLabel: string;
  employeeContributionLabel: string;
  summaryGroupTotalRewardsInsightsLabel: string;
  summaryGroupEquityInsightsLabel: string;
  showCurrencySelector: boolean;
  showPeriodSelector: boolean;
  showYearlyMonthlySelector: boolean;
  equityInsightsLinkLabel?: string;
  equityInsightsLinkUrl?: string;
}

export interface ConfigurationBanners {
  historicalBanners: BannerItem[];
  projectedBanners: BannerItem[];
}

export interface VestingChartCategory {
  equityrsu: ChartCategoryItem;
  equitypsu: ChartCategoryItem;
  equitystockoptions: ChartCategoryItem;
  equitydsu: ChartCategoryItem;
}

export interface VestingChartDetails {
  categories: VestingChartCategory;
}

export interface HistoricalChartDetails {
  categories: CommonChartCategory;
}

export interface ProjectedChartCategory {
  salary: ChartCategoryItem;
  bonus: ChartCategoryItem;
  commission: ChartCategoryItem;
  other: ChartCategoryItem;
  vestedequity: ChartCategoryItem;
  unvestedequity: ChartCategoryItem;
  benefits: ChartCategoryItem;
}

export interface ProjectedChartDetails {
  categories: ProjectedChartCategory;
}

export interface ConfigurationChart {
  showChart: boolean;
  chartHeight: number;
  showLegend: boolean;
  vestingChartDetails: VestingChartDetails;
  historicalChartDetails: HistoricalChartDetails;
  projectedChartDetails: ProjectedChartDetails;
}

export interface ConfigurationWidgets {
  showSummaryCards: boolean;
  showVestingSchedule: boolean;
}

export interface ConfigurationBreakdown {
  showBreakdown: boolean;
  showEmployerContributions: boolean;
  showEmployeeContributions: boolean;
  showPercentages: boolean;
  historicalCategories: Categories;
  projectedCategories: Categories;
}

export interface ConfigurationDisclaimers {
  description: string;
  displayOrder: number;
  location: LocationEnum;
}

export interface Configuration {
  headers: ConfigurationHeaders;
  banners: ConfigurationBanners;
  chart: ConfigurationChart;
  widgets: ConfigurationWidgets;
  breakdown: ConfigurationBreakdown;
  disclaimers: ConfigurationDisclaimers[];
}

export interface ContactEnrolmentDisplayStatus {
  type: string;
  text: string;
}

export interface ContactEnrollmentList {
  readonly benefitName: string;
  readonly benefitId: number;
  displayStatus: ContactEnrolmentDisplayStatus;
}

/**
 * * `SPOUSE` - Spouse / Partner
 * * `CHILD` - Child
 * * `FRIEND` - Friend
 * * `OTHER` - Other
 * * `SELF` - Self
 */
export type ContactTypeEnum =
  (typeof ContactTypeEnum)[keyof typeof ContactTypeEnum];

export const ContactTypeEnum = {
  SPOUSE: 'SPOUSE',
  CHILD: 'CHILD',
  FRIEND: 'FRIEND',
  OTHER: 'OTHER',
  SELF: 'SELF',
} as const;

export interface ContributionHolidaysExportResponse {
  status: ContributionHolidaysExportJobStatusEnum;
  /** @nullable */
  downloadUrl?: string | null;
  /** @nullable */
  expiresAt?: string | null;
  /** @nullable */
  filename?: string | null;
  /** @nullable */
  error?: string | null;
  /** @nullable */
  createdTimestamp?: string | null;
}

export interface ContributionHolidaysGenerateResponse {
  status: ContributionHolidaysExportJobStatusEnum;
}

/**
 * * `RECURRING` - RECURRING
 * * `IMMEDIATE_DEDUCTION` - IMMEDIATE_DEDUCTION
 */
export type PeriodAwareContributionSourceResponseTypeEnum =
  (typeof PeriodAwareContributionSourceResponseTypeEnum)[keyof typeof PeriodAwareContributionSourceResponseTypeEnum];

export const PeriodAwareContributionSourceResponseTypeEnum = {
  RECURRING: 'RECURRING',
  IMMEDIATE_DEDUCTION: 'IMMEDIATE_DEDUCTION',
} as const;

export interface PeriodAwareContributionSourceResponse {
  /**
   * @nullable
   * @pattern ^-?\d{0,8}(?:\.\d{0,2})?$
   */
  amount: string | null;
  /** @nullable */
  currency: string | null;
  type: PeriodAwareContributionSourceResponseTypeEnum;
  /**
   * @nullable
   * @pattern ^-?\d{0,8}(?:\.\d{0,2})?$
   */
  previousAmount?: string | null;
}

export interface ContributionSourcesResponse {
  salary: PeriodAwareContributionSourceResponse;
  allowance: PeriodAwareContributionSourceResponse;
}

export type CorporateKYBRequestRequest = AirwallexAccountCreateRequestRequest;

export interface WeavrKYBResponse {
  /** @nullable */
  errorCode?: string | null;
  weavrToken: string;
  reference: string;
}

export type CorporateKYBResponse =
  | WeavrKYBResponse
  | AirwallexAccountCreateResponse;

export interface CreateCampaignRequestRequest {
  /**
   * @minLength 1
   * @maxLength 255
   */
  title: string;
  /** @maxLength 1024 */
  description?: string;
  segmentQuery?: unknown | null;
  template: CampaignTemplateRequestRequest;
}

/**
 * * `OPT_IN` - Opt in
 * * `OPT_OUT` - Opt out
 * * `LOCKED` - Locked
 * * `INFO_ONLY` - Informational
 * * `DISCOUNT` - Discount
 */
export type EnrolmentTypeEnum =
  (typeof EnrolmentTypeEnum)[keyof typeof EnrolmentTypeEnum];

export const EnrolmentTypeEnum = {
  OPT_IN: 'OPT_IN',
  OPT_OUT: 'OPT_OUT',
  LOCKED: 'LOCKED',
  INFO_ONLY: 'INFO_ONLY',
  DISCOUNT: 'DISCOUNT',
} as const;

export interface EnrollableBenefitFeatureRequest {
  id?: number;
  /** @minLength 1 */
  title: string;
  /** @minLength 1 */
  description: string;
  /** @minLength 1 */
  icon: string;
  /** @minLength 1 */
  category: string;
  rank?: number;
}

export interface EnrollableBenefitSubPriceRequest {
  pricingFormula: string;
  employeeContribution: number;
}

export interface EnrollableBenefitPricingRequest {
  showPrice?: boolean;
  subPrices: EnrollableBenefitSubPriceRequest[];
}

/**
 * * `PUBLISHED` - Published
 * * `UNPUBLISHED` - Unpublished
 * * `DRAFT` - Draft
 * * `SCHEDULED` - Scheduled
 */
export type StatusC27Enum = (typeof StatusC27Enum)[keyof typeof StatusC27Enum];

export const StatusC27Enum = {
  PUBLISHED: 'PUBLISHED',
  UNPUBLISHED: 'UNPUBLISHED',
  DRAFT: 'DRAFT',
  SCHEDULED: 'SCHEDULED',
} as const;

/**
 * Serializer for creating/updating an EnrollableBenefit.
 * Excludes the 'name' field and sets the 'name' field to a placeholder value.
 */
export interface CreateEnrollableBenefitRequest {
  /** @nullable */
  contentCs?: string | null;
  /** @nullable */
  contentDe?: string | null;
  /** @nullable */
  contentEl?: string | null;
  /** @nullable */
  contentEn?: string | null;
  /** @nullable */
  contentEnUs?: string | null;
  /** @nullable */
  contentEs?: string | null;
  /** @nullable */
  contentEsXl?: string | null;
  /** @nullable */
  contentFr?: string | null;
  /** @nullable */
  contentHu?: string | null;
  /** @nullable */
  contentIo?: string | null;
  /** @nullable */
  contentIt?: string | null;
  /** @nullable */
  contentJa?: string | null;
  /** @nullable */
  contentKo?: string | null;
  /** @nullable */
  contentMs?: string | null;
  /** @nullable */
  contentPl?: string | null;
  /** @nullable */
  contentPt?: string | null;
  /** @nullable */
  contentSk?: string | null;
  /** @nullable */
  contentTr?: string | null;
  /** @nullable */
  contentVi?: string | null;
  /** @nullable */
  contentZh?: string | null;
  /**
   * @maxLength 250
   * @nullable
   */
  ctaTextCs?: string | null;
  /**
   * @maxLength 250
   * @nullable
   */
  ctaTextDe?: string | null;
  /**
   * @maxLength 250
   * @nullable
   */
  ctaTextEl?: string | null;
  /**
   * @maxLength 250
   * @nullable
   */
  ctaTextEn?: string | null;
  /**
   * @maxLength 250
   * @nullable
   */
  ctaTextEnUs?: string | null;
  /**
   * @maxLength 250
   * @nullable
   */
  ctaTextEs?: string | null;
  /**
   * @maxLength 250
   * @nullable
   */
  ctaTextEsXl?: string | null;
  /**
   * @maxLength 250
   * @nullable
   */
  ctaTextFr?: string | null;
  /**
   * @maxLength 250
   * @nullable
   */
  ctaTextHu?: string | null;
  /**
   * @maxLength 250
   * @nullable
   */
  ctaTextIo?: string | null;
  /**
   * @maxLength 250
   * @nullable
   */
  ctaTextIt?: string | null;
  /**
   * @maxLength 250
   * @nullable
   */
  ctaTextJa?: string | null;
  /**
   * @maxLength 250
   * @nullable
   */
  ctaTextKo?: string | null;
  /**
   * @maxLength 250
   * @nullable
   */
  ctaTextMs?: string | null;
  /**
   * @maxLength 250
   * @nullable
   */
  ctaTextPl?: string | null;
  /**
   * @maxLength 250
   * @nullable
   */
  ctaTextPt?: string | null;
  /**
   * @maxLength 250
   * @nullable
   */
  ctaTextSk?: string | null;
  /**
   * @maxLength 250
   * @nullable
   */
  ctaTextTr?: string | null;
  /**
   * @maxLength 250
   * @nullable
   */
  ctaTextVi?: string | null;
  /**
   * @maxLength 250
   * @nullable
   */
  ctaTextZh?: string | null;
  /**
   * @maxLength 200
   * @nullable
   */
  displayNameCs?: string | null;
  /**
   * @maxLength 200
   * @nullable
   */
  displayNameDe?: string | null;
  /**
   * @maxLength 200
   * @nullable
   */
  displayNameEl?: string | null;
  /**
   * @maxLength 200
   * @nullable
   */
  displayNameEn?: string | null;
  /**
   * @maxLength 200
   * @nullable
   */
  displayNameEnUs?: string | null;
  /**
   * @maxLength 200
   * @nullable
   */
  displayNameEs?: string | null;
  /**
   * @maxLength 200
   * @nullable
   */
  displayNameEsXl?: string | null;
  /**
   * @maxLength 200
   * @nullable
   */
  displayNameFr?: string | null;
  /**
   * @maxLength 200
   * @nullable
   */
  displayNameHu?: string | null;
  /**
   * @maxLength 200
   * @nullable
   */
  displayNameIo?: string | null;
  /**
   * @maxLength 200
   * @nullable
   */
  displayNameIt?: string | null;
  /**
   * @maxLength 200
   * @nullable
   */
  displayNameJa?: string | null;
  /**
   * @maxLength 200
   * @nullable
   */
  displayNameKo?: string | null;
  /**
   * @maxLength 200
   * @nullable
   */
  displayNameMs?: string | null;
  /**
   * @maxLength 200
   * @nullable
   */
  displayNamePl?: string | null;
  /**
   * @maxLength 200
   * @nullable
   */
  displayNamePt?: string | null;
  /**
   * @maxLength 200
   * @nullable
   */
  displayNameSk?: string | null;
  /**
   * @maxLength 200
   * @nullable
   */
  displayNameTr?: string | null;
  /**
   * @maxLength 200
   * @nullable
   */
  displayNameVi?: string | null;
  /**
   * @maxLength 200
   * @nullable
   */
  displayNameZh?: string | null;
  /** @nullable */
  grossPayDeductionDescriptionCs?: string | null;
  /** @nullable */
  grossPayDeductionDescriptionDe?: string | null;
  /** @nullable */
  grossPayDeductionDescriptionEl?: string | null;
  /** @nullable */
  grossPayDeductionDescriptionEn?: string | null;
  /** @nullable */
  grossPayDeductionDescriptionEnUs?: string | null;
  /** @nullable */
  grossPayDeductionDescriptionEs?: string | null;
  /** @nullable */
  grossPayDeductionDescriptionEsXl?: string | null;
  /** @nullable */
  grossPayDeductionDescriptionFr?: string | null;
  /** @nullable */
  grossPayDeductionDescriptionHu?: string | null;
  /** @nullable */
  grossPayDeductionDescriptionIo?: string | null;
  /** @nullable */
  grossPayDeductionDescriptionIt?: string | null;
  /** @nullable */
  grossPayDeductionDescriptionJa?: string | null;
  /** @nullable */
  grossPayDeductionDescriptionKo?: string | null;
  /** @nullable */
  grossPayDeductionDescriptionMs?: string | null;
  /** @nullable */
  grossPayDeductionDescriptionPl?: string | null;
  /** @nullable */
  grossPayDeductionDescriptionPt?: string | null;
  /** @nullable */
  grossPayDeductionDescriptionSk?: string | null;
  /** @nullable */
  grossPayDeductionDescriptionTr?: string | null;
  /** @nullable */
  grossPayDeductionDescriptionVi?: string | null;
  /** @nullable */
  grossPayDeductionDescriptionZh?: string | null;
  /** @nullable */
  grossPayDeductionTitleCs?: string | null;
  /** @nullable */
  grossPayDeductionTitleDe?: string | null;
  /** @nullable */
  grossPayDeductionTitleEl?: string | null;
  /** @nullable */
  grossPayDeductionTitleEn?: string | null;
  /** @nullable */
  grossPayDeductionTitleEnUs?: string | null;
  /** @nullable */
  grossPayDeductionTitleEs?: string | null;
  /** @nullable */
  grossPayDeductionTitleEsXl?: string | null;
  /** @nullable */
  grossPayDeductionTitleFr?: string | null;
  /** @nullable */
  grossPayDeductionTitleHu?: string | null;
  /** @nullable */
  grossPayDeductionTitleIo?: string | null;
  /** @nullable */
  grossPayDeductionTitleIt?: string | null;
  /** @nullable */
  grossPayDeductionTitleJa?: string | null;
  /** @nullable */
  grossPayDeductionTitleKo?: string | null;
  /** @nullable */
  grossPayDeductionTitleMs?: string | null;
  /** @nullable */
  grossPayDeductionTitlePl?: string | null;
  /** @nullable */
  grossPayDeductionTitlePt?: string | null;
  /** @nullable */
  grossPayDeductionTitleSk?: string | null;
  /** @nullable */
  grossPayDeductionTitleTr?: string | null;
  /** @nullable */
  grossPayDeductionTitleVi?: string | null;
  /** @nullable */
  grossPayDeductionTitleZh?: string | null;
  /** @nullable */
  netPayDeductionDescriptionCs?: string | null;
  /** @nullable */
  netPayDeductionDescriptionDe?: string | null;
  /** @nullable */
  netPayDeductionDescriptionEl?: string | null;
  /** @nullable */
  netPayDeductionDescriptionEn?: string | null;
  /** @nullable */
  netPayDeductionDescriptionEnUs?: string | null;
  /** @nullable */
  netPayDeductionDescriptionEs?: string | null;
  /** @nullable */
  netPayDeductionDescriptionEsXl?: string | null;
  /** @nullable */
  netPayDeductionDescriptionFr?: string | null;
  /** @nullable */
  netPayDeductionDescriptionHu?: string | null;
  /** @nullable */
  netPayDeductionDescriptionIo?: string | null;
  /** @nullable */
  netPayDeductionDescriptionIt?: string | null;
  /** @nullable */
  netPayDeductionDescriptionJa?: string | null;
  /** @nullable */
  netPayDeductionDescriptionKo?: string | null;
  /** @nullable */
  netPayDeductionDescriptionMs?: string | null;
  /** @nullable */
  netPayDeductionDescriptionPl?: string | null;
  /** @nullable */
  netPayDeductionDescriptionPt?: string | null;
  /** @nullable */
  netPayDeductionDescriptionSk?: string | null;
  /** @nullable */
  netPayDeductionDescriptionTr?: string | null;
  /** @nullable */
  netPayDeductionDescriptionVi?: string | null;
  /** @nullable */
  netPayDeductionDescriptionZh?: string | null;
  /** @nullable */
  netPayDeductionTitleCs?: string | null;
  /** @nullable */
  netPayDeductionTitleDe?: string | null;
  /** @nullable */
  netPayDeductionTitleEl?: string | null;
  /** @nullable */
  netPayDeductionTitleEn?: string | null;
  /** @nullable */
  netPayDeductionTitleEnUs?: string | null;
  /** @nullable */
  netPayDeductionTitleEs?: string | null;
  /** @nullable */
  netPayDeductionTitleEsXl?: string | null;
  /** @nullable */
  netPayDeductionTitleFr?: string | null;
  /** @nullable */
  netPayDeductionTitleHu?: string | null;
  /** @nullable */
  netPayDeductionTitleIo?: string | null;
  /** @nullable */
  netPayDeductionTitleIt?: string | null;
  /** @nullable */
  netPayDeductionTitleJa?: string | null;
  /** @nullable */
  netPayDeductionTitleKo?: string | null;
  /** @nullable */
  netPayDeductionTitleMs?: string | null;
  /** @nullable */
  netPayDeductionTitlePl?: string | null;
  /** @nullable */
  netPayDeductionTitlePt?: string | null;
  /** @nullable */
  netPayDeductionTitleSk?: string | null;
  /** @nullable */
  netPayDeductionTitleTr?: string | null;
  /** @nullable */
  netPayDeductionTitleVi?: string | null;
  /** @nullable */
  netPayDeductionTitleZh?: string | null;
  /**
   * @maxLength 70
   * @nullable
   */
  shortDescriptionCs?: string | null;
  /**
   * @maxLength 70
   * @nullable
   */
  shortDescriptionDe?: string | null;
  /**
   * @maxLength 70
   * @nullable
   */
  shortDescriptionEl?: string | null;
  /**
   * @maxLength 70
   * @nullable
   */
  shortDescriptionEn?: string | null;
  /**
   * @maxLength 70
   * @nullable
   */
  shortDescriptionEnUs?: string | null;
  /**
   * @maxLength 70
   * @nullable
   */
  shortDescriptionEs?: string | null;
  /**
   * @maxLength 70
   * @nullable
   */
  shortDescriptionEsXl?: string | null;
  /**
   * @maxLength 70
   * @nullable
   */
  shortDescriptionFr?: string | null;
  /**
   * @maxLength 70
   * @nullable
   */
  shortDescriptionHu?: string | null;
  /**
   * @maxLength 70
   * @nullable
   */
  shortDescriptionIo?: string | null;
  /**
   * @maxLength 70
   * @nullable
   */
  shortDescriptionIt?: string | null;
  /**
   * @maxLength 70
   * @nullable
   */
  shortDescriptionJa?: string | null;
  /**
   * @maxLength 70
   * @nullable
   */
  shortDescriptionKo?: string | null;
  /**
   * @maxLength 70
   * @nullable
   */
  shortDescriptionMs?: string | null;
  /**
   * @maxLength 70
   * @nullable
   */
  shortDescriptionPl?: string | null;
  /**
   * @maxLength 70
   * @nullable
   */
  shortDescriptionPt?: string | null;
  /**
   * @maxLength 70
   * @nullable
   */
  shortDescriptionSk?: string | null;
  /**
   * @maxLength 70
   * @nullable
   */
  shortDescriptionTr?: string | null;
  /**
   * @maxLength 70
   * @nullable
   */
  shortDescriptionVi?: string | null;
  /**
   * @maxLength 70
   * @nullable
   */
  shortDescriptionZh?: string | null;
  active?: boolean;
  autoActivating?: boolean;
  /**
   * Select the programme that this benefit belongs to.
   * @nullable
   */
  benefitProgramme?: number | null;
  benefitRequirements?: BenefitRequirementsEnum[];
  /** @nullable */
  broker?: number | null;
  categories?: number[];
  /** Whether employees need to wait for open benefit window to opt into benefit after opt out. */
  closeOptInWindowAfterOptOut?: boolean;
  documents?: BenefitDocumentRequest[];
  enrolmentType?: EnrolmentTypeEnum;
  /**
   * @maxLength 2100
   * @nullable
   */
  externalLinkUrl?: string | null;
  features?: EnrollableBenefitFeatureRequest[];
  /**
   * @maxLength 100
   * @nullable
   */
  groupMembershipNumber?: string | null;
  hasRenewableBenefit?: boolean;
  /**
   * @minLength 1
   * @nullable
   */
  heroImage?: string | null;
  /** @nullable */
  heroImageAltText?: string | null;
  /**
   * @minLength 1
   * @nullable
   */
  image?: string | null;
  /** @nullable */
  imageAltText?: string | null;
  /**
   * @maxLength 50
   * @nullable
   */
  optInButtonText?: string | null;
  /**
   * Copy to be shown on the benefit tile and banner.If not provided, the default copy will be used.
   * @maxLength 255
   * @nullable
   */
  optInCopy?: string | null;
  /**
   * Copy to be shown on the benefit tile and banner.If not provided, the default copy will be used.
   * @maxLength 255
   * @nullable
   */
  optOutCopy?: string | null;
  /**
   * Copy to be shown on the benefit tile and banner.
   * @maxLength 255
   * @nullable
   */
  optInCopyPreposition?: string | null;
  /**
   * Copy to be shown on the benefit tile and banner.
   * @maxLength 255
   * @nullable
   */
  optOutCopyPreposition?: string | null;
  pricing?: EnrollableBenefitPricingRequest;
  /** @nullable */
  provider?: number | null;
  /**
   * @minimum -2147483648
   * @maximum 2147483647
   */
  rank?: number;
  /**
   *
   *             Date of the upcoming renewal, does not affect new renewal flow.
   * @nullable
   */
  renewalDate?: string | null;
  /** Whether company admins need to approve opt-ins or changes to enrolments. */
  requiresActivationApproval?: boolean;
  /** Whether company admins need to approve opt-outs to enrolments. */
  requiresDeactivationApproval?: boolean;
  status?: StatusC27Enum | null;
  /** @nullable */
  airtableId?: string | null;
}

/**
 * Serializer for the query params to make a new creation assessment.
 */
export interface CreationAssessmentRequestRequest {
  benefitType: number;
  isExistingBenefit: boolean;
  isManagedByBen: boolean;
  allEmployeesAreEligible: boolean;
  hasPrice: boolean;
  /** @nullable */
  hasFixedPrice?: boolean | null;
}

/**
 * * `MARKETPLACE` - Marketplace
 * * `BENEFIT_CREATION` - Benefit Creation
 * * `AIRTABLE` - Airtable
 */
export type OutcomeEnum = (typeof OutcomeEnum)[keyof typeof OutcomeEnum];

export const OutcomeEnum = {
  MARKETPLACE: 'MARKETPLACE',
  BENEFIT_CREATION: 'BENEFIT_CREATION',
  AIRTABLE: 'AIRTABLE',
} as const;

/**
 * Serializer for the outcome of a creation assessment.
 */
export interface CreationAssessmentResponse {
  outcome: OutcomeEnum;
}

/**
 * * `ALLOWANCE` - Allowance
 * * `BENEFIT` - Benefit
 */
export type Type226Enum = (typeof Type226Enum)[keyof typeof Type226Enum];

export const Type226Enum = {
  ALLOWANCE: 'ALLOWANCE',
  BENEFIT: 'BENEFIT',
} as const;

export interface CreationRequestResponse {
  readonly id: number;
  type: Type226Enum;
  name: string;
  /**
   * @maxLength 200
   * @nullable
   */
  airtableUrl?: string | null;
  readonly createdAt: string;
}

/**
 * Serializer for a list of CreationRequests
 */
export interface CreationRequestListResponse {
  totalItemCount: number;
  creationRequests: CreationRequestResponse[];
}

/**
 * Serializer for the CreationRequest model
 */
export interface CreationRequestRequest {
  type: Type226Enum;
  /** @minLength 1 */
  name: string;
  benefitType?: number;
}

/**
 * * `GBP` - GBP
 * * `EUR` - EUR
 * * `USD` - USD
 */
export type CurrencyEnum = (typeof CurrencyEnum)[keyof typeof CurrencyEnum];

export const CurrencyEnum = {
  GBP: 'GBP',
  EUR: 'EUR',
  USD: 'USD',
} as const;

/**
 * * `GBP` - GBP
 * * `EUR` - EUR
 * * `USD` - USD
 */
export type CurrencySelectionOptionsEnum =
  (typeof CurrencySelectionOptionsEnum)[keyof typeof CurrencySelectionOptionsEnum];

export const CurrencySelectionOptionsEnum = {
  GBP: 'GBP',
  EUR: 'EUR',
  USD: 'USD',
} as const;

export interface CurrentTaxYear {
  /** @nullable */
  startDate: string | null;
  /** @nullable */
  endDate: string | null;
}

export interface CustomEmployerRole {
  id: number;
  name: string;
  permissions: BenPermission[];
}

/**
 * * `MONTHLY` - monthly
 * * `BI_WEEKLY` - bi-weekly
 * * `SEMI_MONTHLY` - semi-monthly
 * * `WEEKLY` - weekly
 * * `FOUR_WEEKLY` - four-weekly
 */
export type CycleFrequencyEnum =
  (typeof CycleFrequencyEnum)[keyof typeof CycleFrequencyEnum];

export const CycleFrequencyEnum = {
  MONTHLY: 'MONTHLY',
  BI_WEEKLY: 'BI_WEEKLY',
  SEMI_MONTHLY: 'SEMI_MONTHLY',
  WEEKLY: 'WEEKLY',
  FOUR_WEEKLY: 'FOUR_WEEKLY',
} as const;

export interface CycleSnapshot {
  startDate: string;
  endDate: string;
  cutoffDate: string;
  /** @nullable */
  id?: number | null;
}

export interface CycleSnapshotRequest {
  startDate: string;
  endDate: string;
  cutoffDate: string;
  /** @nullable */
  id?: number | null;
}

export interface DashboardBenefitSubset {
  count?: number;
  benefits?: BenefitForDashboardResponse[];
}

export interface DashboardBenefitsListResponse {
  enrolled: DashboardBenefitSubset;
}

/**
 * * `OPT_OUT_CLOSING` - Opt Out Closing
 * * `OPT_IN_CLOSING` - Opt In Closing
 * * `ALLOWANCE_EXPIRY` - Allowance Expiry
 * * `ALLOWANCE_RENEWAL_ROLLOVER` - Allowance Renewal Rollover
 * * `ALLOWANCE_RENEWAL_PARTIAL_ROLLOVER` - Allowance Renewal Partial Rollover
 * * `ALLOWANCE_RENEWAL_NO_ROLLOVER` - Allowance Renewal No Rollover
 * * `MISSING_TRANSACTION_RECEIPTS` - Missing receipts for transactions
 */
export type DashboardRemindersTypeEnum =
  (typeof DashboardRemindersTypeEnum)[keyof typeof DashboardRemindersTypeEnum];

export const DashboardRemindersTypeEnum = {
  OPT_OUT_CLOSING: 'OPT_OUT_CLOSING',
  OPT_IN_CLOSING: 'OPT_IN_CLOSING',
  ALLOWANCE_EXPIRY: 'ALLOWANCE_EXPIRY',
  ALLOWANCE_RENEWAL_ROLLOVER: 'ALLOWANCE_RENEWAL_ROLLOVER',
  ALLOWANCE_RENEWAL_PARTIAL_ROLLOVER: 'ALLOWANCE_RENEWAL_PARTIAL_ROLLOVER',
  ALLOWANCE_RENEWAL_NO_ROLLOVER: 'ALLOWANCE_RENEWAL_NO_ROLLOVER',
  MISSING_TRANSACTION_RECEIPTS: 'MISSING_TRANSACTION_RECEIPTS',
} as const;

export interface DashboardReminders {
  type: DashboardRemindersTypeEnum;
  name: string;
  dueDate: string;
  /** @nullable */
  allowanceCurrency: string | null;
  /**
   * @nullable
   * @pattern ^-?\d{0,8}(?:\.\d{0,2})?$
   */
  allowanceBalance: string | null;
  /**
   * @nullable
   * @pattern ^-?\d{0,8}(?:\.\d{0,2})?$
   */
  allowanceRolloverAmount: string | null;
  /** @nullable */
  allowanceId: number | null;
  /** @nullable */
  benefitId: number | null;
  /** @nullable */
  benefitTypeIsModular: boolean | null;
  /** @nullable */
  count: number | null;
}

export interface DashboardRemindersSerializerResponse {
  reminders: DashboardReminders[];
  count: number;
}

export interface DashboardYearlyCompensationResponse {
  /** @nullable */
  currency: string | null;
  /** @nullable */
  grossSalary: number | null;
  /** @nullable */
  wallet: number | null;
  total: number;
  /** @nullable */
  pension: number | null;
  /** @nullable */
  benefits: number | null;
  /** @nullable */
  bonus: number | null;
  /** @nullable */
  lastUpdatedAt: string | null;
  taxYear: CurrentTaxYear | null;
}

/**
 * * `ALLOWANCE_FIRST` - Allowance First
 * * `SALARY_FIRST` - Salary First
 */
export type DefaultDeductionSourceEnum =
  (typeof DefaultDeductionSourceEnum)[keyof typeof DefaultDeductionSourceEnum];

export const DefaultDeductionSourceEnum = {
  ALLOWANCE_FIRST: 'ALLOWANCE_FIRST',
  SALARY_FIRST: 'SALARY_FIRST',
} as const;

/**
 * * `growth` - growth
 * * `price` - price
 */
export type DefaultModeEnum =
  (typeof DefaultModeEnum)[keyof typeof DefaultModeEnum];

export const DefaultModeEnum = {
  growth: 'growth',
  price: 'price',
} as const;

/**
 * * `chart` - chart
 * * `table` - table
 */
export type DefaultViewEnum =
  (typeof DefaultViewEnum)[keyof typeof DefaultViewEnum];

export const DefaultViewEnum = {
  chart: 'chart',
  table: 'table',
} as const;

export interface DocumentSigningExportResponse {
  status: ContributionHolidaysExportJobStatusEnum;
  /** @nullable */
  downloadUrl?: string | null;
  /** @nullable */
  expiresAt?: string | null;
  /** @nullable */
  filename?: string | null;
  /** @nullable */
  error?: string | null;
  /** @nullable */
  createdTimestamp?: string | null;
}

export interface DocumentSigningGenerateResponse {
  status: ContributionHolidaysExportJobStatusEnum;
}

export type EaHomepageLayoutItemConfig = { [key: string]: unknown };

/**
 * * `benefit` - Benefit
 * * `allowance` - Allowance
 * * `quick_link` - Quick link
 * * `announcement` - Announcement
 * * `est_comp_package` - Estimated Compensation Package
 * * `benefit_contributions` - Benefit contributions
 * * `resource` - Resource
 */
export type EntityTypeEnum =
  (typeof EntityTypeEnum)[keyof typeof EntityTypeEnum];

export const EntityTypeEnum = {
  benefit: 'benefit',
  allowance: 'allowance',
  quick_link: 'quick_link',
  announcement: 'announcement',
  est_comp_package: 'est_comp_package',
  benefit_contributions: 'benefit_contributions',
  resource: 'resource',
} as const;

/**
 * Shared fields for every shape of layout block: entity/block type + grid coords.
 *
 * Validators are declared here so write-time parsing enforces them; on read-only
 * usages they are inert but still surface in the OpenAPI schema.
 */
export interface EaHomepageLayoutItem {
  entityType: EntityTypeEnum;
  blockType: BlockTypeEnum;
  /**
   * @minimum 0
   * @maximum 11
   */
  x: number;
  /** @minimum 0 */
  y: number;
  /**
   * @minimum 1
   * @maximum 12
   */
  w: number;
  /** @minimum 1 */
  h: number;
  config: EaHomepageLayoutItemConfig;
  readonly id: string;
}

export interface HomepageTheme {
  backgroundColour: string;
  /** @nullable */
  backgroundImageUrl: string | null;
  /** @nullable */
  textColourVariant: string | null;
  /** @nullable */
  headerBackgroundColour: string | null;
}

export interface EaHomepageLayoutResponse {
  items: EaHomepageLayoutItem[];
  theme: HomepageTheme;
}

/**
 * * `asc` - asc
 * * `desc` - desc
 */
export type SortingOrderEnum =
  (typeof SortingOrderEnum)[keyof typeof SortingOrderEnum];

export const SortingOrderEnum = {
  asc: 'asc',
  desc: 'desc',
} as const;

/**
 * * `CREATED` - created
 * * `RECEIVED` - received
 * * `PUBLIC_WALL` - public_wall
 */
export type EaRecognitionsListRequestVisibilityEnum =
  (typeof EaRecognitionsListRequestVisibilityEnum)[keyof typeof EaRecognitionsListRequestVisibilityEnum];

export const EaRecognitionsListRequestVisibilityEnum = {
  CREATED: 'CREATED',
  RECEIVED: 'RECEIVED',
  PUBLIC_WALL: 'PUBLIC_WALL',
} as const;

/**
 * * `SENDER` - sender
 * * `CREATED_AT` - created_at
 * * `AMOUNT` - amount
 */
export type SortingField7a2Enum =
  (typeof SortingField7a2Enum)[keyof typeof SortingField7a2Enum];

export const SortingField7a2Enum = {
  SENDER: 'SENDER',
  CREATED_AT: 'CREATED_AT',
  AMOUNT: 'AMOUNT',
} as const;

/**
 * Serializer for the recognition request filters parameter.
 */
export interface RecognitionFiltersRequestRequest {
  officeLocation?: unknown[];
  createdAt?: unknown[];
  department?: unknown[];
  rewardIncluded?: unknown[];
  sender?: unknown[];
  recipient?: unknown[];
  manager?: unknown[];
  sentVia?: unknown[];
}

/**
 * Serializer for the query params of the recognitions list.
 */
export interface EaRecognitionsListRequestRequest {
  pageNumber?: number;
  /** @minimum 0 */
  pageSize?: number;
  /**
   * @minLength 1
   * @maxLength 200
   */
  searchValue?: string;
  sortingOrder?: SortingOrderEnum;
  visibility: EaRecognitionsListRequestVisibilityEnum;
  companyValueId?: number;
  sortingField?: SortingField7a2Enum;
  filters?: RecognitionFiltersRequestRequest;
}

export interface EccChatCreateResponse {
  conversationId: string;
  agentSlug: string;
  /** @nullable */
  title?: string | null;
}

/**
 * * `user` - user
 * * `assistant` - assistant
 */
export type RoleEnum = (typeof RoleEnum)[keyof typeof RoleEnum];

export const RoleEnum = {
  user: 'user',
  assistant: 'assistant',
} as const;

export interface MessageContent {
  text: string;
}

export interface Message {
  id: string;
  role: RoleEnum;
  createdAt: string;
  content: MessageContent;
}

export interface EccChatDetail {
  conversationId: string;
  /** @nullable */
  readonly title: string | null;
  status: string;
  readonly messages: readonly Message[];
}

export interface EccChatList {
  conversationId: string;
  /** @nullable */
  readonly title: string | null;
  updatedAt: string;
}

export interface EccChatListPaginatedResponse {
  count: number;
  /** @nullable */
  next: string | null;
  /** @nullable */
  previous: string | null;
  results: EccChatList[];
}

export interface EccHandoffResponse {
  status: string;
}

export type EccHomepageLayoutItemRequestRequestConfig = {
  [key: string]: unknown;
};

/**
 * Shared fields for every shape of layout block: entity/block type + grid coords.
 *
 * Validators are declared here so write-time parsing enforces them; on read-only
 * usages they are inert but still surface in the OpenAPI schema.
 */
export interface EccHomepageLayoutItemRequestRequest {
  entityType: EntityTypeEnum;
  blockType: BlockTypeEnum;
  /**
   * @minimum 0
   * @maximum 11
   */
  x: number;
  /** @minimum 0 */
  y: number;
  /**
   * @minimum 1
   * @maximum 12
   */
  w: number;
  /** @minimum 1 */
  h: number;
  config: EccHomepageLayoutItemRequestRequestConfig;
}

export type EccHomepageLayoutItemResponseConfig = { [key: string]: unknown };

/**
 * Shared fields for every shape of layout block: entity/block type + grid coords.
 *
 * Validators are declared here so write-time parsing enforces them; on read-only
 * usages they are inert but still surface in the OpenAPI schema.
 */
export interface EccHomepageLayoutItemResponse {
  entityType: EntityTypeEnum;
  blockType: BlockTypeEnum;
  /**
   * @minimum 0
   * @maximum 11
   */
  x: number;
  /** @minimum 0 */
  y: number;
  /**
   * @minimum 1
   * @maximum 12
   */
  w: number;
  /** @minimum 1 */
  h: number;
  config: EccHomepageLayoutItemResponseConfig;
  readonly id: string;
}

export interface EccHomepageLayoutRequestRequest {
  items: EccHomepageLayoutItemRequestRequest[];
}

export interface EmployeeRef {
  id: number;
  displayName: string;
}

export interface EccHomepageLayoutResponse {
  items: EccHomepageLayoutItemResponse[];
  theme: HomepageTheme;
  /** @nullable */
  updatedAt: string | null;
  updatedBy: EmployeeRef | null;
}

export interface Error {
  code: string;
  message: string;
  retryable: boolean;
}

export interface EccPollTurnResponse {
  turnId: string;
  status: string;
  message: Message | null;
  error: Error | null;
}

/**
 * Serializer for the query params of the houston recognitions list.
 */
export interface EccRecognitionsListRequestRequest {
  pageNumber?: number;
  /** @minimum 0 */
  pageSize?: number;
  /**
   * @minLength 1
   * @maxLength 200
   */
  searchValue?: string;
  sortingOrder?: SortingOrderEnum;
  sortingField?: SortingField7a2Enum;
  filters?: RecognitionFiltersRequestRequest;
}

export interface EccSubmitTurnConflict {
  code: CodeEnum;
  message: string;
  turnId?: string;
}

export interface EccSubmitTurnRequestRequest {
  /** @minLength 1 */
  message: string;
}

export interface EccSubmitTurnResponse {
  turnId: string;
  status: string;
}

export interface Suggestion {
  label: string;
  prompt: string;
}

export interface EccSuggestionsResponse {
  suggestions: Suggestion[];
}

export interface EligibilityResponse {
  /** @nullable */
  eligibilityRule: string | null;
  /** @nullable */
  numberOfEligibleEmployees: number | null;
  /** @nullable */
  numberOfIneligibleEmployees: number | null;
}

export interface EligibleEmployeeResponse {
  name: string;
  eligibility: boolean;
  /** @nullable */
  failingCondition: string | null;
}

export interface EligibleEmployeesResponse {
  employees: EligibleEmployeeResponse[];
  totalItemCount: number;
}

export interface EmailPreviewRequestRequest {
  header?: string;
  /** @minLength 1 */
  message: string;
  buttonText?: string;
  buttonUrl?: string;
  helpText?: string;
  signature?: string;
  removeFooter?: boolean;
}

export interface EmailPreviewResponse {
  htmlBody: string;
}

export interface EmployeeAddress {
  /** @maxLength 250 */
  addressLine1: string;
  /**
   * @maxLength 250
   * @nullable
   */
  addressLine2?: string | null;
  /** @maxLength 250 */
  city: string;
  country: HomeAddressCountryEnum;
  /** @maxLength 20 */
  postcode: string;
  /**
   * @maxLength 150
   * @nullable
   */
  state?: string | null;
  readonly addressType: AddressTypeEnum;
}

export interface EmployeeAddressRequest {
  /** @maxLength 250 */
  addressLine1: string;
  /**
   * @maxLength 250
   * @nullable
   */
  addressLine2?: string | null;
  /** @maxLength 250 */
  city: string;
  country: HomeAddressCountryEnum;
  /** @maxLength 20 */
  postcode: string;
  /**
   * @maxLength 150
   * @nullable
   */
  state?: string | null;
  addressType?: AddressTypeEnum;
}

export interface EmployeeAddressRequestRequest {
  /**
   * @minLength 1
   * @maxLength 250
   */
  addressLine1: string;
  /**
   * @maxLength 250
   * @nullable
   */
  addressLine2?: string | null;
  /**
   * @minLength 1
   * @maxLength 250
   */
  city: string;
  country: HomeAddressCountryEnum;
  /**
   * @minLength 1
   * @maxLength 20
   */
  postcode: string;
  /**
   * @maxLength 150
   * @nullable
   */
  state?: string | null;
  addressType?: AddressTypeEnum;
}

/**
 * * `FEMALE` - Female
 * * `MALE` - Male
 * * `NOT_SPECIFIED` - Not Specified
 */
export type GenderEnum = (typeof GenderEnum)[keyof typeof GenderEnum];

export const GenderEnum = {
  FEMALE: 'FEMALE',
  MALE: 'MALE',
  NOT_SPECIFIED: 'NOT_SPECIFIED',
} as const;

export interface EmployeeContact {
  readonly pk: number;
  contactType: ContactTypeEnum;
  /**
   * @maxLength 20
   * @nullable
   */
  contactTypeOtherRelationship?: string | null;
  /** @maxLength 250 */
  firstName: string;
  /** @maxLength 250 */
  lastName: string;
  gender: GenderEnum;
  /** @nullable */
  dob?: string | null;
  /** @nullable */
  fullTimeEducation?: boolean | null;
  /** @nullable */
  educationEndDate?: string | null;
  /** @nullable */
  financiallyDependent?: boolean | null;
  maritalStatus?: MaritalStatusEnum | null;
  address?: EmployeeAddressRequest | null;
  addressSameAsHomeAddress?: boolean;
  /**
   * @maxLength 200
   * @nullable
   */
  ssn?: string | null;
  nationality?: HomeAddressCountryEnum | null;
}

export interface EmployeeContactDetail {
  readonly id: number;
  contactType: ContactTypeEnum;
  /**
   * @maxLength 20
   * @nullable
   */
  contactTypeOtherRelationship?: string | null;
  /** @maxLength 250 */
  firstName: string;
  /** @maxLength 250 */
  lastName: string;
  gender: GenderEnum;
  /** @nullable */
  dob?: string | null;
  /** @nullable */
  fullTimeEducation?: boolean | null;
  /** @nullable */
  educationEndDate?: string | null;
  /** @nullable */
  financiallyDependent?: boolean | null;
  maritalStatus?: MaritalStatusEnum | null;
  address: EmployeeAddressRequest | null;
  addressSameAsHomeAddress?: boolean;
  /**
   * @maxLength 200
   * @nullable
   */
  ssn?: string | null;
  /** @nullable */
  nationality?: string | null;
}

export interface EmployeeContactDetailRequest {
  contactType: ContactTypeEnum;
  /**
   * @minLength 1
   * @maxLength 20
   * @nullable
   */
  contactTypeOtherRelationship?: string | null;
  /**
   * @minLength 1
   * @maxLength 250
   */
  firstName: string;
  /**
   * @minLength 1
   * @maxLength 250
   */
  lastName: string;
  gender: GenderEnum;
  /** @nullable */
  dob?: string | null;
  /** @nullable */
  fullTimeEducation?: boolean | null;
  /** @nullable */
  educationEndDate?: string | null;
  /** @nullable */
  financiallyDependent?: boolean | null;
  maritalStatus?: MaritalStatusEnum | null;
  address: EmployeeAddressRequestRequest | null;
  addressSameAsHomeAddress?: boolean;
  /**
   * @minLength 1
   * @maxLength 200
   * @nullable
   */
  ssn?: string | null;
  /**
   * @minLength 1
   * @nullable
   */
  nationality?: string | null;
  isArchived?: boolean;
}

export interface EmployeeContactList {
  id: number;
  firstName: string;
  lastName: string;
  contactType: ContactTypeEnum;
}

export interface EmployeeContactRequest {
  contactType: ContactTypeEnum;
  /**
   * @maxLength 20
   * @nullable
   */
  contactTypeOtherRelationship?: string | null;
  /**
   * @minLength 1
   * @maxLength 250
   */
  firstName: string;
  /**
   * @minLength 1
   * @maxLength 250
   */
  lastName: string;
  gender: GenderEnum;
  /** @nullable */
  dob?: string | null;
  /** @nullable */
  fullTimeEducation?: boolean | null;
  /** @nullable */
  educationEndDate?: string | null;
  /** @nullable */
  financiallyDependent?: boolean | null;
  maritalStatus?: MaritalStatusEnum | null;
  address?: EmployeeAddressRequestRequest | null;
  addressSameAsHomeAddress?: boolean;
  /**
   * @maxLength 200
   * @nullable
   */
  ssn?: string | null;
  nationality?: HomeAddressCountryEnum | null;
}

/**
 * * `TEXT` - Text
 * * `NUMBER` - Number
 * * `DATE` - Date
 * * `BOOLEAN` - Boolean
 * * `LIST_OF_TEXT` - List of Text
 * * `KEY_VALUE_TEXT` - Key Value Text
 */
export type EmployeeCustomFieldValueTypeEnum =
  (typeof EmployeeCustomFieldValueTypeEnum)[keyof typeof EmployeeCustomFieldValueTypeEnum];

export const EmployeeCustomFieldValueTypeEnum = {
  TEXT: 'TEXT',
  NUMBER: 'NUMBER',
  DATE: 'DATE',
  BOOLEAN: 'BOOLEAN',
  LIST_OF_TEXT: 'LIST_OF_TEXT',
  KEY_VALUE_TEXT: 'KEY_VALUE_TEXT',
} as const;

export interface EmployeeCustomFieldValue {
  displayName: string;
  slug: string;
  type: EmployeeCustomFieldValueTypeEnum;
  value: unknown | null;
}

export interface EmployeeDependent {
  id: string;
  name: string;
}

export interface EmployeeEnrollmentDetailsResponse {
  id: number;
  email: string;
  firstName: string;
  lastName: string;
  readonly tagsList: readonly unknown[];
  readonly hasValidPhoneNumber: boolean;
}

export interface EmployeeInfoAllowanceBalanceResponse {
  readonly id: number;
  /** @pattern ^-?\d{0,13}(?:\.\d{0,2})?$ */
  availableBalance: string;
  readonly availableBalanceCurrency: string;
  allowanceName: string;
  readonly isProgramme: boolean;
  requiresReceipts: boolean;
  allowanceId: number;
}

export interface EmployeeManagedCardResponse {
  readonly id: number;
  externalId: string;
  /**
   * @nullable
   * @pattern ^-?\d{0,13}(?:\.\d{0,2})?$
   */
  availableBalance?: string | null;
  /** @nullable */
  readonly availableBalanceCurrency: string | null;
  /** @nullable */
  readonly employerAvailableBalance: string | null;
  /** @nullable */
  readonly employerAvailableBalanceCurrency: string | null;
  readonly cardDisplayName: string;
  readonly isProgramme: boolean;
  requiresReceipts: boolean;
  readonly allowanceId: number;
}

/**
 * * `MR` - Mr
 * * `MRS` - Mrs
 * * `MS` - Ms
 * * `MISS` - Miss
 * * `DR` - Dr
 * * `MX` - Mx
 * * `PROF` - Prof
 * * `PROF_DR` - Prof. Dr
 * * `OTHER` - Other
 */
export type TitleEnum = (typeof TitleEnum)[keyof typeof TitleEnum];

export const TitleEnum = {
  MR: 'MR',
  MRS: 'MRS',
  MS: 'MS',
  MISS: 'MISS',
  DR: 'DR',
  MX: 'MX',
  PROF: 'PROF',
  PROF_DR: 'PROF_DR',
  OTHER: 'OTHER',
} as const;

export interface EmployeeProfile {
  title?: TitleEnum | null;
  /**
   * @maxLength 250
   * @nullable
   */
  preferredName?: string | null;
  /** @nullable */
  dob?: string | null;
  gender?: GenderEnum | null;
  maritalStatus?: MaritalStatusEnum | null;
  /**
   * @maxLength 250
   * @nullable
   */
  nationality?: string | null;
  /**
   * @maxLength 50
   * @nullable
   */
  niNumber?: string | null;
  /**
   * @maxLength 21
   * @nullable
   */
  phoneNumber?: string | null;
  /** @nullable */
  workEmail?: string | null;
  /** @nullable */
  contactEmail?: string | null;
  homeAddress?: EmployeeAddressRequest | null;
  /**
   * @maxLength 255
   * @nullable
   */
  jobTitle?: string | null;
  country?: HomeAddressCountryEnum | null;
  /** @nullable */
  residencyType?: number | null;
}

/**
 * * `PASS` - Pass
 * * `FAIL` - Fail
 * * `AT_RISK` - At risk
 * * `NOT_APPLICABLE` - Not applicable
 * * `ERROR` - Error
 */
export type NmwStatusEnum = (typeof NmwStatusEnum)[keyof typeof NmwStatusEnum];

export const NmwStatusEnum = {
  PASS: 'PASS',
  FAIL: 'FAIL',
  AT_RISK: 'AT_RISK',
  NOT_APPLICABLE: 'NOT_APPLICABLE',
  ERROR: 'ERROR',
} as const;

/**
 * NMW compliance status nested within the employee profile response.
 */
export interface EmployeeNmwStatus {
  status: NmwStatusEnum;
  /** @nullable */
  likelyCause: string | null;
  /** @nullable */
  recommendedAction: string | null;
  /** @nullable */
  cycleCutoff: string | null;
  /**
   * @nullable
   * @pattern ^-?\d{0,8}(?:\.\d{0,2})?$
   */
  shortfallAmount: string | null;
  /** @nullable */
  shortfallCurrency: string | null;
}

export interface EmployeeInfoResponse {
  homeAddress: EmployeeAddress;
  managedCards: EmployeeManagedCardResponse[];
  allowanceBalances: EmployeeInfoAllowanceBalanceResponse[];
  employee: EmployeeProfile;
  nmwStatus: EmployeeNmwStatus;
  canViewEquityModeler: boolean;
  customFields: EmployeeCustomFieldValue[];
}

export interface EmployeeMinimalDetailsResponseRequest {
  id: number;
  /** @minLength 1 */
  email: string;
  firstName: string;
  lastName: string;
}

export interface EmployeeMobileDeviceRequestRequest {
  /**
   * @minLength 1
   * @maxLength 200
   */
  deviceId: string;
  /**
   * @maxLength 250
   * @nullable
   */
  expoPushToken?: string | null;
  hasNotificationPermission?: boolean;
}

export interface TaxableAmount {
  name: string;
  /** @pattern ^-?\d{0,8}(?:\.\d{0,2})?$ */
  grossSalaryImpact: string;
  /** @pattern ^-?\d{0,8}(?:\.\d{0,2})?$ */
  netSalaryImpact: string;
  /** @pattern ^-?\d{0,8}(?:\.\d{0,2})?$ */
  taxImpact: string;
  /** @maxLength 3 */
  currency: string;
  /** @pattern ^-?\d{0,8}(?:\.\d{0,2})?$ */
  allowanceFundedAmount?: string;
}

export interface EmployeeNetPayEstimateResponse {
  grossSalary: Amount[];
  deductions: Amount[];
  allowances: TaxableAmount[];
  benefits: TaxableAmount[];
  estimatedTakeHomePay: Amount;
  benefitRequests: TaxableAmount[];
}

export type EmployeeProfileConfigResponseContactEmail = {
  readonly editable?: boolean;
  readonly hidden?: boolean;
};

export type EmployeeProfileConfigResponseDob = {
  readonly editable?: boolean;
};

export type EmployeeProfileConfigResponseGender = {
  readonly editable?: boolean;
};

export type EmployeeProfileConfigResponseHomeAddress = {
  readonly editable?: boolean;
};

export type EmployeeProfileConfigResponseJobTitle = {
  readonly editable?: boolean;
};

export type EmployeeProfileConfigResponseMaritalStatus = {
  readonly editable?: boolean;
};

export type EmployeeProfileConfigResponseNationality = {
  readonly editable?: boolean;
};

export type EmployeeProfileConfigResponseNiNumber = {
  readonly editable?: boolean;
};

export type EmployeeProfileConfigResponsePhoneNumber = {
  readonly editable?: boolean;
};

export type EmployeeProfileConfigResponsePreferredName = {
  readonly editable?: boolean;
};

export type EmployeeProfileConfigResponseWorkEmail = {
  readonly editable?: boolean;
};

export interface EmployeeProfileConfigResponse {
  readonly contactEmail: EmployeeProfileConfigResponseContactEmail;
  readonly dob: EmployeeProfileConfigResponseDob;
  readonly gender: EmployeeProfileConfigResponseGender;
  readonly homeAddress: EmployeeProfileConfigResponseHomeAddress;
  readonly jobTitle: EmployeeProfileConfigResponseJobTitle;
  readonly maritalStatus: EmployeeProfileConfigResponseMaritalStatus;
  readonly nationality: EmployeeProfileConfigResponseNationality;
  readonly niNumber: EmployeeProfileConfigResponseNiNumber;
  readonly phoneNumber: EmployeeProfileConfigResponsePhoneNumber;
  readonly preferredName: EmployeeProfileConfigResponsePreferredName;
  readonly workEmail: EmployeeProfileConfigResponseWorkEmail;
}

export interface EmployeeProfileRequest {
  title?: TitleEnum | null;
  /**
   * @maxLength 250
   * @nullable
   */
  preferredName?: string | null;
  /** @nullable */
  dob?: string | null;
  gender?: GenderEnum | null;
  maritalStatus?: MaritalStatusEnum | null;
  /**
   * @maxLength 250
   * @nullable
   */
  nationality?: string | null;
  /**
   * @maxLength 50
   * @nullable
   */
  niNumber?: string | null;
  /**
   * @minLength 1
   * @maxLength 21
   * @nullable
   */
  phoneNumber?: string | null;
  /**
   * @minLength 1
   * @nullable
   */
  workEmail?: string | null;
  /**
   * @minLength 1
   * @nullable
   */
  contactEmail?: string | null;
  homeAddress?: EmployeeAddressRequestRequest | null;
  /**
   * @maxLength 255
   * @nullable
   */
  jobTitle?: string | null;
  country?: HomeAddressCountryEnum | null;
  /** @nullable */
  residencyType?: number | null;
}

/**
 * * `3` - User
 * * `2` - Admin
 * * `5` - Card Admin
 * * `6` - Manager
 */
export type EmployeeRequestRolesEnum =
  (typeof EmployeeRequestRolesEnum)[keyof typeof EmployeeRequestRolesEnum];

export const EmployeeRequestRolesEnum = {
  NUMBER_3: 3,
  NUMBER_2: 2,
  NUMBER_5: 5,
  NUMBER_6: 6,
} as const;

export interface EmployeeRequestRequest {
  /**
   * @maxLength 150
   * @nullable
   */
  uniqueId?: string | null;
  /** @minLength 1 */
  email: string;
  /**
   * @minLength 1
   * @maxLength 150
   */
  firstName: string;
  /**
   * @minLength 1
   * @maxLength 150
   */
  lastName: string;
  /** @nullable */
  dob?: string | null;
  roles: EmployeeRequestRolesEnum[];
  tagsList: unknown[];
  excludeFromHrisSync?: boolean;
}

/**
 * * `GROSS` - Gross
 * * `BASIC` - Basic
 * * `FTE` - FTE
 * * `REFERENCE` - Reference
 * * `PENSIONABLE` - Pensionable
 */
export type Type095Enum = (typeof Type095Enum)[keyof typeof Type095Enum];

export const Type095Enum = {
  GROSS: 'GROSS',
  BASIC: 'BASIC',
  FTE: 'FTE',
  REFERENCE: 'REFERENCE',
  PENSIONABLE: 'PENSIONABLE',
} as const;

export interface EmployeeSalaryRequest {
  /**
   * @nullable
   * @pattern ^-?\d{0,13}(?:\.\d{0,2})?$
   */
  yearlyGrossSalary?: string | null;
  /**
   * @nullable
   * @pattern ^-?\d{0,13}(?:\.\d{0,2})?$
   */
  amount?: string | null;
  type?: Type095Enum;
}

export interface EmployeeSalaryResponse {
  /**
   * @nullable
   * @pattern ^-?\d{0,13}(?:\.\d{0,2})?$
   */
  yearlyGrossSalary?: string | null;
  /** @nullable */
  readonly yearlyGrossSalaryCurrency: string | null;
  /**
   * @nullable
   * @pattern ^-?\d{0,13}(?:\.\d{0,2})?$
   */
  amount?: string | null;
  /** @nullable */
  readonly amountCurrency: string | null;
  type?: Type095Enum;
}

export interface EmployeeSegmentCreateRequestRequest {
  /**
   * @minLength 1
   * @maxLength 255
   */
  name: string;
  /**
   * @minLength 1
   * @maxLength 255
   * @pattern ^[-a-zA-Z0-9_]+$
   */
  slug: string;
  /** @nullable */
  description?: string | null;
  queryJson: unknown;
}

export interface EmployeeSegmentEmployee {
  readonly id: number;
  /** @maxLength 254 */
  readonly email: string;
  /** @maxLength 150 */
  readonly firstName: string;
  /** @maxLength 150 */
  readonly lastName: string;
}

export interface EmployeeSegmentList {
  readonly id: number;
  /** @maxLength 255 */
  readonly name: string;
  /** @pattern ^[-a-zA-Z0-9_]+$ */
  readonly slug: string;
  /** @nullable */
  readonly description: string | null;
  readonly query: string;
  readonly queryJson: unknown | null;
  /** @nullable */
  readonly aiSummary: string | null;
  readonly createdBy: EmployeeSegmentEmployee | null;
  readonly createdTimestamp: string;
  readonly updatedTimestamp: string;
}

export interface EmployeeSegmentQueryRequestRequest {
  queryJson: unknown;
}

/**
 * @nullable
 */
export type EmployeeSnapshotCustomData = { [key: string]: unknown } | null;

export interface SalarySnapshot {
  type: string;
  /** @nullable */
  amountAmount?: number | null;
  amountCurrency?: string;
  /** @nullable */
  startDate?: string | null;
  /** @nullable */
  endDate?: string | null;
  isArchived?: boolean;
}

export interface EmployeeSnapshot {
  id: number;
  /** @nullable */
  customData?: EmployeeSnapshotCustomData;
  /** @nullable */
  country?: string | null;
  /** @nullable */
  homeAddressCountry?: string | null;
  /** @nullable */
  employmentStart?: string | null;
  /** @nullable */
  employmentEnd?: string | null;
  /** @nullable */
  employeeId?: string | null;
  /** @nullable */
  payrollId?: string | null;
  totalAnnualSalaryDeductions?: number;
  previousTotalAnnualSalaryDeductions?: number;
  totalAnnualAllowanceDeductions?: number;
  /** @nullable */
  totalCycleReimbursements?: number | null;
  /** @nullable */
  salaryYearlyGrossAmount?: number | null;
  /** @nullable */
  salaryCurrency?: string | null;
  isActive?: boolean;
  /** @nullable */
  deactivatedTimestamp?: string | null;
  salaries?: SalarySnapshot[];
}

/**
 * @nullable
 */
export type EmployeeSnapshotRequestCustomData = {
  [key: string]: unknown;
} | null;

export interface SalarySnapshotRequest {
  /** @minLength 1 */
  type: string;
  /** @nullable */
  amountAmount?: number | null;
  /** @minLength 1 */
  amountCurrency?: string;
  /** @nullable */
  startDate?: string | null;
  /** @nullable */
  endDate?: string | null;
  isArchived?: boolean;
}

export interface EmployeeSnapshotRequest {
  id: number;
  /** @nullable */
  customData?: EmployeeSnapshotRequestCustomData;
  /**
   * @minLength 1
   * @nullable
   */
  country?: string | null;
  /**
   * @minLength 1
   * @nullable
   */
  homeAddressCountry?: string | null;
  /** @nullable */
  employmentStart?: string | null;
  /** @nullable */
  employmentEnd?: string | null;
  /**
   * @minLength 1
   * @nullable
   */
  employeeId?: string | null;
  /**
   * @minLength 1
   * @nullable
   */
  payrollId?: string | null;
  totalAnnualSalaryDeductions?: number;
  previousTotalAnnualSalaryDeductions?: number;
  totalAnnualAllowanceDeductions?: number;
  /** @nullable */
  totalCycleReimbursements?: number | null;
  /** @nullable */
  salaryYearlyGrossAmount?: number | null;
  /**
   * @minLength 1
   * @nullable
   */
  salaryCurrency?: string | null;
  isActive?: boolean;
  /** @nullable */
  deactivatedTimestamp?: string | null;
  salaries?: SalarySnapshotRequest[];
}

/**
 * * `2` - Company HR (Admin)
 * * `3` - Company User
 * * `8` - Company Tester (Early Access)
 * * `4` - Corporate Root
 * * `5` - Delegated Root (Card Admin)
 * * `6` - Manager
 * * `7` - Managing Entity Admin
 * * `9` - Columbia Access
 * * `10` - Approver Root
 */
export type RolesA5dEnum = (typeof RolesA5dEnum)[keyof typeof RolesA5dEnum];

export const RolesA5dEnum = {
  NUMBER_2: 2,
  NUMBER_3: 3,
  NUMBER_8: 8,
  NUMBER_4: 4,
  NUMBER_5: 5,
  NUMBER_6: 6,
  NUMBER_7: 7,
  NUMBER_9: 9,
  NUMBER_10: 10,
} as const;

export interface EmployeeUpdateRequest {
  isActive?: boolean;
  /** @nullable */
  dob?: string | null;
  gender?: GenderEnum | null;
  /**
   * @maxLength 255
   * @nullable
   */
  jobTitle?: string | null;
  /**
   * @maxLength 250
   * @nullable
   */
  employeeId?: string | null;
  /** @nullable */
  employmentStart?: string | null;
  /** @nullable */
  employmentEnd?: string | null;
  /**
   * @minimum 0
   * @maximum 1
   * @nullable
   */
  fullTimeEquivalent?: number | null;
  roles?: RolesA5dEnum[];
  /** @nullable */
  employerRoles?: number[] | null;
  /**
   * @items.minLength 1
   * @items.maxLength 100
   */
  tagsList?: string[];
  /**
   * @maxLength 250
   * @nullable
   */
  nationality?: string | null;
  /**
   * @maxLength 250
   * @nullable
   */
  niNumber?: string | null;
  maritalStatus?: MaritalStatusEnum | null;
  title?: TitleEnum | null;
  /** @nullable */
  probationEnd?: string | null;
  /**
   * @minLength 1
   * @nullable
   */
  department?: string | null;
  /**
   * @minLength 1
   * @nullable
   */
  officeLocation?: string | null;
  /** @nullable */
  residencyType?: number | null;
  preferredName?: string;
  country?: string;
  /** If enabled, this employee will be excluded from HRIS sync */
  excludeFromHrisSync?: boolean;
  /** Exclude from automatic enrolment rule processing */
  excludeFromAutoEnrolmentRules?: boolean;
  /** @maxLength 200 */
  autoEnrolmentExclusionReason?: string;
  /** Exclude this employee from the National Minimum Wage check */
  excludeFromNmwCheck?: boolean;
  /** @maxLength 200 */
  nmwExclusionReason?: string;
}

/**
 * * `ADP` - ADP
 * * `AED` - AED
 * * `AFA` - AFA
 * * `AFN` - AFN
 * * `ALK` - ALK
 * * `ALL` - ALL
 * * `AMD` - AMD
 * * `ANG` - ANG
 * * `AOA` - AOA
 * * `AOK` - AOK
 * * `AON` - AON
 * * `AOR` - AOR
 * * `ARA` - ARA
 * * `ARL` - ARL
 * * `ARM` - ARM
 * * `ARP` - ARP
 * * `ARS` - ARS
 * * `ATS` - ATS
 * * `AUD` - AUD
 * * `AWG` - AWG
 * * `AZM` - AZM
 * * `AZN` - AZN
 * * `BAD` - BAD
 * * `BAM` - BAM
 * * `BAN` - BAN
 * * `BBD` - BBD
 * * `BDT` - BDT
 * * `BEC` - BEC
 * * `BEF` - BEF
 * * `BEL` - BEL
 * * `BGL` - BGL
 * * `BGM` - BGM
 * * `BGN` - BGN
 * * `BGO` - BGO
 * * `BHD` - BHD
 * * `BIF` - BIF
 * * `BMD` - BMD
 * * `BND` - BND
 * * `BOB` - BOB
 * * `BOL` - BOL
 * * `BOP` - BOP
 * * `BOV` - BOV
 * * `BRB` - BRB
 * * `BRC` - BRC
 * * `BRE` - BRE
 * * `BRL` - BRL
 * * `BRN` - BRN
 * * `BRR` - BRR
 * * `BRZ` - BRZ
 * * `BSD` - BSD
 * * `BTN` - BTN
 * * `BUK` - BUK
 * * `BWP` - BWP
 * * `BYB` - BYB
 * * `BYN` - BYN
 * * `BYR` - BYR
 * * `BZD` - BZD
 * * `CAD` - CAD
 * * `CDF` - CDF
 * * `CHE` - CHE
 * * `CHF` - CHF
 * * `CHW` - CHW
 * * `CLE` - CLE
 * * `CLF` - CLF
 * * `CLP` - CLP
 * * `CNH` - CNH
 * * `CNX` - CNX
 * * `CNY` - CNY
 * * `COP` - COP
 * * `COU` - COU
 * * `CRC` - CRC
 * * `CSD` - CSD
 * * `CSK` - CSK
 * * `CUC` - CUC
 * * `CUP` - CUP
 * * `CVE` - CVE
 * * `CYP` - CYP
 * * `CZK` - CZK
 * * `DDM` - DDM
 * * `DEM` - DEM
 * * `DJF` - DJF
 * * `DKK` - DKK
 * * `DOP` - DOP
 * * `DZD` - DZD
 * * `ECS` - ECS
 * * `ECV` - ECV
 * * `EEK` - EEK
 * * `EGP` - EGP
 * * `ERN` - ERN
 * * `ESA` - ESA
 * * `ESB` - ESB
 * * `ESP` - ESP
 * * `ETB` - ETB
 * * `EUR` - EUR
 * * `FIM` - FIM
 * * `FJD` - FJD
 * * `FKP` - FKP
 * * `FRF` - FRF
 * * `GBP` - GBP
 * * `GEK` - GEK
 * * `GEL` - GEL
 * * `GHC` - GHC
 * * `GHS` - GHS
 * * `GIP` - GIP
 * * `GMD` - GMD
 * * `GNF` - GNF
 * * `GNS` - GNS
 * * `GQE` - GQE
 * * `GRD` - GRD
 * * `GTQ` - GTQ
 * * `GWE` - GWE
 * * `GWP` - GWP
 * * `GYD` - GYD
 * * `HKD` - HKD
 * * `HNL` - HNL
 * * `HRD` - HRD
 * * `HRK` - HRK
 * * `HTG` - HTG
 * * `HUF` - HUF
 * * `IDR` - IDR
 * * `IEP` - IEP
 * * `ILP` - ILP
 * * `ILR` - ILR
 * * `ILS` - ILS
 * * `IMP` - IMP
 * * `INR` - INR
 * * `IQD` - IQD
 * * `IRR` - IRR
 * * `ISJ` - ISJ
 * * `ISK` - ISK
 * * `ITL` - ITL
 * * `JMD` - JMD
 * * `JOD` - JOD
 * * `JPY` - JPY
 * * `KES` - KES
 * * `KGS` - KGS
 * * `KHR` - KHR
 * * `KMF` - KMF
 * * `KPW` - KPW
 * * `KRH` - KRH
 * * `KRO` - KRO
 * * `KRW` - KRW
 * * `KWD` - KWD
 * * `KYD` - KYD
 * * `KZT` - KZT
 * * `LAK` - LAK
 * * `LBP` - LBP
 * * `LKR` - LKR
 * * `LRD` - LRD
 * * `LSL` - LSL
 * * `LTL` - LTL
 * * `LTT` - LTT
 * * `LUC` - LUC
 * * `LUF` - LUF
 * * `LUL` - LUL
 * * `LVL` - LVL
 * * `LVR` - LVR
 * * `LYD` - LYD
 * * `MAD` - MAD
 * * `MAF` - MAF
 * * `MCF` - MCF
 * * `MDC` - MDC
 * * `MDL` - MDL
 * * `MGA` - MGA
 * * `MGF` - MGF
 * * `MKD` - MKD
 * * `MKN` - MKN
 * * `MLF` - MLF
 * * `MMK` - MMK
 * * `MNT` - MNT
 * * `MOP` - MOP
 * * `MRO` - MRO
 * * `MRU` - MRU
 * * `MTL` - MTL
 * * `MTP` - MTP
 * * `MUR` - MUR
 * * `MVP` - MVP
 * * `MVR` - MVR
 * * `MWK` - MWK
 * * `MXN` - MXN
 * * `MXP` - MXP
 * * `MXV` - MXV
 * * `MYR` - MYR
 * * `MZE` - MZE
 * * `MZM` - MZM
 * * `MZN` - MZN
 * * `NAD` - NAD
 * * `NGN` - NGN
 * * `NIC` - NIC
 * * `NIO` - NIO
 * * `NLG` - NLG
 * * `NOK` - NOK
 * * `NPR` - NPR
 * * `NZD` - NZD
 * * `OMR` - OMR
 * * `PAB` - PAB
 * * `PEI` - PEI
 * * `PEN` - PEN
 * * `PES` - PES
 * * `PGK` - PGK
 * * `PHP` - PHP
 * * `PKR` - PKR
 * * `PLN` - PLN
 * * `PLZ` - PLZ
 * * `PTE` - PTE
 * * `PYG` - PYG
 * * `QAR` - QAR
 * * `RHD` - RHD
 * * `ROL` - ROL
 * * `RON` - RON
 * * `RSD` - RSD
 * * `RUB` - RUB
 * * `RUR` - RUR
 * * `RWF` - RWF
 * * `SAR` - SAR
 * * `SBD` - SBD
 * * `SCR` - SCR
 * * `SDD` - SDD
 * * `SDG` - SDG
 * * `SDP` - SDP
 * * `SEK` - SEK
 * * `SGD` - SGD
 * * `SHP` - SHP
 * * `SIT` - SIT
 * * `SKK` - SKK
 * * `SLE` - SLE
 * * `SLL` - SLL
 * * `SOS` - SOS
 * * `SRD` - SRD
 * * `SRG` - SRG
 * * `SSP` - SSP
 * * `STD` - STD
 * * `STN` - STN
 * * `SUR` - SUR
 * * `SVC` - SVC
 * * `SYP` - SYP
 * * `SZL` - SZL
 * * `THB` - THB
 * * `TJR` - TJR
 * * `TJS` - TJS
 * * `TMM` - TMM
 * * `TMT` - TMT
 * * `TND` - TND
 * * `TOP` - TOP
 * * `TPE` - TPE
 * * `TRL` - TRL
 * * `TRY` - TRY
 * * `TTD` - TTD
 * * `TVD` - TVD
 * * `TWD` - TWD
 * * `TZS` - TZS
 * * `UAH` - UAH
 * * `UAK` - UAK
 * * `UGS` - UGS
 * * `UGX` - UGX
 * * `USD` - USD
 * * `USN` - USN
 * * `USS` - USS
 * * `UYI` - UYI
 * * `UYP` - UYP
 * * `UYU` - UYU
 * * `UYW` - UYW
 * * `UZS` - UZS
 * * `VEB` - VEB
 * * `VED` - VED
 * * `VEF` - VEF
 * * `VES` - VES
 * * `VND` - VND
 * * `VNN` - VNN
 * * `VUV` - VUV
 * * `WST` - WST
 * * `XAF` - XAF
 * * `XAG` - XAG
 * * `XAU` - XAU
 * * `XBA` - XBA
 * * `XBB` - XBB
 * * `XBC` - XBC
 * * `XBD` - XBD
 * * `XCD` - XCD
 * * `XDR` - XDR
 * * `XEU` - XEU
 * * `XFO` - XFO
 * * `XFU` - XFU
 * * `XOF` - XOF
 * * `XPD` - XPD
 * * `XPF` - XPF
 * * `XPT` - XPT
 * * `XRE` - XRE
 * * `XSU` - XSU
 * * `XTS` - XTS
 * * `XUA` - XUA
 * * `XXX` - XXX
 * * `YDD` - YDD
 * * `YER` - YER
 * * `YUD` - YUD
 * * `YUM` - YUM
 * * `YUN` - YUN
 * * `YUR` - YUR
 * * `ZAL` - ZAL
 * * `ZAR` - ZAR
 * * `ZMK` - ZMK
 * * `ZMW` - ZMW
 * * `ZRN` - ZRN
 * * `ZRZ` - ZRZ
 * * `ZWD` - ZWD
 * * `ZWL` - ZWL
 * * `ZWN` - ZWN
 * * `ZWR` - ZWR
 */
export type SalaryCurrencyEnum =
  (typeof SalaryCurrencyEnum)[keyof typeof SalaryCurrencyEnum];

export const SalaryCurrencyEnum = {
  ADP: 'ADP',
  AED: 'AED',
  AFA: 'AFA',
  AFN: 'AFN',
  ALK: 'ALK',
  ALL: 'ALL',
  AMD: 'AMD',
  ANG: 'ANG',
  AOA: 'AOA',
  AOK: 'AOK',
  AON: 'AON',
  AOR: 'AOR',
  ARA: 'ARA',
  ARL: 'ARL',
  ARM: 'ARM',
  ARP: 'ARP',
  ARS: 'ARS',
  ATS: 'ATS',
  AUD: 'AUD',
  AWG: 'AWG',
  AZM: 'AZM',
  AZN: 'AZN',
  BAD: 'BAD',
  BAM: 'BAM',
  BAN: 'BAN',
  BBD: 'BBD',
  BDT: 'BDT',
  BEC: 'BEC',
  BEF: 'BEF',
  BEL: 'BEL',
  BGL: 'BGL',
  BGM: 'BGM',
  BGN: 'BGN',
  BGO: 'BGO',
  BHD: 'BHD',
  BIF: 'BIF',
  BMD: 'BMD',
  BND: 'BND',
  BOB: 'BOB',
  BOL: 'BOL',
  BOP: 'BOP',
  BOV: 'BOV',
  BRB: 'BRB',
  BRC: 'BRC',
  BRE: 'BRE',
  BRL: 'BRL',
  BRN: 'BRN',
  BRR: 'BRR',
  BRZ: 'BRZ',
  BSD: 'BSD',
  BTN: 'BTN',
  BUK: 'BUK',
  BWP: 'BWP',
  BYB: 'BYB',
  BYN: 'BYN',
  BYR: 'BYR',
  BZD: 'BZD',
  CAD: 'CAD',
  CDF: 'CDF',
  CHE: 'CHE',
  CHF: 'CHF',
  CHW: 'CHW',
  CLE: 'CLE',
  CLF: 'CLF',
  CLP: 'CLP',
  CNH: 'CNH',
  CNX: 'CNX',
  CNY: 'CNY',
  COP: 'COP',
  COU: 'COU',
  CRC: 'CRC',
  CSD: 'CSD',
  CSK: 'CSK',
  CUC: 'CUC',
  CUP: 'CUP',
  CVE: 'CVE',
  CYP: 'CYP',
  CZK: 'CZK',
  DDM: 'DDM',
  DEM: 'DEM',
  DJF: 'DJF',
  DKK: 'DKK',
  DOP: 'DOP',
  DZD: 'DZD',
  ECS: 'ECS',
  ECV: 'ECV',
  EEK: 'EEK',
  EGP: 'EGP',
  ERN: 'ERN',
  ESA: 'ESA',
  ESB: 'ESB',
  ESP: 'ESP',
  ETB: 'ETB',
  EUR: 'EUR',
  FIM: 'FIM',
  FJD: 'FJD',
  FKP: 'FKP',
  FRF: 'FRF',
  GBP: 'GBP',
  GEK: 'GEK',
  GEL: 'GEL',
  GHC: 'GHC',
  GHS: 'GHS',
  GIP: 'GIP',
  GMD: 'GMD',
  GNF: 'GNF',
  GNS: 'GNS',
  GQE: 'GQE',
  GRD: 'GRD',
  GTQ: 'GTQ',
  GWE: 'GWE',
  GWP: 'GWP',
  GYD: 'GYD',
  HKD: 'HKD',
  HNL: 'HNL',
  HRD: 'HRD',
  HRK: 'HRK',
  HTG: 'HTG',
  HUF: 'HUF',
  IDR: 'IDR',
  IEP: 'IEP',
  ILP: 'ILP',
  ILR: 'ILR',
  ILS: 'ILS',
  IMP: 'IMP',
  INR: 'INR',
  IQD: 'IQD',
  IRR: 'IRR',
  ISJ: 'ISJ',
  ISK: 'ISK',
  ITL: 'ITL',
  JMD: 'JMD',
  JOD: 'JOD',
  JPY: 'JPY',
  KES: 'KES',
  KGS: 'KGS',
  KHR: 'KHR',
  KMF: 'KMF',
  KPW: 'KPW',
  KRH: 'KRH',
  KRO: 'KRO',
  KRW: 'KRW',
  KWD: 'KWD',
  KYD: 'KYD',
  KZT: 'KZT',
  LAK: 'LAK',
  LBP: 'LBP',
  LKR: 'LKR',
  LRD: 'LRD',
  LSL: 'LSL',
  LTL: 'LTL',
  LTT: 'LTT',
  LUC: 'LUC',
  LUF: 'LUF',
  LUL: 'LUL',
  LVL: 'LVL',
  LVR: 'LVR',
  LYD: 'LYD',
  MAD: 'MAD',
  MAF: 'MAF',
  MCF: 'MCF',
  MDC: 'MDC',
  MDL: 'MDL',
  MGA: 'MGA',
  MGF: 'MGF',
  MKD: 'MKD',
  MKN: 'MKN',
  MLF: 'MLF',
  MMK: 'MMK',
  MNT: 'MNT',
  MOP: 'MOP',
  MRO: 'MRO',
  MRU: 'MRU',
  MTL: 'MTL',
  MTP: 'MTP',
  MUR: 'MUR',
  MVP: 'MVP',
  MVR: 'MVR',
  MWK: 'MWK',
  MXN: 'MXN',
  MXP: 'MXP',
  MXV: 'MXV',
  MYR: 'MYR',
  MZE: 'MZE',
  MZM: 'MZM',
  MZN: 'MZN',
  NAD: 'NAD',
  NGN: 'NGN',
  NIC: 'NIC',
  NIO: 'NIO',
  NLG: 'NLG',
  NOK: 'NOK',
  NPR: 'NPR',
  NZD: 'NZD',
  OMR: 'OMR',
  PAB: 'PAB',
  PEI: 'PEI',
  PEN: 'PEN',
  PES: 'PES',
  PGK: 'PGK',
  PHP: 'PHP',
  PKR: 'PKR',
  PLN: 'PLN',
  PLZ: 'PLZ',
  PTE: 'PTE',
  PYG: 'PYG',
  QAR: 'QAR',
  RHD: 'RHD',
  ROL: 'ROL',
  RON: 'RON',
  RSD: 'RSD',
  RUB: 'RUB',
  RUR: 'RUR',
  RWF: 'RWF',
  SAR: 'SAR',
  SBD: 'SBD',
  SCR: 'SCR',
  SDD: 'SDD',
  SDG: 'SDG',
  SDP: 'SDP',
  SEK: 'SEK',
  SGD: 'SGD',
  SHP: 'SHP',
  SIT: 'SIT',
  SKK: 'SKK',
  SLE: 'SLE',
  SLL: 'SLL',
  SOS: 'SOS',
  SRD: 'SRD',
  SRG: 'SRG',
  SSP: 'SSP',
  STD: 'STD',
  STN: 'STN',
  SUR: 'SUR',
  SVC: 'SVC',
  SYP: 'SYP',
  SZL: 'SZL',
  THB: 'THB',
  TJR: 'TJR',
  TJS: 'TJS',
  TMM: 'TMM',
  TMT: 'TMT',
  TND: 'TND',
  TOP: 'TOP',
  TPE: 'TPE',
  TRL: 'TRL',
  TRY: 'TRY',
  TTD: 'TTD',
  TVD: 'TVD',
  TWD: 'TWD',
  TZS: 'TZS',
  UAH: 'UAH',
  UAK: 'UAK',
  UGS: 'UGS',
  UGX: 'UGX',
  USD: 'USD',
  USN: 'USN',
  USS: 'USS',
  UYI: 'UYI',
  UYP: 'UYP',
  UYU: 'UYU',
  UYW: 'UYW',
  UZS: 'UZS',
  VEB: 'VEB',
  VED: 'VED',
  VEF: 'VEF',
  VES: 'VES',
  VND: 'VND',
  VNN: 'VNN',
  VUV: 'VUV',
  WST: 'WST',
  XAF: 'XAF',
  XAG: 'XAG',
  XAU: 'XAU',
  XBA: 'XBA',
  XBB: 'XBB',
  XBC: 'XBC',
  XBD: 'XBD',
  XCD: 'XCD',
  XDR: 'XDR',
  XEU: 'XEU',
  XFO: 'XFO',
  XFU: 'XFU',
  XOF: 'XOF',
  XPD: 'XPD',
  XPF: 'XPF',
  XPT: 'XPT',
  XRE: 'XRE',
  XSU: 'XSU',
  XTS: 'XTS',
  XUA: 'XUA',
  XXX: 'XXX',
  YDD: 'YDD',
  YER: 'YER',
  YUD: 'YUD',
  YUM: 'YUM',
  YUN: 'YUN',
  YUR: 'YUR',
  ZAL: 'ZAL',
  ZAR: 'ZAR',
  ZMK: 'ZMK',
  ZMW: 'ZMW',
  ZRN: 'ZRN',
  ZRZ: 'ZRZ',
  ZWD: 'ZWD',
  ZWL: 'ZWL',
  ZWN: 'ZWN',
  ZWR: 'ZWR',
} as const;

export interface EmployeeUpdateRequestRequest {
  /**
   * @maxLength 150
   * @nullable
   */
  uniqueId?: string | null;
  /** @minLength 1 */
  email: string;
  /** @maxLength 150 */
  firstName?: string;
  /** @maxLength 150 */
  lastName?: string;
  /** @nullable */
  tagsList?: unknown[] | null;
  /** @maxLength 250 */
  employeeId?: string;
  /** @nullable */
  dob?: string | null;
  gender?: GenderEnum;
  /** @maxLength 250 */
  nationality?: string;
  country?: HomeAddressCountryEnum;
  /** @maxLength 50 */
  payrollId?: string;
  /** @maxLength 50 */
  niNumber?: string;
  note?: string;
  maritalStatus?: MaritalStatusEnum;
  title?: TitleEnum;
  /** @maxLength 250 */
  costCentre?: string;
  /**
   * @minimum 0
   * @maximum 1
   * @nullable
   */
  fullTimeEquivalent?: number | null;
  /**
   * @nullable
   * @pattern ^-?\d{0,8}(?:\.\d{0,2})?$
   */
  yearlyGrossSalary?: string | null;
  salaryCurrency?: SalaryCurrencyEnum;
  /**
   * @nullable
   * @pattern ^-?\d{0,3}(?:\.\d{0,2})?$
   */
  weeklyContractedHours?: string | null;
  excludeFromHrisSync?: boolean;
  /** @maxLength 50 */
  homeAddressAddressLine1?: string;
  /** @maxLength 50 */
  homeAddressAddressLine2?: string;
  /** @maxLength 20 */
  homeAddressCity?: string;
  homeAddressCountry?: HomeAddressCountryEnum;
  /** @maxLength 10 */
  homeAddressPostcode?: string;
  /** @maxLength 50 */
  homeAddressState?: string;
  /** @nullable */
  employmentStart?: string | null;
  /** @nullable */
  employmentEnd?: string | null;
  /** @nullable */
  probationEnd?: string | null;
  /** @maxLength 255 */
  jobTitle?: string;
  /** @maxLength 100 */
  department?: string;
  /** @maxLength 100 */
  officeLocation?: string;
  /** @maxLength 200 */
  residencyType?: string;
  /** @maxLength 200 */
  mobileNumber?: string;
  /** @maxLength 10 */
  mobileCountryCode?: string;
  updateAllFields?: boolean;
}

export interface EmployeeUrlResponse {
  url: string;
}

export interface EmployeeWeavrMFARequestRequest {
  phoneNumber: string;
}

/**
 * * `PENDING_VERIFICATION` - Pending Verification
 * * `ACTIVE` - Active
 * * `INACTIVE` - Inactive
 */
export type EmployeeWeavrMFAResponseStatusEnum =
  (typeof EmployeeWeavrMFAResponseStatusEnum)[keyof typeof EmployeeWeavrMFAResponseStatusEnum];

export const EmployeeWeavrMFAResponseStatusEnum = {
  PENDING_VERIFICATION: 'PENDING_VERIFICATION',
  ACTIVE: 'ACTIVE',
  INACTIVE: 'INACTIVE',
} as const;

export interface EmployeeWeavrMFAResponse {
  channel?: ChannelEnum;
  status?: EmployeeWeavrMFAResponseStatusEnum;
}

export interface EmployerConfigField {
  slug: string;
  value?: unknown | null;
}

export interface EmployerConfiguration {
  /** @maxLength 250 */
  adminHelpDeskUrl?: string;
  canCreateBenefit?: boolean;
  canViewBenefitWizard?: boolean;
  canViewSystemNotifications?: boolean;
  canViewCompanyWallet?: boolean;
  canCreateAllowanceRequest?: boolean;
  canViewCompensationCard?: boolean;
  canViewContributionCard?: boolean;
  canViewSearch?: boolean;
  canEmployeeViewIntercomMessenger?: boolean;
  canEmployeeViewIntercomSurveys?: boolean;
  canAdminViewIntercom?: boolean;
  canViewInvoices?: boolean;
  canViewMoneyManagement?: boolean;
  canViewProgrammes?: boolean;
  canViewCampaigns?: boolean;
  canViewResourcesHub?: boolean;
  /**
   * Custom name for the resources hub. Leave blank to use the default 'Resources' label.
   * @maxLength 20
   * @nullable
   */
  resourcesHubName?: string | null;
  enableHrisIntegrationConfig?: boolean;
  /** @maxLength 250 */
  helpDeskUrl?: string;
  /** @nullable */
  readonly mobileAppUrl: string | null;
  readonly isWhitelabel: boolean;
  values: EmployerConfigField[];
  /** Allow for the collection of alternate contact emails for employees */
  allowContactEmailUsage?: boolean;
  useCustomBenefitSorting?: boolean;
  readonly hasRewardsAndRecognition: boolean;
  readonly canViewEquityModeler: boolean;
  readonly showEnrolmentRequestsTab: boolean;
  readonly showBenefitRequestsTab: boolean;
  readonly showContributionHolidaysReport: boolean;
  readonly showDocumentSigningReport: boolean;
  /** Enable the NMW compliance report on ECC */
  showNmwReport?: boolean;
  /** Enable the auto-enrolment assessment report on ECC */
  showAeReport?: boolean;
  /** Send weekly auto-enrolment assessment report emails */
  aeWeeklyEmailOptIn?: boolean;
  canUseAchDirectDebit?: boolean;
  readonly contactTimezone: string;
}

export interface EmployerExternalLink {
  readonly id: number;
  name: string;
  /** @nullable */
  description: string | null;
  link: string;
  /** @nullable */
  readonly logoUrl: string | null;
  logoAltText: string;
}

export interface EmployerExternalLinkRequest {
  /** @minLength 1 */
  name: string;
  /** @nullable */
  description: string | null;
  /** @minLength 1 */
  link: string;
  /** @minLength 1 */
  logo_alt_text: string;
  logo?: Blob;
}

export interface SlackEmployerIntegrationChannel {
  id: number;
  slackId: string;
  name: string;
}

export interface SlackEmployerIntegrationTeam {
  id: number;
  slackId: string;
  name: string;
}

export interface SlackEmployerIntegration {
  status: string;
  editable: boolean;
  selectedChannels: SlackEmployerIntegrationChannel[];
  selectedTeams: SlackEmployerIntegrationTeam[];
  adminEmail: string;
  createdAt: string;
  /** @nullable */
  addWorkspacesRedirectUrl?: string | null;
}

export interface MSTeamsEmployerIntegrationChannel {
  id: number;
  msTeamsId: string;
  name: string;
}

export interface MSTeamsEmployerIntegrationTeam {
  id: number;
  name: string;
}

export interface MSTeamsEmployerIntegration {
  status: string;
  selectedChannels: MSTeamsEmployerIntegrationChannel[];
  selectedTeams: MSTeamsEmployerIntegrationTeam[];
  adminEmail: string;
  createdAt: string;
}

export interface EmployerIntegrationResponse {
  slack?: SlackEmployerIntegration | null;
  msTeams?: MSTeamsEmployerIntegration | null;
}

export interface EmployerListResponse {
  readonly id: number;
  /** @maxLength 200 */
  name: string;
}

export interface EmployerOfflineWorkerForm {
  id: string;
  /** @maxLength 250 */
  name: string;
  /** @nullable */
  description?: string | null;
  readonly schema: unknown;
  mapping: unknown;
  /** @nullable */
  readonly employerUrlSlug: string | null;
}

/**
 * @nullable
 */
export type EmployerResponseAuthConfiguration = {
  [key: string]: unknown;
} | null;

export interface EmployerResponse {
  companyId: number;
  name: string;
  iconUrl: string;
  welcomeText: string;
  hideProgrammes: boolean;
  /** @nullable */
  readonly authConfiguration: EmployerResponseAuthConfiguration;
  customCardImageMenuUrl: string;
  customCardImageVirtualUrl: string;
  customCardImagePhysicalUrl: string;
  hasTopupCards: boolean;
  hasCardProduct: boolean;
  readonly hasPerksatwork: boolean;
  currency: string;
  hideOffers: boolean;
  showEmployeeCompensation: boolean;
  profileExistingDataIsReadOnly: boolean;
  hostname: string;
  readonly reimbursementsManagedExternally: boolean;
  cardProvider: string;
  readonly hasHrisActive: boolean;
}

export interface EmployerRolesResponse {
  employerRoles: CustomEmployerRole[];
}

export type EnrollableBenefitLastEdited = { [key: string]: string };

export interface EnrollableBenefitFeature {
  id?: number;
  title: string;
  description: string;
  icon: string;
  category: string;
  readonly categoryTitle: string;
  readonly groupedCategory: string;
  readonly groupedCategoryTitle: string;
  readonly categoryIcon: string;
  rank?: number;
  readonly isFavorite: boolean;
}

export interface EnrollableBenefitSubPrice {
  pricingFormula: string;
  employeeContribution: number;
}

export interface EnrollableBenefitPricing {
  showPrice?: boolean;
  subPrices: EnrollableBenefitSubPrice[];
}

/**
 * Adds update and create logic shared between EnrollableBenefit serializers
 */
export interface EnrollableBenefit {
  /** @nullable */
  contentCs?: string | null;
  /** @nullable */
  contentDe?: string | null;
  /** @nullable */
  contentEl?: string | null;
  /** @nullable */
  contentEn?: string | null;
  /** @nullable */
  contentEnUs?: string | null;
  /** @nullable */
  contentEs?: string | null;
  /** @nullable */
  contentEsXl?: string | null;
  /** @nullable */
  contentFr?: string | null;
  /** @nullable */
  contentHu?: string | null;
  /** @nullable */
  contentIo?: string | null;
  /** @nullable */
  contentIt?: string | null;
  /** @nullable */
  contentJa?: string | null;
  /** @nullable */
  contentKo?: string | null;
  /** @nullable */
  contentMs?: string | null;
  /** @nullable */
  contentPl?: string | null;
  /** @nullable */
  contentPt?: string | null;
  /** @nullable */
  contentSk?: string | null;
  /** @nullable */
  contentTr?: string | null;
  /** @nullable */
  contentVi?: string | null;
  /** @nullable */
  contentZh?: string | null;
  /**
   * @maxLength 250
   * @nullable
   */
  ctaTextCs?: string | null;
  /**
   * @maxLength 250
   * @nullable
   */
  ctaTextDe?: string | null;
  /**
   * @maxLength 250
   * @nullable
   */
  ctaTextEl?: string | null;
  /**
   * @maxLength 250
   * @nullable
   */
  ctaTextEn?: string | null;
  /**
   * @maxLength 250
   * @nullable
   */
  ctaTextEnUs?: string | null;
  /**
   * @maxLength 250
   * @nullable
   */
  ctaTextEs?: string | null;
  /**
   * @maxLength 250
   * @nullable
   */
  ctaTextEsXl?: string | null;
  /**
   * @maxLength 250
   * @nullable
   */
  ctaTextFr?: string | null;
  /**
   * @maxLength 250
   * @nullable
   */
  ctaTextHu?: string | null;
  /**
   * @maxLength 250
   * @nullable
   */
  ctaTextIo?: string | null;
  /**
   * @maxLength 250
   * @nullable
   */
  ctaTextIt?: string | null;
  /**
   * @maxLength 250
   * @nullable
   */
  ctaTextJa?: string | null;
  /**
   * @maxLength 250
   * @nullable
   */
  ctaTextKo?: string | null;
  /**
   * @maxLength 250
   * @nullable
   */
  ctaTextMs?: string | null;
  /**
   * @maxLength 250
   * @nullable
   */
  ctaTextPl?: string | null;
  /**
   * @maxLength 250
   * @nullable
   */
  ctaTextPt?: string | null;
  /**
   * @maxLength 250
   * @nullable
   */
  ctaTextSk?: string | null;
  /**
   * @maxLength 250
   * @nullable
   */
  ctaTextTr?: string | null;
  /**
   * @maxLength 250
   * @nullable
   */
  ctaTextVi?: string | null;
  /**
   * @maxLength 250
   * @nullable
   */
  ctaTextZh?: string | null;
  /**
   * @maxLength 200
   * @nullable
   */
  displayNameCs?: string | null;
  /**
   * @maxLength 200
   * @nullable
   */
  displayNameDe?: string | null;
  /**
   * @maxLength 200
   * @nullable
   */
  displayNameEl?: string | null;
  /**
   * @maxLength 200
   * @nullable
   */
  displayNameEn?: string | null;
  /**
   * @maxLength 200
   * @nullable
   */
  displayNameEnUs?: string | null;
  /**
   * @maxLength 200
   * @nullable
   */
  displayNameEs?: string | null;
  /**
   * @maxLength 200
   * @nullable
   */
  displayNameEsXl?: string | null;
  /**
   * @maxLength 200
   * @nullable
   */
  displayNameFr?: string | null;
  /**
   * @maxLength 200
   * @nullable
   */
  displayNameHu?: string | null;
  /**
   * @maxLength 200
   * @nullable
   */
  displayNameIo?: string | null;
  /**
   * @maxLength 200
   * @nullable
   */
  displayNameIt?: string | null;
  /**
   * @maxLength 200
   * @nullable
   */
  displayNameJa?: string | null;
  /**
   * @maxLength 200
   * @nullable
   */
  displayNameKo?: string | null;
  /**
   * @maxLength 200
   * @nullable
   */
  displayNameMs?: string | null;
  /**
   * @maxLength 200
   * @nullable
   */
  displayNamePl?: string | null;
  /**
   * @maxLength 200
   * @nullable
   */
  displayNamePt?: string | null;
  /**
   * @maxLength 200
   * @nullable
   */
  displayNameSk?: string | null;
  /**
   * @maxLength 200
   * @nullable
   */
  displayNameTr?: string | null;
  /**
   * @maxLength 200
   * @nullable
   */
  displayNameVi?: string | null;
  /**
   * @maxLength 200
   * @nullable
   */
  displayNameZh?: string | null;
  /** @nullable */
  grossPayDeductionDescriptionCs?: string | null;
  /** @nullable */
  grossPayDeductionDescriptionDe?: string | null;
  /** @nullable */
  grossPayDeductionDescriptionEl?: string | null;
  /** @nullable */
  grossPayDeductionDescriptionEn?: string | null;
  /** @nullable */
  grossPayDeductionDescriptionEnUs?: string | null;
  /** @nullable */
  grossPayDeductionDescriptionEs?: string | null;
  /** @nullable */
  grossPayDeductionDescriptionEsXl?: string | null;
  /** @nullable */
  grossPayDeductionDescriptionFr?: string | null;
  /** @nullable */
  grossPayDeductionDescriptionHu?: string | null;
  /** @nullable */
  grossPayDeductionDescriptionIo?: string | null;
  /** @nullable */
  grossPayDeductionDescriptionIt?: string | null;
  /** @nullable */
  grossPayDeductionDescriptionJa?: string | null;
  /** @nullable */
  grossPayDeductionDescriptionKo?: string | null;
  /** @nullable */
  grossPayDeductionDescriptionMs?: string | null;
  /** @nullable */
  grossPayDeductionDescriptionPl?: string | null;
  /** @nullable */
  grossPayDeductionDescriptionPt?: string | null;
  /** @nullable */
  grossPayDeductionDescriptionSk?: string | null;
  /** @nullable */
  grossPayDeductionDescriptionTr?: string | null;
  /** @nullable */
  grossPayDeductionDescriptionVi?: string | null;
  /** @nullable */
  grossPayDeductionDescriptionZh?: string | null;
  /** @nullable */
  grossPayDeductionTitleCs?: string | null;
  /** @nullable */
  grossPayDeductionTitleDe?: string | null;
  /** @nullable */
  grossPayDeductionTitleEl?: string | null;
  /** @nullable */
  grossPayDeductionTitleEn?: string | null;
  /** @nullable */
  grossPayDeductionTitleEnUs?: string | null;
  /** @nullable */
  grossPayDeductionTitleEs?: string | null;
  /** @nullable */
  grossPayDeductionTitleEsXl?: string | null;
  /** @nullable */
  grossPayDeductionTitleFr?: string | null;
  /** @nullable */
  grossPayDeductionTitleHu?: string | null;
  /** @nullable */
  grossPayDeductionTitleIo?: string | null;
  /** @nullable */
  grossPayDeductionTitleIt?: string | null;
  /** @nullable */
  grossPayDeductionTitleJa?: string | null;
  /** @nullable */
  grossPayDeductionTitleKo?: string | null;
  /** @nullable */
  grossPayDeductionTitleMs?: string | null;
  /** @nullable */
  grossPayDeductionTitlePl?: string | null;
  /** @nullable */
  grossPayDeductionTitlePt?: string | null;
  /** @nullable */
  grossPayDeductionTitleSk?: string | null;
  /** @nullable */
  grossPayDeductionTitleTr?: string | null;
  /** @nullable */
  grossPayDeductionTitleVi?: string | null;
  /** @nullable */
  grossPayDeductionTitleZh?: string | null;
  /**
   * @maxLength 200
   * @nullable
   */
  nameCs?: string | null;
  /**
   * @maxLength 200
   * @nullable
   */
  nameDe?: string | null;
  /**
   * @maxLength 200
   * @nullable
   */
  nameEl?: string | null;
  /**
   * @maxLength 200
   * @nullable
   */
  nameEn?: string | null;
  /**
   * @maxLength 200
   * @nullable
   */
  nameEnUs?: string | null;
  /**
   * @maxLength 200
   * @nullable
   */
  nameEs?: string | null;
  /**
   * @maxLength 200
   * @nullable
   */
  nameEsXl?: string | null;
  /**
   * @maxLength 200
   * @nullable
   */
  nameFr?: string | null;
  /**
   * @maxLength 200
   * @nullable
   */
  nameHu?: string | null;
  /**
   * @maxLength 200
   * @nullable
   */
  nameIo?: string | null;
  /**
   * @maxLength 200
   * @nullable
   */
  nameIt?: string | null;
  /**
   * @maxLength 200
   * @nullable
   */
  nameJa?: string | null;
  /**
   * @maxLength 200
   * @nullable
   */
  nameKo?: string | null;
  /**
   * @maxLength 200
   * @nullable
   */
  nameMs?: string | null;
  /**
   * @maxLength 200
   * @nullable
   */
  namePl?: string | null;
  /**
   * @maxLength 200
   * @nullable
   */
  namePt?: string | null;
  /**
   * @maxLength 200
   * @nullable
   */
  nameSk?: string | null;
  /**
   * @maxLength 200
   * @nullable
   */
  nameTr?: string | null;
  /**
   * @maxLength 200
   * @nullable
   */
  nameVi?: string | null;
  /**
   * @maxLength 200
   * @nullable
   */
  nameZh?: string | null;
  /** @nullable */
  netPayDeductionDescriptionCs?: string | null;
  /** @nullable */
  netPayDeductionDescriptionDe?: string | null;
  /** @nullable */
  netPayDeductionDescriptionEl?: string | null;
  /** @nullable */
  netPayDeductionDescriptionEn?: string | null;
  /** @nullable */
  netPayDeductionDescriptionEnUs?: string | null;
  /** @nullable */
  netPayDeductionDescriptionEs?: string | null;
  /** @nullable */
  netPayDeductionDescriptionEsXl?: string | null;
  /** @nullable */
  netPayDeductionDescriptionFr?: string | null;
  /** @nullable */
  netPayDeductionDescriptionHu?: string | null;
  /** @nullable */
  netPayDeductionDescriptionIo?: string | null;
  /** @nullable */
  netPayDeductionDescriptionIt?: string | null;
  /** @nullable */
  netPayDeductionDescriptionJa?: string | null;
  /** @nullable */
  netPayDeductionDescriptionKo?: string | null;
  /** @nullable */
  netPayDeductionDescriptionMs?: string | null;
  /** @nullable */
  netPayDeductionDescriptionPl?: string | null;
  /** @nullable */
  netPayDeductionDescriptionPt?: string | null;
  /** @nullable */
  netPayDeductionDescriptionSk?: string | null;
  /** @nullable */
  netPayDeductionDescriptionTr?: string | null;
  /** @nullable */
  netPayDeductionDescriptionVi?: string | null;
  /** @nullable */
  netPayDeductionDescriptionZh?: string | null;
  /** @nullable */
  netPayDeductionTitleCs?: string | null;
  /** @nullable */
  netPayDeductionTitleDe?: string | null;
  /** @nullable */
  netPayDeductionTitleEl?: string | null;
  /** @nullable */
  netPayDeductionTitleEn?: string | null;
  /** @nullable */
  netPayDeductionTitleEnUs?: string | null;
  /** @nullable */
  netPayDeductionTitleEs?: string | null;
  /** @nullable */
  netPayDeductionTitleEsXl?: string | null;
  /** @nullable */
  netPayDeductionTitleFr?: string | null;
  /** @nullable */
  netPayDeductionTitleHu?: string | null;
  /** @nullable */
  netPayDeductionTitleIo?: string | null;
  /** @nullable */
  netPayDeductionTitleIt?: string | null;
  /** @nullable */
  netPayDeductionTitleJa?: string | null;
  /** @nullable */
  netPayDeductionTitleKo?: string | null;
  /** @nullable */
  netPayDeductionTitleMs?: string | null;
  /** @nullable */
  netPayDeductionTitlePl?: string | null;
  /** @nullable */
  netPayDeductionTitlePt?: string | null;
  /** @nullable */
  netPayDeductionTitleSk?: string | null;
  /** @nullable */
  netPayDeductionTitleTr?: string | null;
  /** @nullable */
  netPayDeductionTitleVi?: string | null;
  /** @nullable */
  netPayDeductionTitleZh?: string | null;
  /**
   * @maxLength 70
   * @nullable
   */
  shortDescriptionCs?: string | null;
  /**
   * @maxLength 70
   * @nullable
   */
  shortDescriptionDe?: string | null;
  /**
   * @maxLength 70
   * @nullable
   */
  shortDescriptionEl?: string | null;
  /**
   * @maxLength 70
   * @nullable
   */
  shortDescriptionEn?: string | null;
  /**
   * @maxLength 70
   * @nullable
   */
  shortDescriptionEnUs?: string | null;
  /**
   * @maxLength 70
   * @nullable
   */
  shortDescriptionEs?: string | null;
  /**
   * @maxLength 70
   * @nullable
   */
  shortDescriptionEsXl?: string | null;
  /**
   * @maxLength 70
   * @nullable
   */
  shortDescriptionFr?: string | null;
  /**
   * @maxLength 70
   * @nullable
   */
  shortDescriptionHu?: string | null;
  /**
   * @maxLength 70
   * @nullable
   */
  shortDescriptionIo?: string | null;
  /**
   * @maxLength 70
   * @nullable
   */
  shortDescriptionIt?: string | null;
  /**
   * @maxLength 70
   * @nullable
   */
  shortDescriptionJa?: string | null;
  /**
   * @maxLength 70
   * @nullable
   */
  shortDescriptionKo?: string | null;
  /**
   * @maxLength 70
   * @nullable
   */
  shortDescriptionMs?: string | null;
  /**
   * @maxLength 70
   * @nullable
   */
  shortDescriptionPl?: string | null;
  /**
   * @maxLength 70
   * @nullable
   */
  shortDescriptionPt?: string | null;
  /**
   * @maxLength 70
   * @nullable
   */
  shortDescriptionSk?: string | null;
  /**
   * @maxLength 70
   * @nullable
   */
  shortDescriptionTr?: string | null;
  /**
   * @maxLength 70
   * @nullable
   */
  shortDescriptionVi?: string | null;
  /**
   * @maxLength 70
   * @nullable
   */
  shortDescriptionZh?: string | null;
  active?: boolean;
  autoActivating?: boolean;
  /**
   * Select the programme that this benefit belongs to.
   * @nullable
   */
  benefitProgramme?: number | null;
  benefitRequirements?: BenefitRequirementsEnum[];
  /** @nullable */
  broker?: number | null;
  categories?: number[];
  /** Whether employees need to wait for open benefit window to opt into benefit after opt out. */
  closeOptInWindowAfterOptOut?: boolean;
  readonly currency: string;
  documents?: BenefitDocument[];
  enrolmentType?: EnrolmentTypeEnum;
  readonly enrolledEmployeesCount: number;
  /**
   * @maxLength 2100
   * @nullable
   */
  externalLinkUrl?: string | null;
  features?: EnrollableBenefitFeature[];
  /**
   * @maxLength 100
   * @nullable
   */
  groupMembershipNumber?: string | null;
  hasRenewableBenefit?: boolean;
  readonly id: number;
  /** @nullable */
  heroImage?: string | null;
  /** @nullable */
  heroImageAltText?: string | null;
  readonly heroImageUrl: string;
  /** @nullable */
  image?: string | null;
  /** @nullable */
  imageAltText?: string | null;
  readonly imageUrl: string;
  readonly isRestricted: boolean;
  readonly lastEdited: EnrollableBenefitLastEdited;
  readonly managedBy: string;
  /**
   * @maxLength 50
   * @nullable
   */
  optInButtonText?: string | null;
  /**
   * Copy to be shown on the benefit tile and banner.If not provided, the default copy will be used.
   * @maxLength 255
   * @nullable
   */
  optInCopy?: string | null;
  /**
   * Copy to be shown on the benefit tile and banner.If not provided, the default copy will be used.
   * @maxLength 255
   * @nullable
   */
  optOutCopy?: string | null;
  /**
   * Copy to be shown on the benefit tile and banner.
   * @maxLength 255
   * @nullable
   */
  optInCopyPreposition?: string | null;
  /**
   * Copy to be shown on the benefit tile and banner.
   * @maxLength 255
   * @nullable
   */
  optOutCopyPreposition?: string | null;
  pricing?: EnrollableBenefitPricing;
  /** @nullable */
  provider?: number | null;
  /**
   * @minimum -2147483648
   * @maximum 2147483647
   */
  rank?: number;
  /**
   *
   *             Date of the upcoming renewal, does not affect new renewal flow.
   * @nullable
   */
  renewalDate?: string | null;
  /** Whether company admins need to approve opt-ins or changes to enrolments. */
  requiresActivationApproval?: boolean;
  /** Whether company admins need to approve opt-outs to enrolments. */
  requiresDeactivationApproval?: boolean;
  status?: StatusC27Enum | null;
  /** @nullable */
  airtableId?: string | null;
  readonly hasEligibilityRule: boolean;
  readonly hasActiveAutoEnrolmentRules: boolean;
}

export type EnrollableBenefitDetailResponseOptOutReasonChoicesItem = {
  [key: string]: unknown;
};

export type EnrollableBenefitDetailResponseTabs = { [key: string]: boolean };

export type EnrollableBenefitDetailResponseBenefitRequestsItem = {
  [key: string]: unknown;
};

export type EnrollableBenefitDetailResponseFeaturesItem = {
  [key: string]: unknown;
};

export type EnrollableBenefitDetailResponseCustomModalsItem = {
  [key: string]: unknown;
};

export type PaymentSourceEnum =
  (typeof PaymentSourceEnum)[keyof typeof PaymentSourceEnum];

export const PaymentSourceEnum = {
  SALARY: 'SALARY',
  ALLOWANCE: 'ALLOWANCE',
  SALARY_ALLOWANCE: 'SALARY_ALLOWANCE',
  SALARY_OR_ALLOWANCE: 'SALARY_OR_ALLOWANCE',
  ALLOWANCE_THEN_SALARY: 'ALLOWANCE_THEN_SALARY',
} as const;

/**
 * * `REGULAR` - Regular
 * * `LOAN` - Loan
 */
export type NewBenefitTypeEnum =
  (typeof NewBenefitTypeEnum)[keyof typeof NewBenefitTypeEnum];

export const NewBenefitTypeEnum = {
  REGULAR: 'REGULAR',
  LOAN: 'LOAN',
} as const;

/**
 * @nullable
 */
export type EnrollableBenefitResponseAdditionalConfig = {
  [key: string]: unknown;
} | null;

/**
 * @nullable
 */
export type EnrollableBenefitResponseAllowance = {
  [key: string]: unknown;
} | null;

export interface EnrollableBenefitResponse {
  readonly id: number;
  name: string;
  showPrice?: boolean;
  /** Show payment sources in the benefit details screen. */
  showPaymentSources?: boolean;
  /** Show total loan banner in the benefit details screen. */
  showTotalLoanBanner?: boolean;
  paymentSource?: PaymentSourceEnum;
  /**
   * Controls the pre-selected default split for Salary and Allowance and Salary or Allowance payment sources. ALLOWANCE_FIRST maximises allowance usage, SALARY_FIRST defaults to full salary deduction.
   *
   * * `ALLOWANCE_FIRST` - Allowance First
   * * `SALARY_FIRST` - Salary First
   */
  defaultDeductionSource?: DefaultDeductionSourceEnum;
  readonly missingRequirements: readonly string[];
  benefitRequirements: BenefitRequirementsEnum[];
  /** @nullable */
  readonly additionalConfig: EnrollableBenefitResponseAdditionalConfig;
  /** @nullable */
  imageUrl: string | null;
  /** @nullable */
  imageAltText: string | null;
  /** @nullable */
  readonly heroImageUrl: string | null;
  /** @nullable */
  readonly allowance: EnrollableBenefitResponseAllowance;
  /** @nullable */
  readonly content: string | null;
  /**
   * @maxLength 250
   * @nullable
   */
  ctaText?: string | null;
  /** @nullable */
  readonly externalLinkUrl: string | null;
  /** @nullable */
  readonly benefitProductType: string | null;
  /**
   *
   *         New benefit type field, discussion ongoing on whether we extend this or not.
   *
   *
   * * `REGULAR` - Regular
   * * `LOAN` - Loan
   */
  newBenefitType?: NewBenefitTypeEnum;
  readonly documents: string;
  /**
   * @maxLength 50
   * @nullable
   */
  optInButtonText?: string | null;
  hasWaiverGroup?: boolean;
  /** Allow employee to choose pay deduction type (Gross or Net) during enrolment. */
  allowEmployeePayDeductionChoice?: boolean;
  /** @nullable */
  grossPayDeductionTitle?: string | null;
  /** @nullable */
  grossPayDeductionDescription?: string | null;
  /** @nullable */
  netPayDeductionTitle?: string | null;
  /** @nullable */
  netPayDeductionDescription?: string | null;
  /** Automatically close all enrollment windows when fulfillment occurs */
  closeWindowsOnFulfillment?: boolean;
  /** Hide the 'configuration window closed' banner in the EA for externally managed benefits */
  hideClosedConfigWindowBanner?: boolean;
  /**
   * Minimum monthly amount (in benefit currency) that must come from allowance. Only valid for SALARY_ALLOWANCE payment source. Set to the same value as max_allowance_deduction to lock the allowance contribution to a fixed amount.
   * @nullable
   * @pattern ^-?\d{0,13}(?:\.\d{0,2})?$
   */
  minAllowanceDeduction?: string | null;
  /**
   * Maximum monthly amount (in benefit currency) that can come from allowance. Only valid for SALARY_ALLOWANCE payment source. Set to the same value as min_allowance_deduction to lock the allowance contribution to a fixed amount.
   * @nullable
   * @pattern ^-?\d{0,13}(?:\.\d{0,2})?$
   */
  maxAllowanceDeduction?: string | null;
}

export interface PensionHolidayContext {
  isEnabled: boolean;
  isEligible: boolean;
  /** @nullable */
  ineligibilityReasonCode: string | null;
  requiresApproval: boolean;
  /** @nullable */
  benefitRequestConfigId: number | null;
  durationMode: string;
  allowedDurationsMonths: number[];
  /** @nullable */
  fixedDurationMonths: number | null;
  allowIndefinite: boolean;
  earliestStartDate: string;
  openRequest: BenefitRequestGetResponse | null;
  activeHoliday: ActiveHoliday | null;
  awaitingResume: AwaitingResumeHoliday | null;
  avcAvailable: boolean;
}

export interface EnrollableBenefitDetailResponse {
  readonly name: string;
  readonly benefit: EnrollableBenefitResponse;
  enrolment: BenefitEnrolmentResponse | null;
  readonly canOptIn: boolean;
  readonly canUpdate: boolean;
  readonly canOptOut: boolean;
  readonly canWaive: boolean;
  readonly optOutReasonChoices: readonly EnrollableBenefitDetailResponseOptOutReasonChoicesItem[];
  readonly tabs: EnrollableBenefitDetailResponseTabs;
  readonly benefitRequests: readonly EnrollableBenefitDetailResponseBenefitRequestsItem[];
  readonly features: readonly EnrollableBenefitDetailResponseFeaturesItem[];
  readonly customModals: readonly EnrollableBenefitDetailResponseCustomModalsItem[];
  /** @nullable */
  readonly optInCopy: string | null;
  /** @nullable */
  readonly optOutCopy: string | null;
  /** @nullable */
  readonly optInCopyPreposition: string | null;
  /** @nullable */
  readonly optOutCopyPreposition: string | null;
  canFallbackToSalary?: boolean;
  readonly avcCycleContext: AvcCycleContext | null;
  readonly pensionHoliday: PensionHolidayContext | null;
}

export interface EnrollableBenefitEmployeeFeatureUpdate {
  isFavorite: boolean;
}

/**
 * * `BENEFIT_TYPE_LIFESTYLE` - Lifestyle
 * * `BENEFIT_TYPE_FINANCE` - Finance
 * * `BENEFIT_TYPE_FAMILY` - Family
 * * `BENEFIT_TYPE_HEALTH_WELLBEING` - Health & Wellbeing
 * * `BENEFIT_TYPE_OTHER` - Other
 * * `UNASSIGNED` - UNASSIGNED
 */
export type NameEnum = (typeof NameEnum)[keyof typeof NameEnum];

export const NameEnum = {
  BENEFIT_TYPE_LIFESTYLE: 'BENEFIT_TYPE_LIFESTYLE',
  BENEFIT_TYPE_FINANCE: 'BENEFIT_TYPE_FINANCE',
  BENEFIT_TYPE_FAMILY: 'BENEFIT_TYPE_FAMILY',
  BENEFIT_TYPE_HEALTH_WELLBEING: 'BENEFIT_TYPE_HEALTH_WELLBEING',
  BENEFIT_TYPE_OTHER: 'BENEFIT_TYPE_OTHER',
  UNASSIGNED: 'UNASSIGNED',
} as const;

export interface MinimalEnrollableBenefitFeature {
  id: number;
  title: string;
}

export interface EnrollableBenefitFeatureCategory {
  name: NameEnum;
  readonly icon: string;
  features: MinimalEnrollableBenefitFeature[];
}

export interface EnrollableBenefitFeatureCategoryResponse {
  count: number;
  results: EnrollableBenefitFeatureCategory[];
}

export interface EnrollableBenefitFeatureSerializerWithBenefitDetails {
  id?: number;
  title: string;
  description: string;
  icon: string;
  category: string;
  readonly categoryTitle: string;
  readonly groupedCategory: string;
  readonly groupedCategoryTitle: string;
  readonly categoryIcon: string;
  rank?: number;
  readonly isFavorite: boolean;
  benefitId: number;
  readonly benefitName: string;
  /** @nullable */
  benefitImageAltText?: string | null;
  benefitImageUrl: string;
}

export type EnrollableBenefitListResponseEnrollableBenefitsItem =
  | {
      id: number;
      name: string;
    }
  | {
      readonly id: number;
      categories: BenefitCategory[];
      /**
       * @maxLength 200
       * @nullable
       */
      displayNameEn?: string | null;
      /**
       * Select the programme that this benefit belongs to.
       * @nullable
       */
      benefitProgramme?: number | null;
      /** @maxLength 200 */
      name: string;
      status?: StatusC27Enum | null;
      enrolledEmployeesCount: number;
      readonly image: BaseImage;
      imageAltText: string;
      readonly isRestricted: boolean;
      readonly lastEdited: { [key: string]: string | null };
      readonly managedBy: string;
    };

export interface EnrollableBenefitListResponse {
  totalItemCount?: number;
  enrollableBenefits?: EnrollableBenefitListResponseEnrollableBenefitsItem[];
}

/**
 * Minimal name and id only serializer for a list of enrollable benefits.
 */
export interface EnrollableBenefitNamesOnlyResponse {
  id: number;
  name: string;
}

export type EnrollableBenefitPreviewResponseLastEdited = {
  [key: string]: string | null;
};

/**
 * Serializer for previewing the EnrollableBenefit model,
 * serializing selected fields along with additional calculated fields.
 */
export interface EnrollableBenefitPreviewResponse {
  readonly id: number;
  categories: BenefitCategory[];
  /**
   * @maxLength 200
   * @nullable
   */
  displayNameEn?: string | null;
  /**
   * Select the programme that this benefit belongs to.
   * @nullable
   */
  benefitProgramme?: number | null;
  /** @maxLength 200 */
  name: string;
  status?: StatusC27Enum | null;
  enrolledEmployeesCount: number;
  readonly image: BaseImage;
  imageAltText: string;
  readonly isRestricted: boolean;
  readonly lastEdited: EnrollableBenefitPreviewResponseLastEdited;
  readonly managedBy: string;
}

export interface EnrollableBenefitVersion {
  readonly id: number;
  scheduledRenewalDate: string;
  /** @nullable */
  renewalWindowStartDate?: string | null;
  /** @nullable */
  renewalWindowEndDate?: string | null;
  isInRenewalPhase: boolean;
}

export interface EnrolmentChangeResponse {
  readonly notifications: unknown;
  readonly unreadNotificationsCount: number;
}

export interface EnrolmentSnapshot {
  id: number;
  benefitId: number;
  benefitName: string;
  /** @nullable */
  benefitProgrammeAllowanceId?: number | null;
  /** @nullable */
  pricePerMonth?: number | null;
  /** @nullable */
  employeeMonthlyPrice?: number | null;
  /** @nullable */
  employerMonthlyPrice?: number | null;
  /** @nullable */
  employeeYearlyPrice?: number | null;
  /** @nullable */
  employerYearlyPrice?: number | null;
  /** @nullable */
  salaryDeduction?: number | null;
  /** @nullable */
  allowanceDeduction?: number | null;
  /** @nullable */
  benefitStartDate?: string | null;
  /** @nullable */
  benefitEndDate?: string | null;
  isActive?: boolean;
}

export interface EnrolmentSnapshotRequest {
  id: number;
  benefitId: number;
  /** @minLength 1 */
  benefitName: string;
  /** @nullable */
  benefitProgrammeAllowanceId?: number | null;
  /** @nullable */
  pricePerMonth?: number | null;
  /** @nullable */
  employeeMonthlyPrice?: number | null;
  /** @nullable */
  employerMonthlyPrice?: number | null;
  /** @nullable */
  employeeYearlyPrice?: number | null;
  /** @nullable */
  employerYearlyPrice?: number | null;
  /** @nullable */
  salaryDeduction?: number | null;
  /** @nullable */
  allowanceDeduction?: number | null;
  /** @nullable */
  benefitStartDate?: string | null;
  /** @nullable */
  benefitEndDate?: string | null;
  isActive?: boolean;
}

export interface EnrolmentUpdateRequestRequest {
  contributionSources?: BenefitEnrolmentContributionSourceRequestRequest | null;
  /** @nullable */
  changeReason?: string | null;
  payDeductionType?: PayDeductionTypeEnum | null;
}

/**
 * * `CONFIG_WINDOW` - Config Window
 * * `OPT_IN_WINDOW` - Opt-in Window
 * * `OPT_OUT_WINDOW` - Opt-out Window
 * * `LOCKED_WINDOW` - Locked Window
 * * `REQUEST_WINDOW` - Request Window
 */
export type WindowTypeEnum =
  (typeof WindowTypeEnum)[keyof typeof WindowTypeEnum];

export const WindowTypeEnum = {
  CONFIG_WINDOW: 'CONFIG_WINDOW',
  OPT_IN_WINDOW: 'OPT_IN_WINDOW',
  OPT_OUT_WINDOW: 'OPT_OUT_WINDOW',
  LOCKED_WINDOW: 'LOCKED_WINDOW',
  REQUEST_WINDOW: 'REQUEST_WINDOW',
} as const;

/**
 * * `OPEN` - OPEN
 * * `CLOSE` - CLOSE
 */
export type EnrolmentWindowChangeActionEnum =
  (typeof EnrolmentWindowChangeActionEnum)[keyof typeof EnrolmentWindowChangeActionEnum];

export const EnrolmentWindowChangeActionEnum = {
  OPEN: 'OPEN',
  CLOSE: 'CLOSE',
} as const;

export interface EnrolmentWindowChange {
  benefit: number;
  employees: number[];
  windowType: WindowTypeEnum;
  action: EnrolmentWindowChangeActionEnum;
}

export interface EnrolmentWindowChangeRequest {
  benefit: number;
  employees: number[];
  windowType: WindowTypeEnum;
  action: EnrolmentWindowChangeActionEnum;
}

export interface EntityRef {
  id: number;
  name: string;
}

export interface EquityItem {
  text: string;
  /** @pattern ^-?\d{0,14}(?:\.\d{0,6})?$ */
  value: string;
  /** @pattern ^-?\d{0,14}(?:\.\d{0,6})?$ */
  shares: string;
  tooltipText?: string;
}

export interface EquityModelerGrowthRangeConfig {
  default: number;
  min: number;
  max: number;
  step: number;
}

export interface EquityModelerPriceRangeConfig {
  default: number;
  min: number;
  /** @nullable */
  max: number | null;
  /** @nullable */
  step: number | null;
}

export interface EquityModelerPriceModeConfig {
  defaultMode: DefaultModeEnum;
  allowToggle: boolean;
  visible: boolean;
  growth: EquityModelerGrowthRangeConfig;
  price: EquityModelerPriceRangeConfig;
}

export interface EquityModelerTaxRateConfig {
  visible: boolean;
  default: number;
  min: number;
  max: number;
  step: number;
}

export interface EquityModelerPerformanceFactorConfig {
  visible: boolean;
  default: number;
  /** @nullable */
  min: number | null;
  /** @nullable */
  max: number | null;
  /** @nullable */
  step: number | null;
}

export interface EquityModelerProjectedGrantAmountConfig {
  max: number;
}

export interface EquityModelerAssumptionsConfig {
  priceMode: EquityModelerPriceModeConfig;
  taxRate: EquityModelerTaxRateConfig;
  performanceFactor: EquityModelerPerformanceFactorConfig;
  projectionYears?: number;
  projectedGrantAmount?: EquityModelerProjectedGrantAmountConfig;
}

/**
 * * `growth` - growth
 * * `price` - price
 */
export type PriceModeEnum = (typeof PriceModeEnum)[keyof typeof PriceModeEnum];

export const PriceModeEnum = {
  growth: 'growth',
  price: 'price',
} as const;

export interface EquityModelerCalculateAssumptionsRequest {
  /** @pattern ^-?\d{0,14}(?:\.\d{0,6})?$ */
  growthRate: string;
  /** @pattern ^-?\d{0,14}(?:\.\d{0,6})?$ */
  taxRate: string;
  /** @pattern ^-?\d{0,14}(?:\.\d{0,6})?$ */
  stockPrice: string;
  /** @pattern ^-?\d{0,14}(?:\.\d{0,6})?$ */
  psuPerformance?: string;
  priceMode?: PriceModeEnum;
}

/**
 * * `summary_cards` - summary_cards
 * * `projection_panel` - projection_panel
 */
export type EquityModelerOutputsComponentTypeEnum =
  (typeof EquityModelerOutputsComponentTypeEnum)[keyof typeof EquityModelerOutputsComponentTypeEnum];

export const EquityModelerOutputsComponentTypeEnum = {
  summary_cards: 'summary_cards',
  projection_panel: 'projection_panel',
} as const;

/**
 * * `currency` - currency
 * * `percent` - percent
 * * `percent_growth` - percent_growth
 * * `number` - number
 */
export type FormatEnum = (typeof FormatEnum)[keyof typeof FormatEnum];

export const FormatEnum = {
  currency: 'currency',
  percent: 'percent',
  percent_growth: 'percent_growth',
  number: 'number',
} as const;

export interface SummaryCardItem {
  id: string;
  label: string;
  /** @pattern ^-?\d{0,10}(?:\.\d{0,10})?$ */
  value: string;
  format: FormatEnum;
}

export interface ProjectionTableColumn {
  dataKey: string;
  align: AlignEnum;
}

export interface ProjectionTableRow {
  id: string;
  year: string;
  /** @pattern ^-?\d{0,18}(?:\.\d{0,2})?$ */
  rsuGranted?: string;
  /** @pattern ^-?\d{0,18}(?:\.\d{0,2})?$ */
  rsuProjected?: string;
  /** @pattern ^-?\d{0,18}(?:\.\d{0,2})?$ */
  psuGranted?: string;
  /** @pattern ^-?\d{0,18}(?:\.\d{0,2})?$ */
  psuProjected?: string;
  /** @pattern ^-?\d{0,18}(?:\.\d{0,2})?$ */
  estimatedTaxes: string;
  /** @pattern ^-?\d{0,18}(?:\.\d{0,2})?$ */
  total: string;
}

export interface ProjectionTotalsRow {
  id: string;
  /** @nullable */
  year: string | null;
  /** @pattern ^-?\d{0,18}(?:\.\d{0,2})?$ */
  rsuGranted?: string;
  /** @pattern ^-?\d{0,18}(?:\.\d{0,2})?$ */
  rsuProjected?: string;
  /** @pattern ^-?\d{0,18}(?:\.\d{0,2})?$ */
  psuGranted?: string;
  /** @pattern ^-?\d{0,18}(?:\.\d{0,2})?$ */
  psuProjected?: string;
  /** @pattern ^-?\d{0,18}(?:\.\d{0,2})?$ */
  estimatedTaxes: string;
  /** @pattern ^-?\d{0,18}(?:\.\d{0,2})?$ */
  total: string;
}

export interface ProjectionTable {
  columns: ProjectionTableColumn[];
  rows: ProjectionTableRow[];
  totalsRow: ProjectionTotalsRow;
}

export interface ProjectionChart {
  legend: ChartLegendEntry[];
  years: ChartYearPoint[];
}

export interface EquityModelerOutputsComponent {
  type: EquityModelerOutputsComponentTypeEnum;
  items?: SummaryCardItem[];
  defaultView?: DefaultViewEnum;
  table?: ProjectionTable;
  chart?: ProjectionChart;
}

export interface EquityModelerCalculateOutputs {
  components: EquityModelerOutputsComponent[];
}

/**
 * @nullable
 */
export type EquityModelerCalculateRequestRequestProjectedGrantValues = {
  [key: string]: number;
} | null;

export interface EquityModelerCalculateRequestRequest {
  assumptions: EquityModelerCalculateAssumptionsRequest;
  /** @nullable */
  projectedGrantValues?: EquityModelerCalculateRequestRequestProjectedGrantValues;
}

export interface EquityModelerCalculateResponse {
  outputs: EquityModelerCalculateOutputs;
}

export interface EquityModelerChartSeriesColors {
  rsuGranted: string;
  rsuProjected: string;
  psuGranted: string;
  psuProjected: string;
  estimatedTaxes: string;
}

export interface EquityModelerCopyAssumptionsModeToggle {
  growth: string;
  price: string;
}

export type EquityModelerCopyAssumptionsPanelTooltips = {
  [key: string]: string;
};

export interface EquityModelerCopyAssumptionsPanel {
  growthLabel: string;
  priceLabel: string;
  taxLabel: string;
  modeToggle: EquityModelerCopyAssumptionsModeToggle;
  title?: string;
  tooltips?: EquityModelerCopyAssumptionsPanelTooltips;
  psuModifierLabel?: string;
}

export interface EquityModelerCopyGrantsTableColumns {
  year: string;
  rsuGrantValue: string;
  psuGrantValue: string;
}

export interface EquityModelerCopyGrantsTable {
  columns: EquityModelerCopyGrantsTableColumns;
  psuTooltip: string;
  rsuTooltip?: string;
  rowSuffixGranted?: string;
  rowSuffixProjected?: string;
}

export interface EquityModelerCopyOutputCard {
  label: string;
  description: string;
}

export interface EquityModelerCopyOutputCardLabelOnly {
  label: string;
}

export interface EquityModelerCopyOutputCards {
  projectedTotal: EquityModelerCopyOutputCard;
  valueGrowth: EquityModelerCopyOutputCard;
  estimatedTaxes?: EquityModelerCopyOutputCardLabelOnly;
}

export type EquityModelerCopyProjectionPanelColumnLabels = {
  [key: string]: string;
};

export type EquityModelerCopyProjectionPanelLegendLabels = {
  [key: string]: string;
};

export type EquityModelerCopyProjectionPanelChartHover = {
  [key: string]: string;
};

export interface EquityModelerCopyProjectionToggleLabels {
  chart: string;
  table: string;
}

export interface EquityModelerCopyProjectionPanel {
  title: string;
  description: string;
  toggleLabels: EquityModelerCopyProjectionToggleLabels;
  columnLabels?: EquityModelerCopyProjectionPanelColumnLabels;
  legendLabels?: EquityModelerCopyProjectionPanelLegendLabels;
  totalsRowLabel?: string;
  chartHover?: EquityModelerCopyProjectionPanelChartHover;
}

export interface EquityModelerCopyTodayCard {
  title: string;
  description: string;
}

export interface EquityModelerDisclaimerItem {
  title: string;
  description: string;
}

export interface EquityModelerEmployeeIdentity {
  id: number;
  email: string;
  firstName: string;
  lastName: string;
  preferredLanguage: string;
}

export interface EquityModelerVisibility {
  showModeler: boolean;
  showRsuFields: boolean;
  showPsuFields: boolean;
}

export interface EquityModelerSharePrice {
  /** @pattern ^-?\d{0,16}(?:\.\d{0,2})?$ */
  amount: string;
  asOfDate: string;
}

export interface EquityModelerUnvestedValue {
  /** @pattern ^-?\d{0,16}(?:\.\d{0,2})?$ */
  amount: string;
}

/**
 * * `granted` - granted
 * * `projected` - projected
 */
export type EquityModelerGrantsByYearRowStatusEnum =
  (typeof EquityModelerGrantsByYearRowStatusEnum)[keyof typeof EquityModelerGrantsByYearRowStatusEnum];

export const EquityModelerGrantsByYearRowStatusEnum = {
  granted: 'granted',
  projected: 'projected',
} as const;

export interface EquityModelerGrantsByYearRow {
  id: string;
  year: string;
  /** @pattern ^-?\d{0,16}(?:\.\d{0,2})?$ */
  rsuGrantValue: string;
  /** @pattern ^-?\d{0,16}(?:\.\d{0,2})?$ */
  psuGrantValue: string;
  status: EquityModelerGrantsByYearRowStatusEnum;
}

export interface EquityModelerEmployeeStateResponse {
  visibility: EquityModelerVisibility;
  employee: EquityModelerEmployeeIdentity;
  sharePrice: EquityModelerSharePrice;
  unvestedValue: EquityModelerUnvestedValue;
  grantsByYear: EquityModelerGrantsByYearRow[];
}

export type EquityModelerPageCopySections = { [key: string]: string };

export interface EquityModelerPageCopy {
  pageTitle: string;
  pageSubtitle: string;
  sections: EquityModelerPageCopySections;
  todayCard: EquityModelerCopyTodayCard;
  outputCards: EquityModelerCopyOutputCards;
  projectionPanel: EquityModelerCopyProjectionPanel;
  assumptionsPanel: EquityModelerCopyAssumptionsPanel;
  grantsTable: EquityModelerCopyGrantsTable;
}

/**
 * * `rsu_granted` - rsu_granted
 * * `rsu_projected` - rsu_projected
 * * `psu_granted` - psu_granted
 * * `psu_projected` - psu_projected
 * * `estimated_taxes` - estimated_taxes
 */
export type LegendOrderEnum =
  (typeof LegendOrderEnum)[keyof typeof LegendOrderEnum];

export const LegendOrderEnum = {
  rsu_granted: 'rsu_granted',
  rsu_projected: 'rsu_projected',
  psu_granted: 'psu_granted',
  psu_projected: 'psu_projected',
  estimated_taxes: 'estimated_taxes',
} as const;

export interface EquityModelerTheme {
  chartSeriesColors: EquityModelerChartSeriesColors;
  legendOrder?: LegendOrderEnum[];
}

export interface EquityModelerPageContextResponse {
  employerCurrency: string;
  /** @nullable */
  schemaVersion: string | null;
  copy: EquityModelerPageCopy;
  assumptionsConfig: EquityModelerAssumptionsConfig;
  theme: EquityModelerTheme;
  disclaimers: EquityModelerDisclaimerItem[];
  calculationSummary: unknown;
}

export interface EquitySummary {
  groupId: string;
  cardType: string;
  text: string;
  /** @pattern ^-?\d{0,14}(?:\.\d{0,6})?$ */
  totalValue: string;
  /** @pattern ^-?\d{0,14}(?:\.\d{0,6})?$ */
  totalShares: string;
  shareItems: EquityItem[];
  tooltipText: string;
}

export interface EstCompPackageFeaturedBlockData {
  currency: string;
  /** @nullable */
  grossSalary: string | null;
  /** @nullable */
  pension: string | null;
  /** @nullable */
  wallet: string | null;
  /** @nullable */
  totalPackage: string | null;
  taxYear: CurrentTaxYear | null;
}

export interface ExtractionField {
  value: unknown | null;
  /** @nullable */
  confidence: number | null;
}

/**
 * * `benefit` - Benefit
 */
export type FeatureTypeEnum =
  (typeof FeatureTypeEnum)[keyof typeof FeatureTypeEnum];

export const FeatureTypeEnum = {
  benefit: 'benefit',
} as const;

export interface FeaturedProviderResponse {
  readonly id: number;
  /** @nullable */
  imageUrl: string | null;
  /** @maxLength 200 */
  name: string;
  /**
   * @maxLength 200
   * @nullable
   */
  nameEn?: string | null;
  /**
   * @maxLength 200
   * @nullable
   */
  nameDe?: string | null;
  /**
   * @maxLength 200
   * @nullable
   */
  nameFr?: string | null;
  /**
   * @maxLength 200
   * @nullable
   */
  nameEs?: string | null;
  /**
   * @maxLength 200
   * @nullable
   */
  nameEsXl?: string | null;
  /**
   * @maxLength 200
   * @nullable
   */
  nameEnUs?: string | null;
  /**
   * @maxLength 200
   * @nullable
   */
  nameSk?: string | null;
  /**
   * @maxLength 200
   * @nullable
   */
  nameEl?: string | null;
  /**
   * @maxLength 200
   * @nullable
   */
  nameCs?: string | null;
  /**
   * @maxLength 200
   * @nullable
   */
  nameIt?: string | null;
  /**
   * @maxLength 200
   * @nullable
   */
  nameJa?: string | null;
  /**
   * @maxLength 200
   * @nullable
   */
  nameKo?: string | null;
  /**
   * @maxLength 200
   * @nullable
   */
  nameMs?: string | null;
  /**
   * @maxLength 200
   * @nullable
   */
  namePl?: string | null;
  /**
   * @maxLength 200
   * @nullable
   */
  nameTr?: string | null;
  /**
   * @maxLength 200
   * @nullable
   */
  namePt?: string | null;
  /**
   * @maxLength 200
   * @nullable
   */
  nameHu?: string | null;
  /**
   * @maxLength 200
   * @nullable
   */
  nameIo?: string | null;
  /**
   * @maxLength 200
   * @nullable
   */
  nameVi?: string | null;
  /**
   * @maxLength 200
   * @nullable
   */
  nameZh?: string | null;
  /** @maxLength 200 */
  shortDescription: string;
  /**
   * @maxLength 200
   * @nullable
   */
  shortDescriptionEn?: string | null;
  /**
   * @maxLength 200
   * @nullable
   */
  shortDescriptionDe?: string | null;
  /**
   * @maxLength 200
   * @nullable
   */
  shortDescriptionFr?: string | null;
  /**
   * @maxLength 200
   * @nullable
   */
  shortDescriptionEs?: string | null;
  /**
   * @maxLength 200
   * @nullable
   */
  shortDescriptionEsXl?: string | null;
  /**
   * @maxLength 200
   * @nullable
   */
  shortDescriptionEnUs?: string | null;
  /**
   * @maxLength 200
   * @nullable
   */
  shortDescriptionSk?: string | null;
  /**
   * @maxLength 200
   * @nullable
   */
  shortDescriptionEl?: string | null;
  /**
   * @maxLength 200
   * @nullable
   */
  shortDescriptionCs?: string | null;
  /**
   * @maxLength 200
   * @nullable
   */
  shortDescriptionIt?: string | null;
  /**
   * @maxLength 200
   * @nullable
   */
  shortDescriptionJa?: string | null;
  /**
   * @maxLength 200
   * @nullable
   */
  shortDescriptionKo?: string | null;
  /**
   * @maxLength 200
   * @nullable
   */
  shortDescriptionMs?: string | null;
  /**
   * @maxLength 200
   * @nullable
   */
  shortDescriptionPl?: string | null;
  /**
   * @maxLength 200
   * @nullable
   */
  shortDescriptionTr?: string | null;
  /**
   * @maxLength 200
   * @nullable
   */
  shortDescriptionPt?: string | null;
  /**
   * @maxLength 200
   * @nullable
   */
  shortDescriptionHu?: string | null;
  /**
   * @maxLength 200
   * @nullable
   */
  shortDescriptionIo?: string | null;
  /**
   * @maxLength 200
   * @nullable
   */
  shortDescriptionVi?: string | null;
  /**
   * @maxLength 200
   * @nullable
   */
  shortDescriptionZh?: string | null;
  description?: string;
  /** @nullable */
  descriptionEn?: string | null;
  /** @nullable */
  descriptionDe?: string | null;
  /** @nullable */
  descriptionFr?: string | null;
  /** @nullable */
  descriptionEs?: string | null;
  /** @nullable */
  descriptionEsXl?: string | null;
  /** @nullable */
  descriptionEnUs?: string | null;
  /** @nullable */
  descriptionSk?: string | null;
  /** @nullable */
  descriptionEl?: string | null;
  /** @nullable */
  descriptionCs?: string | null;
  /** @nullable */
  descriptionIt?: string | null;
  /** @nullable */
  descriptionJa?: string | null;
  /** @nullable */
  descriptionKo?: string | null;
  /** @nullable */
  descriptionMs?: string | null;
  /** @nullable */
  descriptionPl?: string | null;
  /** @nullable */
  descriptionTr?: string | null;
  /** @nullable */
  descriptionPt?: string | null;
  /** @nullable */
  descriptionHu?: string | null;
  /** @nullable */
  descriptionIo?: string | null;
  /** @nullable */
  descriptionVi?: string | null;
  /** @nullable */
  descriptionZh?: string | null;
  /**
   * @maxLength 200
   * @nullable
   */
  externalLinkUrl?: string | null;
  /** @nullable */
  readonly pricePerMonthCurrency: string | null;
  /**
   * @nullable
   * @pattern ^-?\d{0,8}(?:\.\d{0,2})?$
   */
  pricePerMonth?: string | null;
  isActive?: boolean;
  hideTaskPage?: boolean;
  /**
   * Leave this field empty if you want to use this provider with more than one employer.
   * @nullable
   */
  employer?: number | null;
}

/**
 * * `TEXT` - Text
 * * `NUMBER` - Number
 * * `BOOLEAN` - Boolean
 * * `DATE` - Date
 */
export type FieldTypeEnum = (typeof FieldTypeEnum)[keyof typeof FieldTypeEnum];

export const FieldTypeEnum = {
  TEXT: 'TEXT',
  NUMBER: 'NUMBER',
  BOOLEAN: 'BOOLEAN',
  DATE: 'DATE',
} as const;

/**
 * Serializer for individual filter choice items.
 */
export interface FilterChoiceResponse {
  id: unknown;
  name: string;
}

/**
 * * `EQUAL_DISTINCT_FILTER` - EQUAL_DISTINCT_FILTER
 * * `DATE_DATERANGE_FILTER` - DATE_DATERANGE_FILTER
 * * `FREE_TEXT_FILTER` - FREE_TEXT_FILTER
 */
export type FilterResponseTypeEnum =
  (typeof FilterResponseTypeEnum)[keyof typeof FilterResponseTypeEnum];

export const FilterResponseTypeEnum = {
  EQUAL_DISTINCT_FILTER: 'EQUAL_DISTINCT_FILTER',
  DATE_DATERANGE_FILTER: 'DATE_DATERANGE_FILTER',
  FREE_TEXT_FILTER: 'FREE_TEXT_FILTER',
} as const;

/**
 * Serializer for individual filter items.
 */
export interface FilterResponse {
  type: FilterResponseTypeEnum;
  name: string;
  displayName: string;
  /** @nullable */
  icon?: string | null;
  choices?: FilterChoiceResponse[];
}

/**
 * Serializer for the recognition filters response.
 */
export interface FilterGroupsResponse {
  filters: FilterResponse[][];
}

/**
 * * `INACTIVE` - Inactive
 * * `SETUP_COMPLETE` - Setup complete
 * * `AWAITING_USER_ACTION` - Awaiting user action
 * * `ENROLLMENT_DATA_MISSING` - Enrollment data missing
 */
export type FilteredEmployeeStatusEnum =
  (typeof FilteredEmployeeStatusEnum)[keyof typeof FilteredEmployeeStatusEnum];

export const FilteredEmployeeStatusEnum = {
  INACTIVE: 'INACTIVE',
  SETUP_COMPLETE: 'SETUP_COMPLETE',
  AWAITING_USER_ACTION: 'AWAITING_USER_ACTION',
  ENROLLMENT_DATA_MISSING: 'ENROLLMENT_DATA_MISSING',
} as const;

export interface FilteredEmployee {
  id: number;
  firstName: string;
  lastName: string;
  /** @nullable */
  email?: string | null;
  status?: FilteredEmployeeStatusEnum | null;
  tagsList: string[];
  roles: RolesA5dEnum[];
  employerRoles: number[];
  excludeFromHrisSync?: boolean;
  readonly hasValidPhoneNumber: boolean;
}

export interface FilteredEmployeesFilterRequest {
  tags?: unknown[];
  isActive?: unknown[];
  dob?: unknown[];
  addressesCountry?: unknown[];
  employmentStart?: unknown[];
  employmentEnd?: unknown[];
  probationEnd?: unknown[];
  officeLocation?: unknown[];
  department?: unknown[];
  jobTitle?: unknown[];
  employeeId?: unknown[];
  reportingStatus?: unknown[];
  excludeFromHrisSync?: unknown[];
  roles?: unknown[];
  employerRoles?: unknown[];
}

/**
 * * `NAME` - name
 * * `EMAIL` - email
 */
export type FilteredEmployeesRequestSortingFieldEnum =
  (typeof FilteredEmployeesRequestSortingFieldEnum)[keyof typeof FilteredEmployeesRequestSortingFieldEnum];

export const FilteredEmployeesRequestSortingFieldEnum = {
  NAME: 'NAME',
  EMAIL: 'EMAIL',
} as const;

/**
 * Base serializer for the query params of a paginated list.
 */
export interface FilteredEmployeesRequestRequest {
  pageNumber?: number;
  /** @nullable */
  pageSize?: number | null;
  sortingOrder?: SortingOrderEnum;
  /**
   * @minLength 1
   * @maxLength 200
   */
  searchValue?: string;
  filters?: FilteredEmployeesFilterRequest;
  sortingField?: FilteredEmployeesRequestSortingFieldEnum;
}

export interface FilteredEmployeesResponse {
  employees: FilteredEmployee[];
  total: number;
  totalPages: number;
  /** @nullable */
  next: number | null;
  /** @nullable */
  prev: number | null;
}

/**
 * * `MONTHLY` - MONTHLY
 * * `YEARLY` - YEARLY
 * * `QUARTERLY` - Quarterly
 */
export type FrequencyEnum = (typeof FrequencyEnum)[keyof typeof FrequencyEnum];

export const FrequencyEnum = {
  MONTHLY: 'MONTHLY',
  YEARLY: 'YEARLY',
  QUARTERLY: 'QUARTERLY',
} as const;

/**
 * * `PENDING` - Pending
 * * `CANCELLED` - Cancelled
 * * `COMPLETED` - Completed
 */
export type FulfillmentStateEnum =
  (typeof FulfillmentStateEnum)[keyof typeof FulfillmentStateEnum];

export const FulfillmentStateEnum = {
  PENDING: 'PENDING',
  CANCELLED: 'CANCELLED',
  COMPLETED: 'COMPLETED',
} as const;

export type FullSearchComponentItem = ActionLinkComponent;

export interface WalletSource {
  /** @nullable */
  allowanceId: number | null;
  /** @nullable */
  managedCardId: string | null;
  title: string;
}

export type FullSearchSourceItem = BenefitSource | WalletSource;

export interface FullSearchResponse {
  response: string;
  readonly sources: readonly FullSearchSourceItem[];
  /** @nullable */
  messageId?: string | null;
  readonly components: readonly FullSearchComponentItem[];
}

export interface FundRequestRequest {
  /**
   * @minLength 1
   * @maxLength 250
   */
  name: string;
  /** @nullable */
  allowance?: number | null;
  /** @nullable */
  topupCardTemplate?: number | null;
  /** @pattern ^-?\d{0,8}(?:\.\d{0,2})?$ */
  amount: string;
  /** @nullable */
  note?: string | null;
  /**
   * @maxLength 250
   * @nullable
   */
  url?: string | null;
  rjsfFormData?: unknown | null;
  rjsfFormSchema?: unknown | null;
}

/**
 * @nullable
 */
export type FundRequestResponseRjsfFormData = { [key: string]: unknown } | null;

export interface FundRequestResponse {
  /** @maxLength 250 */
  name: string;
  allowance: MinimalAllowanceResponse;
  topupCardTemplate: MinimalTopUpCardTemplateResponse;
  /** @pattern ^-?\d{0,8}(?:\.\d{0,2})?$ */
  amount: string;
  /** @nullable */
  note?: string | null;
  /**
   * @maxLength 250
   * @nullable
   */
  url?: string | null;
  /** @nullable */
  readonly rjsfFormData: FundRequestResponseRjsfFormData;
  rjsfFormSchema?: unknown | null;
  employee: MinimalEmployeeResponse;
  approver: MinimalEmployeeResponse;
  approved?: boolean;
  cancelled?: boolean;
  rejected?: boolean;
  /** @nullable */
  rejectionReason?: string | null;
  readonly createdTimestamp: string;
  /** @nullable */
  actionedTimestamp?: string | null;
  readonly reviewers: string;
  readonly approvalRequestState: string;
  readonly transactionTypeDisplayName: string;
}

export interface GenericSummary {
  groupId: string;
  cardType: string;
  text: string;
  employerText: string;
  employeeText: string;
  /** @pattern ^-?\d{0,18}(?:\.\d{0,2})?$ */
  employerContribution: string;
  /** @pattern ^-?\d{0,18}(?:\.\d{0,2})?$ */
  employeeContribution: string;
  /** @pattern ^-?\d{0,18}(?:\.\d{0,2})?$ */
  total: string;
  tooltipText: string;
  showAdditionalItems?: boolean;
}

export interface Goal {
  /**
   * @maxLength 50
   * @pattern ^[-a-zA-Z0-9_]+$
   */
  slug: string;
  displayName: string;
  /** @nullable */
  description?: string | null;
  /**
   * @maxLength 255
   * @nullable
   */
  icon?: string | null;
}

/**
 * * `yearly` - yearly
 * * `monthly` - monthly
 */
export type GranularityEnum =
  (typeof GranularityEnum)[keyof typeof GranularityEnum];

export const GranularityEnum = {
  yearly: 'yearly',
  monthly: 'monthly',
} as const;

export interface HeroComponent {
  type: RewardStatementComponentTypeEnum;
  title: string;
  subtitle: string;
  totalLabel: string;
  /** @pattern ^-?\d{0,18}(?:\.\d{0,2})?$ */
  total: string;
  currency: string;
  /** @nullable */
  startDate: string | null;
  /** @nullable */
  endDate: string | null;
  backgroundColour: string;
}

/**
 * * `HERO` - HERO
 */
export type HeroStatementStatementTypeEnum =
  (typeof HeroStatementStatementTypeEnum)[keyof typeof HeroStatementStatementTypeEnum];

export const HeroStatementStatementTypeEnum = {
  HERO: 'HERO',
} as const;

export interface PeriodOption {
  key: string;
  label: string;
}

export interface Meta {
  currency: CurrencyEnum;
  granularity: GranularityEnum;
  startDate: string;
  endDate: string;
  title: string;
  period: string;
  periodSelectionOptions: PeriodOption[];
  currencySelectionOptions: CurrencySelectionOptionsEnum[];
}

export type RewardStatementComponent =
  | HeroComponent
  | CompositionBarComponent
  | BreakdownComponent;

/**
 * * `ONBOARDING` - Onboarding
 * * `PROMOTION` - Promotion
 * * `PROGRESSION` - Progression
 * * `PAY_REVIEW` - Pay review
 */
export type StatementPresentationStateEnum =
  (typeof StatementPresentationStateEnum)[keyof typeof StatementPresentationStateEnum];

export const StatementPresentationStateEnum = {
  ONBOARDING: 'ONBOARDING',
  PROMOTION: 'PROMOTION',
  PROGRESSION: 'PROGRESSION',
  PAY_REVIEW: 'PAY_REVIEW',
} as const;

export interface StatementHighlight {
  name: string;
  /** @nullable */
  shortDescription: string | null;
  /** @nullable */
  imageUrl: string | null;
  url: string;
}

export interface StatementPresentation {
  state: StatementPresentationStateEnum;
  lifeEventId: number;
  effectiveDate: string;
  headline: string;
  supportingText: string;
  /** @nullable */
  jobTitle: string | null;
  highlights: StatementHighlight[];
}

export interface HeroStatement {
  readonly statementType: HeroStatementStatementTypeEnum;
  meta: Meta;
  /**
   * What the employer pays for this employee over the period.
   * @pattern ^-?\d{0,18}(?:\.\d{0,2})?$
   */
  total: string;
  components: RewardStatementComponent[];
  presentation?: StatementPresentation | null;
  benefitDetailsHidden: boolean;
}

export interface HomeScreenCarouselResponse {
  readonly id: string;
  title: string;
  description: string;
  ctaText: string;
  rank: number;
  imageUrl: string;
  imageAltText: string;
  mobileImageUrl: string;
  /** @nullable */
  readonly ctaLink: string | null;
  expiration?: string;
  readonly isPerksatwork: string | boolean | null;
}

export interface QuickLinkGridBlockItem {
  id: number;
  name: string;
  /** @nullable */
  description: string | null;
  link: string;
  /** @nullable */
  logoUrl: string | null;
  logoAltText: string;
}

export interface QuickLinkGridBlockData {
  items: QuickLinkGridBlockItem[];
  hasMore: boolean;
}

export interface ResourceHorizontalListBlockItem {
  id: number;
  title: string;
  summary: string;
  /** @nullable */
  thumbnailUrl: string | null;
  thumbnailAlt: string;
  type: string;
  /** @nullable */
  readMinutes: number | null;
  category: string;
  createdAt: string;
}

export interface ResourceHorizontalListBlockData {
  items: ResourceHorizontalListBlockItem[];
}

export type HomepageBlockData =
  | AllowanceListBlockData
  | BenefitListBlockData
  | QuickLinkGridBlockData
  | AnnouncementFeaturedBlockData
  | EstCompPackageFeaturedBlockData
  | BenefitContributionsFeaturedBlockData
  | ResourceHorizontalListBlockData;

export type HomepageBlockResponseConfig = { [key: string]: unknown };

export interface HomepageBlockResponse {
  entityType: EntityTypeEnum;
  blockType: BlockTypeEnum;
  config: HomepageBlockResponseConfig;
  readonly blockData: HomepageBlockData;
}

export type HomepageRegistryBlockConfigSchema = { [key: string]: unknown };

/**
 * * `featured` - Featured
 * * `horizontal_list` - Horizontal list
 * * `vertical_list` - Vertical list
 * * `grid` - Grid
 */
export type TypeB2eEnum = (typeof TypeB2eEnum)[keyof typeof TypeB2eEnum];

export const TypeB2eEnum = {
  featured: 'featured',
  horizontal_list: 'horizontal_list',
  vertical_list: 'vertical_list',
  grid: 'grid',
} as const;

export interface HomepageRegistryBlock {
  type: TypeB2eEnum;
  configSchema: HomepageRegistryBlockConfigSchema;
}

/**
 * * `benefit` - Benefit
 * * `allowance` - Allowance
 * * `quick_link` - Quick link
 * * `announcement` - Announcement
 * * `est_comp_package` - Estimated Compensation Package
 * * `benefit_contributions` - Benefit contributions
 * * `resource` - Resource
 */
export type TypeFe6Enum = (typeof TypeFe6Enum)[keyof typeof TypeFe6Enum];

export const TypeFe6Enum = {
  benefit: 'benefit',
  allowance: 'allowance',
  quick_link: 'quick_link',
  announcement: 'announcement',
  est_comp_package: 'est_comp_package',
  benefit_contributions: 'benefit_contributions',
  resource: 'resource',
} as const;

export interface HomepageRegistryEntity {
  type: TypeFe6Enum;
  label: string;
  description: string;
  blocks: HomepageRegistryBlock[];
}

export interface HomepageRegistryResponse {
  entities: HomepageRegistryEntity[];
}

export interface ImpersonationUserResponse {
  readonly id: number;
  readonly fullName: string;
}

export interface ImpersonationSessionResponse {
  readonly id: string;
  readonly expiresAt: string;
  readonly impersonatee: ImpersonationUserResponse;
  readonly impersonator: ImpersonationUserResponse;
}

export type InputSnapshotEffectiveAllowanceBalances = {
  [key: string]: AllowanceBalanceSnapshot[];
};

/**
 * @nullable
 */
export type SubscriptionSnapshotSelection = { [key: string]: unknown } | null;

export interface SubscriptionSnapshot {
  /** @nullable */
  id?: number | null;
  /** @nullable */
  selection?: SubscriptionSnapshotSelection;
  /** @nullable */
  monthlyPrice?: number | null;
  /** @nullable */
  employeeMonthlyPrice?: number | null;
  /** @nullable */
  employeeYearlyPrice?: number | null;
  /** @nullable */
  employerMonthlyPrice?: number | null;
  /** @nullable */
  employerYearlyPrice?: number | null;
  /** @nullable */
  salaryDeduction?: number | null;
  /** @nullable */
  allowanceDeduction?: number | null;
  /** @nullable */
  startDate?: string | null;
  /** @nullable */
  endDate?: string | null;
  /** @nullable */
  optInDate?: string | null;
  /** @nullable */
  benefitStartDate?: string | null;
  /** @nullable */
  benefitEndDate?: string | null;
  /** @nullable */
  yearlyPrice?: number | null;
  /** @nullable */
  payDeductionType?: string | null;
}

export interface InputSnapshot {
  employee: EmployeeSnapshot;
  enrolment: EnrolmentSnapshot;
  cycle: CycleSnapshot;
  currentSubscription?: SubscriptionSnapshot | null;
  previousSubscription?: SubscriptionSnapshot | null;
  previousCycle?: CycleSnapshot | null;
  allowanceBalance?: AllowanceBalanceSnapshot | null;
  historicalAllowanceBalance?: AllowanceBalanceSnapshot | null;
  effectiveAllowanceBalances?: InputSnapshotEffectiveAllowanceBalances;
  concurrentJoinerBenefitIds?: number[];
  concurrentLeaverBenefitIds?: number[];
  activeBenefitIds?: number[];
}

export type InputSnapshotRequestEffectiveAllowanceBalances = {
  [key: string]: AllowanceBalanceSnapshotRequest[];
};

/**
 * @nullable
 */
export type SubscriptionSnapshotRequestSelection = {
  [key: string]: unknown;
} | null;

export interface SubscriptionSnapshotRequest {
  /** @nullable */
  id?: number | null;
  /** @nullable */
  selection?: SubscriptionSnapshotRequestSelection;
  /** @nullable */
  monthlyPrice?: number | null;
  /** @nullable */
  employeeMonthlyPrice?: number | null;
  /** @nullable */
  employeeYearlyPrice?: number | null;
  /** @nullable */
  employerMonthlyPrice?: number | null;
  /** @nullable */
  employerYearlyPrice?: number | null;
  /** @nullable */
  salaryDeduction?: number | null;
  /** @nullable */
  allowanceDeduction?: number | null;
  /** @nullable */
  startDate?: string | null;
  /** @nullable */
  endDate?: string | null;
  /** @nullable */
  optInDate?: string | null;
  /** @nullable */
  benefitStartDate?: string | null;
  /** @nullable */
  benefitEndDate?: string | null;
  /** @nullable */
  yearlyPrice?: number | null;
  /**
   * @minLength 1
   * @nullable
   */
  payDeductionType?: string | null;
}

export interface InputSnapshotRequest {
  employee: EmployeeSnapshotRequest;
  enrolment: EnrolmentSnapshotRequest;
  cycle: CycleSnapshotRequest;
  currentSubscription?: SubscriptionSnapshotRequest | null;
  previousSubscription?: SubscriptionSnapshotRequest | null;
  previousCycle?: CycleSnapshotRequest | null;
  allowanceBalance?: AllowanceBalanceSnapshotRequest | null;
  historicalAllowanceBalance?: AllowanceBalanceSnapshotRequest | null;
  effectiveAllowanceBalances?: InputSnapshotRequestEffectiveAllowanceBalances;
  concurrentJoinerBenefitIds?: number[];
  concurrentLeaverBenefitIds?: number[];
  activeBenefitIds?: number[];
}

export interface IntegrationActionResponse {
  success: boolean;
  /** @nullable */
  result: string | null;
}

export interface IntegrationInstance {
  contentType: string;
  objectId: string;
}

export type IntegrationResponseActionsItem = { [key: string]: unknown };

/**
 * * `HRIS` - HRIS
 * * `ACCOUNTING` - ACCOUNTING
 * * `SSO` - SSO
 */
export type ServiceTypeEnum =
  (typeof ServiceTypeEnum)[keyof typeof ServiceTypeEnum];

export const ServiceTypeEnum = {
  HRIS: 'HRIS',
  ACCOUNTING: 'ACCOUNTING',
  SSO: 'SSO',
} as const;

export interface UserMinimalResponse {
  /** @maxLength 254 */
  email?: string;
  /** @maxLength 150 */
  firstName?: string;
  /** @maxLength 150 */
  lastName?: string;
}

export interface IntegrationResponse {
  instance: IntegrationInstance;
  serviceType: ServiceTypeEnum;
  serviceName: string;
  status: string;
  createdBy: UserMinimalResponse | null;
  actions: IntegrationResponseActionsItem[];
  /** @nullable */
  createdAt: string | null;
  /** @nullable */
  lastRefreshed: string | null;
}

export interface IntentProfileResponse {
  /** @items.pattern ^[-a-zA-Z0-9_]+$ */
  goalsRanked: string[];
  /** @items.pattern ^[-a-zA-Z0-9_.]+$ */
  needsSelected: string[];
  tier: number;
  /** @nullable */
  additionalNote: string | null;
}

/**
 * * `BEN` - Ben
 * * `SUPPLIER` - Supplier
 */
export type InvoiceResponseTypeEnum =
  (typeof InvoiceResponseTypeEnum)[keyof typeof InvoiceResponseTypeEnum];

export const InvoiceResponseTypeEnum = {
  BEN: 'BEN',
  SUPPLIER: 'SUPPLIER',
} as const;

export interface InvoiceResponse {
  readonly id: number;
  /** @maxLength 250 */
  title: string;
  readonly date: string;
  /** @pattern ^-?\d{0,13}(?:\.\d{0,2})?$ */
  totalAmount: string;
  readonly totalAmountCurrency: string;
  document: string;
  approver: EmployeeMinimalDetailsResponse;
  approved?: boolean;
  /** @nullable */
  approvedTimestamp?: string | null;
  paid?: boolean;
  /** @nullable */
  paidTimestamp?: string | null;
  type: InvoiceResponseTypeEnum;
}

export interface LeftNavigationResponse {
  hasRewards: boolean;
  hasUnseenRewards: boolean;
  hasBenefits: boolean;
  hasWallet: boolean;
  hasEquityModeler: boolean;
  hasResources: boolean;
  hasTotalRewards: boolean;
}

export interface LegendItem {
  baseKey: string;
  label: string;
  color: string;
  striped?: boolean;
  /** @nullable */
  tooltipText?: string | null;
}

export interface LifeEventEmployeeResponse {
  readonly id: number;
  /** @maxLength 150 */
  firstName?: string;
  /** @maxLength 150 */
  lastName?: string;
}

/**
 * * `BIRTH_OR_ADOPTION` - BIRTH_OR_ADOPTION
 * * `CHANGE_IN_CONTRACTED_HOURS` - CHANGE_IN_CONTRACTED_HOURS
 * * `DEATH` - DEATH
 * * `DEMOTION` - DEMOTION
 * * `DIVORCE` - DIVORCE
 * * `ENROLLMENT_EVENT` - ENROLLMENT_EVENT
 * * `INCOME_CHANGES` - INCOME_CHANGES
 * * `LOSS_OF_COVERAGE` - LOSS_OF_COVERAGE
 * * `MARRIAGE` - MARRIAGE
 * * `MOVING_HOME` - MOVING_HOME
 * * `NEWLY_ELIGIBLE` - NEWLY_ELIGIBLE
 * * `ONBOARDING` - ONBOARDING
 * * `OTHER` - OTHER
 * * `OVERSEAS_SECONDMENT` - OVERSEAS_SECONDMENT
 * * `PAY_REVIEW` - PAY_REVIEW
 * * `PROGRESSION` - PROGRESSION
 * * `PROMOTION` - PROMOTION
 * * `RETURN_FROM_OVERSEAS_SECONDMENT` - RETURN_FROM_OVERSEAS_SECONDMENT
 * * `RETURN_TO_WORK` - RETURN_TO_WORK
 * * `UNPAID_SICKNESS_OR_LEAVE` - UNPAID_SICKNESS_OR_LEAVE
 */
export type LifeEventTypeEnum =
  (typeof LifeEventTypeEnum)[keyof typeof LifeEventTypeEnum];

export const LifeEventTypeEnum = {
  BIRTH_OR_ADOPTION: 'BIRTH_OR_ADOPTION',
  CHANGE_IN_CONTRACTED_HOURS: 'CHANGE_IN_CONTRACTED_HOURS',
  DEATH: 'DEATH',
  DEMOTION: 'DEMOTION',
  DIVORCE: 'DIVORCE',
  ENROLLMENT_EVENT: 'ENROLLMENT_EVENT',
  INCOME_CHANGES: 'INCOME_CHANGES',
  LOSS_OF_COVERAGE: 'LOSS_OF_COVERAGE',
  MARRIAGE: 'MARRIAGE',
  MOVING_HOME: 'MOVING_HOME',
  NEWLY_ELIGIBLE: 'NEWLY_ELIGIBLE',
  ONBOARDING: 'ONBOARDING',
  OTHER: 'OTHER',
  OVERSEAS_SECONDMENT: 'OVERSEAS_SECONDMENT',
  PAY_REVIEW: 'PAY_REVIEW',
  PROGRESSION: 'PROGRESSION',
  PROMOTION: 'PROMOTION',
  RETURN_FROM_OVERSEAS_SECONDMENT: 'RETURN_FROM_OVERSEAS_SECONDMENT',
  RETURN_TO_WORK: 'RETURN_TO_WORK',
  UNPAID_SICKNESS_OR_LEAVE: 'UNPAID_SICKNESS_OR_LEAVE',
} as const;

export interface LifeEventRequest {
  lifeEventType: LifeEventTypeEnum;
  customLifeEvent?: string;
  /** @nullable */
  eventDate?: string | null;
  /** @nullable */
  document?: string | null;
}

export interface LifeEventRequestRequest {
  life_event_type: LifeEventTypeEnum;
  custom_life_event?: string;
  /** @nullable */
  event_date?: string | null;
  /** @nullable */
  document?: Blob | null;
}

export type LifeEventResponseDisplayStatus = { [key: string]: string };

/**
 * * `MANUAL` - MANUAL
 * * `AUTO_TRIGGERED` - AUTO_TRIGGERED
 */
export type SourceA7fEnum = (typeof SourceA7fEnum)[keyof typeof SourceA7fEnum];

export const SourceA7fEnum = {
  MANUAL: 'MANUAL',
  AUTO_TRIGGERED: 'AUTO_TRIGGERED',
} as const;

export interface LifeEventResponse {
  readonly id: number;
  user: LifeEventEmployeeResponse;
  lifeEventType: LifeEventTypeEnum;
  /** @maxLength 200 */
  customLifeEvent?: string;
  readonly requestedAt: string;
  readonly displayStatus: LifeEventResponseDisplayStatus;
  readonly status: string;
  /**
   * Whether this life event was submitted manually by the employee (MANUAL) or created automatically from an HRIS-driven change (AUTO_TRIGGERED).
   *
   * * `MANUAL` - MANUAL
   * * `AUTO_TRIGGERED` - AUTO_TRIGGERED
   */
  source?: SourceA7fEnum;
}

export type LifeEventResponseDetailDisplayStatus = { [key: string]: string };

/**
 * @nullable
 */
export type LifeEventResponseDetailFile = { [key: string]: string } | null;

export interface TriggerChangesetResponse {
  fieldChanged: string;
  /** @nullable */
  oldValue: string | null;
  /** @nullable */
  newValue: string | null;
  /** @nullable */
  effectiveDate: string | null;
}

export interface LifeEventResponseDetail {
  readonly id: number;
  user: LifeEventEmployeeResponse;
  lifeEventType: LifeEventTypeEnum;
  /** @maxLength 200 */
  customLifeEvent?: string;
  readonly requestedAt: string;
  readonly displayStatus: LifeEventResponseDetailDisplayStatus;
  readonly status: string;
  /**
   * Whether this life event was submitted manually by the employee (MANUAL) or created automatically from an HRIS-driven change (AUTO_TRIGGERED).
   *
   * * `MANUAL` - MANUAL
   * * `AUTO_TRIGGERED` - AUTO_TRIGGERED
   */
  source?: SourceA7fEnum;
  /** @nullable */
  eventDate?: string | null;
  readonly actionedAt: string;
  readonly actionedBy: string;
  /** @nullable */
  readonly file: LifeEventResponseDetailFile;
  readonly affectedBenefits: string;
  readonly rejectionReason: string;
  readonly unapprovedBenefits: string;
  readonly approvedBenefits: string;
  readonly autoApprovedBenefits: string;
  readonly rejectedBenefits: string;
  readonly triggerChangeset: TriggerChangesetResponse | null;
}

export interface LifeEventReviewErrorResponse {
  approvedBenefits: string[];
  errorCode: string;
}

export interface LifeEventReviewRequestRequest {
  isApproved: boolean;
  approvedBenefits: number[];
  /** @minLength 1 */
  rejectionReason?: string;
}

export type LineItemTrace = { [key: string]: unknown };

/**
 * @nullable
 */
export type LineItemOutput = { [key: string]: unknown } | null;

export interface LineItem {
  fired: boolean;
  /** @nullable */
  instructionConfigId?: number | null;
  instructionConfigName?: string;
  trace?: LineItemTrace;
  /** @nullable */
  output?: LineItemOutput;
}

export type LoginMetadataResponseUiColorsPalette = { [key: string]: unknown };

/**
 * @nullable
 */
export type LoginMetadataResponseAuthConfiguration = {
  [key: string]: unknown;
} | null;

export interface LoginMetadataResponse {
  readonly uiColorsPalette: LoginMetadataResponseUiColorsPalette;
  readonly navbarLogoUrl: string;
  readonly navbarLogoAltText: string;
  name: string;
  iconUrl: string;
  welcomeText: string;
  /** @nullable */
  readonly authConfiguration: LoginMetadataResponseAuthConfiguration;
  isWhitelabel?: boolean;
}

export interface LoginRequestRequest {
  /** @minLength 1 */
  tokenizedPassword: string;
}

export interface LoginResponse {
  token: string;
}

export interface LostPasscodeResumeRequestRequest {
  /** @nullable */
  phoneNumber?: string | null;
  /** @minLength 1 */
  nonce: string;
  /** @minLength 1 */
  tokenizedPassword: string;
}

export interface MSTeamsChannel {
  id: string;
  name: string;
}

export interface MSTeamsChannelsResponse {
  channels: MSTeamsChannel[];
}

export interface MSTeamsCompleteAuthRequestRequest {
  /** @minLength 1 */
  code: string;
  /** @minLength 1 */
  clientInfo: string;
  /** @minLength 1 */
  state: string;
  /** @minLength 1 */
  sessionState: string;
}

export interface MSTeamsStartAuthResponse {
  authorizeUrl: string;
}

export interface MSTeamsTeam {
  id: number;
  name: string;
}

export interface MSTeamsTeamsResponse {
  teams: MSTeamsTeam[];
}

export interface WeavrAccountDetails {
  /** @nullable */
  beneficiary?: string | null;
  /** @nullable */
  beneficiaryBank?: string | null;
  /** @nullable */
  paymentReference?: string | null;
  /** @nullable */
  accountType?: string | null;
  /** @nullable */
  accountNumber?: string | null;
  /** @nullable */
  sortCode?: string | null;
  /** @nullable */
  iban?: string | null;
  /** @nullable */
  bankIdentifierCode?: string | null;
  /** @nullable */
  code?: string | null;
  /** @nullable */
  currency?: string | null;
}

export type ManagedAccount =
  | WeavrAccountDetails
  | AirwallexGlobalAccountDetails;

export interface ManagedAccountBalances {
  /**
   * @nullable
   * @pattern ^-?\d{0,13}(?:\.\d{0,2})?$
   */
  availableBalance: string | null;
  /**
   * @nullable
   * @pattern ^-?\d{0,13}(?:\.\d{0,2})?$
   */
  actualBalance: string | null;
  currency: string;
  /** @nullable */
  balancesSyncedAt: string | null;
}

/**
 * Serializer for the current period managed card breakdown.
 */
export interface ManagedCardCurrentPeriodBreakdownResponse {
  interval: string;
  periodStart: string;
  periodEnd: string;
  /** @pattern ^-?\d{0,8}(?:\.\d{0,2})?$ */
  available: string;
  renewal: RenewalResponse | null;
  /** @nullable */
  enrolledBenefits: EnrollableBenefitCostResponse[] | null;
  /** @pattern ^-?\d{0,8}(?:\.\d{0,2})?$ */
  transactions: string;
  /** @pattern ^-?\d{0,8}(?:\.\d{0,2})?$ */
  topUp: string;
}

/**
 * Serializer for a period-aware managed card breakdown.
 */
export interface ManagedCardPeriodBreakdownResponse {
  interval: string;
  periodStart: string;
  periodEnd: string;
  /** @pattern ^-?\d{0,8}(?:\.\d{0,2})?$ */
  available: string;
  renewal: RenewalResponse | null;
  /** @nullable */
  enrolledBenefits: EnrollableBenefitCostResponse[] | null;
}

/**
 * Serializer for a breakdown of current and next month managed card spend.
 */
export interface ManagedCardBreakdownResponse {
  name: string;
  id: number;
  /** @maxLength 3 */
  currency: string;
  currentMonthBalance: BreakdownCurrentMonthResponse;
  nextMonthBalance: BreakdownNextMonthResponse;
  currentPeriod?: ManagedCardCurrentPeriodBreakdownResponse;
  nextPeriod?: ManagedCardPeriodBreakdownResponse;
}

/**
 * Serializer for previewing the ManagedCardConfig model
 */
export interface ManagedCardConfigPreviewResponse {
  readonly id: number;
  readonly requiresReceipts: boolean;
  reimbursementAllowed?: boolean;
}

export interface ManagedCardMinimal {
  readonly id: number;
  externalId: string;
  /** @maxLength 50 */
  friendlyName: string;
}

/**
 * @nullable
 */
export type ManagedCardsTransactionResponseMerchantInfo = {
  [key: string]: unknown;
} | null;

/**
 * @nullable
 */
export type ManagedCardsTransactionResponseReceiptDisplayStatus = {
  [key: string]: unknown;
} | null;

export interface TransactionDisplayStatus {
  type: string;
  status?: string;
  disabled?: boolean;
}

export interface ManagedCardsTransactionResponse {
  description: string;
  date: string;
  timestamp: string;
  /** @pattern ^-?\d{0,8}(?:\.\d{0,2})?$ */
  amount: string;
  currency: string;
  /**
   * @nullable
   * @pattern ^-?\d{0,8}(?:\.\d{0,2})?$
   */
  employerAmount: string | null;
  /** @nullable */
  employerCurrency: string | null;
  transactionStatus: TransactionDisplayStatus;
  /** @nullable */
  transactionStatusReason: string | null;
  transactionType: string;
  readonly transactionTypeDisplayName: string;
  transactionObjectType: string;
  transactionObjectId: number;
  receiptAttached: boolean;
  /** @nullable */
  receiptUnavailable: boolean | null;
  /** @nullable */
  receiptUploadedAt: string | null;
  /** @nullable */
  longDescription: string | null;
  /** @nullable */
  imageUrl: string | null;
  readonly iconType: string;
  /** @nullable */
  receiptUrl: string | null;
  /** @nullable */
  readonly merchantInfo: ManagedCardsTransactionResponseMerchantInfo;
  /** @nullable */
  note: string | null;
  /** @nullable */
  readonly receiptDisplayStatus: ManagedCardsTransactionResponseReceiptDisplayStatus;
  receiptRejection?: boolean;
  receiptRejectionReason?: string;
  receiptRejectionTimestamp?: string;
  receiptRejectionTransactionId?: number;
}

export type MePendingActions = { [key: string]: unknown };

export interface MeManagedAccount {
  currency: string;
  id: number;
}

export interface MeEmployer {
  name: string;
  iconUrl: string;
  currency: string;
  pk: number;
  hostname: string;
  cardProvider: string;
  hasHrisActive: boolean;
  managedAccount?: MeManagedAccount;
}

export interface Me {
  id: number;
  email: string;
  /** @maxLength 150 */
  firstName: string;
  /** @maxLength 150 */
  lastName: string;
  weavrPasswordSet: boolean;
  mobilePhoneVerified: boolean;
  /** @nullable */
  preferredLanguage: string | null;
  /** @nullable */
  imageUrl: string | null;
  /** @nullable */
  readonly intercomIdentityHash: string | null;
  /** @nullable */
  readonly intercomIdentityHashIos: string | null;
  /** @nullable */
  readonly intercomIdentityHashAndroid: string | null;
  readonly cycleFrequency: CycleFrequencyEnum;
  mobileNumber: string;
  mobileCountryCode: string;
  isHr: boolean;
  isSocialAuth: boolean;
  employer: MeEmployer;
  emailVerified: boolean;
  hasCardProduct: boolean;
  isRootUser: boolean;
  isKybComplete: boolean;
  isDelegatedRoot: boolean;
  hasCorporate: boolean;
  hasTopupCards: boolean;
  isManager: boolean;
  pendingActions: MePendingActions;
  managedAccountsCreated: boolean;
  hasSelfManagedBenefits: boolean;
  permissions: unknown[];
  requireEmployeeSalary: boolean;
  showEmployeeCompensation: boolean;
  hasHrisIntegrations: boolean;
  numberOfEmployeesMissingRequirements: number;
  usernameStrategy: string;
  hasBenefits: boolean;
  hasAllowances: boolean;
  disableInviteEmail: boolean;
}

export type MeResponseCustomData = { [key: string]: unknown };

export interface RolesResponse {
  id: number;
}

export interface MeResponse {
  id: number;
  email: string;
  /** @maxLength 150 */
  firstName: string;
  /** @maxLength 150 */
  lastName: string;
  weavrPasswordSet: boolean;
  mobilePhoneVerified: boolean;
  /** @nullable */
  preferredLanguage: string | null;
  /** @nullable */
  imageUrl: string | null;
  /** @nullable */
  readonly intercomIdentityHash: string | null;
  /** @nullable */
  readonly intercomIdentityHashIos: string | null;
  /** @nullable */
  readonly intercomIdentityHashAndroid: string | null;
  readonly cycleFrequency: CycleFrequencyEnum;
  weavrUserId: number;
  readonly weavrTokenStaleTimestamp: string;
  hasPolicies: boolean;
  hasCompletedBenefitEnrolment: boolean;
  hasPerksatworkAccount: boolean;
  /** @nullable */
  readonly missingReceiptsCount: number | null;
  perksatworkAuthUrl: string;
  /** @nullable */
  readonly nextClosingWindow: string | null;
  readonly employer: EmployerResponse;
  roles: RolesResponse[];
  readonly hasCards: boolean;
  readonly permissions: readonly string[];
  /**
   * @nullable
   * @pattern ^-?\d{0,13}(?:\.\d{0,2})?$
   */
  yearlyGrossSalary: string | null;
  /** @nullable */
  readonly yearlyGrossSalaryCurrency: string | null;
  profileConfirmationRequired: boolean;
  gender: GenderEnum | null;
  /**
   * @maxLength 255
   * @nullable
   */
  jobTitle: string | null;
  /** @nullable */
  dob: string | null;
  /**
   * @maxLength 250
   * @nullable
   */
  nationality: string | null;
  country: HomeAddressCountryEnum | null;
  /**
   * @maxLength 50
   * @nullable
   */
  niNumber: string | null;
  maritalStatus: MaritalStatusEnum | null;
  homeAddress: EmployeeAddressRequest | null;
  /** @nullable */
  phoneNumber: string | null;
  readonly cardProviderRequiresAuthentication: boolean;
  /** @nullable */
  readonly rootUrl: string | null;
  readonly customData: MeResponseCustomData;
  /** @nullable */
  readonly shouldCompleteInterestsSelection: boolean | null;
}

/**
 * Serializer for the media field of the recognition create request.
 */
export interface Media {
  id: string;
  url: string;
  alt?: string;
  creator?: string;
  creatorUrl?: string;
  provider?: string;
  providerUrl?: string;
}

/**
 * Serializer for the media field of the recognition create request.
 */
export interface MediaRequest {
  /** @minLength 1 */
  id: string;
  /** @minLength 1 */
  url: string;
  alt?: string;
  creator?: string;
  creatorUrl?: string;
  provider?: string;
  providerUrl?: string;
}

export interface MessageFeedbackRequestRequest {
  positive: boolean;
  /**
   * @minLength 1
   * @nullable
   */
  longDescription: string | null;
}

export interface Metabase {
  /** @nullable */
  metabaseIframeUrl?: string | null;
  /** @nullable */
  metabasePayrollReportUrl?: string | null;
  /** @nullable */
  metabaseWalletReportUrl?: string | null;
  /** @nullable */
  metabaseTotalRewardsReportUrl?: string | null;
  /** @nullable */
  metabasePreClearanceReportUrl?: string | null;
}

export type MobileLoginMetadataResponseUiColorsPalette = {
  [key: string]: unknown;
};

/**
 * @nullable
 */
export type MobileLoginMetadataResponseMobileAuthConfiguration = {
  [key: string]: unknown;
} | null;

export interface MobileLoginMetadataResponse {
  readonly uiColorsPalette: MobileLoginMetadataResponseUiColorsPalette;
  readonly navbarLogoUrl: string;
  readonly navbarLogoAltText: string;
  readonly urlSlug: string;
  /** @nullable */
  readonly mobileAuthConfiguration: MobileLoginMetadataResponseMobileAuthConfiguration;
  readonly minAndroidVersion: string;
  readonly minIosVersion: string;
}

export interface ModularBenefitListResponse {
  readonly id: number;
  /** @maxLength 200 */
  name: string;
  employer: string;
  active?: boolean;
}

export interface ModularBenefitListResponseRequest {
  /**
   * @minLength 1
   * @maxLength 200
   */
  name: string;
  /** @minLength 1 */
  employer: string;
  active?: boolean;
}

export interface ModularBenefitMinMaxFormulaFieldRecalculateCockpitResponse {
  /** @pattern ^-?\d{0,10}(?:\.\d{0,2})?$ */
  minValue: string;
  /** @pattern ^-?\d{0,10}(?:\.\d{0,2})?$ */
  maxValue: string;
  key: string;
  /** @pattern ^-?\d{0,10}(?:\.\d{0,2})?$ */
  sellMax?: string;
}

export interface ModularBenefitMinMaxFormulaFieldRecalculateHoustonResponse {
  /** @pattern ^-?\d{0,10}(?:\.\d{0,2})?$ */
  minValue: string;
  /** @pattern ^-?\d{0,10}(?:\.\d{0,2})?$ */
  maxValue: string;
  key: string;
  /** @pattern ^-?\d{0,10}(?:\.\d{0,2})?$ */
  sellMax?: string;
}

/**
 * Advisory NMW assessment of a proposed enrolment, for admin surfaces only.
 */
export interface ModularBenefitNmwImpact {
  status: NmwStatusEnum;
  /** @nullable */
  likelyCause: string | null;
  /** @nullable */
  recommendedAction: string | null;
  /**
   * @nullable
   * @pattern ^-?\d{0,10}(?:\.\d{0,2})?$
   */
  shortfallAmount: string | null;
  /** @nullable */
  shortfallCurrency: string | null;
  /**
   * @nullable
   * @pattern ^-?\d{0,10}(?:\.\d{0,2})?$
   */
  projectedHourlyRate: string | null;
  /**
   * @nullable
   * @pattern ^-?\d{0,10}(?:\.\d{0,2})?$
   */
  minHourlyRate: string | null;
}

export interface PayrollCycleResponse {
  id: number;
  startDate: string;
  endDate: string;
}

export interface PriceResponse {
  /** @pattern ^-?\d{0,8}(?:\.\d{0,2})?$ */
  amount: string;
  /** @maxLength 5 */
  currency: string;
  /**
   * @nullable
   * @pattern ^-?\d{0,8}(?:\.\d{0,2})?$
   */
  previousAmount?: string | null;
}

/**
 * * `PAYROLL_CORRECTION` - PAYROLL_CORRECTION
 * * `PAYROLL_ITEM` - PAYROLL_ITEM
 * * `BENEFIT_REQUEST` - BENEFIT_REQUEST
 */
export type ModularBenefitPayrollCycleTypeEnum =
  (typeof ModularBenefitPayrollCycleTypeEnum)[keyof typeof ModularBenefitPayrollCycleTypeEnum];

export const ModularBenefitPayrollCycleTypeEnum = {
  PAYROLL_CORRECTION: 'PAYROLL_CORRECTION',
  PAYROLL_ITEM: 'PAYROLL_ITEM',
  BENEFIT_REQUEST: 'BENEFIT_REQUEST',
} as const;

export interface ModularBenefitPayrollCycle {
  readonly payrollCycle: PayrollCycleResponse;
  readonly employeeContribution: PriceResponse;
  readonly employerContribution: PriceResponse;
  payrollPeriod: PayrollPeriodEnum;
  readonly paymentSource: string;
  status: PayrollPaymentHistoryStatusEnum;
  type: ModularBenefitPayrollCycleTypeEnum;
  correctionId?: number;
}

export interface SplitPriceResponse {
  employee: PriceResponse;
  employer: PriceResponse;
}

export interface PriceBreakdownResponse {
  /** @maxLength 200 */
  name?: string;
  employee: PriceResponse;
  employer: PriceResponse;
}

/**
 * * `CURRENT` - Current
 * * `PENDING_CHANGE_APPROVAL` - Pending Change Approval
 * * `PENDING_RENEWAL` - Pending Renewal
 * * `RENEWAL_WINDOW_EXPIRED` - Renewal Window Expired
 */
export type SelectionStateResponseStatusEnum =
  (typeof SelectionStateResponseStatusEnum)[keyof typeof SelectionStateResponseStatusEnum];

export const SelectionStateResponseStatusEnum = {
  CURRENT: 'CURRENT',
  PENDING_CHANGE_APPROVAL: 'PENDING_CHANGE_APPROVAL',
  PENDING_RENEWAL: 'PENDING_RENEWAL',
  RENEWAL_WINDOW_EXPIRED: 'RENEWAL_WINDOW_EXPIRED',
} as const;

/**
 * * `CURRENT_SUBSCRIPTION` - Current Subscription
 * * `PENDING_SUBSCRIPTION` - Pending Subscription
 */
export type SelectionStateResponseSourceEnum =
  (typeof SelectionStateResponseSourceEnum)[keyof typeof SelectionStateResponseSourceEnum];

export const SelectionStateResponseSourceEnum = {
  CURRENT_SUBSCRIPTION: 'CURRENT_SUBSCRIPTION',
  PENDING_SUBSCRIPTION: 'PENDING_SUBSCRIPTION',
} as const;

export interface SelectionStateResponse {
  status: SelectionStateResponseStatusEnum;
  renewalWindowExpired: boolean;
  immediateDeduction: boolean;
  isReselectionWindow: boolean;
  hasFutureSubscription: boolean;
  /** @nullable */
  effectiveFrom: string | null;
  /** @nullable */
  currentUntil: string | null;
  /**
   * @nullable
   * @pattern ^-?\d{0,8}(?:\.\d{0,2})?$
   */
  currentEmployeePriceOnReselection: string | null;
  source: SelectionStateResponseSourceEnum;
}

export interface ModularBenefitPriceResponse {
  total: SplitPriceResponse;
  breakdown: PriceBreakdownResponse[];
  contributionSources: ContributionSourcesResponse;
  priceIsEstimate: boolean;
  periodContext?: AllowancePeriodContextResponse | null;
  selectionState: SelectionStateResponse;
  nmwImpact?: ModularBenefitNmwImpact | null;
}

export interface ModularBenefitStepComponentKeyList {
  readonly id: number;
  /**
   * @maxLength 250
   * @pattern ^[a-z][a-z0-9_]*$
   */
  key: string;
}

export interface ModularBenefitStepComponentKeyListRequest {
  /**
   * @minLength 1
   * @maxLength 250
   * @pattern ^[a-z][a-z0-9_]*$
   */
  key: string;
}

export interface Subscription {
  readonly id: number;
  selection?: unknown | null;
}

export interface ModularBenefitSubscriptionsResponse {
  subscriptions: Subscription[];
}

export interface ModularBenefitTag {
  /** @maxLength 50 */
  name: string;
  id?: number;
}

export interface ModularBenefitTagRequest {
  /**
   * @minLength 1
   * @maxLength 50
   */
  name: string;
  id?: number;
}

export interface ModularBenefitUploadedFileRequestRequest {
  file: Blob;
}

export interface ModularBenefitUploadedFileResponse {
  readonly uuid: string;
  file: string;
  originalName: string;
}

export interface ModularBenefitVersionsResponse {
  enrollableBenefit?: EnrollableBenefitVersion;
}

export type MomentActionParams = { [key: string]: unknown };

export interface MomentAction {
  route: string;
  params: MomentActionParams;
}

export interface MomentAttribution {
  key: string;
  displayName: string;
  /** @nullable */
  icon: string | null;
}

/**
 * * `REQUIRED` - Required
 * * `RECOMMENDED` - Recommended
 * * `INFORMATIONAL` - Informational
 */
export type UrgencyEnum = (typeof UrgencyEnum)[keyof typeof UrgencyEnum];

export const UrgencyEnum = {
  REQUIRED: 'REQUIRED',
  RECOMMENDED: 'RECOMMENDED',
  INFORMATIONAL: 'INFORMATIONAL',
} as const;

export interface MomentFeature {
  featureType: FeatureTypeEnum;
  featureId: string;
  displayName: string;
  /** @nullable */
  subtitle: string | null;
  /** @nullable */
  iconLabel: string | null;
  /** @nullable */
  imageUrl: string | null;
  /** @nullable */
  imageAltText: string | null;
}

export interface MomentCard {
  key: string;
  urgency: UrgencyEnum;
  /** @nullable */
  relevanceTag: string | null;
  /** @nullable */
  headline: string | null;
  /** @nullable */
  body: string | null;
  feature: MomentFeature;
  action: MomentAction;
  /** @nullable */
  validUntil: string | null;
  attribution: MomentAttribution | null;
}

export interface MomentGroup {
  header: string;
  subtext: string;
  tag: string;
  cards: MomentCard[];
}

export interface Need {
  /**
   * @maxLength 255
   * @pattern ^[-a-zA-Z0-9_.]+$
   */
  slug: string;
  displayName: string;
  /** @nullable */
  description?: string | null;
  /**
   * @maxLength 255
   * @nullable
   */
  icon?: string | null;
}

export interface NmwCheckEmployee {
  employeeId: number;
  fullName: string;
  email: string;
  readonly cycleCutoff: string;
  status: NmwStatusEnum;
  /**
   * @nullable
   * @pattern ^-?\d{0,8}(?:\.\d{0,2})?$
   */
  hoursUsed: string | null;
  /**
   * @nullable
   * @pattern ^-?\d{0,8}(?:\.\d{0,2})?$
   */
  hourlyRate: string | null;
  /**
   * @nullable
   * @pattern ^-?\d{0,8}(?:\.\d{0,2})?$
   */
  shortfallAmount: string | null;
  /** @nullable */
  shortfallCurrency: string | null;
  /** @nullable */
  likelyCause: string | null;
  /**
   * @nullable
   * @pattern ^-?\d{0,8}(?:\.\d{0,2})?$
   */
  nmwRate: string | null;
}

export interface NmwCheckExportResponse {
  downloadUrl: string;
  expiresAt: string;
  filename: string;
}

export interface NmwFilterOption {
  value: string;
  displayLabel: string;
}

export interface NmwCheckFilterOptionsResponse {
  likelyCause: NmwFilterOption[];
  status: NmwFilterOption[];
}

export interface NmwCheckGenerateResponse {
  status: string;
}

export interface NmwCheckReportResponse {
  /** @nullable */
  lastUpdatedAt: string | null;
  /** @nullable */
  minDate: string | null;
  /** @nullable */
  maxDate: string | null;
  count: number;
  /** @nullable */
  next: number | null;
  /** @nullable */
  previous: number | null;
  results: NmwCheckEmployee[];
}

export interface NotificationChannelConfigDetailResponse {
  channel: string;
  availableLanguages: string[];
}

export interface NotificationDefinitionDetailResponse {
  id: number;
  name: string;
  recipientType: string;
  /** @nullable */
  lastSent: string | null;
  eventCountLastSevenDays: number;
  channels: NotificationChannelConfigDetailResponse[];
  canBePaused: boolean;
  description: string;
  isPaused: boolean;
  category: string;
}

export interface NotificationDefinitionResponse {
  id: number;
  name: string;
  readonly channels: readonly string[];
  eventCountLastSevenDays: number;
  canBePaused: boolean;
  category: string;
  isPaused: boolean;
}

export interface NotificationDefinitionsResponse {
  totalItemCount: number;
  notificationDefinitions: NotificationDefinitionResponse[];
}

export interface NotificationEventRecipient {
  id: number;
  firstName: string;
  lastName: string;
  email: string;
}

export interface NotificationEventResponse {
  id: number;
  recipient: NotificationEventRecipient;
  language: string;
  status: string;
  channel: string;
  sentAt: string;
  createdAt: string;
}

export interface NotificationEventsResponse {
  totalItemCount: number;
  events: NotificationEventResponse[];
}

export interface NotificationTemplatePreviewResponse {
  id: number;
  /** @nullable */
  title: string | null;
  /** @nullable */
  message: string | null;
}

/**
 * * `ROLE_CHANGE` - role_change
 * * `ANNIVERSARY` - anniversary
 * * `UNRECOGNIZED` - unrecognized
 */
export type OccasionEnum = (typeof OccasionEnum)[keyof typeof OccasionEnum];

export const OccasionEnum = {
  ROLE_CHANGE: 'ROLE_CHANGE',
  ANNIVERSARY: 'ANNIVERSARY',
  UNRECOGNIZED: 'UNRECOGNIZED',
} as const;

export interface OnboardingChecklistItem {
  id: number;
  rank: number;
  name: string;
  url: string;
  mobileUrl: string;
  icon: string;
  completed: boolean;
}

export interface OnboardingChecklistModal {
  title: string;
  description: string;
  footer: string;
}

export interface OnboardingChecklistResponse {
  enabled: boolean;
  dismissed?: boolean;
  minimized?: boolean;
  modal?: OnboardingChecklistModal;
  items?: OnboardingChecklistItem[];
}

/**
 * * `CUSTOM` - Custom
 * * `INTERESTS` - Interests
 * * `GOALS` - Goals
 * * `NEEDS` - Needs
 */
export type OnboardingStepStepTypeEnum =
  (typeof OnboardingStepStepTypeEnum)[keyof typeof OnboardingStepStepTypeEnum];

export const OnboardingStepStepTypeEnum = {
  CUSTOM: 'CUSTOM',
  INTERESTS: 'INTERESTS',
  GOALS: 'GOALS',
  NEEDS: 'NEEDS',
} as const;

export interface OnboardingStep {
  readonly id: number;
  stepType: OnboardingStepStepTypeEnum;
  /**
   * @maxLength 255
   * @nullable
   */
  title?: string | null;
  /** @nullable */
  subtitle?: string | null;
  /** @nullable */
  content?: string | null;
  /** @nullable */
  readonly imageUrl: string | null;
  /**
   * @maxLength 200
   * @nullable
   */
  videoUrl?: string | null;
  /**
   * @maxLength 255
   * @nullable
   */
  additionalTitle?: string | null;
  /** @nullable */
  additionalContent?: string | null;
  /** @maxLength 100 */
  progressTitle: string;
}

export interface OnboardingResponse {
  enabled: boolean;
  completed: boolean;
  totalSteps: number;
  id: string;
  steps: OnboardingStep[];
}

export interface OptOutReasonRequestRequest {
  /** @minLength 1 */
  code: string;
  customReason?: string;
}

export interface OptOutReasonsGroup {
  id?: number;
  /** @maxLength 100 */
  name: string;
  isWaiver?: boolean;
}

export interface OptOutReasonsGroupRequest {
  id?: number;
  /**
   * @minLength 1
   * @maxLength 100
   */
  name: string;
  isWaiver?: boolean;
}

export interface WeavrAddressRequestRequest {
  /**
   * @minLength 1
   * @maxLength 50
   */
  addressLine1: string;
  /**
   * @maxLength 50
   * @nullable
   */
  addressLine2?: string | null;
  /**
   * @minLength 1
   * @maxLength 20
   */
  city: string;
  country: HomeAddressCountryEnum;
  /**
   * @minLength 1
   * @maxLength 10
   */
  postcode: string;
  /**
   * @minLength 1
   * @maxLength 50
   * @nullable
   */
  state?: string | null;
  addressType?: AddressTypeEnum;
}

export interface OrderPhysicalManagedCardRequestRequest {
  /** @minLength 1 */
  managedCardId: string;
  employeeAddress: WeavrAddressRequestRequest;
  /** @minLength 1 */
  tokenizedPin?: string;
  /**
   * @minLength 1
   * @maxLength 20
   */
  nameOnCard?: string;
  /**
   * Required for Airwallex cards shipping to the US due to DHL tracking requirements
   * @minLength 1
   * @maxLength 30
   */
  mobileNumber?: string;
}

export interface OutboundProvider {
  readonly id: number;
  /** @maxLength 250 */
  name: string;
}

export interface PaginatedAdminEnrolmentChangeListResponseList {
  count: number;
  /** @nullable */
  next?: string | null;
  /** @nullable */
  previous?: string | null;
  results: AdminEnrolmentChangeListResponse[];
}

export interface PaginatedAirwallexFinancialReportListItemList {
  count: number;
  /** @nullable */
  next?: string | null;
  /** @nullable */
  previous?: string | null;
  results: AirwallexFinancialReportListItem[];
}

export interface PaginatedApprovalRequestResponseList {
  count: number;
  /** @nullable */
  next?: string | null;
  /** @nullable */
  previous?: string | null;
  results: ApprovalRequestResponse[];
}

export interface PaginatedApprovalRequestStepExecutionResponseList {
  count: number;
  /** @nullable */
  next?: string | null;
  /** @nullable */
  previous?: string | null;
  results: ApprovalRequestStepExecutionResponse[];
}

export interface PaginatedBenefitBrokerList {
  count: number;
  /** @nullable */
  next?: string | null;
  /** @nullable */
  previous?: string | null;
  results: BenefitBroker[];
}

export interface PaginatedBenefitDelayList {
  count: number;
  /** @nullable */
  next?: string | null;
  /** @nullable */
  previous?: string | null;
  results: BenefitDelay[];
}

export interface PaginatedBenefitDocumentCreateRequestList {
  count: number;
  /** @nullable */
  next?: string | null;
  /** @nullable */
  previous?: string | null;
  results: BenefitDocumentCreateRequest[];
}

export interface PaginatedBenefitEnrollmentList {
  count: number;
  /** @nullable */
  next?: string | null;
  /** @nullable */
  previous?: string | null;
  results: BenefitEnrollment[];
}

export interface PaginatedBenefitHeroImageList {
  count: number;
  /** @nullable */
  next?: string | null;
  /** @nullable */
  previous?: string | null;
  results: BenefitHeroImage[];
}

export interface PaginatedBenefitImageList {
  count: number;
  /** @nullable */
  next?: string | null;
  /** @nullable */
  previous?: string | null;
  results: BenefitImage[];
}

export interface PaginatedBenefitManagerList {
  count: number;
  /** @nullable */
  next?: string | null;
  /** @nullable */
  previous?: string | null;
  results: BenefitManager[];
}

export interface PaginatedBenefitProductTypeList {
  count: number;
  /** @nullable */
  next?: string | null;
  /** @nullable */
  previous?: string | null;
  results: BenefitProductType[];
}

export interface PaginatedCampaignListResponse {
  /** @nullable */
  next: number | null;
  /** @nullable */
  previous: number | null;
  count: number;
  results: CampaignListItemResponse[];
}

export interface PaginatedContactEnrollmentListList {
  count: number;
  /** @nullable */
  next?: string | null;
  /** @nullable */
  previous?: string | null;
  results: ContactEnrollmentList[];
}

export interface PaginatedEmployeeContactListList {
  count: number;
  /** @nullable */
  next?: string | null;
  /** @nullable */
  previous?: string | null;
  results: EmployeeContactList[];
}

export interface PaginatedEmployeeSegmentEmployeeList {
  count: number;
  /** @nullable */
  next?: string | null;
  /** @nullable */
  previous?: string | null;
  results: EmployeeSegmentEmployee[];
}

export interface PaginatedEmployeeSegmentListList {
  count: number;
  /** @nullable */
  next?: string | null;
  /** @nullable */
  previous?: string | null;
  results: EmployeeSegmentList[];
}

export interface PaginatedEmployerListResponseList {
  count: number;
  /** @nullable */
  next?: string | null;
  /** @nullable */
  previous?: string | null;
  results: EmployerListResponse[];
}

export interface PaginatedEnrollableBenefitFeatureSerializerWithBenefitDetailsList {
  count: number;
  /** @nullable */
  next?: string | null;
  /** @nullable */
  previous?: string | null;
  results: EnrollableBenefitFeatureSerializerWithBenefitDetails[];
}

export interface PaginatedEnrolmentChangeResponseList {
  count: number;
  /** @nullable */
  next?: string | null;
  /** @nullable */
  previous?: string | null;
  results: EnrolmentChangeResponse[];
}

export interface PaginatedLifeEventResponseList {
  count: number;
  /** @nullable */
  next?: string | null;
  /** @nullable */
  previous?: string | null;
  results: LifeEventResponse[];
}

export interface PaginatedModularBenefitListResponseList {
  count: number;
  /** @nullable */
  next?: string | null;
  /** @nullable */
  previous?: string | null;
  results: ModularBenefitListResponse[];
}

export interface PaginatedModularBenefitStepComponentKeyListList {
  count: number;
  /** @nullable */
  next?: string | null;
  /** @nullable */
  previous?: string | null;
  results: ModularBenefitStepComponentKeyList[];
}

export interface PaginatedModularBenefitTagList {
  count: number;
  /** @nullable */
  next?: string | null;
  /** @nullable */
  previous?: string | null;
  results: ModularBenefitTag[];
}

export interface PaginatedOptOutReasonsGroupList {
  count: number;
  /** @nullable */
  next?: string | null;
  /** @nullable */
  previous?: string | null;
  results: OptOutReasonsGroup[];
}

export interface PaginatedOutboundProviderList {
  count: number;
  /** @nullable */
  next?: string | null;
  /** @nullable */
  previous?: string | null;
  results: OutboundProvider[];
}

export interface PayrollCycle {
  readonly id: number;
  readonly startDate: string;
  readonly endDate: string;
  readonly cutoffDate: string;
  readonly payrollConfigName: string;
}

export interface PaginatedPayrollCycleList {
  count: number;
  /** @nullable */
  next?: string | null;
  /** @nullable */
  previous?: string | null;
  results: PayrollCycle[];
}

export interface _OutputSchemaNested {
  readonly id: number;
  readonly name: string;
}

/**
 * * `NET_CHANGE` - Net change (last reported to cutoff)
 * * `ALL_TRANSITIONS` - All transitions (every consecutive change)
 */
export type TransitionModeEnum =
  (typeof TransitionModeEnum)[keyof typeof TransitionModeEnum];

export const TransitionModeEnum = {
  NET_CHANGE: 'NET_CHANGE',
  ALL_TRANSITIONS: 'ALL_TRANSITIONS',
} as const;

export interface PayrollInstructionFieldMapping {
  readonly id: number;
  outputFieldId: number;
  readonly outputFieldKey: string;
  /** @nullable */
  getter?: string | null;
  /** @nullable */
  defaultValue?: string | null;
}

export interface PayrollInstructionConfig {
  readonly id: number;
  readonly outputSchema: _OutputSchemaNested;
  /** @maxLength 255 */
  name: string;
  condition: string;
  order: number;
  isActive?: boolean;
  transitionMode: TransitionModeEnum;
  readonly payrollConfigIds: readonly number[];
  readonly benefitIds: readonly number[];
  fieldMappings: PayrollInstructionFieldMapping[];
  readonly warnings: readonly string[];
  readonly createdTimestamp: string;
  readonly updatedTimestamp: string;
}

export interface PaginatedPayrollInstructionConfigList {
  count: number;
  /** @nullable */
  next?: string | null;
  /** @nullable */
  previous?: string | null;
  results: PayrollInstructionConfig[];
}

export interface PayrollInstructionOutputField {
  readonly id: number;
  /** @maxLength 255 */
  key: string;
  order: number;
  fieldType: FieldTypeEnum;
}

/**
 * * `COMPLETED` - Completed
 * * `PROCESSING` - Processing
 * * `GENERATING` - Generating
 * * `FAILED` - Failed
 */
export type StatusF97Enum = (typeof StatusF97Enum)[keyof typeof StatusF97Enum];

export const StatusF97Enum = {
  COMPLETED: 'COMPLETED',
  PROCESSING: 'PROCESSING',
  GENERATING: 'GENERATING',
  FAILED: 'FAILED',
} as const;

export interface PayrollInstructionOutputSchema {
  readonly id: number;
  /** @maxLength 255 */
  name: string;
  schemaFields: PayrollInstructionOutputField[];
  readonly status: StatusF97Enum;
  readonly instructionsCount: number;
  readonly createdTimestamp: string;
  readonly updatedTimestamp: string;
}

export interface PaginatedPayrollInstructionOutputSchemaList {
  count: number;
  /** @nullable */
  next?: string | null;
  /** @nullable */
  previous?: string | null;
  results: PayrollInstructionOutputSchema[];
}

/**
 * Reads latest-report-file annotations from an annotated PayrollCycle.
 */
export interface PayrollInstructionSchemaCycleReportFile {
  id: number;
  status: ContributionHolidaysExportJobStatusEnum;
  isProvisional: boolean;
  /** @nullable */
  generatedAt: string | null;
  /** @nullable */
  rowCount: number | null;
}

/**
 * Cycle fields plus the schema's latest report file, if any.
 */
export interface PayrollInstructionSchemaCycle {
  readonly id: number;
  readonly startDate: string;
  readonly endDate: string;
  readonly cutoffDate: string;
  readonly payrollConfigName: string;
  readonly reportFile: PayrollInstructionSchemaCycleReportFile | null;
}

export interface PaginatedPayrollInstructionSchemaCycleList {
  count: number;
  /** @nullable */
  next?: string | null;
  /** @nullable */
  previous?: string | null;
  results: PayrollInstructionSchemaCycle[];
}

export interface Provider {
  readonly id: number;
  /** @maxLength 200 */
  name: string;
}

export interface PaginatedProviderList {
  count: number;
  /** @nullable */
  next?: string | null;
  /** @nullable */
  previous?: string | null;
  results: Provider[];
}

export interface ProviderResponse {
  id: number;
  /** @maxLength 200 */
  name: string;
}

export interface PaginatedProviderResponseList {
  count: number;
  /** @nullable */
  next?: string | null;
  /** @nullable */
  previous?: string | null;
  results: ProviderResponse[];
}

export interface StatePensionAgeConfig {
  readonly id: number;
  country: HomeAddressCountryEnum;
}

export interface PaginatedStatePensionAgeConfigList {
  count: number;
  /** @nullable */
  next?: string | null;
  /** @nullable */
  previous?: string | null;
  results: StatePensionAgeConfig[];
}

export type PaginatedTestCaseListListStatusCounts = {
  passed: number;
  failed: number;
  untested: number;
  error: number;
};

export interface TestCaseList {
  readonly id: number;
  /** @nullable */
  readonly name: string | null;
  readonly status: string;
  readonly isSnapshot: boolean;
  readonly updatedTimestamp: string;
}

export interface PaginatedTestCaseListList {
  count: number;
  /** @nullable */
  next?: string | null;
  /** @nullable */
  previous?: string | null;
  results: TestCaseList[];
  statusCounts: PaginatedTestCaseListListStatusCounts;
}

/**
 * Successful PAN token reveal payload from Airwallex.
 */
export interface PanTokenResponse {
  token: string;
  expiresAt: string;
}

export interface PatchEmployerConfiguration {
  useCustomBenefitSorting?: boolean;
}

export interface PatchedAllowanceReceiptUpdateRequestRequest {
  /** @minLength 1 */
  note?: string;
  /** @minimum 0 */
  taxRate?: number;
  rjsfFormData?: unknown | null;
}

export interface PatchedBeneficiaryRequestRequest {
  type?: BeneficiaryRequestTypeEnum;
  person?: BeneficiaryPersonRequestRequest;
}

/**
 * Serializer for partial update of a BenefitCategory
 */
export interface PatchedBenefitCategoryPartialUpdateRequest {
  id?: number;
  icon?: string;
  benefits?: number[];
}

export interface PatchedBenefitDocumentUpdateRequestRequest {
  /**
   * @minLength 1
   * @maxLength 200
   */
  name?: string;
  description?: string;
  isPolicyDocument?: boolean;
}

export interface PatchedBenefitEnrollmentUpdateRequest {
  isFavorite?: boolean;
  payDeductionType?: PayDeductionTypeEnum;
}

export interface PatchedBenefitRequestPatchRequest {
  requestData?: unknown;
  hasSeenAlert?: boolean;
}

export interface TopUpCardTemplateRequestRequest {
  /**
   * @minLength 1
   * @maxLength 50
   */
  name: string;
  description?: string;
  requiresReceipts: boolean;
  reimbursementAllowed: boolean;
  fundRequestAllowed: boolean;
}

export interface PatchedBudgetUpdateRequestRequest {
  /** @pattern ^-?\d{0,8}(?:\.\d{0,2})?$ */
  budgetAmount?: string;
  /**
   * @minLength 1
   * @maxLength 50
   */
  iconName?: string;
  /** @nullable */
  budgetOwner?: number | null;
  template?: TopUpCardTemplateRequestRequest | null;
}

export interface PatchedCarouselRankRequest {
  new_index?: number;
}

export interface PatchedCompanyValueCreateUpdateRequest {
  /** @nullable */
  image?: string | null;
  /**
   * @minLength 1
   * @maxLength 30
   */
  name?: string;
  /** @maxLength 360 */
  description?: string;
  /**
   * @minLength 1
   * @maxLength 100
   */
  icon?: string;
  /** @maxLength 100 */
  imageAltText?: string;
}

export interface PatchedCompleteOnboardingRequestRequest {
  completed?: boolean;
}

/**
 * Serializer for creating/updating an EnrollableBenefit.
 * Excludes the 'name' field and sets the 'name' field to a placeholder value.
 */
export interface PatchedCreateEnrollableBenefitRequest {
  /** @nullable */
  contentCs?: string | null;
  /** @nullable */
  contentDe?: string | null;
  /** @nullable */
  contentEl?: string | null;
  /** @nullable */
  contentEn?: string | null;
  /** @nullable */
  contentEnUs?: string | null;
  /** @nullable */
  contentEs?: string | null;
  /** @nullable */
  contentEsXl?: string | null;
  /** @nullable */
  contentFr?: string | null;
  /** @nullable */
  contentHu?: string | null;
  /** @nullable */
  contentIo?: string | null;
  /** @nullable */
  contentIt?: string | null;
  /** @nullable */
  contentJa?: string | null;
  /** @nullable */
  contentKo?: string | null;
  /** @nullable */
  contentMs?: string | null;
  /** @nullable */
  contentPl?: string | null;
  /** @nullable */
  contentPt?: string | null;
  /** @nullable */
  contentSk?: string | null;
  /** @nullable */
  contentTr?: string | null;
  /** @nullable */
  contentVi?: string | null;
  /** @nullable */
  contentZh?: string | null;
  /**
   * @maxLength 250
   * @nullable
   */
  ctaTextCs?: string | null;
  /**
   * @maxLength 250
   * @nullable
   */
  ctaTextDe?: string | null;
  /**
   * @maxLength 250
   * @nullable
   */
  ctaTextEl?: string | null;
  /**
   * @maxLength 250
   * @nullable
   */
  ctaTextEn?: string | null;
  /**
   * @maxLength 250
   * @nullable
   */
  ctaTextEnUs?: string | null;
  /**
   * @maxLength 250
   * @nullable
   */
  ctaTextEs?: string | null;
  /**
   * @maxLength 250
   * @nullable
   */
  ctaTextEsXl?: string | null;
  /**
   * @maxLength 250
   * @nullable
   */
  ctaTextFr?: string | null;
  /**
   * @maxLength 250
   * @nullable
   */
  ctaTextHu?: string | null;
  /**
   * @maxLength 250
   * @nullable
   */
  ctaTextIo?: string | null;
  /**
   * @maxLength 250
   * @nullable
   */
  ctaTextIt?: string | null;
  /**
   * @maxLength 250
   * @nullable
   */
  ctaTextJa?: string | null;
  /**
   * @maxLength 250
   * @nullable
   */
  ctaTextKo?: string | null;
  /**
   * @maxLength 250
   * @nullable
   */
  ctaTextMs?: string | null;
  /**
   * @maxLength 250
   * @nullable
   */
  ctaTextPl?: string | null;
  /**
   * @maxLength 250
   * @nullable
   */
  ctaTextPt?: string | null;
  /**
   * @maxLength 250
   * @nullable
   */
  ctaTextSk?: string | null;
  /**
   * @maxLength 250
   * @nullable
   */
  ctaTextTr?: string | null;
  /**
   * @maxLength 250
   * @nullable
   */
  ctaTextVi?: string | null;
  /**
   * @maxLength 250
   * @nullable
   */
  ctaTextZh?: string | null;
  /**
   * @maxLength 200
   * @nullable
   */
  displayNameCs?: string | null;
  /**
   * @maxLength 200
   * @nullable
   */
  displayNameDe?: string | null;
  /**
   * @maxLength 200
   * @nullable
   */
  displayNameEl?: string | null;
  /**
   * @maxLength 200
   * @nullable
   */
  displayNameEn?: string | null;
  /**
   * @maxLength 200
   * @nullable
   */
  displayNameEnUs?: string | null;
  /**
   * @maxLength 200
   * @nullable
   */
  displayNameEs?: string | null;
  /**
   * @maxLength 200
   * @nullable
   */
  displayNameEsXl?: string | null;
  /**
   * @maxLength 200
   * @nullable
   */
  displayNameFr?: string | null;
  /**
   * @maxLength 200
   * @nullable
   */
  displayNameHu?: string | null;
  /**
   * @maxLength 200
   * @nullable
   */
  displayNameIo?: string | null;
  /**
   * @maxLength 200
   * @nullable
   */
  displayNameIt?: string | null;
  /**
   * @maxLength 200
   * @nullable
   */
  displayNameJa?: string | null;
  /**
   * @maxLength 200
   * @nullable
   */
  displayNameKo?: string | null;
  /**
   * @maxLength 200
   * @nullable
   */
  displayNameMs?: string | null;
  /**
   * @maxLength 200
   * @nullable
   */
  displayNamePl?: string | null;
  /**
   * @maxLength 200
   * @nullable
   */
  displayNamePt?: string | null;
  /**
   * @maxLength 200
   * @nullable
   */
  displayNameSk?: string | null;
  /**
   * @maxLength 200
   * @nullable
   */
  displayNameTr?: string | null;
  /**
   * @maxLength 200
   * @nullable
   */
  displayNameVi?: string | null;
  /**
   * @maxLength 200
   * @nullable
   */
  displayNameZh?: string | null;
  /** @nullable */
  grossPayDeductionDescriptionCs?: string | null;
  /** @nullable */
  grossPayDeductionDescriptionDe?: string | null;
  /** @nullable */
  grossPayDeductionDescriptionEl?: string | null;
  /** @nullable */
  grossPayDeductionDescriptionEn?: string | null;
  /** @nullable */
  grossPayDeductionDescriptionEnUs?: string | null;
  /** @nullable */
  grossPayDeductionDescriptionEs?: string | null;
  /** @nullable */
  grossPayDeductionDescriptionEsXl?: string | null;
  /** @nullable */
  grossPayDeductionDescriptionFr?: string | null;
  /** @nullable */
  grossPayDeductionDescriptionHu?: string | null;
  /** @nullable */
  grossPayDeductionDescriptionIo?: string | null;
  /** @nullable */
  grossPayDeductionDescriptionIt?: string | null;
  /** @nullable */
  grossPayDeductionDescriptionJa?: string | null;
  /** @nullable */
  grossPayDeductionDescriptionKo?: string | null;
  /** @nullable */
  grossPayDeductionDescriptionMs?: string | null;
  /** @nullable */
  grossPayDeductionDescriptionPl?: string | null;
  /** @nullable */
  grossPayDeductionDescriptionPt?: string | null;
  /** @nullable */
  grossPayDeductionDescriptionSk?: string | null;
  /** @nullable */
  grossPayDeductionDescriptionTr?: string | null;
  /** @nullable */
  grossPayDeductionDescriptionVi?: string | null;
  /** @nullable */
  grossPayDeductionDescriptionZh?: string | null;
  /** @nullable */
  grossPayDeductionTitleCs?: string | null;
  /** @nullable */
  grossPayDeductionTitleDe?: string | null;
  /** @nullable */
  grossPayDeductionTitleEl?: string | null;
  /** @nullable */
  grossPayDeductionTitleEn?: string | null;
  /** @nullable */
  grossPayDeductionTitleEnUs?: string | null;
  /** @nullable */
  grossPayDeductionTitleEs?: string | null;
  /** @nullable */
  grossPayDeductionTitleEsXl?: string | null;
  /** @nullable */
  grossPayDeductionTitleFr?: string | null;
  /** @nullable */
  grossPayDeductionTitleHu?: string | null;
  /** @nullable */
  grossPayDeductionTitleIo?: string | null;
  /** @nullable */
  grossPayDeductionTitleIt?: string | null;
  /** @nullable */
  grossPayDeductionTitleJa?: string | null;
  /** @nullable */
  grossPayDeductionTitleKo?: string | null;
  /** @nullable */
  grossPayDeductionTitleMs?: string | null;
  /** @nullable */
  grossPayDeductionTitlePl?: string | null;
  /** @nullable */
  grossPayDeductionTitlePt?: string | null;
  /** @nullable */
  grossPayDeductionTitleSk?: string | null;
  /** @nullable */
  grossPayDeductionTitleTr?: string | null;
  /** @nullable */
  grossPayDeductionTitleVi?: string | null;
  /** @nullable */
  grossPayDeductionTitleZh?: string | null;
  /** @nullable */
  netPayDeductionDescriptionCs?: string | null;
  /** @nullable */
  netPayDeductionDescriptionDe?: string | null;
  /** @nullable */
  netPayDeductionDescriptionEl?: string | null;
  /** @nullable */
  netPayDeductionDescriptionEn?: string | null;
  /** @nullable */
  netPayDeductionDescriptionEnUs?: string | null;
  /** @nullable */
  netPayDeductionDescriptionEs?: string | null;
  /** @nullable */
  netPayDeductionDescriptionEsXl?: string | null;
  /** @nullable */
  netPayDeductionDescriptionFr?: string | null;
  /** @nullable */
  netPayDeductionDescriptionHu?: string | null;
  /** @nullable */
  netPayDeductionDescriptionIo?: string | null;
  /** @nullable */
  netPayDeductionDescriptionIt?: string | null;
  /** @nullable */
  netPayDeductionDescriptionJa?: string | null;
  /** @nullable */
  netPayDeductionDescriptionKo?: string | null;
  /** @nullable */
  netPayDeductionDescriptionMs?: string | null;
  /** @nullable */
  netPayDeductionDescriptionPl?: string | null;
  /** @nullable */
  netPayDeductionDescriptionPt?: string | null;
  /** @nullable */
  netPayDeductionDescriptionSk?: string | null;
  /** @nullable */
  netPayDeductionDescriptionTr?: string | null;
  /** @nullable */
  netPayDeductionDescriptionVi?: string | null;
  /** @nullable */
  netPayDeductionDescriptionZh?: string | null;
  /** @nullable */
  netPayDeductionTitleCs?: string | null;
  /** @nullable */
  netPayDeductionTitleDe?: string | null;
  /** @nullable */
  netPayDeductionTitleEl?: string | null;
  /** @nullable */
  netPayDeductionTitleEn?: string | null;
  /** @nullable */
  netPayDeductionTitleEnUs?: string | null;
  /** @nullable */
  netPayDeductionTitleEs?: string | null;
  /** @nullable */
  netPayDeductionTitleEsXl?: string | null;
  /** @nullable */
  netPayDeductionTitleFr?: string | null;
  /** @nullable */
  netPayDeductionTitleHu?: string | null;
  /** @nullable */
  netPayDeductionTitleIo?: string | null;
  /** @nullable */
  netPayDeductionTitleIt?: string | null;
  /** @nullable */
  netPayDeductionTitleJa?: string | null;
  /** @nullable */
  netPayDeductionTitleKo?: string | null;
  /** @nullable */
  netPayDeductionTitleMs?: string | null;
  /** @nullable */
  netPayDeductionTitlePl?: string | null;
  /** @nullable */
  netPayDeductionTitlePt?: string | null;
  /** @nullable */
  netPayDeductionTitleSk?: string | null;
  /** @nullable */
  netPayDeductionTitleTr?: string | null;
  /** @nullable */
  netPayDeductionTitleVi?: string | null;
  /** @nullable */
  netPayDeductionTitleZh?: string | null;
  /**
   * @maxLength 70
   * @nullable
   */
  shortDescriptionCs?: string | null;
  /**
   * @maxLength 70
   * @nullable
   */
  shortDescriptionDe?: string | null;
  /**
   * @maxLength 70
   * @nullable
   */
  shortDescriptionEl?: string | null;
  /**
   * @maxLength 70
   * @nullable
   */
  shortDescriptionEn?: string | null;
  /**
   * @maxLength 70
   * @nullable
   */
  shortDescriptionEnUs?: string | null;
  /**
   * @maxLength 70
   * @nullable
   */
  shortDescriptionEs?: string | null;
  /**
   * @maxLength 70
   * @nullable
   */
  shortDescriptionEsXl?: string | null;
  /**
   * @maxLength 70
   * @nullable
   */
  shortDescriptionFr?: string | null;
  /**
   * @maxLength 70
   * @nullable
   */
  shortDescriptionHu?: string | null;
  /**
   * @maxLength 70
   * @nullable
   */
  shortDescriptionIo?: string | null;
  /**
   * @maxLength 70
   * @nullable
   */
  shortDescriptionIt?: string | null;
  /**
   * @maxLength 70
   * @nullable
   */
  shortDescriptionJa?: string | null;
  /**
   * @maxLength 70
   * @nullable
   */
  shortDescriptionKo?: string | null;
  /**
   * @maxLength 70
   * @nullable
   */
  shortDescriptionMs?: string | null;
  /**
   * @maxLength 70
   * @nullable
   */
  shortDescriptionPl?: string | null;
  /**
   * @maxLength 70
   * @nullable
   */
  shortDescriptionPt?: string | null;
  /**
   * @maxLength 70
   * @nullable
   */
  shortDescriptionSk?: string | null;
  /**
   * @maxLength 70
   * @nullable
   */
  shortDescriptionTr?: string | null;
  /**
   * @maxLength 70
   * @nullable
   */
  shortDescriptionVi?: string | null;
  /**
   * @maxLength 70
   * @nullable
   */
  shortDescriptionZh?: string | null;
  active?: boolean;
  autoActivating?: boolean;
  /**
   * Select the programme that this benefit belongs to.
   * @nullable
   */
  benefitProgramme?: number | null;
  benefitRequirements?: BenefitRequirementsEnum[];
  /** @nullable */
  broker?: number | null;
  categories?: number[];
  /** Whether employees need to wait for open benefit window to opt into benefit after opt out. */
  closeOptInWindowAfterOptOut?: boolean;
  documents?: BenefitDocumentRequest[];
  enrolmentType?: EnrolmentTypeEnum;
  /**
   * @maxLength 2100
   * @nullable
   */
  externalLinkUrl?: string | null;
  features?: EnrollableBenefitFeatureRequest[];
  /**
   * @maxLength 100
   * @nullable
   */
  groupMembershipNumber?: string | null;
  hasRenewableBenefit?: boolean;
  /**
   * @minLength 1
   * @nullable
   */
  heroImage?: string | null;
  /** @nullable */
  heroImageAltText?: string | null;
  /**
   * @minLength 1
   * @nullable
   */
  image?: string | null;
  /** @nullable */
  imageAltText?: string | null;
  /**
   * @maxLength 50
   * @nullable
   */
  optInButtonText?: string | null;
  /**
   * Copy to be shown on the benefit tile and banner.If not provided, the default copy will be used.
   * @maxLength 255
   * @nullable
   */
  optInCopy?: string | null;
  /**
   * Copy to be shown on the benefit tile and banner.If not provided, the default copy will be used.
   * @maxLength 255
   * @nullable
   */
  optOutCopy?: string | null;
  /**
   * Copy to be shown on the benefit tile and banner.
   * @maxLength 255
   * @nullable
   */
  optInCopyPreposition?: string | null;
  /**
   * Copy to be shown on the benefit tile and banner.
   * @maxLength 255
   * @nullable
   */
  optOutCopyPreposition?: string | null;
  pricing?: EnrollableBenefitPricingRequest;
  /** @nullable */
  provider?: number | null;
  /**
   * @minimum -2147483648
   * @maximum 2147483647
   */
  rank?: number;
  /**
   *
   *             Date of the upcoming renewal, does not affect new renewal flow.
   * @nullable
   */
  renewalDate?: string | null;
  /** Whether company admins need to approve opt-ins or changes to enrolments. */
  requiresActivationApproval?: boolean;
  /** Whether company admins need to approve opt-outs to enrolments. */
  requiresDeactivationApproval?: boolean;
  status?: StatusC27Enum | null;
  /** @nullable */
  airtableId?: string | null;
}

export interface PatchedEmployeeInfoRequestRequest {
  homeAddress?: EmployeeAddressRequest | null;
  employee?: EmployeeUpdateRequest;
}

/**
 * Serializer for updating employee interests.
 */
export interface PatchedEmployeeInterestsUpdateRequest {
  /** @nullable */
  areasOfInterest?: number[] | null;
  /** @nullable */
  benefitTags?: number[] | null;
}

export interface PatchedEmployeePatchRequestRequest {
  employeeIds?: number[];
  isActive?: boolean;
}

export interface PatchedEmployeeProfileRequest {
  title?: TitleEnum | null;
  /**
   * @maxLength 250
   * @nullable
   */
  preferredName?: string | null;
  /** @nullable */
  dob?: string | null;
  gender?: GenderEnum | null;
  maritalStatus?: MaritalStatusEnum | null;
  /**
   * @maxLength 250
   * @nullable
   */
  nationality?: string | null;
  /**
   * @maxLength 50
   * @nullable
   */
  niNumber?: string | null;
  /**
   * @minLength 1
   * @maxLength 21
   * @nullable
   */
  phoneNumber?: string | null;
  /**
   * @minLength 1
   * @nullable
   */
  workEmail?: string | null;
  /**
   * @minLength 1
   * @nullable
   */
  contactEmail?: string | null;
  homeAddress?: EmployeeAddressRequestRequest | null;
  /**
   * @maxLength 255
   * @nullable
   */
  jobTitle?: string | null;
  country?: HomeAddressCountryEnum | null;
  /** @nullable */
  residencyType?: number | null;
}

export interface PatchedEmployeeRolesUpdateRequest {
  roles?: RolesA5dEnum[];
  /** @nullable */
  employerRoles?: number[] | null;
}

export interface PatchedEmployerChangeRequestRequest {
  employer?: number;
}

export interface PatchedEmployerExternalLinkRankRequest {
  new_index?: number;
}

export interface PatchedEnrollableBenefitEmployeeFeatureUpdateRequest {
  isFavorite?: boolean;
}

export interface PatchedEnrollableBenefitFeatureUpdateRequestRequest {
  id?: number;
  category?: Category379Enum;
}

export interface PatchedEnrolmentUpdateRequestRequest {
  contributionSources?: BenefitEnrolmentContributionSourceRequestRequest | null;
  /** @nullable */
  changeReason?: string | null;
  payDeductionType?: PayDeductionTypeEnum | null;
}

export interface PatchedIntentProfileRequest {
  /**
   * @maxItems 3
   * @items.minLength 1
   * @items.pattern ^[-a-zA-Z0-9_]+$
   */
  goalsRanked?: string[];
  /**
   * @items.minLength 1
   * @items.pattern ^[-a-zA-Z0-9_.]+$
   */
  needsSelected?: string[];
  /** @nullable */
  additionalNote?: string | null;
}

export interface PatchedKomboSetupActivateRequestRequest {
  /** @minLength 1 */
  token?: string;
}

export interface PatchedMSTeamsUpdateEmployerConfigRequestRequest {
  selectedTeamIds?: number[];
  /** @items.minLength 1 */
  selectedChannelIds?: string[];
}

/**
 * * `en` - English
 * * `de` - Deutsch
 * * `fr` - Français
 * * `es` - Español (España)
 * * `es-XL` - Español (Latin America)
 * * `en-US` - English (United States)
 * * `sk` - Slovenčina
 * * `el` - Greek
 * * `cs` - Čeština
 * * `it` - Italiano
 * * `ja` - 日本語
 * * `ko` - 한국어
 * * `ms` - Bahasa Melayu
 * * `pl` - Polski
 * * `tr` - Türkçe
 * * `pt` - Português
 * * `hu` - Magyar
 * * `io` - Bahasa Indonesia
 * * `vi` - Tiếng Việt
 * * `zh` - 中文
 */
export type PreferredLanguageEnum =
  (typeof PreferredLanguageEnum)[keyof typeof PreferredLanguageEnum];

export const PreferredLanguageEnum = {
  en: 'en',
  de: 'de',
  fr: 'fr',
  es: 'es',
  'es-XL': 'es-XL',
  'en-US': 'en-US',
  sk: 'sk',
  el: 'el',
  cs: 'cs',
  it: 'it',
  ja: 'ja',
  ko: 'ko',
  ms: 'ms',
  pl: 'pl',
  tr: 'tr',
  pt: 'pt',
  hu: 'hu',
  io: 'io',
  vi: 'vi',
  zh: 'zh',
} as const;

export interface PatchedMeRequestRequest {
  preferredLanguage?: PreferredLanguageEnum | null;
}

export interface PatchedModularBenefitUnenrollRequestRequest {
  optOutReason?: OptOutReasonRequestRequest;
}

export interface PatchedNotificationDefinitionUpdateRequestRequest {
  /** @nullable */
  isPaused?: boolean | null;
}

export interface PatchedOnboardingChecklistRequestRequest {
  dismissed?: boolean;
  minimized?: boolean;
}

export interface PatchedPatchEmployerConfigurationRequest {
  useCustomBenefitSorting?: boolean;
}

export interface PayrollInstructionFieldMappingRequest {
  outputFieldId: number;
  /**
   * @minLength 1
   * @nullable
   */
  getter?: string | null;
  /**
   * @minLength 1
   * @nullable
   */
  defaultValue?: string | null;
}

export interface PatchedPayrollInstructionConfigCreateRequest {
  outputSchemaId?: number;
  /**
   * @minLength 1
   * @maxLength 255
   */
  name?: string;
  /** @minLength 1 */
  condition?: string;
  order?: number;
  isActive?: boolean;
  transitionMode?: TransitionModeEnum;
  payrollConfigIds?: number[];
  benefitIds?: number[];
  fieldMappings?: PayrollInstructionFieldMappingRequest[];
}

export interface PatchedRankRequestRequest {
  ids?: number[];
  afterIndex?: number;
}

export interface PatchedReadEnrolmentChangeRequestRequest {
  ids?: number[];
}

export interface PatchedReadNotificationRequestRequest {
  ids?: number[];
}

/**
 * * `CUSTOM_ONLY` - CUSTOM_ONLY
 * * `CUSTOM_AND_PRESETS` - CUSTOM_AND_PRESETS
 * * `PRESETS_ONLY` - PRESETS_ONLY
 */
export type RewardModeEnum =
  (typeof RewardModeEnum)[keyof typeof RewardModeEnum];

export const RewardModeEnum = {
  CUSTOM_ONLY: 'CUSTOM_ONLY',
  CUSTOM_AND_PRESETS: 'CUSTOM_AND_PRESETS',
  PRESETS_ONLY: 'PRESETS_ONLY',
} as const;

export interface PatchedRecognitionConfigurationPatchRequestRequest {
  rewardMode?: RewardModeEnum;
}

export interface PatchedRewardPresetPatchRequestRequest {
  /**
   * @minLength 1
   * @maxLength 30
   */
  title?: string;
  /** @pattern ^-?\d{0,13}(?:\.\d{0,2})?$ */
  amount?: string;
  /**
   * @minLength 1
   * @maxLength 3
   */
  currency?: string;
  /** @maxLength 360 */
  description?: string;
  isArchived?: boolean;
}

export interface PatchedRewardPresetReorderRequestRequest {
  /** @items.minimum 1 */
  rewardPresetIds?: number[];
}

export interface PatchedRewardsBudgetMembersBalanceRequestRequest {
  employees?: number[];
  /**
   * @nullable
   * @pattern ^-?\d{0,8}(?:\.\d{0,2})?$
   */
  amount?: string | null;
  /** @minLength 1 */
  name?: string;
  deductAllFunds?: boolean;
}

export interface PatchedRewardsBudgetMembersUpdateRequestRequest {
  includedMembers?: (number | null)[];
  excludedMembers?: (number | null)[];
}

export interface PatchedRewardsBudgetUpdateRequestRequest {
  /**
   * @minLength 1
   * @maxLength 50
   */
  name?: string;
  /** @maxLength 1000 */
  description?: string;
  /**
   * @nullable
   * @pattern ^-?\d{0,8}(?:\.\d{0,2})?$
   */
  limitPerReward?: string | null;
  /** @nullable */
  budgetOwnerId?: number | null;
  /** @pattern ^-?\d{0,8}(?:\.\d{0,2})?$ */
  budgetAmount?: string;
}

export interface PatchedSlackUpdateEmployerConfigRequestRequest {
  /** @items.minLength 1 */
  selectedTeamIds?: string[];
  /** @items.minLength 1 */
  selectedChannelIds?: string[];
}

export interface StoredInputsRequest {
  instructionConfigIds?: number[];
  /** @nullable */
  outputSchemaId: number | null;
  snapshot?: InputSnapshotRequest | null;
}

export interface PatchedTestCaseUpdateRequest {
  /** @maxLength 255 */
  name?: string;
  assertions?: AssertionsRequest;
  inputs?: StoredInputsRequest;
}

export interface PatchedUpdateCampaignRequestRequest {
  /**
   * @minLength 1
   * @maxLength 255
   */
  title?: string;
  /** @maxLength 1024 */
  description?: string;
  segmentQuery?: unknown | null;
  template?: CampaignTemplateRequestRequest;
}

export interface PatchedVerifyMobileVerificationCodeRequestRequest {
  /** @minLength 1 */
  nonce?: string;
}

/**
 * * `PENDING` - Pending
 * * `CANCELLED` - Cancelled
 * * `COMPLETED` - Completed
 */
export type PaymentStateEnum =
  (typeof PaymentStateEnum)[keyof typeof PaymentStateEnum];

export const PaymentStateEnum = {
  PENDING: 'PENDING',
  CANCELLED: 'CANCELLED',
  COMPLETED: 'COMPLETED',
} as const;

export interface PayrollConfigOption {
  readonly id: number;
  readonly label: string;
}

export interface PayrollInstructionConfigCreateRequest {
  outputSchemaId: number;
  /**
   * @minLength 1
   * @maxLength 255
   */
  name: string;
  /** @minLength 1 */
  condition: string;
  order: number;
  isActive?: boolean;
  transitionMode?: TransitionModeEnum;
  payrollConfigIds?: number[];
  benefitIds?: number[];
  fieldMappings: PayrollInstructionFieldMappingRequest[];
}

export interface PayrollInstructionConfigDuplicateRequest {
  /**
   * @minLength 1
   * @maxLength 255
   */
  name?: string;
}

export interface PayrollInstructionOutputFieldRequest {
  /**
   * @minLength 1
   * @maxLength 255
   */
  key: string;
  order: number;
  fieldType: FieldTypeEnum;
}

export interface PayrollInstructionOutputSchemaGenerateRequestRequest {
  /**
   * @minLength 1
   * @maxLength 255
   */
  name: string;
  description?: string;
  files?: Blob[];
}

export interface PayrollInstructionOutputSchemaGenerateResponse {
  readonly id: number;
  readonly status: StatusF97Enum;
}

export interface PayrollInstructionOutputSchemaRequest {
  /**
   * @minLength 1
   * @maxLength 255
   */
  name: string;
  schemaFields: PayrollInstructionOutputFieldRequest[];
}

export interface _PayrollInstructionOutputFieldUpdateRequest {
  id?: number;
  /**
   * @minLength 1
   * @maxLength 255
   */
  key: string;
  order: number;
  fieldType: FieldTypeEnum;
}

export interface PayrollInstructionOutputSchemaUpdateRequest {
  /**
   * @minLength 1
   * @maxLength 255
   */
  name: string;
  schemaFields: _PayrollInstructionOutputFieldUpdateRequest[];
}

export interface _PayrollInstructionReportSchemaNested {
  id: number;
  name: string;
}

export interface PayrollInstructionReportDetail {
  reportFileId: number;
  status: ContributionHolidaysExportJobStatusEnum;
  isProvisional: boolean;
  generatedAt: string;
  /** @nullable */
  rowCount: number | null;
  cycle: PayrollCycle;
  schema: _PayrollInstructionReportSchemaNested;
}

export type PayrollInstructionReportRowOutput = { [key: string]: unknown };

export interface PayrollInstructionReportRow {
  id: number;
  employeeId: number;
  output: PayrollInstructionReportRowOutput;
}

export interface PayrollInstructionReportRowsResponse {
  count: number;
  /** @nullable */
  next: number | null;
  /** @nullable */
  previous: number | null;
  results: PayrollInstructionReportRow[];
  columns: string[];
}

export interface PayrollReportExportResponse {
  downloadUrl: string;
  expiresAt: string;
  filename: string;
}

export type PrepareSigningRequestRequestUserInput = { [key: string]: unknown };

export interface PrepareSigningRequestRequest {
  componentId: number;
  userInput: PrepareSigningRequestRequestUserInput;
}

export interface PrepareSigningResponse {
  signingRequestId: number;
  embedSrc: string;
  token: string;
}

/**
 * Serializer for sub-price data in pricing formula preview.
 */
export interface SubPricePreviewRequest {
  id?: number;
  /**
   * @minLength 1
   * @maxLength 250
   */
  name: string;
  /**
   * @minLength 1
   * @maxLength 3000
   */
  pricingFormula: string;
  /**
   * Employee contribution rate in percentage of the price.
   * @minimum 0
   * @maximum 100
   */
  employeeContribution: number;
  /**
   * Limit the employer contribution with a maximum amount.
   * @pattern ^-?\d{0,13}(?:\.\d{0,2})?$
   */
  maxEmployerContributionAmount?: string;
  isDependantPrice?: boolean;
}

/**
 * Serializer for pricing formula preview request.
 */
export interface PricingFormulaPreviewRequestRequest {
  subPrices?: SubPricePreviewRequest[];
  limit?: number;
}

export interface ProductItemResponse {
  id: number;
  /** @pattern ^-?\d{0,5}(?:\.\d{0,2})?$ */
  price: string;
  priceCurrency: string;
  description: string;
  rank: number;
}

export interface ProductResponse {
  readonly id: number;
  /** @nullable */
  imageUrl: string | null;
  /** @pattern ^-?\d{0,5}(?:\.\d{0,2})?$ */
  fromPrice: string;
  fromPriceCurrency?: string;
  items: ProductItemResponse[];
  /** @maxLength 200 */
  name: string;
  /**
   * @maxLength 200
   * @nullable
   */
  nameEn?: string | null;
  /**
   * @maxLength 200
   * @nullable
   */
  nameDe?: string | null;
  /**
   * @maxLength 200
   * @nullable
   */
  nameFr?: string | null;
  /**
   * @maxLength 200
   * @nullable
   */
  nameEs?: string | null;
  /**
   * @maxLength 200
   * @nullable
   */
  nameEsXl?: string | null;
  /**
   * @maxLength 200
   * @nullable
   */
  nameEnUs?: string | null;
  /**
   * @maxLength 200
   * @nullable
   */
  nameSk?: string | null;
  /**
   * @maxLength 200
   * @nullable
   */
  nameEl?: string | null;
  /**
   * @maxLength 200
   * @nullable
   */
  nameCs?: string | null;
  /**
   * @maxLength 200
   * @nullable
   */
  nameIt?: string | null;
  /**
   * @maxLength 200
   * @nullable
   */
  nameJa?: string | null;
  /**
   * @maxLength 200
   * @nullable
   */
  nameKo?: string | null;
  /**
   * @maxLength 200
   * @nullable
   */
  nameMs?: string | null;
  /**
   * @maxLength 200
   * @nullable
   */
  namePl?: string | null;
  /**
   * @maxLength 200
   * @nullable
   */
  nameTr?: string | null;
  /**
   * @maxLength 200
   * @nullable
   */
  namePt?: string | null;
  /**
   * @maxLength 200
   * @nullable
   */
  nameHu?: string | null;
  /**
   * @maxLength 200
   * @nullable
   */
  nameIo?: string | null;
  /**
   * @maxLength 200
   * @nullable
   */
  nameVi?: string | null;
  /**
   * @maxLength 200
   * @nullable
   */
  nameZh?: string | null;
  /** @maxLength 200 */
  shortDescription: string;
  /**
   * @maxLength 200
   * @nullable
   */
  shortDescriptionEn?: string | null;
  /**
   * @maxLength 200
   * @nullable
   */
  shortDescriptionDe?: string | null;
  /**
   * @maxLength 200
   * @nullable
   */
  shortDescriptionFr?: string | null;
  /**
   * @maxLength 200
   * @nullable
   */
  shortDescriptionEs?: string | null;
  /**
   * @maxLength 200
   * @nullable
   */
  shortDescriptionEsXl?: string | null;
  /**
   * @maxLength 200
   * @nullable
   */
  shortDescriptionEnUs?: string | null;
  /**
   * @maxLength 200
   * @nullable
   */
  shortDescriptionSk?: string | null;
  /**
   * @maxLength 200
   * @nullable
   */
  shortDescriptionEl?: string | null;
  /**
   * @maxLength 200
   * @nullable
   */
  shortDescriptionCs?: string | null;
  /**
   * @maxLength 200
   * @nullable
   */
  shortDescriptionIt?: string | null;
  /**
   * @maxLength 200
   * @nullable
   */
  shortDescriptionJa?: string | null;
  /**
   * @maxLength 200
   * @nullable
   */
  shortDescriptionKo?: string | null;
  /**
   * @maxLength 200
   * @nullable
   */
  shortDescriptionMs?: string | null;
  /**
   * @maxLength 200
   * @nullable
   */
  shortDescriptionPl?: string | null;
  /**
   * @maxLength 200
   * @nullable
   */
  shortDescriptionTr?: string | null;
  /**
   * @maxLength 200
   * @nullable
   */
  shortDescriptionPt?: string | null;
  /**
   * @maxLength 200
   * @nullable
   */
  shortDescriptionHu?: string | null;
  /**
   * @maxLength 200
   * @nullable
   */
  shortDescriptionIo?: string | null;
  /**
   * @maxLength 200
   * @nullable
   */
  shortDescriptionVi?: string | null;
  /**
   * @maxLength 200
   * @nullable
   */
  shortDescriptionZh?: string | null;
  description?: string;
  /** @nullable */
  descriptionEn?: string | null;
  /** @nullable */
  descriptionDe?: string | null;
  /** @nullable */
  descriptionFr?: string | null;
  /** @nullable */
  descriptionEs?: string | null;
  /** @nullable */
  descriptionEsXl?: string | null;
  /** @nullable */
  descriptionEnUs?: string | null;
  /** @nullable */
  descriptionSk?: string | null;
  /** @nullable */
  descriptionEl?: string | null;
  /** @nullable */
  descriptionCs?: string | null;
  /** @nullable */
  descriptionIt?: string | null;
  /** @nullable */
  descriptionJa?: string | null;
  /** @nullable */
  descriptionKo?: string | null;
  /** @nullable */
  descriptionMs?: string | null;
  /** @nullable */
  descriptionPl?: string | null;
  /** @nullable */
  descriptionTr?: string | null;
  /** @nullable */
  descriptionPt?: string | null;
  /** @nullable */
  descriptionHu?: string | null;
  /** @nullable */
  descriptionIo?: string | null;
  /** @nullable */
  descriptionVi?: string | null;
  /** @nullable */
  descriptionZh?: string | null;
  isActive?: boolean;
  /** @nullable */
  provider?: number | null;
  supplier: number;
}

export interface ProgrammeAllowance {
  readonly id: number;
  /**
   * @nullable
   * @pattern ^-?\d{0,13}(?:\.\d{0,2})?$
   */
  amount?: string | null;
  /** @nullable */
  readonly amountCurrency: string | null;
  /** @nullable */
  readonly employerAmount: string | null;
  /** @nullable */
  readonly employerAmountCurrency: string | null;
  /**
   * @nullable
   * @pattern ^-?\d{0,5}(?:\.\d{0,2})?$
   */
  percentage?: string | null;
  interval?: IntervalEnum | null;
  rollover?: boolean;
  hasManagedCards?: boolean;
  /** @nullable */
  managedCardConfigId: number | null;
}

export interface ProgrammeBenefitCategoryResponse {
  /** @maxLength 200 */
  name: string;
  /** @nullable */
  description?: string | null;
  /**
   * @minimum -2147483648
   * @maximum 2147483647
   */
  rank?: number;
  /**
   * @minimum -2147483648
   * @maximum 2147483647
   * @nullable
   */
  maxEnrollableBenefit?: number | null;
}

export interface ProgrammeBenefitEnrolmentResponse {
  readonly name: string;
  readonly benefitId: number;
  status?: Status00aEnum;
  /** @nullable */
  readonly price: string | null;
  /** @nullable */
  readonly employeeMonthlyPrice: string | null;
  /** @nullable */
  readonly employerMonthlyPrice: string | null;
  /** @nullable */
  readonly priceCurrency: string | null;
  readonly enrolmentWindows: readonly EnrolmentWindowResponse[];
  imageUrl: string;
  imageAltText: string;
  shortDescription: string;
  readonly id: number;
  readonly pk: number;
  categories: ProgrammeBenefitCategoryResponse[];
  showPrice: boolean;
  lockedEnrolment: boolean;
  readonly isSelected: boolean;
  enrolmentType: string;
  benefitType: string;
  readonly displayStatus: string;
  readonly sortingRank: number;
  isFavorite?: boolean;
  readonly programmes: string;
  /**
   * Return false if the benefit is a _modular_ benefit.
   * Return true if there is no config window or any of the config windows
   * is open. Return false otherwise.
   */
  readonly configWindowOpen: boolean;
  /** @nullable */
  readonly externalLinkUrl: string | null;
  /** @nullable */
  readonly discountText: string | null;
  /** @nullable */
  readonly ctaText: string | null;
  readonly content: string;
  readonly provider: unknown;
  readonly isEnrolledByDefault: boolean;
  /** @nullable */
  readonly enrolmentStartDate: string | null;
  /** @nullable */
  readonly enrolmentFulfillmentDate: string | null;
  /** @nullable */
  readonly enrolmentEndDate: string | null;
  readonly isPendingApproval: boolean;
  readonly isEnrolled: boolean;
  readonly isAvailable: boolean;
  /** @nullable */
  optInCopy: string | null;
  /** @nullable */
  optOutCopy: string | null;
  /** @nullable */
  optInCopyPreposition: string | null;
  /** @nullable */
  optOutCopyPreposition: string | null;
}

export interface ProgrammeBulkEnrolmentRequestRequest {
  employee: number;
  programmes: number[];
}

export interface ProgrammeBulkEnrolmentResponse {
  readonly id: number;
  /** @maxLength 254 */
  email?: string;
  /** @maxLength 150 */
  firstName?: string;
  /** @maxLength 150 */
  lastName?: string;
  readonly tagsList: readonly string[];
  readonly enrolledProgrammes: readonly number[];
}

export interface ProgrammeCostPreviewRequestRequest {
  programmeId: number;
  employeeIds: number[];
}

export interface ProgrammeCostResponse {
  readonly cost: string;
}

export interface ProgrammeEnrollmentRequestRequest {
  programmeId: number;
  enroll: number[];
  unenroll: number[];
}

export interface ProgrammeEnrollmentResponse {
  readonly id: number;
  employeeDetail: EmployeeEnrollmentDetailsResponse;
  readonly createdTimestamp: string;
  enrollmentTimestamp?: string;
  /**
   * Per-employee override for when the Allowance.rollover_max_periods clock starts. Only relevant when the linked Allowance has rollover_max_periods set. Leave blank in normal cases — the clock then starts from enrollment_timestamp. Set this date only to correct bad data, e.g. an employee was incorrectly unenrolled and re-enrolled so their enrollment_timestamp is too recent and would otherwise grant a fresh rollover window. Cleared automatically when the employee is re-enrolled via the product.
   * @nullable
   */
  rolloverExpiryAnchorDate?: string | null;
  isActive?: boolean;
  /** @nullable */
  deactivatedTimestamp?: string | null;
  /** @nullable */
  invitationEmailTimestamp?: string | null;
  programme: number;
  employee: number;
  /** @nullable */
  createdBy?: number | null;
}

/**
 * Serializer for previewing the Programme model,
 */
export interface ProgrammePreviewResponse {
  readonly id: number;
  /** @maxLength 100 */
  name: string;
  eligibilityDescription: string;
  frequency?: FrequencyEnum;
  allowance: ProgrammeAllowance;
  totalEnrollments: number;
  totalBenefits: number;
}

/**
 * Serializer for a list of programmes.
 */
export interface ProgrammeListResponse {
  totalItemCount: number;
  programmes: ProgrammePreviewResponse[];
}

/**
 * Serializer for the ProviderPitch model
 */
export interface ProviderPitch {
  readonly id: number;
  /** @maxLength 40 */
  name: string;
  /** @nullable */
  readonly url: string | null;
  /** @maxLength 100 */
  description?: string;
  /** @nullable */
  readonly imageUrl: string | null;
  /** @nullable */
  readonly imageAltText: string | null;
}

/**
 * Serializer for a list of ProviderPitch objects
 */
export interface ProviderPitchListResponse {
  totalItemCount: number;
  providerPitches: ProviderPitch[];
}

export interface ProviderRequest {
  /**
   * @minLength 1
   * @maxLength 200
   */
  name: string;
}

export interface PublicEmployeeResponse {
  readonly id: number;
  readonly fullName: string;
  /** @maxLength 254 */
  email?: string;
}

export interface PurchaseResponse {
  readonly id: number;
  readonly orderNumber: string;
  fulfillmentState?: FulfillmentStateEnum;
  paymentState?: PaymentStateEnum;
  readonly orderAmountCurrency: string;
  /** @pattern ^-?\d{0,8}(?:\.\d{0,2})?$ */
  orderAmount?: string;
  /** @nullable */
  readonly timestamp: string | null;
  /** @nullable */
  readonly updatedTimestamp: string | null;
  /** @nullable */
  productItem?: number | null;
  /** @nullable */
  product?: number | null;
  /** @nullable */
  supplier?: number | null;
  /** @nullable */
  employee?: number | null;
  /** @nullable */
  ledgerEntry?: number | null;
}

export interface QueryBuilderOperator {
  name: string;
  label: string;
}

export interface QueryBuilderValue {
  label: string;
  value: string;
}

export interface QueryBuilderField {
  name: string;
  label: string;
  valueEditorType: string;
  operators: QueryBuilderOperator[];
  values?: QueryBuilderValue[];
}

export interface QueryBuilderSchemaResponse {
  fields: QueryBuilderField[];
  operators: QueryBuilderOperator[];
  maxDepth: number;
  maxRules: number;
}

export interface QuerySuggestion {
  readonly id: number;
  /**
   * Predefined search query to be used when prompting the AI model. These queries will be suggested to users when using the search functionality.
   * @maxLength 300
   */
  query: string;
}

export interface ReadEnrolmentChangeResponse {
  updatedCount: number;
}

export interface ReadNotificationResponse {
  updatedCount: number;
}

/**
 * * `LOST_STOLEN` - Card Lost/Stolen
 * * `DAMAGED` - Card Damaged
 * * `NOT_WORKING` - Card No Longer Works
 * * `NOT_RECEIVED` - Card Not Received
 */
export type ReasonEnum = (typeof ReasonEnum)[keyof typeof ReasonEnum];

export const ReasonEnum = {
  LOST_STOLEN: 'LOST_STOLEN',
  DAMAGED: 'DAMAGED',
  NOT_WORKING: 'NOT_WORKING',
  NOT_RECEIVED: 'NOT_RECEIVED',
} as const;

/**
 * @nullable
 */
export type ReceiptRjsfFormData = { [key: string]: unknown } | null;

export interface Receipt {
  receiptId: string;
  /** @nullable */
  note?: string | null;
  readonly receiptFile: string;
  /**
   * @maxLength 500
   * @nullable
   */
  receiptFilename?: string | null;
  /** @nullable */
  taxRate?: number | null;
  receiptUnavailable?: boolean;
  rjsfFormSchema?: unknown | null;
  /** @nullable */
  readonly rjsfFormData: ReceiptRjsfFormData;
}

export type ReceiptExtractionDataCustomFields = { [key: string]: unknown };

/**
 * Strict allowlist of extracted fields safe to surface to the client.
 *
 * Only the pre-fill fields are exposed as ``{value, confidence}`` pairs;
 * fraud, authenticity, document quality, the receipt-likelihood routing
 * signals and the raw model response stay server-side. ``to_representation``
 * builds the response from an explicit allowlist, so unexpected keys in
 * ``extraction_data`` can never leak even if the upstream result grows.
 */
export interface ReceiptExtractionData {
  merchantName: ExtractionField;
  totalAmount: ExtractionField;
  currencyCode: ExtractionField;
  transactionDate: ExtractionField;
  description: ExtractionField;
  customFields?: ReceiptExtractionDataCustomFields;
}

export interface ReceiptDraftStatus {
  draftId: string;
  status: string;
  /** @nullable */
  errorReason: string | null;
  readonly extraction: ReceiptExtractionData | null;
}

export interface ReceiptExtractionCreateRequest {
  file: Blob;
  rjsf_config_id?: string;
  rjsf_field_descriptors?: string;
}

export interface SenderRecognitionDomainResponse {
  name: string;
  /** @nullable */
  slackChannelName: string | null;
  /** @nullable */
  msTeamsChannelName: string | null;
}

export interface RecognitionConfigurationResponse {
  aiSuggestionsEnabled?: boolean;
  rewardMode?: RewardModeEnum;
  /** When checked, employees must select a company value when sending a recognition. */
  companyValueRequired?: boolean;
  domainScopingEnabled?: boolean;
  readonly senderDomain: SenderRecognitionDomainResponse | null;
}

/**
 * * `SHOW_WITH_AMOUNT` - show_with_amount
 * * `SHOW_WITHOUT_AMOUNT` - show_without_amount
 * * `DO_NOT_SHOW` - do_not_show
 */
export type Visibility8a0Enum =
  (typeof Visibility8a0Enum)[keyof typeof Visibility8a0Enum];

export const Visibility8a0Enum = {
  SHOW_WITH_AMOUNT: 'SHOW_WITH_AMOUNT',
  SHOW_WITHOUT_AMOUNT: 'SHOW_WITHOUT_AMOUNT',
  DO_NOT_SHOW: 'DO_NOT_SHOW',
} as const;

export interface RecognitionRewardRequestRequest {
  /** @pattern ^-?\d{0,8}(?:\.\d{0,2})?$ */
  amount?: string;
  visibility?: Visibility8a0Enum;
  rewardsBudgetId?: number;
  rewardPresetId?: number;
}

/**
 * Serializer for the request of creating a recognition.
 */
export interface RecognitionCreateRequestRequest {
  recipientIds: number[];
  /**
   * @minLength 1
   * @maxLength 10000
   */
  message: string;
  sendVia: CommunicationChannelsRequest;
  media?: MediaRequest | null;
  /**
   * @minLength 1
   * @nullable
   */
  mediaUrl?: string | null;
  reward?: RecognitionRewardRequestRequest;
  /** @nullable */
  companyValueId?: number | null;
}

/**
 * Generic serializer for employee responses in recognition endpoints.
 */
export interface RecognitionEmployeeResponse {
  readonly id: number;
  /** @maxLength 254 */
  email?: string;
  /** @maxLength 150 */
  firstName?: string;
  /** @maxLength 150 */
  lastName?: string;
  /** @nullable */
  readonly preferredName: string | null;
  /**
   * @maxLength 255
   * @nullable
   */
  companyPosition?: string | null;
  /**
   * @maxLength 2048
   * @nullable
   */
  imageUrl?: string | null;
}

export interface RecognitionEmployeesResponse {
  employees: RecognitionEmployeeResponse[];
  totalItemCount: number;
}

export interface RecognitionRewardResponse {
  /** @nullable */
  readonly amount: string | null;
  /** @nullable */
  readonly amountPerRecipient: string | null;
  visibility?: Visibility8a0Enum;
  /** @nullable */
  readonly currency: string | null;
  /** @maxLength 30 */
  title?: string;
  /** @maxLength 360 */
  description?: string;
}

/**
 * * `PENDING` - Pending
 * * `SENT` - Sent
 * * `REJECTED` - Rejected
 * * `FAILED` - Failed
 */
export type RecognitionResponseStatusEnum =
  (typeof RecognitionResponseStatusEnum)[keyof typeof RecognitionResponseStatusEnum];

export const RecognitionResponseStatusEnum = {
  PENDING: 'PENDING',
  SENT: 'SENT',
  REJECTED: 'REJECTED',
  FAILED: 'FAILED',
} as const;

/**
 * Serializer for the recognition
 */
export interface RecognitionResponse {
  readonly id: number;
  recipients: RecognitionEmployeeResponse[];
  sender: RecognitionEmployeeResponse;
  message: string;
  readonly createdAt: string;
  readonly reward: RecognitionRewardResponse | null;
  status?: RecognitionResponseStatusEnum;
  /**
   * @maxLength 200
   * @nullable
   */
  mediaUrl?: string | null;
  media?: Media | null;
  sentVia: CommunicationChannels;
  companyValue?: CompanyValueResponse | null;
}

/**
 * Serializer for Money objects.
 */
export interface RewardsSent {
  /** @pattern ^-?\d{0,8}(?:\.\d{0,2})?$ */
  amount: string;
  currency: string;
}

/**
 * Serializer for the response of the recognition statistics.
 */
export interface RecognitionStatisticsResponse {
  recognitionsSent: number;
  rewardsSent: RewardsSent | null;
}

export interface RecognitionSuggestionsRequestRequest {
  recipientIds: number[];
  occasion?: OccasionEnum;
  /**
   * @minLength 1
   * @maxLength 2000
   */
  message?: string;
}

export interface RecognitionSuggestionsResponse {
  message: string;
}

/**
 * Serializer for the response of the recognitions list.
 */
export interface RecognitionsListResponse {
  results: RecognitionResponse[];
  totalItemCount: number;
}

/**
 * @nullable
 */
export type ReimbursementRequestBaseRjsfFormData = {
  [key: string]: unknown;
} | null;

export interface TransferDetail {
  readonly state: string;
  /** @nullable */
  readonly failureReason: string | null;
  readonly createdTimestamp: string;
  readonly updatedTimestamp: string;
}

export interface ReimbursementRequestBase {
  readonly uuid: string;
  allowance: MinimalAllowanceResponse;
  topupCardTemplate: MinimalTopUpCardTemplateResponse;
  employee: MinimalEmployeeResponse;
  approver: MinimalEmployeeResponse;
  readonly approvalRequestState: string;
  readonly transactionTypeDisplayName: string;
  readonly reviewers: string;
  rjsfFormSchema?: unknown | null;
  /** @nullable */
  readonly rjsfFormData: ReimbursementRequestBaseRjsfFormData;
  readonly transferDetails: TransferDetail | null;
  readonly amountCurrency: string;
  /** @pattern ^-?\d{0,13}(?:\.\d{0,2})?$ */
  amount: string;
  /** @nullable */
  readonly actualAmountCurrency: string | null;
  /**
   * Amount in card's currency
   * @nullable
   * @pattern ^-?\d{0,13}(?:\.\d{0,2})?$
   */
  actualAmount?: string | null;
  /** @nullable */
  readonly transferAmountCurrency: string | null;
  /**
   * This is the amount that will be used for SendTransfer/Transfer if the account currency is different from the card currency.
   * @nullable
   * @pattern ^-?\d{0,13}(?:\.\d{0,2})?$
   */
  transferAmount?: string | null;
  /** @maxLength 250 */
  name: string;
  purchaseDate: string;
  readonly uploadedTimestamp: string;
  /** @nullable */
  actionedTimestamp?: string | null;
  /** @nullable */
  note?: string | null;
  receiptFile: string;
  approved?: boolean;
  rejected?: boolean;
  cancelled?: boolean;
  /** @nullable */
  rejectionReason?: string | null;
  manualTransferComplete?: boolean;
  /** @nullable */
  taxRate?: number | null;
  /**
   * @maxLength 100
   * @nullable
   */
  xeroTaxCode?: string | null;
  managedExternally?: boolean;
  fxDetails?: unknown | null;
  /** @nullable */
  readonly deductedFromAvailableBalanceCurrency: string | null;
  /**
   * This is the amount that will be taken from available balance of the card
   * @nullable
   * @pattern ^-?\d{0,13}(?:\.\d{0,2})?$
   */
  deductedFromAvailableBalance?: string | null;
  /** @nullable */
  readonly deductedFromReservedBalanceCurrency: string | null;
  /**
   * This is the amount that will be taken from reserved balance of the card
   * @nullable
   * @pattern ^-?\d{0,13}(?:\.\d{0,2})?$
   */
  deductedFromReservedBalance?: string | null;
  /** @nullable */
  readonly exceedingAmountCurrency: string | null;
  /**
   * This is the amount that is exceeding the available balance + reserved balance
   * @nullable
   * @pattern ^-?\d{0,13}(?:\.\d{0,2})?$
   */
  exceedingAmount?: string | null;
  employer: number;
  /** @nullable */
  transfer?: number | null;
  /** @nullable */
  currentApprovalStep?: number | null;
}

export interface ReimbursementRequestRequest {
  /** @nullable */
  allowance?: number | null;
  /** @nullable */
  topupCardTemplate?: number | null;
  /** @pattern ^-?\d{0,13}(?:\.\d{0,2})?$ */
  amount: string;
  /**
   * @minLength 1
   * @maxLength 250
   */
  name: string;
  purchaseDate: string;
  /** @nullable */
  note?: string | null;
  receiptFile: Blob;
  rjsfFormData?: unknown | null;
  rjsfFormSchema?: unknown | null;
}

export interface ReorderManagedCardRequestRequest {
  /** @minLength 1 */
  managedCardId: string;
  reason: ReasonEnum;
  /**
   * Required for Airwallex cards shipping to the US due to DHL tracking requirements
   * @minLength 1
   * @maxLength 30
   */
  mobileNumber?: string;
}

export interface RequirementGroupRef {
  id: string;
  name: string;
  /** @nullable */
  domain: string | null;
}

/**
 * One requirement: ``name`` is the question, ``body`` the answer.
 */
export interface Requirement {
  id: string;
  name: string;
  body: string;
  intent: string;
  confidence: string;
  source: unknown;
  /** @nullable */
  supersededBy: string | null;
  createdAt: string;
  group: RequirementGroupRef;
  status: string;
  contentHash: string;
  supersedes: string[];
}

export interface RunRef {
  id: number;
  status: string;
  operation: string;
  createdTimestamp: string;
}

export type RequirementGroupSummaryChangeCounts = { [key: string]: number };

/**
 * A requirement group plus the workspace context for one card.
 */
export interface RequirementGroupSummary {
  id: string;
  employer: number;
  name: string;
  intent: string;
  /** @nullable */
  entity: string | null;
  /** @nullable */
  domain: string | null;
  /** @nullable */
  parentId: string | null;
  createdAt: string;
  path: string;
  benefit: EntityRef | null;
  programmes: EntityRef[];
  statusCounts: StatusCounts;
  statusCountsInTree: StatusCounts;
  childGroupCount: number;
  latestRun: RunRef | null;
  changeCounts: RequirementGroupSummaryChangeCounts;
  pendingChanges: ChangeRef[];
}

/**
 * A single group, its direct children and its run history.
 */
export interface RequirementGroupDetail {
  group: RequirementGroupSummary;
  children: ChildGroupSummary[];
  runs: RunRef[];
}

/**
 * The envelope ``get_paginated_response`` wraps every list in.
 */
export interface RequirementGroupPage {
  count: number;
  /** @nullable */
  next: number | null;
  /** @nullable */
  previous: number | null;
  results: RequirementGroupSummary[];
}

/**
 * The envelope ``get_paginated_response`` wraps every list in.
 */
export interface RequirementPage {
  count: number;
  /** @nullable */
  next: number | null;
  /** @nullable */
  previous: number | null;
  results: Requirement[];
}

export interface ResendInviteEmailRequestRequest {
  employees: number[];
}

export interface ResidencyType {
  readonly id: number;
  /** @maxLength 200 */
  name: string;
}

export interface ResourcesArticleCreatedBy {
  id: number;
  firstName: string;
  lastName: string;
  /** @nullable */
  imageUrl: string | null;
}

/**
 * * `ARTICLE` - ARTICLE
 * * `VIDEO` - VIDEO
 */
export type Type046Enum = (typeof Type046Enum)[keyof typeof Type046Enum];

export const Type046Enum = {
  ARTICLE: 'ARTICLE',
  VIDEO: 'VIDEO',
} as const;

/**
 * Serializer for a single resources attachment on the article detail response.
 * The `file` field resolves to a 24h presigned S3 URL.
 */
export interface ResourcesAttachmentResponse {
  id: number;
  name: string;
  file: string;
  /** @nullable */
  mimeType: string | null;
}

/**
 * Serializer for resources article detail response
 * (extends list item with content and additional fields).
 */
export interface ResourcesArticleDetailResponse {
  id: number;
  thumbnailImg: string;
  thumbnailAlt: string;
  title: string;
  summary: string;
  readonly category: string;
  type: Type046Enum;
  isFeatured: boolean;
  /** @nullable */
  readMinutes: number | null;
  createdAt: string;
  /** @nullable */
  mediaUrl: string | null;
  /** @nullable */
  body: string | null;
  readonly createdBy: ResourcesArticleCreatedBy | null;
  readonly attachments: readonly ResourcesAttachmentResponse[];
}

/**
 * Serializer for a single resources article in list responses (without content).
 */
export interface ResourcesArticleListItemResponse {
  id: number;
  thumbnailImg: string;
  thumbnailAlt: string;
  title: string;
  summary: string;
  readonly category: string;
  type: Type046Enum;
  isFeatured: boolean;
  /** @nullable */
  readMinutes: number | null;
  createdAt: string;
}

/**
 * Serializer for a list of resources articles.
 */
export interface ResourcesArticleListResponse {
  totalItemCount: number;
  results: ResourcesArticleListItemResponse[];
}

/**
 * Serializer for a single resources category.
 */
export interface ResourcesCategoryItemResponse {
  id: number;
  name: string;
}

/**
 * Serializer for a list of resources categories.
 */
export interface ResourcesCategoriesListResponse {
  categories: ResourcesCategoryItemResponse[];
}

export interface RewardCostResponse {
  /** @pattern ^-?\d{0,8}(?:\.\d{0,2})?$ */
  totalCost: string;
  /** @maxLength 3 */
  totalCostCurrency: string;
}

export interface RewardCreatedByResponseRequest {
  /** @minLength 1 */
  firstName: string;
  /** @minLength 1 */
  lastName: string;
}

export interface RewardPresetCreateRequestRequest {
  /**
   * @minLength 1
   * @maxLength 30
   */
  title: string;
  /**
   * @nullable
   * @pattern ^-?\d{0,8}(?:\.\d{0,2})?$
   */
  amount?: string | null;
  /**
   * @minLength 1
   * @maxLength 3
   * @nullable
   */
  currency?: string | null;
  description?: string;
}

export interface RewardPresetResponse {
  id: number;
  /** @maxLength 30 */
  title: string;
  /** @nullable */
  readonly amount: string | null;
  /** @nullable */
  readonly currency: string | null;
  /** @maxLength 360 */
  description: string;
  isArchived: boolean;
  order: number;
}

export interface RewardPresetsResponse {
  results: RewardPresetResponse[];
}

export interface RewardResponse {
  id: number;
  title: string;
  message: string;
  /** @pattern ^-?\d{0,5}(?:\.\d{0,2})?$ */
  amount: string;
  /** @maxLength 3 */
  amountCurrency: string;
  addressWithFirstName: boolean;
  /** @nullable */
  imageUrl?: string | null;
  dateCreated: string;
  viewedTimestamp: string;
}

export interface RewardResponseRequest {
  /**
   * @minLength 1
   * @maxLength 250
   */
  title: string;
  /** @nullable */
  message?: string | null;
  createdBy: RewardCreatedByResponseRequest | null;
  /** @pattern ^-?\d{0,8}(?:\.\d{0,2})?$ */
  amount: string;
  addressWithFirstName?: boolean;
  employees: EmployeeMinimalDetailsResponseRequest[];
  /**
   * @maxLength 255
   * @nullable
   */
  imageUrl?: string | null;
  /** @pattern ^-?\d{0,8}(?:\.\d{0,2})?$ */
  employerAmount?: string;
  /** @minLength 1 */
  employerAmountCurrency?: string;
}

export interface RewardsBudgetOwner {
  readonly id: number;
  /** @maxLength 150 */
  firstName?: string;
  /** @maxLength 150 */
  lastName?: string;
}

export interface RewardsBudget {
  readonly id: number;
  /** @maxLength 50 */
  name: string;
  readonly budgetOwner: RewardsBudgetOwner;
  readonly membersCount: number;
  /** @pattern ^-?\d{0,8}(?:\.\d{0,2})?$ */
  readonly budgetAmount: string;
  readonly budgetCurrency: string;
  /**
   * @nullable
   * @pattern ^-?\d{0,8}(?:\.\d{0,2})?$
   */
  readonly budgetAmountInEmployerCurrency: string | null;
  /** @nullable */
  readonly employerCurrency: string | null;
}

export interface RewardsBudgetCreateRequestRequest {
  /**
   * @minLength 1
   * @maxLength 50
   */
  name: string;
  /** @maxLength 1000 */
  description?: string;
  /**
   * @nullable
   * @pattern ^-?\d{0,8}(?:\.\d{0,2})?$
   */
  limitPerReward?: string | null;
  /** @nullable */
  budgetOwnerId?: number | null;
  /** @minLength 1 */
  currency: string;
  /** @pattern ^-?\d{0,8}(?:\.\d{0,2})?$ */
  budgetAmount: string;
}

export interface RewardsBudgetDetailResponse {
  readonly id: number;
  /** @maxLength 50 */
  name: string;
  description?: string;
  readonly currency: string;
  /** @pattern ^-?\d{0,8}(?:\.\d{0,2})?$ */
  readonly budgetAmount: string;
  /** @pattern ^-?\d{0,8}(?:\.\d{0,2})?$ */
  readonly assignedBudgetAmount: string;
  /** @pattern ^-?\d{0,8}(?:\.\d{0,2})?$ */
  readonly unassignedBudgetAmount: string;
  /** @pattern ^-?\d{0,8}(?:\.\d{0,2})?$ */
  readonly limitPerReward: string;
  readonly budgetOwner: MinimalEmployeeResponse;
  readonly membersCount: number;
}

export interface RewardsBudgetMember {
  readonly id: number;
  /**
   * @maxLength 250
   * @nullable
   */
  employeeId?: string | null;
  firstName: string;
  lastName: string;
  email: string;
  readonly isBudgetOwner: boolean;
  /** @pattern ^-?\d{0,8}(?:\.\d{0,2})?$ */
  readonly currentBalance: string;
  /** @pattern ^-?\d{0,8}(?:\.\d{0,2})?$ */
  readonly totalSpent: string;
  /** @pattern ^-?\d{0,8}(?:\.\d{0,2})?$ */
  readonly totalReceived: string;
  readonly currency: string;
}

/**
 * * `NAME` - name
 * * `TOTAL_RECEIVED` - total_received
 * * `TOTAL_SPENT` - total_spent
 * * `CURRENT_BALANCE` - current_balance
 */
export type RewardsBudgetMembersRequestSortingFieldEnum =
  (typeof RewardsBudgetMembersRequestSortingFieldEnum)[keyof typeof RewardsBudgetMembersRequestSortingFieldEnum];

export const RewardsBudgetMembersRequestSortingFieldEnum = {
  NAME: 'NAME',
  TOTAL_RECEIVED: 'TOTAL_RECEIVED',
  TOTAL_SPENT: 'TOTAL_SPENT',
  CURRENT_BALANCE: 'CURRENT_BALANCE',
} as const;

/**
 * Base serializer for the query params of a paginated list.
 */
export interface RewardsBudgetMembersRequestRequest {
  pageNumber?: number;
  /** @minimum 0 */
  pageSize?: number;
  /**
   * @minLength 1
   * @maxLength 200
   */
  searchValue?: string;
  sortingOrder?: SortingOrderEnum;
  sortingField?: RewardsBudgetMembersRequestSortingFieldEnum;
  filters?: FilteredEmployeesFilterRequest;
}

export interface RewardsBudgetMembersResponse {
  totalItemCount: number;
  members: RewardsBudgetMember[];
}

export interface RewardsBudgetResponse {
  readonly id: number;
}

export interface RewardsBudgetsResponse {
  totalItemCount: number;
  rewardsBudgets: RewardsBudget[];
}

export interface RewardsListResponse {
  rewards: RewardResponse[];
  rewardsCost: RewardCostResponse;
  rewardsCount: number;
  rewardsEmployeesCount: number;
}

export interface RewardsSpendingBalanceResponse {
  readonly id: number;
  rewardsBudgetId: number;
  rewardsBudgetName: string;
  rewardsBudgetDescription: string;
  /** @pattern ^-?\d{0,13}(?:\.\d{0,2})?$ */
  availableAmount: string;
  /**
   * @nullable
   * @pattern ^-?\d{0,13}(?:\.\d{0,2})?$
   */
  limitPerReward: string | null;
  currency: string;
}

export interface RewardsSpendingBalanceListResponse {
  totalItemCount: number;
  rewardsSpendingBalances: RewardsSpendingBalanceResponse[];
}

export type RewardsTransactionResponseTransactionStatus = {
  [key: string]: string | boolean;
};

export interface RewardsTransactionResponse {
  readonly id: number;
  description: string;
  readonly transactionTypeDisplayName: string;
  /** @nullable */
  readonly recipient: string | null;
  readonly timestamp: string;
  /** @pattern ^-?\d{0,13}(?:\.\d{0,2})?$ */
  amount: string;
  currency: string;
  readonly transactionStatus: RewardsTransactionResponseTransactionStatus;
}

export interface RewardsTransactionsResponse {
  totalItemCount: number;
  transactions: RewardsTransactionResponse[];
}

export interface RichTextImageUploadRequestRequest {
  employerId?: number;
  /**
   * @minLength 1
   * @maxLength 255
   */
  filename: string;
  /**
   * @minLength 1
   * @maxLength 100
   */
  contentType: string;
  fileSize: number;
}

export type RichTextImageUploadResponseUploadFields = {
  [key: string]: unknown;
};

export interface RichTextImageUploadResponse {
  uuid: string;
  uploadUrl: string;
  uploadFields: RichTextImageUploadResponseUploadFields;
  placeholderUrl: string;
  signedUrl: string;
}

export interface RunError {
  stage: string;
  message: string;
  /** @nullable */
  instructionConfigId?: number | null;
}

export interface SalaryDeductionItem {
  benefitId: number;
  benefitName?: string;
  /** @pattern ^-?\d{0,8}(?:\.\d{0,2})?$ */
  amount: string;
  currency: string;
}

export interface SalaryDeductionsResponse {
  totalItemCount: number;
  results: SalaryDeductionItem[];
}

export interface ScaAuthorizeResponse {
  authCode: string;
  codeVerifier: string;
  env: string;
  clientId: string;
}

/**
 * 403 payload telling the client to run the SCA verify flow.
 *
 * ``sca_session_code`` is the one-time code echoed from the upstream
 * ``x-sca-session-code`` header.
 */
export interface ScaRequiredResponse {
  code: string;
  scaSessionCode: string;
}

export interface SearchResult {
  id: number;
  /** @nullable */
  readonly benefitId: number | null;
  readonly title: string;
  /** @nullable */
  readonly benefitName: string | null;
  /** @nullable */
  imageUrl?: string | null;
  /** @nullable */
  icon?: string | null;
  searchRank: number;
  readonly searchType: string;
}

export interface WalletResult {
  /** @nullable */
  readonly allowanceId: number | null;
  /** @nullable */
  readonly managedCardId: string | null;
  /** @nullable */
  readonly walletName: string | null;
}

export interface SearchResponse {
  results?: SearchResult[];
  querySuggestions?: QuerySuggestion[];
  walletResults?: WalletResult[];
}

export interface SendCampaignRequestRequest {
  /** @nullable */
  scheduleAt?: string | null;
}

export interface SharePriceSummary {
  groupId: string;
  cardType: string;
  text: string;
  /** @pattern ^-?\d{0,14}(?:\.\d{0,6})?$ */
  sharePrice: string;
  /** @maxLength 3 */
  currency: string;
  sharePriceDate: string;
  /** @nullable */
  logo: string | null;
  tooltipText: string;
}

export interface SlackChannel {
  id: string;
  name: string;
}

export interface SlackChannelsResponse {
  channels: SlackChannel[];
}

export interface SlackCompleteAuthRequestRequest {
  /** @minLength 1 */
  code: string;
  /** @minLength 1 */
  state: string;
}

export interface SlackCompleteAuthResponse {
  /** @nullable */
  addWorkspacesRedirectUrl: string | null;
}

export interface SlackCompleteUsersAuthRequestRequest {
  /** @minLength 1 */
  code: string;
  /** @minLength 1 */
  state: string;
}

export interface SlackExternalMultiSelectOptionText {
  type?: string;
  text: string;
}

export interface SlackExternalMultiSelectOption {
  text: SlackExternalMultiSelectOptionText;
  value: string;
}

export interface SlackExternalMultiSelectOptionsResponse {
  options: SlackExternalMultiSelectOption[];
}

export interface SlackStartAuthResponse {
  authorizeUrl: string;
}

export interface SlackStartUsersAuthResponse {
  authorizeUrl: string;
}

export interface SlackTeam {
  id: string;
  name: string;
}

export interface SlackTeamsResponse {
  teams: SlackTeam[];
}

export interface SlackUser {
  readonly id: number;
  /** @maxLength 255 */
  userId: string;
  /** @maxLength 255 */
  displayName?: string;
  connectedAt: string;
}

export interface SlackUsersResponse {
  slackUser?: SlackUser | null;
}

export interface StartImpersonationSessionRequestRequest {
  impersonateeId: number;
}

/**
 * The run a start request created.
 *
 * Deliberately thin: the caller already knows what it asked for, and the
 * workspace reads a group's runs through the requirement group endpoint.
 */
export interface StartedRun {
  id: number;
  operation: string;
  status: string;
  requirementGroup: RunGroupRef;
  programme: RunEntityRef | null;
  benefit: RunEntityRef | null;
  createdTimestamp: string;
}

export interface StoredInputs {
  instructionConfigIds?: number[];
  /** @nullable */
  outputSchemaId: number | null;
  snapshot?: InputSnapshot | null;
}

export interface SummaryGroup {
  id: string;
  text: string;
}

export type SummaryItem = GenericSummary | SharePriceSummary | EquitySummary;

export interface TestCaseCreateRequest {
  /**
   * @minLength 1
   * @maxLength 255
   */
  name?: string;
  cycleId: number;
  enrolmentId: number;
  /** @nullable */
  allowanceId?: number | null;
  instructionConfigIds?: number[];
}

export interface TestCaseDetail {
  readonly id: number;
  /** @nullable */
  readonly name: string | null;
  readonly status: string;
  readonly isSnapshot: boolean;
  readonly assertions: Assertions;
  readonly lineItems: readonly LineItem[];
  readonly runErrors: readonly RunError[];
  readonly inputs: StoredInputs | null;
  readonly createdTimestamp: string;
  readonly updatedTimestamp: string;
}

export interface TestCaseDuplicateRequest {
  /**
   * @minLength 1
   * @maxLength 255
   */
  name?: string;
}

export interface TopupEmployeeResponse {
  id: number;
  firstName: string;
  lastName: string;
  email: string;
  tagsList: unknown[];
  readonly allowanceBalance: CardBalanceResponse;
}

export interface TopupEmployeesResponse {
  totalItemCount: number;
  results: TopupEmployeeResponse[];
}

export type TotalRewardsChartChartDataItem = { [key: string]: unknown };

export interface TotalRewardsChart {
  meta: Meta;
  chartData: TotalRewardsChartChartDataItem[];
  chartMetadata: ChartMeta[];
  chartPeriods: ChartPeriod[];
  legend: LegendItem[];
}

/**
 * * `CLASSIC` - CLASSIC
 */
export type TotalRewardsStatementStatementTypeEnum =
  (typeof TotalRewardsStatementStatementTypeEnum)[keyof typeof TotalRewardsStatementStatementTypeEnum];

export const TotalRewardsStatementStatementTypeEnum = {
  CLASSIC: 'CLASSIC',
} as const;

export interface TotalRewardsStatement {
  readonly statementType: TotalRewardsStatementStatementTypeEnum;
  meta: Meta;
  readonly summary: readonly SummaryItem[];
  summaryGroups: SummaryGroup[];
  breakdown: Breakdown;
  configuration: Configuration;
}

export type TotalRewardsStatementResponse =
  | TotalRewardsStatement
  | HeroStatement;

export type TotalRewardsVestingScheduleChartDataItem = {
  [key: string]: unknown;
};

export interface VestingScheduleSharePrice {
  text: string;
  /** @pattern ^-?\d{0,6}(?:\.\d{0,6})?$ */
  value: string;
  /** @maxLength 3 */
  currency: string;
  date: string;
}

export interface VestingScheduleTotal {
  text: string;
  unitText: string;
  /** @pattern ^-?\d{0,9}(?:\.\d{0,6})?$ */
  unitCount: string;
  /** @pattern ^-?\d{0,8}(?:\.\d{0,6})?$ */
  value: string;
}

/**
 * Mixin to add dynamic currency field with employee-specific choices and default.
 */
export interface VestingScheduleMeta {
  currency: CurrencyEnum;
  startDate: string;
  endDate: string;
  title: string;
  subtitle: string;
  sharePrice: VestingScheduleSharePrice;
  total: VestingScheduleTotal;
}

export interface TotalRewardsVestingSchedule {
  meta: VestingScheduleMeta;
  chartData: TotalRewardsVestingScheduleChartDataItem[];
  chartMetadata: ChartMeta[];
}

/**
 * @nullable
 */
export type TransactionResponseMerchantInfo = { [key: string]: unknown } | null;

/**
 * @nullable
 */
export type TransactionResponseReceiptDisplayStatus = {
  [key: string]: unknown;
} | null;

export interface TransactionResponse {
  description: string;
  /** @nullable */
  longDescription: string | null;
  /** @nullable */
  imageUrl: string | null;
  date: string;
  timestamp: string;
  /** @nullable */
  purchaseDate: string | null;
  /** @pattern ^-?\d{0,8}(?:\.\d{0,2})?$ */
  amount: string;
  currency: string;
  /**
   * @nullable
   * @pattern ^-?\d{0,8}(?:\.\d{0,2})?$
   */
  employerAmount: string | null;
  /** @nullable */
  employerCurrency: string | null;
  /**
   * @nullable
   * @pattern ^-?\d{0,8}(?:\.\d{0,2})?$
   */
  sourceAmount: string | null;
  /** @nullable */
  sourceCurrency: string | null;
  transactionType: string;
  transactionStatus: TransactionDisplayStatus;
  /** @nullable */
  transactionStatusReason: string | null;
  /** @nullable */
  transactionPaymentFailureReason: string | null;
  /** @nullable */
  declineReason?: string | null;
  /** @nullable */
  authRuleFailedReason?: string | null;
  /** @nullable */
  awxFailureReason?: string | null;
  /** @nullable */
  readonly transactionTypeDisplayName: string | null;
  transactionObjectType: string;
  transactionObjectId: string;
  receiptAttached: boolean;
  /** @nullable */
  receiptUnavailable: boolean | null;
  /** @nullable */
  receiptUploadedAt: string | null;
  /** @nullable */
  receiptUrl: string | null;
  /** @nullable */
  readonly merchantInfo: TransactionResponseMerchantInfo;
  taxRate?: number;
  walletName?: string;
  walletId?: string;
  walletType?: string;
  readonly iconType: string;
  message?: string;
  cancelled?: boolean;
  /** @nullable */
  approvalRequestState: string | null;
  approver: Approver | null;
  /** @nullable */
  actionedTimestamp: string | null;
  /** @nullable */
  rejectionReason: string | null;
  /** @nullable */
  note: string | null;
  /** @nullable */
  readonly receiptDisplayStatus: TransactionResponseReceiptDisplayStatus;
  canEditReceipts?: boolean;
  receiptMoreInformationRequired?: string;
  receiptRejection?: boolean;
  receiptRejectionReason?: string;
  receiptRejectionTimestamp?: string;
  receiptRejectionTransactionId?: number;
  allowReceiptUnavailable?: boolean;
}

export type UiConfigResponseHeaderMenu = { [key: string]: unknown };

/**
 * @nullable
 */
export type UiConfigResponseEmployeeConfiguration = {
  [key: string]: unknown;
} | null;

export interface UiConfigResponse {
  leftNav: LeftNavigationResponse;
  headerMenu: UiConfigResponseHeaderMenu;
  employerConfiguration: EmployerConfiguration | null;
  /** @nullable */
  readonly employeeConfiguration: UiConfigResponseEmployeeConfiguration;
}

export interface WeavrPasswordRequestRequest {
  /** @minLength 1 */
  tokenizedPassword: string;
}

export type BenefitTypeEnum =
  (typeof BenefitTypeEnum)[keyof typeof BenefitTypeEnum];

export const BenefitTypeEnum = {
  REGULAR: 'REGULAR',
  LOAN: 'LOAN',
} as const;

export type PolicyNumberEnum =
  (typeof PolicyNumberEnum)[keyof typeof PolicyNumberEnum];

export const PolicyNumberEnum = {
  GROUP_MEMBERSHIP_NUMBER: 'GROUP_MEMBERSHIP_NUMBER',
  POLICY_NUMBER: 'POLICY_NUMBER',
  GROUP_AND_POLICY_NUMBER: 'GROUP_AND_POLICY_NUMBER',
  NOT_APPLICABLE: 'NOT_APPLICABLE',
  TO_BE_CONFIRMED: 'TO_BE_CONFIRMED',
} as const;

export type ContactRemovalTriggerEnum =
  (typeof ContactRemovalTriggerEnum)[keyof typeof ContactRemovalTriggerEnum];

export const ContactRemovalTriggerEnum = {
  END_OF_POLICY_YEAR: 'END_OF_POLICY_YEAR',
  DAY_BEFORE_BIRTHDAY: 'DAY_BEFORE_BIRTHDAY',
  ON_BIRTHDAY: 'ON_BIRTHDAY',
  END_OF_BIRTHDAY_MONTH: 'END_OF_BIRTHDAY_MONTH',
} as const;

export type BenefitConfigurationV10ChangesListParams = {
  benefit?: number;
  employer?: number;
  /**
   * @minimum 1
   */
  page?: number;
  /**
   * @minimum 1
   * @maximum 100
   */
  pageSize?: number;
  run?: number;
  /**
   * * `PENDING` - Pending
   * * `APPLIED` - Applied
   * * `REJECTED` - Rejected
   * * `SUPERSEDED` - Superseded
   */
  status?: BenefitConfigurationV10ChangesListStatus;
};

export type BenefitConfigurationV10ChangesListStatus =
  (typeof BenefitConfigurationV10ChangesListStatus)[keyof typeof BenefitConfigurationV10ChangesListStatus];

export const BenefitConfigurationV10ChangesListStatus = {
  PENDING: 'PENDING',
  APPLIED: 'APPLIED',
  REJECTED: 'REJECTED',
  SUPERSEDED: 'SUPERSEDED',
} as const;

export type RequirementsV10GroupsListParams = {
  /**
   * * `details` - Details
   * * `content` - Content
   * * `selections` - Selections
   * * `eligibility` - Eligibility
   * * `enrolment` - Enrolment
   * * `pricing` - Pricing
   * * `windows` - Windows
   * * `life_events` - Life events
   */
  domain?: RequirementsV10GroupsListDomain;
  employer: number;
  /**
   * * `benefit` - Benefit
   * * `none` - Unclassified
   */
  entity?: RequirementsV10GroupsListEntity;
  /**
   * @minimum 1
   */
  page?: number;
  /**
   * @minimum 1
   * @maximum 100
   */
  pageSize?: number;
  rootsOnly?: boolean;
};

export type RequirementsV10GroupsListDomain =
  (typeof RequirementsV10GroupsListDomain)[keyof typeof RequirementsV10GroupsListDomain];

export const RequirementsV10GroupsListDomain = {
  details: 'details',
  content: 'content',
  selections: 'selections',
  eligibility: 'eligibility',
  enrolment: 'enrolment',
  pricing: 'pricing',
  windows: 'windows',
  life_events: 'life_events',
} as const;

export type RequirementsV10GroupsListEntity =
  (typeof RequirementsV10GroupsListEntity)[keyof typeof RequirementsV10GroupsListEntity];

export const RequirementsV10GroupsListEntity = {
  benefit: 'benefit',
  none: 'none',
} as const;

export type RequirementsV10GroupsRequirementsListParams = {
  /**
   * * `details` - Details
   * * `content` - Content
   * * `selections` - Selections
   * * `eligibility` - Eligibility
   * * `enrolment` - Enrolment
   * * `pricing` - Pricing
   * * `windows` - Windows
   * * `life_events` - Life events
   */
  domain?: RequirementsV10GroupsRequirementsListDomain;
  /**
   * @minimum 1
   */
  page?: number;
  /**
   * @minimum 1
   * @maximum 100
   */
  pageSize?: number;
  /**
   * * `DIRTY` - DIRTY
   * * `PROPOSED` - PROPOSED
   * * `CLEAN` - CLEAN
   * * `OUT_OF_SCOPE` - OUT_OF_SCOPE
   */
  status?: RequirementsV10GroupsRequirementsListStatus;
};

export type RequirementsV10GroupsRequirementsListDomain =
  (typeof RequirementsV10GroupsRequirementsListDomain)[keyof typeof RequirementsV10GroupsRequirementsListDomain];

export const RequirementsV10GroupsRequirementsListDomain = {
  details: 'details',
  content: 'content',
  selections: 'selections',
  eligibility: 'eligibility',
  enrolment: 'enrolment',
  pricing: 'pricing',
  windows: 'windows',
  life_events: 'life_events',
} as const;

export type RequirementsV10GroupsRequirementsListStatus =
  (typeof RequirementsV10GroupsRequirementsListStatus)[keyof typeof RequirementsV10GroupsRequirementsListStatus];

export const RequirementsV10GroupsRequirementsListStatus = {
  DIRTY: 'DIRTY',
  PROPOSED: 'PROPOSED',
  CLEAN: 'CLEAN',
  OUT_OF_SCOPE: 'OUT_OF_SCOPE',
} as const;

export type ApiSchemaRetrieveParams = {
  format?: ApiSchemaRetrieveFormat;
  lang?: ApiSchemaRetrieveLang;
};

export type ApiSchemaRetrieveFormat =
  (typeof ApiSchemaRetrieveFormat)[keyof typeof ApiSchemaRetrieveFormat];

export const ApiSchemaRetrieveFormat = {
  json: 'json',
  yaml: 'yaml',
} as const;

export type ApiSchemaRetrieveLang =
  (typeof ApiSchemaRetrieveLang)[keyof typeof ApiSchemaRetrieveLang];

export const ApiSchemaRetrieveLang = {
  cs: 'cs',
  de: 'de',
  el: 'el',
  en: 'en',
  'en-US': 'en-US',
  es: 'es',
  'es-XL': 'es-XL',
  fr: 'fr',
  hu: 'hu',
  io: 'io',
  it: 'it',
  ja: 'ja',
  ko: 'ko',
  ms: 'ms',
  pl: 'pl',
  pt: 'pt',
  sk: 'sk',
  tr: 'tr',
  vi: 'vi',
  zh: 'zh',
} as const;

export type ApiSchemaRetrieve200One = { [key: string]: unknown };

export type ApiSchemaRetrieve200Two = { [key: string]: unknown };

export type ApiSchemaRetrieve200Three = { [key: string]: unknown };

export type ApiSchemaRetrieve200Four = { [key: string]: unknown };

export type ApiV10BenefitCategoriesRetrieveParams = {
  includeBenefits?: boolean;
  includeSharedCategories?: boolean;
  onlyEmployeeCategories?: boolean;
  pageNumber?: number;
  /**
   * @minimum 0
   */
  pageSize?: number;
  /**
   * @minLength 1
   * @maxLength 200
   */
  searchValue?: string;
};

export type ApiV10BenefitsFeaturesListParams = {
  /**
   * Order by field. Prefix with '-' for descending order.
   */
  ordering?: ApiV10BenefitsFeaturesListOrdering;
  /**
   * A page number within the paginated result set.
   */
  page?: number;
  /**
   * Number of results to return per page.
   */
  pageSize?: number;
  /**
   * A search term.
   */
  search?: string;
};

export type ApiV10BenefitsFeaturesListOrdering =
  (typeof ApiV10BenefitsFeaturesListOrdering)[keyof typeof ApiV10BenefitsFeaturesListOrdering];

export const ApiV10BenefitsFeaturesListOrdering = {
  '-rank': '-rank',
  rank: 'rank',
} as const;

export type ApiV10EmployeeInterestsPartialUpdateParams = {
  /**
   * Set to true if the employee skipped the interests selection
   */
  skipped?: boolean;
};

export type ApiV10EmployeesContactsListParams = {
  ordering?: ApiV10EmployeesContactsListOrdering;
  /**
   * A page number within the paginated result set.
   */
  page?: number;
  /**
   * Number of results to return per page.
   */
  pageSize?: number;
};

export type ApiV10EmployeesContactsListOrdering =
  (typeof ApiV10EmployeesContactsListOrdering)[keyof typeof ApiV10EmployeesContactsListOrdering];

export const ApiV10EmployeesContactsListOrdering = {
  '-contact_type': '-contact_type',
  '-name': '-name',
  contact_type: 'contact_type',
  name: 'name',
} as const;

export type ApiV10EmployeesContactsEnrollmentsListParams = {
  ordering?: ApiV10EmployeesContactsEnrollmentsListOrdering;
  /**
   * A page number within the paginated result set.
   */
  page?: number;
  /**
   * Number of results to return per page.
   */
  pageSize?: number;
};

export type ApiV10EmployeesContactsEnrollmentsListOrdering =
  (typeof ApiV10EmployeesContactsEnrollmentsListOrdering)[keyof typeof ApiV10EmployeesContactsEnrollmentsListOrdering];

export const ApiV10EmployeesContactsEnrollmentsListOrdering = {
  '-benefit_name': '-benefit_name',
  '-status': '-status',
  benefit_name: 'benefit_name',
  status: 'status',
} as const;

export type ApiV10EmployeesTotalRewardsRetrieveParams = {
  /**
   * * `GBP` - GBP
   * * `EUR` - EUR
   * * `USD` - USD
   */
  currency?: ApiV10EmployeesTotalRewardsRetrieveCurrency;
  /**
   * * `yearly` - yearly
   * * `monthly` - monthly
   */
  granularity?: ApiV10EmployeesTotalRewardsRetrieveGranularity;
  /**
   * @minLength 1
   */
  period?: string;
  /**
   * @minLength 1
   */
  timezone?: string;
  today?: string;
};

export type ApiV10EmployeesTotalRewardsRetrieveCurrency =
  (typeof ApiV10EmployeesTotalRewardsRetrieveCurrency)[keyof typeof ApiV10EmployeesTotalRewardsRetrieveCurrency];

export const ApiV10EmployeesTotalRewardsRetrieveCurrency = {
  GBP: 'GBP',
  EUR: 'EUR',
  USD: 'USD',
} as const;

export type ApiV10EmployeesTotalRewardsRetrieveGranularity =
  (typeof ApiV10EmployeesTotalRewardsRetrieveGranularity)[keyof typeof ApiV10EmployeesTotalRewardsRetrieveGranularity];

export const ApiV10EmployeesTotalRewardsRetrieveGranularity = {
  yearly: 'yearly',
  monthly: 'monthly',
} as const;

export type ApiV10EmployeesTotalRewardsChartRetrieveParams = {
  /**
   * * `GBP` - GBP
   * * `EUR` - EUR
   * * `USD` - USD
   */
  currency?: ApiV10EmployeesTotalRewardsChartRetrieveCurrency;
  /**
   * * `yearly` - yearly
   * * `monthly` - monthly
   */
  granularity?: ApiV10EmployeesTotalRewardsChartRetrieveGranularity;
  /**
   * @minLength 1
   */
  timezone?: string;
  today?: string;
};

export type ApiV10EmployeesTotalRewardsChartRetrieveCurrency =
  (typeof ApiV10EmployeesTotalRewardsChartRetrieveCurrency)[keyof typeof ApiV10EmployeesTotalRewardsChartRetrieveCurrency];

export const ApiV10EmployeesTotalRewardsChartRetrieveCurrency = {
  GBP: 'GBP',
  EUR: 'EUR',
  USD: 'USD',
} as const;

export type ApiV10EmployeesTotalRewardsChartRetrieveGranularity =
  (typeof ApiV10EmployeesTotalRewardsChartRetrieveGranularity)[keyof typeof ApiV10EmployeesTotalRewardsChartRetrieveGranularity];

export const ApiV10EmployeesTotalRewardsChartRetrieveGranularity = {
  yearly: 'yearly',
  monthly: 'monthly',
} as const;

export type ApiV10EmployeesTotalRewardsPdfRetrieveParams = {
  /**
   * * `GBP` - GBP
   * * `EUR` - EUR
   * * `USD` - USD
   */
  currency?: ApiV10EmployeesTotalRewardsPdfRetrieveCurrency;
  /**
   * * `yearly` - yearly
   * * `monthly` - monthly
   */
  granularity?: ApiV10EmployeesTotalRewardsPdfRetrieveGranularity;
  /**
   * @minLength 1
   */
  period?: string;
  /**
   * @minLength 1
   */
  timezone?: string;
  today?: string;
};

export type ApiV10EmployeesTotalRewardsPdfRetrieveCurrency =
  (typeof ApiV10EmployeesTotalRewardsPdfRetrieveCurrency)[keyof typeof ApiV10EmployeesTotalRewardsPdfRetrieveCurrency];

export const ApiV10EmployeesTotalRewardsPdfRetrieveCurrency = {
  GBP: 'GBP',
  EUR: 'EUR',
  USD: 'USD',
} as const;

export type ApiV10EmployeesTotalRewardsPdfRetrieveGranularity =
  (typeof ApiV10EmployeesTotalRewardsPdfRetrieveGranularity)[keyof typeof ApiV10EmployeesTotalRewardsPdfRetrieveGranularity];

export const ApiV10EmployeesTotalRewardsPdfRetrieveGranularity = {
  yearly: 'yearly',
  monthly: 'monthly',
} as const;

export type ApiV10EmployeesTotalRewardsVestingScheduleRetrieveParams = {
  /**
   * * `GBP` - GBP
   * * `EUR` - EUR
   * * `USD` - USD
   */
  currency?: ApiV10EmployeesTotalRewardsVestingScheduleRetrieveCurrency;
  /**
   * @minLength 1
   */
  timezone?: string;
  year: number;
};

export type ApiV10EmployeesTotalRewardsVestingScheduleRetrieveCurrency =
  (typeof ApiV10EmployeesTotalRewardsVestingScheduleRetrieveCurrency)[keyof typeof ApiV10EmployeesTotalRewardsVestingScheduleRetrieveCurrency];

export const ApiV10EmployeesTotalRewardsVestingScheduleRetrieveCurrency = {
  GBP: 'GBP',
  EUR: 'EUR',
  USD: 'USD',
} as const;

export type ApiV10EnrollableBenefitsRetrieveParams = {
  namesOnly?: boolean;
  pageNumber?: number;
  /**
   * @minimum 0
   */
  pageSize?: number;
  /**
   * @nullable
   */
  programmeId?: number | null;
  /**
   * @minLength 1
   * @maxLength 200
   */
  searchValue?: string;
  /**
   * * `ENROLLED_EMPLOYEES_COUNT` - enrolled_employees_count
   * * `NAME` - name
   * * `DISPLAY_NAME` - display_name
   * * `LAST_EDITED` - last_edited
   * * `STATUS` - status
   * * `CATEGORY` - category
   * * `PRICE_PER_MONTH` - price_per_month
   * * `RANK` - rank
   */
  sortingField?: ApiV10EnrollableBenefitsRetrieveSortingField;
  /**
   * * `asc` - asc
   * * `desc` - desc
   */
  sortingOrder?: ApiV10EnrollableBenefitsRetrieveSortingOrder;
  /**
   * @nullable
   */
  statuses?: ApiV10EnrollableBenefitsRetrieveStatusesItem[] | null;
  uncategorisedOnly?: boolean;
};

export type ApiV10EnrollableBenefitsRetrieveSortingField =
  (typeof ApiV10EnrollableBenefitsRetrieveSortingField)[keyof typeof ApiV10EnrollableBenefitsRetrieveSortingField];

export const ApiV10EnrollableBenefitsRetrieveSortingField = {
  ENROLLED_EMPLOYEES_COUNT: 'ENROLLED_EMPLOYEES_COUNT',
  NAME: 'NAME',
  DISPLAY_NAME: 'DISPLAY_NAME',
  LAST_EDITED: 'LAST_EDITED',
  STATUS: 'STATUS',
  CATEGORY: 'CATEGORY',
  PRICE_PER_MONTH: 'PRICE_PER_MONTH',
  RANK: 'RANK',
} as const;

export type ApiV10EnrollableBenefitsRetrieveSortingOrder =
  (typeof ApiV10EnrollableBenefitsRetrieveSortingOrder)[keyof typeof ApiV10EnrollableBenefitsRetrieveSortingOrder];

export const ApiV10EnrollableBenefitsRetrieveSortingOrder = {
  asc: 'asc',
  desc: 'desc',
} as const;

/**
 * * `PUBLISHED` - PUBLISHED
 * * `UNPUBLISHED` - UNPUBLISHED
 * * `DRAFT` - DRAFT
 */
export type ApiV10EnrollableBenefitsRetrieveStatusesItem =
  (typeof ApiV10EnrollableBenefitsRetrieveStatusesItem)[keyof typeof ApiV10EnrollableBenefitsRetrieveStatusesItem];

export const ApiV10EnrollableBenefitsRetrieveStatusesItem = {
  PUBLISHED: 'PUBLISHED',
  UNPUBLISHED: 'UNPUBLISHED',
  DRAFT: 'DRAFT',
} as const;

export type ApiV10EnrollableBenefitsRetrieve2Params = {
  benefitId?: number;
};

export type ApiV10EnrollableBenefitsPartialUpdateParams = {
  benefitId?: number;
};

export type ApiV10EnrollmentsListParams = {
  /**
   * Filter by category IDs (comma-separated)
   */
  category?: string;
  /**
   * Filter by employee ID
   */
  employeeId?: number;
  /**
   * Filter by active status
   */
  isActive?: boolean;
  /**
   * Filter by favorite status
   */
  isFavorite?: boolean;
  /**
   * Filter by selected status
   */
  isSelected?: boolean;
  /**
   * A page number within the paginated result set.
   */
  page?: number;
  /**
   * Number of results to return per page.
   */
  pageSize?: number;
  /**
   * Sort by field
   */
  sortingField?: ApiV10EnrollmentsListSortingField;
  /**
   * Sorting order
   */
  sortingOrder?: ApiV10EnrollmentsListSortingOrder;
  /**
   * Filter by status
   */
  status?: ApiV10EnrollmentsListStatus;
};

export type ApiV10EnrollmentsListSortingField =
  (typeof ApiV10EnrollmentsListSortingField)[keyof typeof ApiV10EnrollmentsListSortingField];

export const ApiV10EnrollmentsListSortingField = {
  ENROLLED_TIMESTAMP: 'ENROLLED_TIMESTAMP',
  NAME: 'NAME',
  STATUS: 'STATUS',
} as const;

export type ApiV10EnrollmentsListSortingOrder =
  (typeof ApiV10EnrollmentsListSortingOrder)[keyof typeof ApiV10EnrollmentsListSortingOrder];

export const ApiV10EnrollmentsListSortingOrder = {
  asc: 'asc',
  desc: 'desc',
} as const;

export type ApiV10EnrollmentsListStatus =
  (typeof ApiV10EnrollmentsListStatus)[keyof typeof ApiV10EnrollmentsListStatus];

export const ApiV10EnrollmentsListStatus = {
  ACTIVE: 'ACTIVE',
  DEACTIVATED: 'DEACTIVATED',
  DRAFT: 'DRAFT',
  OPTED_OUT: 'OPTED_OUT',
  PENDING_ACTIVATION: 'PENDING_ACTIVATION',
  PENDING_DEACTIVATION: 'PENDING_DEACTIVATION',
  REJECTED: 'REJECTED',
  WAITING_ACTIVATION_APPROVAL: 'WAITING_ACTIVATION_APPROVAL',
  WAITING_DEACTIVATION_APPROVAL: 'WAITING_DEACTIVATION_APPROVAL',
} as const;

export type ApiV10FullSearchRetrieveParams = {
  previousMessageId?: string;
  /**
   * @minLength 1
   */
  query?: string;
  queryId?: number;
};

export type ApiV10ProvidersListParams = {
  /**
   * Which field to use when ordering the results.
   */
  ordering?: string;
  /**
   * A page number within the paginated result set.
   */
  page?: number;
  /**
   * Number of results to return per page.
   */
  pageSize?: number;
  /**
   * A search term.
   */
  search?: string;
};

export type ApiV10RecognitionsRewardPresetsRetrieveParams = {
  includeArchived: boolean;
};

export type ApiV10RecognitionsStatisticsRetrieveParams = {
  fromDate?: string;
  toDate?: string;
};

export type ApiV10ResourcesArticlesRetrieveParams = {
  categoryId?: number;
  /**
   * @nullable
   */
  isFeatured?: boolean | null;
  pageNumber?: number;
  /**
   * @minimum 0
   */
  pageSize?: number;
  /**
   * * `created_at` - Created At
   */
  sortingField?: ApiV10ResourcesArticlesRetrieveSortingField;
  /**
   * * `asc` - asc
   * * `desc` - desc
   */
  sortingOrder?: ApiV10ResourcesArticlesRetrieveSortingOrder;
};

export type ApiV10ResourcesArticlesRetrieveSortingField =
  (typeof ApiV10ResourcesArticlesRetrieveSortingField)[keyof typeof ApiV10ResourcesArticlesRetrieveSortingField];

export const ApiV10ResourcesArticlesRetrieveSortingField = {
  created_at: 'created_at',
} as const;

export type ApiV10ResourcesArticlesRetrieveSortingOrder =
  (typeof ApiV10ResourcesArticlesRetrieveSortingOrder)[keyof typeof ApiV10ResourcesArticlesRetrieveSortingOrder];

export const ApiV10ResourcesArticlesRetrieveSortingOrder = {
  asc: 'asc',
  desc: 'desc',
} as const;

export type ApiV10RewardsBudgetsRetrieveParams = {
  pageNumber?: number;
  /**
   * @minimum 0
   */
  pageSize?: number;
  /**
   * @minLength 1
   * @maxLength 200
   */
  searchValue?: string;
  /**
   * * `TIMESTAMP` - timestamp
   * * `NAME` - name
   * * `BUDGET_OWNER_NAME` - budget_owner_name
   * * `BUDGET_AMOUNT` - budget_amount
   * * `MEMBERS_COUNT` - members_count
   */
  sortingField?: ApiV10RewardsBudgetsRetrieveSortingField;
  /**
   * * `asc` - asc
   * * `desc` - desc
   */
  sortingOrder?: ApiV10RewardsBudgetsRetrieveSortingOrder;
};

export type ApiV10RewardsBudgetsRetrieveSortingField =
  (typeof ApiV10RewardsBudgetsRetrieveSortingField)[keyof typeof ApiV10RewardsBudgetsRetrieveSortingField];

export const ApiV10RewardsBudgetsRetrieveSortingField = {
  TIMESTAMP: 'TIMESTAMP',
  NAME: 'NAME',
  BUDGET_OWNER_NAME: 'BUDGET_OWNER_NAME',
  BUDGET_AMOUNT: 'BUDGET_AMOUNT',
  MEMBERS_COUNT: 'MEMBERS_COUNT',
} as const;

export type ApiV10RewardsBudgetsRetrieveSortingOrder =
  (typeof ApiV10RewardsBudgetsRetrieveSortingOrder)[keyof typeof ApiV10RewardsBudgetsRetrieveSortingOrder];

export const ApiV10RewardsBudgetsRetrieveSortingOrder = {
  asc: 'asc',
  desc: 'desc',
} as const;

export type ApiV10SearchRetrieveParams = {
  limit?: number;
  /**
   * @minLength 1
   */
  query: string;
};

export type AllowancesPartialUpdateBodyOne = { [key: string]: unknown };

export type AllowancesPartialUpdateBodyTwo = { [key: string]: unknown };

export type AllowancesPartialUpdateBodyThree = { [key: string]: unknown };

export type AllowancesPreviewCreateBodyOne = { [key: string]: unknown };

export type AllowancesPreviewCreateBodyTwo = { [key: string]: unknown };

export type AllowancesPreviewCreateBodyThree = { [key: string]: unknown };

export type BenefitsChangesListParams = {
  /**
   * A page number within the paginated result set.
   */
  page?: number;
  /**
   * Number of results to return per page.
   */
  pageSize?: number;
};

export type BenefitsFeaturesListParams = {
  /**
   * Filter by benefit ID
   */
  benefitId?: number;
  /**
   * Filter by category
   */
  category?: BenefitsFeaturesListCategory;
  /**
   * Filter by grouped category
   */
  groupedCategory?: BenefitsFeaturesListGroupedCategory;
  /**
   * Filter by favorite status
   */
  isFavorite?: boolean;
  /**
   * Which field to use when ordering the results.
   */
  ordering?: string;
  /**
   * A page number within the paginated result set.
   */
  page?: number;
  /**
   * Number of results to return per page.
   */
  pageSize?: number;
  /**
   * Filter by enrolment status
   */
  status?: BenefitsFeaturesListStatus;
};

export type BenefitsFeaturesListCategory =
  (typeof BenefitsFeaturesListCategory)[keyof typeof BenefitsFeaturesListCategory];

export const BenefitsFeaturesListCategory = {
  BENEFIT_TYPE_FAMILY: 'BENEFIT_TYPE_FAMILY',
  BENEFIT_TYPE_FINANCE: 'BENEFIT_TYPE_FINANCE',
  BENEFIT_TYPE_HEALTH_WELLBEING: 'BENEFIT_TYPE_HEALTH_WELLBEING',
  BENEFIT_TYPE_LIFESTYLE: 'BENEFIT_TYPE_LIFESTYLE',
  BENEFIT_TYPE_OTHER: 'BENEFIT_TYPE_OTHER',
} as const;

export type BenefitsFeaturesListGroupedCategory =
  (typeof BenefitsFeaturesListGroupedCategory)[keyof typeof BenefitsFeaturesListGroupedCategory];

export const BenefitsFeaturesListGroupedCategory = {
  BENEFIT_TYPE_FAMILY: 'BENEFIT_TYPE_FAMILY',
  BENEFIT_TYPE_FINANCE: 'BENEFIT_TYPE_FINANCE',
  BENEFIT_TYPE_HEALTH_WELLBEING: 'BENEFIT_TYPE_HEALTH_WELLBEING',
  BENEFIT_TYPE_LIFESTYLE: 'BENEFIT_TYPE_LIFESTYLE',
  BENEFIT_TYPE_OTHER: 'BENEFIT_TYPE_OTHER',
} as const;

export type BenefitsFeaturesListStatus =
  (typeof BenefitsFeaturesListStatus)[keyof typeof BenefitsFeaturesListStatus];

export const BenefitsFeaturesListStatus = {
  ACTIVE: 'ACTIVE',
  DEACTIVATED: 'DEACTIVATED',
  DRAFT: 'DRAFT',
  OPTED_OUT: 'OPTED_OUT',
  PENDING_ACTIVATION: 'PENDING_ACTIVATION',
  PENDING_DEACTIVATION: 'PENDING_DEACTIVATION',
  REJECTED: 'REJECTED',
  WAITING_ACTIVATION_APPROVAL: 'WAITING_ACTIVATION_APPROVAL',
  WAITING_DEACTIVATION_APPROVAL: 'WAITING_DEACTIVATION_APPROVAL',
} as const;

export type DashboardRemindersRetrieveParams = {
  includeMissingReceipts?: boolean;
};

export type LifeEventRetrieve200 = {
  lifeEvents?: string[];
};

export type ModularBenefitsMinMaxFormulaFieldRecalculateCreateBodyOne = {
  [key: string]: unknown;
};

export type ModularBenefitsMinMaxFormulaFieldRecalculateCreateBodyTwo = {
  [key: string]: unknown;
};

export type ModularBenefitsMinMaxFormulaFieldRecalculateCreateBodyThree = {
  [key: string]: unknown;
};

export type ModularBenefitsSubscriptionsRetrieveParams = {
  /**
   * @nullable
   */
  dateSubscriptionCovers?: string | null;
  /**
   * * `DRAFT` - DRAFT
   * * `PENDING_OPT_IN_APPROVAL` - PENDING_OPT_IN_APPROVAL
   * * `PENDING_OPT_IN` - PENDING_OPT_IN
   * * `PENDING_OPT_IN_CONFIRMATION` - PENDING_OPT_IN_CONFIRMATION
   * * `PENDING_OPT_IN_ACTIVATION` - PENDING_OPT_IN_ACTIVATION
   * * `PENDING_CHANGE_APPROVAL` - PENDING_CHANGE_APPROVAL
   * * `PENDING_CHANGE` - PENDING_CHANGE
   * * `PENDING_CHANGE_CONFIRMATION` - PENDING_CHANGE_CONFIRMATION
   * * `PENDING_CHANGE_ACTIVATION` - PENDING_CHANGE_ACTIVATION
   * * `PENDING_CHANGE_RENEWAL` - PENDING_CHANGE_RENEWAL
   * * `ACTIVE` - ACTIVE
   * * `PENDING_OPT_OUT_APPROVAL` - PENDING_OPT_OUT_APPROVAL
   * * `PENDING_OPT_OUT` - PENDING_OPT_OUT
   * * `PENDING_OPT_OUT_CONFIRMATION` - PENDING_OPT_OUT_CONFIRMATION
   * * `PENDING_OPT_OUT_DEACTIVATION` - PENDING_OPT_OUT_DEACTIVATION
   * * `DEACTIVATED` - DEACTIVATED
   * * `REJECTED` - REJECTED
   * * `CANCELLED` - CANCELLED
   */
  fulfillmentStatus?: ModularBenefitsSubscriptionsRetrieveFulfillmentStatus;
  /**
   * @nullable
   */
  isActiveForPeriod?: boolean | null;
};

export type ModularBenefitsSubscriptionsRetrieveFulfillmentStatus =
  (typeof ModularBenefitsSubscriptionsRetrieveFulfillmentStatus)[keyof typeof ModularBenefitsSubscriptionsRetrieveFulfillmentStatus];

export const ModularBenefitsSubscriptionsRetrieveFulfillmentStatus = {
  DRAFT: 'DRAFT',
  PENDING_OPT_IN_APPROVAL: 'PENDING_OPT_IN_APPROVAL',
  PENDING_OPT_IN: 'PENDING_OPT_IN',
  PENDING_OPT_IN_CONFIRMATION: 'PENDING_OPT_IN_CONFIRMATION',
  PENDING_OPT_IN_ACTIVATION: 'PENDING_OPT_IN_ACTIVATION',
  PENDING_CHANGE_APPROVAL: 'PENDING_CHANGE_APPROVAL',
  PENDING_CHANGE: 'PENDING_CHANGE',
  PENDING_CHANGE_CONFIRMATION: 'PENDING_CHANGE_CONFIRMATION',
  PENDING_CHANGE_ACTIVATION: 'PENDING_CHANGE_ACTIVATION',
  PENDING_CHANGE_RENEWAL: 'PENDING_CHANGE_RENEWAL',
  ACTIVE: 'ACTIVE',
  PENDING_OPT_OUT_APPROVAL: 'PENDING_OPT_OUT_APPROVAL',
  PENDING_OPT_OUT: 'PENDING_OPT_OUT',
  PENDING_OPT_OUT_CONFIRMATION: 'PENDING_OPT_OUT_CONFIRMATION',
  PENDING_OPT_OUT_DEACTIVATION: 'PENDING_OPT_OUT_DEACTIVATION',
  DEACTIVATED: 'DEACTIVATED',
  REJECTED: 'REJECTED',
  CANCELLED: 'CANCELLED',
} as const;

export type RecognitionsEmployeesRetrieveParams = {
  pageNumber?: number;
  /**
   * @minimum 0
   */
  pageSize?: number;
  /**
   * @minLength 1
   * @maxLength 200
   */
  searchValue?: string;
};

export type RewardsSpendingBalancesRetrieveParams = {
  pageNumber?: number;
  /**
   * @minimum 0
   */
  pageSize?: number;
};

export type RewardsSpendingBalancesTransactionsRetrieveParams = {
  pageNumber?: number;
  /**
   * @minimum 0
   */
  pageSize?: number;
  /**
   * @minLength 1
   * @maxLength 200
   */
  searchValue?: string;
  /**
   * * `NAME` - name
   * * `TYPE` - type
   * * `RECIPIENT` - recipient
   * * `DATE` - date
   * * `AMOUNT` - amount
   */
  sortingField?: RewardsSpendingBalancesTransactionsRetrieveSortingField;
  /**
   * * `asc` - asc
   * * `desc` - desc
   */
  sortingOrder?: RewardsSpendingBalancesTransactionsRetrieveSortingOrder;
};

export type RewardsSpendingBalancesTransactionsRetrieveSortingField =
  (typeof RewardsSpendingBalancesTransactionsRetrieveSortingField)[keyof typeof RewardsSpendingBalancesTransactionsRetrieveSortingField];

export const RewardsSpendingBalancesTransactionsRetrieveSortingField = {
  NAME: 'NAME',
  TYPE: 'TYPE',
  RECIPIENT: 'RECIPIENT',
  DATE: 'DATE',
  AMOUNT: 'AMOUNT',
} as const;

export type RewardsSpendingBalancesTransactionsRetrieveSortingOrder =
  (typeof RewardsSpendingBalancesTransactionsRetrieveSortingOrder)[keyof typeof RewardsSpendingBalancesTransactionsRetrieveSortingOrder];

export const RewardsSpendingBalancesTransactionsRetrieveSortingOrder = {
  asc: 'asc',
  desc: 'desc',
} as const;

export type BenefitDelaysListParams = {
  /**
   * A page number within the paginated result set.
   */
  page?: number;
};

export type BenefitDocumentsListParams = {
  /**
   * A page number within the paginated result set.
   */
  page?: number;
};

export type BenefitHeroImageListParams = {
  /**
   * A page number within the paginated result set.
   */
  page?: number;
};

export type BenefitImageListParams = {
  /**
   * A page number within the paginated result set.
   */
  page?: number;
};

export type BenefitManagersListParams = {
  /**
   * A page number within the paginated result set.
   */
  page?: number;
};

export type BenefitProductTypesListParams = {
  /**
   * A page number within the paginated result set.
   */
  page?: number;
};

export type BenefitWaiverReasonsGroupsListParams = {
  /**
   * A page number within the paginated result set.
   */
  page?: number;
};

export type BenefitsListParams = {
  active?: boolean;
  benefitProgramme?: number;
  employer?: number;
  employerCorporateGroup?: number;
  /**
   * * `OPT_IN` - Opt in
   * * `OPT_OUT` - Opt out
   * * `LOCKED` - Locked
   * * `INFO_ONLY` - Informational
   * * `DISCOUNT` - Discount
   */
  enrolmentType?: BenefitsListEnrolmentType;
  managedBy?: number;
  /**
   * Which field to use when ordering the results.
   */
  ordering?: string;
  /**
   * A page number within the paginated result set.
   */
  page?: number;
  /**
   * Number of results to return per page.
   */
  pageSize?: number;
  provider?: number;
  /**
   * A search term.
   */
  search?: string;
};

export type BenefitsListEnrolmentType =
  (typeof BenefitsListEnrolmentType)[keyof typeof BenefitsListEnrolmentType];

export const BenefitsListEnrolmentType = {
  DISCOUNT: 'DISCOUNT',
  INFO_ONLY: 'INFO_ONLY',
  LOCKED: 'LOCKED',
  OPT_IN: 'OPT_IN',
  OPT_OUT: 'OPT_OUT',
} as const;

export type BenefitsBrokersListParams = {
  /**
   * A page number within the paginated result set.
   */
  page?: number;
};

export type ComponentKeysListParams = {
  /**
   * A page number within the paginated result set.
   */
  page?: number;
  /**
   * Number of results to return per page.
   */
  pageSize?: number;
  /**
   * A search term.
   */
  search?: string;
};

export type EmployersListParams = {
  /**
   * A page number within the paginated result set.
   */
  page?: number;
  /**
   * Number of results to return per page.
   */
  pageSize?: number;
  /**
   * A search term.
   */
  search?: string;
};

export type OptOutReasonsGroupsListParams = {
  /**
   * A page number within the paginated result set.
   */
  page?: number;
};

export type OutboundProvidersListParams = {
  /**
   * A page number within the paginated result set.
   */
  page?: number;
  /**
   * Number of results to return per page.
   */
  pageSize?: number;
};

export type ProvidersListParams = {
  /**
   * A page number within the paginated result set.
   */
  page?: number;
};

export type StatePensionAgeConfigsListParams = {
  /**
   * A page number within the paginated result set.
   */
  page?: number;
};

export type TagsListParams = {
  /**
   * A page number within the paginated result set.
   */
  page?: number;
};

/**
 * Unspecified response body
 */
export type AllowanceEmployeeRetrieve200 = { [key: string]: unknown };

export type ApprovalRequestsFundRequestsListParams = {
  approved?: boolean;
  /**
   * A page number within the paginated result set.
   */
  page?: number;
  /**
   * Number of results to return per page.
   */
  pageSize?: number;
  rejected?: boolean;
  search?: string;
};

export type ApprovalRequestsReimbursementsListParams = {
  approved?: boolean;
  /**
   * A page number within the paginated result set.
   */
  page?: number;
  /**
   * Number of results to return per page.
   */
  pageSize?: number;
  rejected?: boolean;
  search?: string;
};

export type ApprovalRequestsStepExecutionsListParams = {
  actionedBy?: number;
  approvalType?: ApprovalRequestsStepExecutionsListApprovalType;
  /**
   * This will fetch step executions for benefit requests and enrolments for the given benefit id.
   */
  benefitId?: number;
  /**
   * A page number within the paginated result set.
   */
  page?: number;
  /**
   * Number of results to return per page.
   */
  pageSize?: number;
  processExecutionUuid?: string;
  /**
   * A search term.
   */
  search?: string;
  status?: ApprovalRequestsStepExecutionsListStatus;
  targetId?: string;
};

export type ApprovalRequestsStepExecutionsListApprovalType =
  (typeof ApprovalRequestsStepExecutionsListApprovalType)[keyof typeof ApprovalRequestsStepExecutionsListApprovalType];

export const ApprovalRequestsStepExecutionsListApprovalType = {
  BENEFIT_ENROLMENT: 'BENEFIT_ENROLMENT',
  BENEFIT_REQUEST: 'BENEFIT_REQUEST',
  FUND_REQUEST: 'FUND_REQUEST',
  REIMBURSEMENT_REQUEST: 'REIMBURSEMENT_REQUEST',
} as const;

export type ApprovalRequestsStepExecutionsListStatus =
  (typeof ApprovalRequestsStepExecutionsListStatus)[keyof typeof ApprovalRequestsStepExecutionsListStatus];

export const ApprovalRequestsStepExecutionsListStatus = {
  APPROVED: 'APPROVED',
  CANCELLED: 'CANCELLED',
  HISTORY: 'HISTORY',
  PENDING: 'PENDING',
  REDIRECTED: 'REDIRECTED',
  REJECTED: 'REJECTED',
} as const;

export type BenefitsEnrolmentsMinMaxFormulaFieldRecalculateCreateBodyOne = {
  [key: string]: unknown;
};

export type BenefitsEnrolmentsMinMaxFormulaFieldRecalculateCreateBodyTwo = {
  [key: string]: unknown;
};

export type BenefitsEnrolmentsMinMaxFormulaFieldRecalculateCreateBodyThree = {
  [key: string]: unknown;
};

export type BudgetsRetrieveParams = {
  pageNumber?: number;
  /**
   * @minimum 0
   */
  pageSize?: number;
  /**
   * @minLength 1
   * @maxLength 200
   */
  searchValue?: string;
  /**
   * * `BUDGET_OWNER` - budget_owner
   * * `NAME` - name
   * * `TOTAL_BALANCE` - total_balance
   * * `ASSIGNED_USERS` - assigned_users
   */
  sortingField?: BudgetsRetrieveSortingField;
  /**
   * * `asc` - asc
   * * `desc` - desc
   */
  sortingOrder?: BudgetsRetrieveSortingOrder;
};

export type BudgetsRetrieveSortingField =
  (typeof BudgetsRetrieveSortingField)[keyof typeof BudgetsRetrieveSortingField];

export const BudgetsRetrieveSortingField = {
  BUDGET_OWNER: 'BUDGET_OWNER',
  NAME: 'NAME',
  TOTAL_BALANCE: 'TOTAL_BALANCE',
  ASSIGNED_USERS: 'ASSIGNED_USERS',
} as const;

export type BudgetsRetrieveSortingOrder =
  (typeof BudgetsRetrieveSortingOrder)[keyof typeof BudgetsRetrieveSortingOrder];

export const BudgetsRetrieveSortingOrder = {
  asc: 'asc',
  desc: 'desc',
} as const;

export type BudgetsMembersListParams = {
  /**
   * @minLength 1
   * @maxLength 200
   */
  searchValue?: string;
};

export type ChangesListParams = {
  /**
   * Which field to use when ordering the results.
   */
  ordering?: string;
  /**
   * A page number within the paginated result set.
   */
  page?: number;
  /**
   * Number of results to return per page.
   */
  pageSize?: number;
  /**
   * A search term.
   */
  search?: string;
};

export type ChangesEnrolmentsListParams = {
  /**
   * A page number within the paginated result set.
   */
  page?: number;
  /**
   * Number of results to return per page.
   */
  pageSize?: number;
};

export type ChatChatsRetrieveParams = {
  page?: number;
  pageSize?: number;
  search?: string;
};

export type EmployeeSegmentsListParams = {
  /**
   * A page number within the paginated result set.
   */
  page?: number;
  /**
   * Number of results to return per page.
   */
  pageSize?: number;
};

export type EmployeeSegmentsEmployeesCreateParams = {
  /**
   * A page number within the paginated result set.
   */
  page?: number;
  /**
   * Number of results to return per page.
   */
  pageSize?: number;
};

export type EmployeesListParams = {
  /**
   * Filter by whether the employee has managed employees
   */
  hasManagedEmployees?: boolean;
  /**
   * Filter by permissions (comma-separated). Employees must have all specified permissions.
   */
  permissions?: string;
};

export type LifeEventsListParams = {
  /**
   * A page number within the paginated result set.
   */
  page?: number;
  /**
   * Number of results to return per page.
   */
  pageSize?: number;
  /**
   * A search term.
   */
  search?: string;
  source?: string;
};

export type ManagedCardsCategoriesEmployeesRetrieveParams = {
  pageNumber?: number;
  /**
   * @minimum 0
   */
  pageSize?: number;
  /**
   * @minLength 1
   * @maxLength 200
   */
  searchValue?: string;
  /**
   * * `NAME` - name
   */
  sortingField?: ManagedCardsCategoriesEmployeesRetrieveSortingField;
  /**
   * * `asc` - asc
   * * `desc` - desc
   */
  sortingOrder?: ManagedCardsCategoriesEmployeesRetrieveSortingOrder;
};

export type ManagedCardsCategoriesEmployeesRetrieveSortingField =
  (typeof ManagedCardsCategoriesEmployeesRetrieveSortingField)[keyof typeof ManagedCardsCategoriesEmployeesRetrieveSortingField];

export const ManagedCardsCategoriesEmployeesRetrieveSortingField = {
  NAME: 'NAME',
} as const;

export type ManagedCardsCategoriesEmployeesRetrieveSortingOrder =
  (typeof ManagedCardsCategoriesEmployeesRetrieveSortingOrder)[keyof typeof ManagedCardsCategoriesEmployeesRetrieveSortingOrder];

export const ManagedCardsCategoriesEmployeesRetrieveSortingOrder = {
  asc: 'asc',
  desc: 'desc',
} as const;

export type PayrollInstructionConfigsListParams = {
  /**
   * Filter by name (case-insensitive substring match).
   */
  name?: string;
  outputSchemaId?: number;
  /**
   * A page number within the paginated result set.
   */
  page?: number;
  /**
   * Number of results to return per page.
   */
  pageSize?: number;
};

export type PayrollInstructionSchemasListParams = {
  /**
   * Filter by name (case-insensitive substring match).
   */
  name?: string;
  /**
   * A page number within the paginated result set.
   */
  page?: number;
  /**
   * Number of results to return per page.
   */
  pageSize?: number;
};

export type PayrollInstructionSchemasCyclesListParams = {
  /**
   * A page number within the paginated result set.
   */
  page?: number;
  /**
   * Number of results to return per page.
   */
  pageSize?: number;
};

export type PayrollInstructionSchemasCyclesRowsListParams = {
  benefitId?: number;
  /**
   * A page number within the paginated result set.
   */
  page?: number;
  /**
   * Number of results to return per page.
   */
  pageSize?: number;
  search?: string;
};

export type PayrollInstructionSchemasTestCasesListParams = {
  /**
   * Filter by name (case-insensitive substring match).
   */
  name?: string;
  /**
   * A page number within the paginated result set.
   */
  page?: number;
  /**
   * Number of results to return per page.
   */
  pageSize?: number;
  status?: PayrollInstructionSchemasTestCasesListStatus;
};

export type PayrollInstructionSchemasTestCasesListStatus =
  (typeof PayrollInstructionSchemasTestCasesListStatus)[keyof typeof PayrollInstructionSchemasTestCasesListStatus];

export const PayrollInstructionSchemasTestCasesListStatus = {
  ERROR: 'ERROR',
  FAILED: 'FAILED',
  PASSED: 'PASSED',
  UNTESTED: 'UNTESTED',
} as const;

export type PayrollCyclesListParams = {
  /**
   * A page number within the paginated result set.
   */
  page?: number;
  /**
   * Number of results to return per page.
   */
  pageSize?: number;
  /**
   * @nullable
   */
  usesPayrollInstructions?: boolean | null;
};

export type ReportsAirwallexListParams = {
  /**
   * A page number within the paginated result set.
   */
  page?: number;
  /**
   * Number of results to return per page.
   */
  pageSize?: number;
};

export type ReportsNmwCheckListParams = {
  /**
   * Filter by payroll cycle cutoff date (YYYY-MM-DD).
   */
  cycleCutoff?: string;
  /**
   * Filter to payroll cycle cutoff dates strictly after this date (YYYY-MM-DD).
   */
  cycleCutoffAfter?: string;
  /**
   * Filter to payroll cycle cutoff dates strictly before this date (YYYY-MM-DD).
   */
  cycleCutoffBefore?: string;
  /**
   * Filter to payroll cycle cutoff dates on or after this date (YYYY-MM-DD); pair with cycle_cutoff_to for a range.
   */
  cycleCutoffFrom?: string;
  /**
   * Filter to payroll cycle cutoff dates on or before this date (YYYY-MM-DD); pair with cycle_cutoff_from for a range.
   */
  cycleCutoffTo?: string;
  likelyCause?: ReportsNmwCheckListLikelyCause;
  /**
   * Exclude records with this likely cause.
   */
  likelyCauseIsNot?: ReportsNmwCheckListLikelyCauseIsNot;
  page?: number;
  pageSize?: number;
  search?: string;
  status?: ReportsNmwCheckListStatus;
  /**
   * Exclude records with this status.
   */
  statusIsNot?: ReportsNmwCheckListStatusIsNot;
};

export type ReportsNmwCheckListLikelyCause =
  (typeof ReportsNmwCheckListLikelyCause)[keyof typeof ReportsNmwCheckListLikelyCause];

export const ReportsNmwCheckListLikelyCause = {
  MISSING_DOB: 'MISSING_DOB',
  MISSING_SALARY: 'MISSING_SALARY',
  MISSING_COUNTRY: 'MISSING_COUNTRY',
  MISSING_CONTRACTED_HOURS: 'MISSING_CONTRACTED_HOURS',
  ZERO_CONTRACTED_HOURS: 'ZERO_CONTRACTED_HOURS',
  MISSING_WAGE_CONFIG: 'MISSING_WAGE_CONFIG',
  AGE_BAND_CHANGE: 'AGE_BAND_CHANGE',
  NMW_RATE_CHANGE: 'NMW_RATE_CHANGE',
  SALARY_CHANGE: 'SALARY_CHANGE',
  FTE_CHANGE: 'FTE_CHANGE',
  CONTRACTED_HOURS_CHANGE: 'CONTRACTED_HOURS_CHANGE',
  COUNTRY_CHANGE: 'COUNTRY_CHANGE',
  SALARY_DEDUCTIONS: 'SALARY_DEDUCTIONS',
  CURRENCY_MISMATCH: 'CURRENCY_MISMATCH',
} as const;

export type ReportsNmwCheckListLikelyCauseIsNot =
  (typeof ReportsNmwCheckListLikelyCauseIsNot)[keyof typeof ReportsNmwCheckListLikelyCauseIsNot];

export const ReportsNmwCheckListLikelyCauseIsNot = {
  MISSING_DOB: 'MISSING_DOB',
  MISSING_SALARY: 'MISSING_SALARY',
  MISSING_COUNTRY: 'MISSING_COUNTRY',
  MISSING_CONTRACTED_HOURS: 'MISSING_CONTRACTED_HOURS',
  ZERO_CONTRACTED_HOURS: 'ZERO_CONTRACTED_HOURS',
  MISSING_WAGE_CONFIG: 'MISSING_WAGE_CONFIG',
  AGE_BAND_CHANGE: 'AGE_BAND_CHANGE',
  NMW_RATE_CHANGE: 'NMW_RATE_CHANGE',
  SALARY_CHANGE: 'SALARY_CHANGE',
  FTE_CHANGE: 'FTE_CHANGE',
  CONTRACTED_HOURS_CHANGE: 'CONTRACTED_HOURS_CHANGE',
  COUNTRY_CHANGE: 'COUNTRY_CHANGE',
  SALARY_DEDUCTIONS: 'SALARY_DEDUCTIONS',
  CURRENCY_MISMATCH: 'CURRENCY_MISMATCH',
} as const;

export type ReportsNmwCheckListStatus =
  (typeof ReportsNmwCheckListStatus)[keyof typeof ReportsNmwCheckListStatus];

export const ReportsNmwCheckListStatus = {
  PASS: 'PASS',
  FAIL: 'FAIL',
  AT_RISK: 'AT_RISK',
  NOT_APPLICABLE: 'NOT_APPLICABLE',
  ERROR: 'ERROR',
} as const;

export type ReportsNmwCheckListStatusIsNot =
  (typeof ReportsNmwCheckListStatusIsNot)[keyof typeof ReportsNmwCheckListStatusIsNot];

export const ReportsNmwCheckListStatusIsNot = {
  PASS: 'PASS',
  FAIL: 'FAIL',
  AT_RISK: 'AT_RISK',
  NOT_APPLICABLE: 'NOT_APPLICABLE',
  ERROR: 'ERROR',
} as const;

export type ReportsNmwCheckExportRetrieveParams = {
  /**
   * * `OVERVIEW` - OVERVIEW
   * * `ENROLMENT` - ENROLMENT
   */
  exportType: ReportsNmwCheckExportRetrieveExportType;
};

export type ReportsNmwCheckExportRetrieveExportType =
  (typeof ReportsNmwCheckExportRetrieveExportType)[keyof typeof ReportsNmwCheckExportRetrieveExportType];

export const ReportsNmwCheckExportRetrieveExportType = {
  OVERVIEW: 'OVERVIEW',
  ENROLMENT: 'ENROLMENT',
} as const;

export type ReportsPayrollExportRetrieveParams = {
  cycleId: number;
  schemaId: number;
};

export type MessagingIntegrationsV10RetrieveParams = {
  /**
   * * `ACTIVE` - ACTIVE
   * * `ALL` - ALL
   */
  status: MessagingIntegrationsV10RetrieveStatus;
};

export type MessagingIntegrationsV10RetrieveStatus =
  (typeof MessagingIntegrationsV10RetrieveStatus)[keyof typeof MessagingIntegrationsV10RetrieveStatus];

export const MessagingIntegrationsV10RetrieveStatus = {
  ACTIVE: 'ACTIVE',
  ALL: 'ALL',
} as const;

export type MessagingIntegrationsV10MsTeamsAuthRedirectRetrieveParams = {
  /**
   * @minLength 1
   * @nullable
   */
  clientInfo?: string | null;
  /**
   * @minLength 1
   * @nullable
   */
  code?: string | null;
  /**
   * @minLength 1
   * @nullable
   */
  error?: string | null;
  /**
   * @minLength 1
   * @nullable
   */
  errorDescription?: string | null;
  /**
   * @minLength 1
   * @nullable
   */
  errorSubcode?: string | null;
  /**
   * @minLength 1
   * @nullable
   */
  sessionState?: string | null;
  /**
   * @minLength 1
   */
  state: string;
};

export type MessagingIntegrationsV10SlackAuthRedirectRetrieveParams = {
  /**
   * @minLength 1
   * @nullable
   */
  code?: string | null;
  /**
   * @minLength 1
   * @nullable
   */
  state?: string | null;
};

export type MessagingIntegrationsV10SlackAuthUsersRedirectRetrieveParams = {
  /**
   * @minLength 1
   * @nullable
   */
  code?: string | null;
  /**
   * @minLength 1
   */
  state: string;
};

export type NotificationsV10CampaignsRetrieveParams = {
  /**
   * * `title` - title
   * * `status` - status
   * * `scheduled_at` - scheduled_at
   * @nullable
   */
  sortingField?: NotificationsV10CampaignsRetrieveSortingField;
  /**
   * * `asc` - asc
   * * `desc` - desc
   */
  sortingOrder?: NotificationsV10CampaignsRetrieveSortingOrder;
};

export type NotificationsV10CampaignsRetrieveSortingField =
  | (typeof NotificationsV10CampaignsRetrieveSortingField)[keyof typeof NotificationsV10CampaignsRetrieveSortingField]
  | null;

export const NotificationsV10CampaignsRetrieveSortingField = {
  title: 'title',
  status: 'status',
  scheduled_at: 'scheduled_at',
} as const;

export type NotificationsV10CampaignsRetrieveSortingOrder =
  (typeof NotificationsV10CampaignsRetrieveSortingOrder)[keyof typeof NotificationsV10CampaignsRetrieveSortingOrder];

export const NotificationsV10CampaignsRetrieveSortingOrder = {
  asc: 'asc',
  desc: 'desc',
} as const;

export type NotificationsV10EventsRetrieveParams = {
  /**
   * @nullable
   */
  notificationDefinitions?: number[] | null;
};

export type NotificationsV10NotificationDefinitionsRetrieveParams = {
  pageNumber?: number;
  /**
   * @minimum 0
   */
  pageSize?: number;
  /**
   * @minLength 1
   * @maxLength 200
   */
  searchValue?: string;
  /**
   * * `name` - name
   * * `event_count_last_seven_days` - event_count_last_seven_days
   * * `category` - category
   */
  sortingField?: NotificationsV10NotificationDefinitionsRetrieveSortingField;
  /**
   * * `asc` - asc
   * * `desc` - desc
   */
  sortingOrder?: NotificationsV10NotificationDefinitionsRetrieveSortingOrder;
};

export type NotificationsV10NotificationDefinitionsRetrieveSortingField =
  (typeof NotificationsV10NotificationDefinitionsRetrieveSortingField)[keyof typeof NotificationsV10NotificationDefinitionsRetrieveSortingField];

export const NotificationsV10NotificationDefinitionsRetrieveSortingField = {
  name: 'name',
  event_count_last_seven_days: 'event_count_last_seven_days',
  category: 'category',
} as const;

export type NotificationsV10NotificationDefinitionsRetrieveSortingOrder =
  (typeof NotificationsV10NotificationDefinitionsRetrieveSortingOrder)[keyof typeof NotificationsV10NotificationDefinitionsRetrieveSortingOrder];

export const NotificationsV10NotificationDefinitionsRetrieveSortingOrder = {
  asc: 'asc',
  desc: 'desc',
} as const;

export type NotificationsV10NotificationDefinitionsEventsRetrieveParams = {
  pageNumber?: number;
  /**
   * @minimum 0
   */
  pageSize?: number;
  /**
   * @minLength 1
   * @maxLength 200
   */
  searchValue?: string;
  /**
   * * `recipient_name` - recipient_name
   * * `language` - language
   * * `sent_at` - sent_at
   * * `status` - status
   */
  sortingField?: NotificationsV10NotificationDefinitionsEventsRetrieveSortingField;
  /**
   * * `asc` - asc
   * * `desc` - desc
   */
  sortingOrder?: NotificationsV10NotificationDefinitionsEventsRetrieveSortingOrder;
};

export type NotificationsV10NotificationDefinitionsEventsRetrieveSortingField =
  (typeof NotificationsV10NotificationDefinitionsEventsRetrieveSortingField)[keyof typeof NotificationsV10NotificationDefinitionsEventsRetrieveSortingField];

export const NotificationsV10NotificationDefinitionsEventsRetrieveSortingField =
  {
    recipient_name: 'recipient_name',
    language: 'language',
    sent_at: 'sent_at',
    status: 'status',
  } as const;

export type NotificationsV10NotificationDefinitionsEventsRetrieveSortingOrder =
  (typeof NotificationsV10NotificationDefinitionsEventsRetrieveSortingOrder)[keyof typeof NotificationsV10NotificationDefinitionsEventsRetrieveSortingOrder];

export const NotificationsV10NotificationDefinitionsEventsRetrieveSortingOrder =
  {
    asc: 'asc',
    desc: 'desc',
  } as const;

export type NotificationsV10NotificationDefinitionsTemplatesRetrieveParams = {
  /**
   * * `email` - email
   * * `mobile_push` - mobile_push
   * * `slack` - slack
   * * `ms_teams` - ms_teams
   */
  channel: NotificationsV10NotificationDefinitionsTemplatesRetrieveChannel;
  /**
   * @minLength 1
   */
  language: string;
};

export type NotificationsV10NotificationDefinitionsTemplatesRetrieveChannel =
  (typeof NotificationsV10NotificationDefinitionsTemplatesRetrieveChannel)[keyof typeof NotificationsV10NotificationDefinitionsTemplatesRetrieveChannel];

export const NotificationsV10NotificationDefinitionsTemplatesRetrieveChannel = {
  email: 'email',
  mobile_push: 'mobile_push',
  slack: 'slack',
  ms_teams: 'ms_teams',
} as const;
